import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BooleanType: any;
  CustomData: any;
  DateTime: any;
  FloatType: any;
  IntType: any;
  ItemId: any;
  JsonField: any;
  MetaTagAttributes: any;
  UploadId: any;
};

export type AboutAreaModelParagraphField = {
  __typename?: 'AboutAreaModelParagraphField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type About Area (about_area) */
export type AboutAreaRecord = RecordInterface & {
  __typename?: 'AboutAreaRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  iconsWithText: Array<TextIconRecord>;
  id: Scalars['ItemId'];
  linkList: Array<TextLinkRecord>;
  paragraph?: Maybe<AboutAreaModelParagraphField>;
  title: Array<TitleRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type About Area (about_area) */
export type AboutAreaRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AboutAreaRecordListListNonNullMultiLocaleField = {
  __typename?: 'AboutAreaRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<AboutAreaRecord>;
};

/** Block of type Anchor Navigation Item (anchor_navigation_item) */
export type AnchorNavigationItemRecord = RecordInterface & {
  __typename?: 'AnchorNavigationItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  sectionHeading?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Anchor Navigation Item (anchor_navigation_item) */
export type AnchorNavigationItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AnchorNavigationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AnchorNavigationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AnchorNavigationModelFilter>>>;
  id?: InputMaybe<ItemIdFilter>;
};

/** Block of type Anchor Navigation (anchor_navigation) */
export type AnchorNavigationRecord = RecordInterface & {
  __typename?: 'AnchorNavigationRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  items: Array<AnchorNavigationItemRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Anchor Navigation (anchor_navigation) */
export type AnchorNavigationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ArticleModelBodyBlocksField = AnchorNavigationRecord | ButtonRecord | CarInspirationListRecord | HeadlineRecord | HtmlInputRecord | InlineimageRecord | NewsletterSignupRecord | SpacerRecord | SubtitleRecord | TableRecord | TitleRecord | YoutubeClipRecord;

export type ArticleModelBodyField = {
  __typename?: 'ArticleModelBodyField';
  blocks: Array<ArticleModelBodyBlocksField>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type ArticleModelBodyFieldMultiLocaleField = {
  __typename?: 'ArticleModelBodyFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<ArticleModelBodyField>;
};

/** Linking fields */
export type ArticleModelFieldsReferencingCategoryModel =
  | 'article_additionalCategories'
  | 'article_mainCategory'
  | 'article_previousCategory';

/** Linking fields */
export type ArticleModelFieldsReferencingStructuredTextTemplateModel =
  | 'article_seoInfoTemplate';

export type ArticleModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ArticleModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ArticleModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  additionalCategories?: InputMaybe<LinksFilter>;
  articleimage?: InputMaybe<FileFilter>;
  body?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  mainCategory?: InputMaybe<LinkFilter>;
  miniatureImage?: InputMaybe<FileFilter>;
  premable?: InputMaybe<TextFilter>;
  previousCategory?: InputMaybe<LinkFilter>;
  seo?: InputMaybe<SeoFilter>;
  seoInfo?: InputMaybe<StructuredTextFilter>;
  seoInfoTemplate?: InputMaybe<LinkFilter>;
  slug?: InputMaybe<SlugFilter>;
  subtitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type ArticleModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type ArticleModelSeoInfoField = {
  __typename?: 'ArticleModelSeoInfoField';
  blocks: Array<SubtitleRecord>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type ArticleModelSeoInfoFieldMultiLocaleField = {
  __typename?: 'ArticleModelSeoInfoFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<ArticleModelSeoInfoField>;
};

/** Record of type 📰 Article (article) */
export type ArticleRecord = RecordInterface & {
  __typename?: 'ArticleRecord';
  _allBodyLocales?: Maybe<Array<ArticleModelBodyFieldMultiLocaleField>>;
  _allNewsletterSignupSectionLocales?: Maybe<Array<NewsletterSignupRecordListListNonNullMultiLocaleField>>;
  _allPremableLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSeoInfoLocales?: Maybe<Array<ArticleModelSeoInfoFieldMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSlugLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSubtitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  additionalCategories: Array<CategoryRecord>;
  articleimage?: Maybe<FileField>;
  body?: Maybe<ArticleModelBodyField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  mainCategory?: Maybe<CategoryRecord>;
  miniatureImage?: Maybe<FileField>;
  newsletterSignupSection: Array<NewsletterSignupRecord>;
  premable?: Maybe<Scalars['String']>;
  previousCategory?: Maybe<CategoryRecord>;
  seo?: Maybe<SeoField>;
  seoInfo?: Maybe<ArticleModelSeoInfoField>;
  seoInfoTemplate?: Maybe<StructuredTextTemplateRecord>;
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type 📰 Article (article) */
export type ArticleRecord_AllBodyLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecord_AllNewsletterSignupSectionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecord_AllPremableLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecord_AllSeoInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecord_AllSlugLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecord_AllSubtitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecordBodyArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecordNewsletterSignupSectionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecordPremableArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecordSeoInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecordSlugArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecordSubtitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📰 Article (article) */
export type ArticleRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Auction Tips model (auction_tips_model) */
export type AuctionTipsModelRecord = RecordInterface & {
  __typename?: 'AuctionTipsModelRecord';
  _allStructuredTextLocales?: Maybe<Array<StructuredTextBlockRecordMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  structuredText?: Maybe<StructuredTextBlockRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Auction Tips model (auction_tips_model) */
export type AuctionTipsModelRecord_AllStructuredTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Auction Tips model (auction_tips_model) */
export type AuctionTipsModelRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Auction Tips model (auction_tips_model) */
export type AuctionTipsModelRecordStructuredTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type BlockButtonModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockButtonModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockButtonModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  backgroundImage?: InputMaybe<FileFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  linkUrl?: InputMaybe<StringFilter>;
  preamble?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type BlockButtonModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'preamble_ASC'
  | 'preamble_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Block Button (block_button) */
export type BlockButtonRecord = RecordInterface & {
  __typename?: 'BlockButtonRecord';
  _allLinkUrlLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPreambleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundImage?: Maybe<FileField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  linkUrl?: Maybe<Scalars['String']>;
  preamble?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Block Button (block_button) */
export type BlockButtonRecord_AllLinkUrlLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Block Button (block_button) */
export type BlockButtonRecord_AllPreambleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Block Button (block_button) */
export type BlockButtonRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Block Button (block_button) */
export type BlockButtonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Block Button (block_button) */
export type BlockButtonRecordLinkUrlArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Block Button (block_button) */
export type BlockButtonRecordPreambleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Block Button (block_button) */
export type BlockButtonRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type BlockButtonRecordListListNonNullMultiLocaleField = {
  __typename?: 'BlockButtonRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<BlockButtonRecord>;
};

/** Block of type BodyText (bodytext) */
export type BodytextRecord = RecordInterface & {
  __typename?: 'BodytextRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  tag?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type BodyText (bodytext) */
export type BodytextRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']>;
};

export type BooleanTypeMultiLocaleField = {
  __typename?: 'BooleanTypeMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<Scalars['BooleanType']>;
};

export type ButtonModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ButtonModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ButtonModelFilter>>>;
  color?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  openLinkInNewWindow?: InputMaybe<BooleanFilter>;
  size?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  variant?: InputMaybe<StringFilter>;
};

export type ButtonModelModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ButtonModelModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ButtonModelModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  color?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  openLinkInNewWindow?: InputMaybe<BooleanFilter>;
  size?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  url?: InputMaybe<StringFilter>;
};

export type ButtonModelModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'color_ASC'
  | 'color_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openLinkInNewWindow_ASC'
  | 'openLinkInNewWindow_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'url_ASC'
  | 'url_DESC';

/** Record of type Button model (button_model) */
export type ButtonModelRecord = RecordInterface & {
  __typename?: 'ButtonModelRecord';
  _allTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allUrlLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  openLinkInNewWindow?: Maybe<Scalars['BooleanType']>;
  size?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Record of type Button model (button_model) */
export type ButtonModelRecord_AllTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Button model (button_model) */
export type ButtonModelRecord_AllUrlLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Button model (button_model) */
export type ButtonModelRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Button model (button_model) */
export type ButtonModelRecordTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Button model (button_model) */
export type ButtonModelRecordUrlArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type ButtonModelRecordListListNonNullMultiLocaleField = {
  __typename?: 'ButtonModelRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<ButtonModelRecord>;
};

export type ButtonModelRecordMultiLocaleField = {
  __typename?: 'ButtonModelRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<ButtonModelRecord>;
};

/** Block of type Button (button) */
export type ButtonRecord = RecordInterface & {
  __typename?: 'ButtonRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  openLinkInNewWindow?: Maybe<Scalars['BooleanType']>;
  size?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};


/** Block of type Button (button) */
export type ButtonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ButtonRecordListListNonNullMultiLocaleField = {
  __typename?: 'ButtonRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<ButtonRecord>;
};

export type ButtonRecordMultiLocaleField = {
  __typename?: 'ButtonRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<ButtonRecord>;
};

/** Block of type Buy Option (buy_option) */
export type BuyOptionRecord = RecordInterface & {
  __typename?: 'BuyOptionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  link?: Maybe<TextLinkRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Buy Option (buy_option) */
export type BuyOptionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export type CarBrandPageModelFieldsReferencingFilterPageModel =
  | 'carBrandPage_filterPage';

/** Linking fields */
export type CarBrandPageModelFieldsReferencingSeoMetaTemplateModel =
  | 'carBrandPage_seoTemplate';

/** Linking fields */
export type CarBrandPageModelFieldsReferencingStringTemplateModel =
  | 'carBrandPage_headingTemplate';

/** Linking fields */
export type CarBrandPageModelFieldsReferencingStructuredTextTemplateModel =
  | 'carBrandPage_familyPreambleTemplate'
  | 'carBrandPage_preambleTemplate'
  | 'carBrandPage_seoInfoTemplate';

export type CarBrandPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CarBrandPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CarBrandPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  familyPreambleTemplate?: InputMaybe<LinkFilter>;
  filterPage?: InputMaybe<LinkFilter>;
  heading?: InputMaybe<StringFilter>;
  headingTag?: InputMaybe<StringFilter>;
  headingTemplate?: InputMaybe<LinkFilter>;
  id?: InputMaybe<ItemIdFilter>;
  logo?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  preamble?: InputMaybe<StructuredTextFilter>;
  preambleTemplate?: InputMaybe<LinkFilter>;
  queryParams?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  seoInfo?: InputMaybe<StructuredTextFilter>;
  seoInfoTemplate?: InputMaybe<LinkFilter>;
  seoTemplate?: InputMaybe<LinkFilter>;
  slug?: InputMaybe<SlugFilter>;
  text?: InputMaybe<StructuredTextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type CarBrandPageModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'headingTag_ASC'
  | 'headingTag_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'queryParams_ASC'
  | 'queryParams_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type CarBrandPageModelPreambleField = {
  __typename?: 'CarBrandPageModelPreambleField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CarBrandPageModelPreambleFieldMultiLocaleField = {
  __typename?: 'CarBrandPageModelPreambleFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CarBrandPageModelPreambleField>;
};

export type CarBrandPageModelSeoInfoField = {
  __typename?: 'CarBrandPageModelSeoInfoField';
  blocks: Array<SubtitleRecord>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CarBrandPageModelSeoInfoFieldMultiLocaleField = {
  __typename?: 'CarBrandPageModelSeoInfoFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CarBrandPageModelSeoInfoField>;
};

export type CarBrandPageModelTextField = {
  __typename?: 'CarBrandPageModelTextField';
  blocks: Array<SubtitleRecord>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CarBrandPageModelTextFieldMultiLocaleField = {
  __typename?: 'CarBrandPageModelTextFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CarBrandPageModelTextField>;
};

/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecord = RecordInterface & {
  __typename?: 'CarBrandPageRecord';
  _allHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPreambleLocales?: Maybe<Array<CarBrandPageModelPreambleFieldMultiLocaleField>>;
  _allReferencingCarFamilyPages: Array<CarFamilyPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCarFamilyPagesMeta: CollectionMetadata;
  _allSeoInfoLocales?: Maybe<Array<CarBrandPageModelSeoInfoFieldMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allTextLocales?: Maybe<Array<CarBrandPageModelTextFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  familyPreambleTemplate?: Maybe<StructuredTextTemplateRecord>;
  filterPage?: Maybe<FilterPageRecord>;
  heading?: Maybe<Scalars['String']>;
  headingTag?: Maybe<Scalars['String']>;
  headingTemplate?: Maybe<StringTemplateRecord>;
  id: Scalars['ItemId'];
  logo?: Maybe<FileField>;
  name?: Maybe<Scalars['String']>;
  preamble?: Maybe<CarBrandPageModelPreambleField>;
  preambleTemplate?: Maybe<StructuredTextTemplateRecord>;
  queryParams?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoField>;
  seoInfo?: Maybe<CarBrandPageModelSeoInfoField>;
  seoInfoTemplate?: Maybe<StructuredTextTemplateRecord>;
  seoTemplate?: Maybe<SeoMetaTemplateRecord>;
  slug?: Maybe<Scalars['String']>;
  text?: Maybe<CarBrandPageModelTextField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecord_AllHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecord_AllPreambleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecord_AllReferencingCarFamilyPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarFamilyPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarFamilyPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarFamilyPageAndCarBrandPage>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecord_AllReferencingCarFamilyPagesMetaArgs = {
  filter?: InputMaybe<CarFamilyPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarFamilyPageAndCarBrandPage>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecord_AllSeoInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecord_AllTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecordHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecordPreambleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecordSeoInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car brand page (car_brand_page) */
export type CarBrandPageRecordTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export type CarCategoryPageModelFieldsReferencingFilterPageModel =
  | 'carCategoryPage_filterPage';

/** Linking fields */
export type CarCategoryPageModelFieldsReferencingSeoMetaTemplateModel =
  | 'carCategoryPage_seoTemplate';

/** Linking fields */
export type CarCategoryPageModelFieldsReferencingStructuredTextTemplateModel =
  | 'carCategoryPage_seoInfoTemplate';

export type CarCategoryPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CarCategoryPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CarCategoryPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  filterPage?: InputMaybe<LinkFilter>;
  heading?: InputMaybe<StringFilter>;
  headingTag?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  preamble?: InputMaybe<StructuredTextFilter>;
  queryParams?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  seoInfo?: InputMaybe<StructuredTextFilter>;
  seoInfoTemplate?: InputMaybe<LinkFilter>;
  seoTemplate?: InputMaybe<LinkFilter>;
  slug?: InputMaybe<SlugFilter>;
  text?: InputMaybe<StructuredTextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type CarCategoryPageModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'headingTag_ASC'
  | 'headingTag_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'queryParams_ASC'
  | 'queryParams_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type CarCategoryPageModelPreambleField = {
  __typename?: 'CarCategoryPageModelPreambleField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CarCategoryPageModelPreambleFieldMultiLocaleField = {
  __typename?: 'CarCategoryPageModelPreambleFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CarCategoryPageModelPreambleField>;
};

export type CarCategoryPageModelSeoInfoField = {
  __typename?: 'CarCategoryPageModelSeoInfoField';
  blocks: Array<SubtitleRecord>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CarCategoryPageModelSeoInfoFieldMultiLocaleField = {
  __typename?: 'CarCategoryPageModelSeoInfoFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CarCategoryPageModelSeoInfoField>;
};

export type CarCategoryPageModelTextBlocksField = CarInspirationListRecord | SubtitleRecord;

export type CarCategoryPageModelTextField = {
  __typename?: 'CarCategoryPageModelTextField';
  blocks: Array<CarCategoryPageModelTextBlocksField>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CarCategoryPageModelTextFieldMultiLocaleField = {
  __typename?: 'CarCategoryPageModelTextFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CarCategoryPageModelTextField>;
};

/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecord = RecordInterface & {
  __typename?: 'CarCategoryPageRecord';
  _allHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNameLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPreambleLocales?: Maybe<Array<CarCategoryPageModelPreambleFieldMultiLocaleField>>;
  _allSeoInfoLocales?: Maybe<Array<CarCategoryPageModelSeoInfoFieldMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSlugLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTextLocales?: Maybe<Array<CarCategoryPageModelTextFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  filterPage?: Maybe<FilterPageRecord>;
  heading?: Maybe<Scalars['String']>;
  headingTag?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  preamble?: Maybe<CarCategoryPageModelPreambleField>;
  queryParams?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoField>;
  seoInfo?: Maybe<CarCategoryPageModelSeoInfoField>;
  seoInfoTemplate?: Maybe<StructuredTextTemplateRecord>;
  seoTemplate?: Maybe<SeoMetaTemplateRecord>;
  slug?: Maybe<Scalars['String']>;
  text?: Maybe<CarCategoryPageModelTextField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecord_AllHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecord_AllNameLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecord_AllPreambleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecord_AllSeoInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecord_AllSlugLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecord_AllTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecordHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecordNameArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecordPreambleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecordSeoInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecordSlugArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car category page (car_category_page) */
export type CarCategoryPageRecordTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export type CarFamilyPageModelFieldsReferencingCarBrandPageModel =
  | 'carFamilyPage_brand';

/** Linking fields */
export type CarFamilyPageModelFieldsReferencingFilterPageModel =
  | 'carFamilyPage_filterPage';

export type CarFamilyPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CarFamilyPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CarFamilyPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  brand?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  displaySeoText?: InputMaybe<BooleanFilter>;
  filterPage?: InputMaybe<LinkFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  preamble?: InputMaybe<StructuredTextFilter>;
  queryParams?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
  text?: InputMaybe<StructuredTextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type CarFamilyPageModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'displaySeoText_ASC'
  | 'displaySeoText_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'queryParams_ASC'
  | 'queryParams_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type CarFamilyPageModelPreambleField = {
  __typename?: 'CarFamilyPageModelPreambleField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CarFamilyPageModelPreambleFieldMultiLocaleField = {
  __typename?: 'CarFamilyPageModelPreambleFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CarFamilyPageModelPreambleField>;
};

export type CarFamilyPageModelTextField = {
  __typename?: 'CarFamilyPageModelTextField';
  blocks: Array<SubtitleRecord>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CarFamilyPageModelTextFieldMultiLocaleField = {
  __typename?: 'CarFamilyPageModelTextFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CarFamilyPageModelTextField>;
};

/** Record of type Car family page (car_family_page) */
export type CarFamilyPageRecord = RecordInterface & {
  __typename?: 'CarFamilyPageRecord';
  _allPreambleLocales?: Maybe<Array<CarFamilyPageModelPreambleFieldMultiLocaleField>>;
  _allSlugLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTextLocales?: Maybe<Array<CarFamilyPageModelTextFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  brand?: Maybe<CarBrandPageRecord>;
  createdAt: Scalars['DateTime'];
  displaySeoText?: Maybe<Scalars['BooleanType']>;
  filterPage?: Maybe<FilterPageRecord>;
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  preamble?: Maybe<CarFamilyPageModelPreambleField>;
  queryParams?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  text?: Maybe<CarFamilyPageModelTextField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Car family page (car_family_page) */
export type CarFamilyPageRecord_AllPreambleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car family page (car_family_page) */
export type CarFamilyPageRecord_AllSlugLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car family page (car_family_page) */
export type CarFamilyPageRecord_AllTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car family page (car_family_page) */
export type CarFamilyPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car family page (car_family_page) */
export type CarFamilyPageRecordPreambleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car family page (car_family_page) */
export type CarFamilyPageRecordSlugArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Car family page (car_family_page) */
export type CarFamilyPageRecordTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Car guide question (car_guide_question) */
export type CarGuideQuestionRecord = RecordInterface & {
  __typename?: 'CarGuideQuestionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  question?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Car guide question (car_guide_question) */
export type CarGuideQuestionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CarGuideQuestionRecordListListNonNullMultiLocaleField = {
  __typename?: 'CarGuideQuestionRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<CarGuideQuestionRecord>;
};

/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecord = RecordInterface & {
  __typename?: 'CarGuideRecord';
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allImageLocales?: Maybe<Array<FileFieldMultiLocaleField>>;
  _allQuestionsLocales?: Maybe<Array<CarGuideQuestionRecordListListNonNullMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allStartButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  questions: Array<CarGuideQuestionRecord>;
  seo?: Maybe<SeoField>;
  startButtonText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecord_AllImageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecord_AllQuestionsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecord_AllStartButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecordImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecordQuestionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecordStartButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🔎 Car guide (car_guide) */
export type CarGuideRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type CarInspirationListModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CarInspirationListModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CarInspirationListModelFilter>>>;
  heading?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  itemsPerSlide?: InputMaybe<JsonFilter>;
  linkText?: InputMaybe<StringFilter>;
  queryString?: InputMaybe<StringFilter>;
};

/** Block of type CarInspirationList (car_inspiration_list) */
export type CarInspirationListRecord = RecordInterface & {
  __typename?: 'CarInspirationListRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  itemsPerSlide?: Maybe<Scalars['JsonField']>;
  linkText?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type CarInspirationList (car_inspiration_list) */
export type CarInspirationListRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Category blurb (category_blurb) */
export type CategoryBlurbRecord = RecordInterface & {
  __typename?: 'CategoryBlurbRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  imageIcon: Array<ImageIconRecord>;
  link?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Category blurb (category_blurb) */
export type CategoryBlurbRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CategoryBlurbRecordListListNonNullMultiLocaleField = {
  __typename?: 'CategoryBlurbRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<CategoryBlurbRecord>;
};

export type CategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<TextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  structuredDescription?: InputMaybe<StructuredTextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type CategoryModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type CategoryModelStructuredDescriptionField = {
  __typename?: 'CategoryModelStructuredDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CategoryModelStructuredDescriptionFieldMultiLocaleField = {
  __typename?: 'CategoryModelStructuredDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CategoryModelStructuredDescriptionField>;
};

/** Linking fields */
export type CategoryOrderModelFieldsReferencingCategoryModel =
  | 'categoryOrder_categories';

/** Linking fields */
export type CategoryOrderModelFieldsReferencingPageModel =
  | 'categoryOrder_page';

export type CategoryOrderModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryOrderModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryOrderModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  categories?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  page?: InputMaybe<LinkFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type CategoryOrderModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Category Order (category_order) */
export type CategoryOrderRecord = RecordInterface & {
  __typename?: 'CategoryOrderRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  categories: Array<CategoryRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  page?: Maybe<PageRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Category Order (category_order) */
export type CategoryOrderRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Category (category) */
export type CategoryRecord = RecordInterface & {
  __typename?: 'CategoryRecord';
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNameLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOptionalHeroLocales?: Maybe<Array<OptionalHeroRecordMultiLocaleField>>;
  _allReferencingArticles: Array<ArticleRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingArticlesMeta: CollectionMetadata;
  _allReferencingCategoryOrders: Array<CategoryOrderRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCategoryOrdersMeta: CollectionMetadata;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSlugLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allStructuredDescriptionLocales?: Maybe<Array<CategoryModelStructuredDescriptionFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  optionalHero?: Maybe<OptionalHeroRecord>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']>;
  structuredDescription?: Maybe<CategoryModelStructuredDescriptionField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Category (category) */
export type CategoryRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Category (category) */
export type CategoryRecord_AllNameLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecord_AllOptionalHeroLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecord_AllReferencingArticlesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ArticleModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ArticleModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenArticleAndCategory>;
};


/** Record of type Category (category) */
export type CategoryRecord_AllReferencingArticlesMetaArgs = {
  filter?: InputMaybe<ArticleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenArticleAndCategory>;
};


/** Record of type Category (category) */
export type CategoryRecord_AllReferencingCategoryOrdersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CategoryOrderModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CategoryOrderModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCategoryOrderAndCategory>;
};


/** Record of type Category (category) */
export type CategoryRecord_AllReferencingCategoryOrdersMetaArgs = {
  filter?: InputMaybe<CategoryOrderModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCategoryOrderAndCategory>;
};


/** Record of type Category (category) */
export type CategoryRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecord_AllSlugLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecord_AllStructuredDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Category (category) */
export type CategoryRecordNameArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecordOptionalHeroArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecordSlugArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Category (category) */
export type CategoryRecordStructuredDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type CheckoutConfirmationModelCarDealerPaymentInformationTextField = {
  __typename?: 'CheckoutConfirmationModelCarDealerPaymentInformationTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Checkout Confirmation (checkout_confirmation) */
export type CheckoutConfirmationRecord = RecordInterface & {
  __typename?: 'CheckoutConfirmationRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  carDealerPaymentInformationText?: Maybe<CheckoutConfirmationModelCarDealerPaymentInformationTextField>;
  carDealerPaymentInformationTitle?: Maybe<Scalars['String']>;
  checkoutType?: Maybe<Scalars['String']>;
  confirmationSteps: Array<CheckoutConfirmationStepRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  paymentButtonText?: Maybe<Scalars['String']>;
  paymentExplanation?: Maybe<Scalars['String']>;
  paymentInformation?: Maybe<Scalars['String']>;
  paymentTitle?: Maybe<Scalars['String']>;
  reservation?: Maybe<Scalars['String']>;
  reservationNotFirstInLine?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalPriceTitle?: Maybe<Scalars['String']>;
  transportTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  whatHappensNow?: Maybe<Scalars['String']>;
  yourOrder?: Maybe<Scalars['String']>;
};


/** Block of type Checkout Confirmation (checkout_confirmation) */
export type CheckoutConfirmationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CheckoutConfirmationRecordListListNonNullMultiLocaleField = {
  __typename?: 'CheckoutConfirmationRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<CheckoutConfirmationRecord>;
};

/** Block of type Checkout confirmation step (checkout_confirmation_step) */
export type CheckoutConfirmationStepRecord = RecordInterface & {
  __typename?: 'CheckoutConfirmationStepRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Checkout confirmation step (checkout_confirmation_step) */
export type CheckoutConfirmationStepRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CheckoutModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CheckoutModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CheckoutModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  acceptBuyerTransferPolicyText?: InputMaybe<StringFilter>;
  acceptDeliveryPolicyText?: InputMaybe<StringFilter>;
  acceptPickupPolicyText?: InputMaybe<StringFilter>;
  acceptPolicyLinkText?: InputMaybe<StringFilter>;
  acceptPolicyText?: InputMaybe<StringFilter>;
  acceptSitePolicyLinkText?: InputMaybe<StringFilter>;
  auctionDescription?: InputMaybe<StringFilter>;
  auctionTitle?: InputMaybe<StringFilter>;
  checkoutFlow?: InputMaybe<StringFilter>;
  closedDescription?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  finalAuctionSubmitButtonText?: InputMaybe<StringFilter>;
  finalInformationText?: InputMaybe<StringFilter>;
  finalSubmitButtonText?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  policyCompany?: InputMaybe<LinkFilter>;
  policyPrivate?: InputMaybe<LinkFilter>;
  policySite?: InputMaybe<LinkFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type CheckoutModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'acceptBuyerTransferPolicyText_ASC'
  | 'acceptBuyerTransferPolicyText_DESC'
  | 'acceptDeliveryPolicyText_ASC'
  | 'acceptDeliveryPolicyText_DESC'
  | 'acceptPickupPolicyText_ASC'
  | 'acceptPickupPolicyText_DESC'
  | 'acceptPolicyLinkText_ASC'
  | 'acceptPolicyLinkText_DESC'
  | 'acceptPolicyText_ASC'
  | 'acceptPolicyText_DESC'
  | 'acceptSitePolicyLinkText_ASC'
  | 'acceptSitePolicyLinkText_DESC'
  | 'auctionDescription_ASC'
  | 'auctionDescription_DESC'
  | 'auctionTitle_ASC'
  | 'auctionTitle_DESC'
  | 'checkoutFlow_ASC'
  | 'checkoutFlow_DESC'
  | 'closedDescription_ASC'
  | 'closedDescription_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'finalAuctionSubmitButtonText_ASC'
  | 'finalAuctionSubmitButtonText_DESC'
  | 'finalInformationText_ASC'
  | 'finalInformationText_DESC'
  | 'finalSubmitButtonText_ASC'
  | 'finalSubmitButtonText_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord = RecordInterface & {
  __typename?: 'CheckoutRecord';
  _allAcceptBuyerTransferPolicyTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allAcceptDeliveryPolicyTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allAcceptPickupPolicyTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allAcceptPolicyLinkTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allAcceptPolicyTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allAcceptSitePolicyLinkTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allAuctionDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allAuctionTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allClosedDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allConfirmationDataLocales?: Maybe<Array<CheckoutConfirmationRecordListListNonNullMultiLocaleField>>;
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFinalAuctionSubmitButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFinalInformationTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFinalSubmitButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allStepsDeliveryLocales?: Maybe<Array<CheckoutStepRecordMultiLocaleField>>;
  _allStepsFinancingLocales?: Maybe<Array<CheckoutStepRecordMultiLocaleField>>;
  _allStepsOwnerDetailsLocales?: Maybe<Array<CheckoutStepRecordMultiLocaleField>>;
  _allStepsSummaryLocales?: Maybe<Array<CheckoutStepRecordMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  acceptBuyerTransferPolicyText?: Maybe<Scalars['String']>;
  acceptDeliveryPolicyText?: Maybe<Scalars['String']>;
  acceptPickupPolicyText?: Maybe<Scalars['String']>;
  acceptPolicyLinkText?: Maybe<Scalars['String']>;
  acceptPolicyText?: Maybe<Scalars['String']>;
  acceptSitePolicyLinkText?: Maybe<Scalars['String']>;
  auctionDescription?: Maybe<Scalars['String']>;
  auctionTitle?: Maybe<Scalars['String']>;
  checkoutFlow?: Maybe<Scalars['String']>;
  closedDescription?: Maybe<Scalars['String']>;
  confirmationData: Array<CheckoutConfirmationRecord>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  finalAuctionSubmitButtonText?: Maybe<Scalars['String']>;
  finalInformationText?: Maybe<Scalars['String']>;
  finalSubmitButtonText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  policyCompany?: Maybe<StructuredTextRecord>;
  policyPrivate?: Maybe<StructuredTextRecord>;
  policySite?: Maybe<StructuredTextRecord>;
  stepsDelivery?: Maybe<CheckoutStepRecord>;
  stepsFinancing?: Maybe<CheckoutStepRecord>;
  stepsOwnerDetails?: Maybe<CheckoutStepRecord>;
  stepsSummary?: Maybe<CheckoutStepRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllAcceptBuyerTransferPolicyTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllAcceptDeliveryPolicyTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllAcceptPickupPolicyTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllAcceptPolicyLinkTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllAcceptPolicyTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllAcceptSitePolicyLinkTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllAuctionDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllAuctionTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllClosedDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllConfirmationDataLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllFinalAuctionSubmitButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllFinalInformationTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllFinalSubmitButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllStepsDeliveryLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllStepsFinancingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllStepsOwnerDetailsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllStepsSummaryLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordAcceptBuyerTransferPolicyTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordAcceptDeliveryPolicyTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordAcceptPickupPolicyTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordAcceptPolicyLinkTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordAcceptPolicyTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordAcceptSitePolicyLinkTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordAuctionDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordAuctionTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordClosedDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordConfirmationDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordFinalAuctionSubmitButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordFinalInformationTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordFinalSubmitButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordStepsDeliveryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordStepsFinancingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordStepsOwnerDetailsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordStepsSummaryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🛒 Checkout (checkout) */
export type CheckoutRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Checkout step delivery common (checkout_step_delivery_common) */
export type CheckoutStepDeliveryCommonRecord = RecordInterface & {
  __typename?: 'CheckoutStepDeliveryCommonRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  deliveryMethodTitle?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  personIdentificationTitle?: Maybe<Scalars['String']>;
  pickUpMethodTitle?: Maybe<Scalars['String']>;
  pickupMethodInformation?: Maybe<Scalars['String']>;
  pickupTimeTitle?: Maybe<Scalars['String']>;
  timePickerText?: Maybe<Scalars['String']>;
  timePickerTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vehicleLocation?: Maybe<Scalars['String']>;
};


/** Block of type Checkout step delivery common (checkout_step_delivery_common) */
export type CheckoutStepDeliveryCommonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CheckoutStepFinancingCommonModelLoanWarningField = {
  __typename?: 'CheckoutStepFinancingCommonModelLoanWarningField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CheckoutStepFinancingCommonModelServiceAgreementFullDescriptionField = {
  __typename?: 'CheckoutStepFinancingCommonModelServiceAgreementFullDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CheckoutStepFinancingCommonModelWarrantyExtendedInfoField = {
  __typename?: 'CheckoutStepFinancingCommonModelWarrantyExtendedInfoField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Checkout step financing common (checkout_step_financing_common) */
export type CheckoutStepFinancingCommonRecord = RecordInterface & {
  __typename?: 'CheckoutStepFinancingCommonRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  carToSellCheckboxLabel?: Maybe<Scalars['String']>;
  carToSellDescription?: Maybe<Scalars['String']>;
  carToSellTitle?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  featuredWarranty: Array<FeaturedWarrantyRecord>;
  id: Scalars['ItemId'];
  insuranceDescription?: Maybe<Scalars['String']>;
  insuranceTitle?: Maybe<Scalars['String']>;
  labelCash?: Maybe<Scalars['String']>;
  labelLoan?: Maybe<Scalars['String']>;
  loanSellingPoint?: Maybe<Scalars['String']>;
  loanWarning?: Maybe<CheckoutStepFinancingCommonModelLoanWarningField>;
  requestedFinancingLabel?: Maybe<Scalars['String']>;
  serviceAgreementCheckboxLabel?: Maybe<Scalars['String']>;
  serviceAgreementDescription?: Maybe<Scalars['String']>;
  serviceAgreementFullDescription?: Maybe<CheckoutStepFinancingCommonModelServiceAgreementFullDescriptionField>;
  serviceAgreementTitle?: Maybe<Scalars['String']>;
  servicesTitle?: Maybe<Scalars['String']>;
  tireDescription?: Maybe<Scalars['String']>;
  tireTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  warrantyDescription?: Maybe<Scalars['String']>;
  warrantyDescriptionAuction?: Maybe<Scalars['String']>;
  warrantyDescriptionFixedPrice?: Maybe<Scalars['String']>;
  warrantyExtendedInfo?: Maybe<CheckoutStepFinancingCommonModelWarrantyExtendedInfoField>;
  warrantyTitle?: Maybe<Scalars['String']>;
};


/** Block of type Checkout step financing common (checkout_step_financing_common) */
export type CheckoutStepFinancingCommonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CheckoutStepModelDetailsField = CheckoutStepDeliveryCommonRecord | CheckoutStepFinancingCommonRecord | CheckoutStepOwnerDetailsCarDealerRecord | CheckoutStepSummaryCommonRecord;

export type CheckoutStepOwnerDetailsCarDealerModelInformationTextField = {
  __typename?: 'CheckoutStepOwnerDetailsCarDealerModelInformationTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Checkout step owner details Car dealer (checkout_step_owner_details_car_dealer) */
export type CheckoutStepOwnerDetailsCarDealerRecord = RecordInterface & {
  __typename?: 'CheckoutStepOwnerDetailsCarDealerRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  buyerTransferInformationText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  informationText?: Maybe<CheckoutStepOwnerDetailsCarDealerModelInformationTextField>;
  informationTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Checkout step owner details Car dealer (checkout_step_owner_details_car_dealer) */
export type CheckoutStepOwnerDetailsCarDealerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Checkout step (checkout_step) */
export type CheckoutStepRecord = RecordInterface & {
  __typename?: 'CheckoutStepRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  details?: Maybe<CheckoutStepModelDetailsField>;
  id: Scalars['ItemId'];
  nextButtonText?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Checkout step (checkout_step) */
export type CheckoutStepRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CheckoutStepRecordMultiLocaleField = {
  __typename?: 'CheckoutStepRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CheckoutStepRecord>;
};

/** Block of type Checkout step summary common (checkout_step_summary_common) */
export type CheckoutStepSummaryCommonRecord = RecordInterface & {
  __typename?: 'CheckoutStepSummaryCommonRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  totalPriceTitle?: Maybe<Scalars['String']>;
  transportTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vatText?: Maybe<Scalars['String']>;
};


/** Block of type Checkout step summary common (checkout_step_summary_common) */
export type CheckoutStepSummaryCommonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  count: Scalars['IntType'];
};

export type ColorBucketType =
  | 'black'
  | 'blue'
  | 'brown'
  | 'cyan'
  | 'green'
  | 'grey'
  | 'orange'
  | 'pink'
  | 'purple'
  | 'red'
  | 'white'
  | 'yellow';

export type ColorField = {
  __typename?: 'ColorField';
  alpha: Scalars['IntType'];
  blue: Scalars['IntType'];
  cssRgb: Scalars['String'];
  green: Scalars['IntType'];
  hex: Scalars['String'];
  red: Scalars['IntType'];
};

/** Specifies how to filter Color fields */
export type ColorFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

export type CompanyCampaignCarguideModelTextField = {
  __typename?: 'CompanyCampaignCarguideModelTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Company campaign: Carguide (company_campaign_carguide) */
export type CompanyCampaignCarguideRecord = RecordInterface & {
  __typename?: 'CompanyCampaignCarguideRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  button?: Maybe<ButtonRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  preTitle?: Maybe<Scalars['String']>;
  text?: Maybe<CompanyCampaignCarguideModelTextField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Company campaign: Carguide (company_campaign_carguide) */
export type CompanyCampaignCarguideRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CompanyCampaignExistingCustomerPageModelContactFormNewsletterLabelField = {
  __typename?: 'CompanyCampaignExistingCustomerPageModelContactFormNewsletterLabelField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignExistingCustomerPageModelContactFormNewsletterLabelFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignExistingCustomerPageModelContactFormNewsletterLabelFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignExistingCustomerPageModelContactFormNewsletterLabelField>;
};

export type CompanyCampaignExistingCustomerPageModelContactFormSectionDescriptionField = {
  __typename?: 'CompanyCampaignExistingCustomerPageModelContactFormSectionDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignExistingCustomerPageModelContactFormSectionDescriptionFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignExistingCustomerPageModelContactFormSectionDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignExistingCustomerPageModelContactFormSectionDescriptionField>;
};

export type CompanyCampaignExistingCustomerPageModelContactFormSuccessField = {
  __typename?: 'CompanyCampaignExistingCustomerPageModelContactFormSuccessField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignExistingCustomerPageModelContactFormSuccessFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignExistingCustomerPageModelContactFormSuccessFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignExistingCustomerPageModelContactFormSuccessField>;
};

export type CompanyCampaignExistingCustomerPageModelFleetValCompDisclaimerField = {
  __typename?: 'CompanyCampaignExistingCustomerPageModelFleetValCompDisclaimerField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignExistingCustomerPageModelFleetValCompDisclaimerFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignExistingCustomerPageModelFleetValCompDisclaimerFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignExistingCustomerPageModelFleetValCompDisclaimerField>;
};

export type CompanyCampaignExistingCustomerPageModelModularSectionsField = CompanyCampaignCarguideRecord | CompanyCampaignFleetManagerRecord | CompanyCampaignNewsletterRecord | CompanyCampaignReasonsBlockRecord | CompanyCampaignStatsBlockRecord | SmallFeatureCardsBlockRecord;

export type CompanyCampaignExistingCustomerPageModelModularSectionsFieldListListNonNullMultiLocaleField = {
  __typename?: 'CompanyCampaignExistingCustomerPageModelModularSectionsFieldListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<CompanyCampaignExistingCustomerPageModelModularSectionsField>;
};

/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord = RecordInterface & {
  __typename?: 'CompanyCampaignExistingCustomerPageRecord';
  _allContactFormBtnTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactFormNewsletterLabelLocales?: Maybe<Array<CompanyCampaignExistingCustomerPageModelContactFormNewsletterLabelFieldMultiLocaleField>>;
  _allContactFormSectionDescriptionLocales?: Maybe<Array<CompanyCampaignExistingCustomerPageModelContactFormSectionDescriptionFieldMultiLocaleField>>;
  _allContactFormSectionTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactFormSuccessLocales?: Maybe<Array<CompanyCampaignExistingCustomerPageModelContactFormSuccessFieldMultiLocaleField>>;
  _allContactFormTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompAverageValuationDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompDealerValuationDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompDealerValuationTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompDisclaimerLocales?: Maybe<Array<CompanyCampaignExistingCustomerPageModelFleetValCompDisclaimerFieldMultiLocaleField>>;
  _allFleetValCompKvdValuationDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompKvdValuationTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompResultDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompResultTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompTotalVehiclesInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeroFormBtnTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeroFormTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeroLocales?: Maybe<Array<OptionalHeroRecordMultiLocaleField>>;
  _allModularSectionsLocales?: Maybe<Array<CompanyCampaignExistingCustomerPageModelModularSectionsFieldListListNonNullMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  contactFormBtnText?: Maybe<Scalars['String']>;
  contactFormNewsletterLabel?: Maybe<CompanyCampaignExistingCustomerPageModelContactFormNewsletterLabelField>;
  contactFormSectionDescription?: Maybe<CompanyCampaignExistingCustomerPageModelContactFormSectionDescriptionField>;
  contactFormSectionTitle?: Maybe<Scalars['String']>;
  contactFormSuccess?: Maybe<CompanyCampaignExistingCustomerPageModelContactFormSuccessField>;
  contactFormTitle?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fleetValCompAverageProfitPerCar?: Maybe<Scalars['IntType']>;
  fleetValCompAverageValuationDescription?: Maybe<Scalars['String']>;
  fleetValCompDealerAverageValuation?: Maybe<Scalars['IntType']>;
  fleetValCompDealerValuationDescription?: Maybe<Scalars['String']>;
  fleetValCompDealerValuationTitle?: Maybe<Scalars['String']>;
  fleetValCompDisclaimer?: Maybe<CompanyCampaignExistingCustomerPageModelFleetValCompDisclaimerField>;
  fleetValCompKvdAverageValuation?: Maybe<Scalars['IntType']>;
  fleetValCompKvdValuationDescription?: Maybe<Scalars['String']>;
  fleetValCompKvdValuationTitle?: Maybe<Scalars['String']>;
  fleetValCompResultDescription?: Maybe<Scalars['String']>;
  fleetValCompResultTitle?: Maybe<Scalars['String']>;
  fleetValCompTitle?: Maybe<Scalars['String']>;
  fleetValCompTotalVehiclesInfo?: Maybe<Scalars['String']>;
  hero?: Maybe<OptionalHeroRecord>;
  heroFormBtnText?: Maybe<Scalars['String']>;
  heroFormTitle?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  modularSections: Array<CompanyCampaignExistingCustomerPageModelModularSectionsField>;
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllContactFormBtnTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllContactFormNewsletterLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllContactFormSectionDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllContactFormSectionTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllContactFormSuccessLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllContactFormTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompAverageValuationDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompDealerValuationDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompDealerValuationTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompDisclaimerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompKvdValuationDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompKvdValuationTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompResultDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompResultTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllFleetValCompTotalVehiclesInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllHeroFormBtnTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllHeroFormTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllHeroLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllModularSectionsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordContactFormBtnTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordContactFormNewsletterLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordContactFormSectionDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordContactFormSectionTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordContactFormSuccessArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordContactFormTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompAverageValuationDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompDealerValuationDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompDealerValuationTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompDisclaimerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompKvdValuationDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompKvdValuationTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompResultDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompResultTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordFleetValCompTotalVehiclesInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordHeroArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordHeroFormBtnTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordHeroFormTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordModularSectionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign existing customer page (company_campaign_existing_customer_page) */
export type CompanyCampaignExistingCustomerPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type CompanyCampaignFleetManagerModelBulletPointsField = {
  __typename?: 'CompanyCampaignFleetManagerModelBulletPointsField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Company campaign: Fleet manager (company_campaign_fleet_manager) */
export type CompanyCampaignFleetManagerRecord = RecordInterface & {
  __typename?: 'CompanyCampaignFleetManagerRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bulletPoints?: Maybe<CompanyCampaignFleetManagerModelBulletPointsField>;
  button?: Maybe<ButtonRecord>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  youtubeVideo?: Maybe<YoutubeClipRecord>;
};


/** Block of type Company campaign: Fleet manager (company_campaign_fleet_manager) */
export type CompanyCampaignFleetManagerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Company campaign: Fleet manager (company_campaign_fleet_manager) */
export type CompanyCampaignFleetManagerRecordDescriptionArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

/** Block of type Company campaign: Newsletter (company_campaign_newsletter) */
export type CompanyCampaignNewsletterRecord = RecordInterface & {
  __typename?: 'CompanyCampaignNewsletterRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  newsletter?: Maybe<NewsletterSignupRecord>;
  socialMedia?: Maybe<TextIconRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Company campaign: Newsletter (company_campaign_newsletter) */
export type CompanyCampaignNewsletterRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CompanyCampaignPageModelContactFormNewsletterLabelField = {
  __typename?: 'CompanyCampaignPageModelContactFormNewsletterLabelField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignPageModelContactFormNewsletterLabelFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelContactFormNewsletterLabelFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignPageModelContactFormNewsletterLabelField>;
};

export type CompanyCampaignPageModelContactFormSectionDescriptionField = {
  __typename?: 'CompanyCampaignPageModelContactFormSectionDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignPageModelContactFormSectionDescriptionFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelContactFormSectionDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignPageModelContactFormSectionDescriptionField>;
};

export type CompanyCampaignPageModelContactFormSuccessField = {
  __typename?: 'CompanyCampaignPageModelContactFormSuccessField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignPageModelContactFormSuccessFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelContactFormSuccessFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignPageModelContactFormSuccessField>;
};

export type CompanyCampaignPageModelFleetValCompDisclaimerField = {
  __typename?: 'CompanyCampaignPageModelFleetValCompDisclaimerField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignPageModelFleetValCompDisclaimerFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelFleetValCompDisclaimerFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignPageModelFleetValCompDisclaimerField>;
};

export type CompanyCampaignPageModelFleetValReportDisclaimerField = {
  __typename?: 'CompanyCampaignPageModelFleetValReportDisclaimerField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignPageModelFleetValReportDisclaimerFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelFleetValReportDisclaimerFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignPageModelFleetValReportDisclaimerField>;
};

export type CompanyCampaignPageModelFleetValReportExpiredMessageField = {
  __typename?: 'CompanyCampaignPageModelFleetValReportExpiredMessageField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignPageModelFleetValReportExpiredMessageFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelFleetValReportExpiredMessageFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignPageModelFleetValReportExpiredMessageField>;
};

export type CompanyCampaignPageModelFleetValReportProcessingMessageField = {
  __typename?: 'CompanyCampaignPageModelFleetValReportProcessingMessageField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignPageModelFleetValReportProcessingMessageFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelFleetValReportProcessingMessageFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignPageModelFleetValReportProcessingMessageField>;
};

export type CompanyCampaignPageModelFleetValReportRecommendationTextField = {
  __typename?: 'CompanyCampaignPageModelFleetValReportRecommendationTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignPageModelFleetValReportRecommendationTextFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelFleetValReportRecommendationTextFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignPageModelFleetValReportRecommendationTextField>;
};

export type CompanyCampaignPageModelHeroFormSuccessField = {
  __typename?: 'CompanyCampaignPageModelHeroFormSuccessField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type CompanyCampaignPageModelHeroFormSuccessFieldMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelHeroFormSuccessFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<CompanyCampaignPageModelHeroFormSuccessField>;
};

export type CompanyCampaignPageModelModularSectionsField = CompanyCampaignCarguideRecord | CompanyCampaignFleetManagerRecord | CompanyCampaignNewsletterRecord | CompanyCampaignReasonsBlockRecord | CompanyCampaignStatsBlockRecord | SmallFeatureCardsBlockRecord;

export type CompanyCampaignPageModelModularSectionsFieldListListNonNullMultiLocaleField = {
  __typename?: 'CompanyCampaignPageModelModularSectionsFieldListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<CompanyCampaignPageModelModularSectionsField>;
};

/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord = RecordInterface & {
  __typename?: 'CompanyCampaignPageRecord';
  _allContactFormBtnTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactFormNewsletterLabelLocales?: Maybe<Array<CompanyCampaignPageModelContactFormNewsletterLabelFieldMultiLocaleField>>;
  _allContactFormSectionDescriptionLocales?: Maybe<Array<CompanyCampaignPageModelContactFormSectionDescriptionFieldMultiLocaleField>>;
  _allContactFormSectionTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactFormSuccessLocales?: Maybe<Array<CompanyCampaignPageModelContactFormSuccessFieldMultiLocaleField>>;
  _allContactFormTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompAverageValuationDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompDealerAverageValuationDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompDealerValuationDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompDealerValuationTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompDisclaimerLocales?: Maybe<Array<CompanyCampaignPageModelFleetValCompDisclaimerFieldMultiLocaleField>>;
  _allFleetValCompKvdAverageValuationDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompKvdValuationDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompKvdValuationTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompResultDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompResultTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompTotalVehiclesInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompUsp1Locales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompUsp2Locales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValCompUsp3Locales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportAgeDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportAgeRecommendedLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportAgeTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportDealerDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportDealerTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportDisclaimerLocales?: Maybe<Array<CompanyCampaignPageModelFleetValReportDisclaimerFieldMultiLocaleField>>;
  _allFleetValReportExpiredMessageLocales?: Maybe<Array<CompanyCampaignPageModelFleetValReportExpiredMessageFieldMultiLocaleField>>;
  _allFleetValReportFormDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportFormTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportFuelDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportFuelTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportInsightsTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportKvdDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportKvdTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportMakeModelDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportMakeModelMoreInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportMakeModelTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportProcessingMessageLocales?: Maybe<Array<CompanyCampaignPageModelFleetValReportProcessingMessageFieldMultiLocaleField>>;
  _allFleetValReportRecommendationTextLocales?: Maybe<Array<CompanyCampaignPageModelFleetValReportRecommendationTextFieldMultiLocaleField>>;
  _allFleetValReportRecommendationTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportResultDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportResultTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFleetValReportVehicleCountTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeroFormBtnTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeroFormDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeroFormSuccessLocales?: Maybe<Array<CompanyCampaignPageModelHeroFormSuccessFieldMultiLocaleField>>;
  _allHeroFormTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeroLocales?: Maybe<Array<OptionalHeroRecordMultiLocaleField>>;
  _allModularSectionsLocales?: Maybe<Array<CompanyCampaignPageModelModularSectionsFieldListListNonNullMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  contactFormBtnText?: Maybe<Scalars['String']>;
  contactFormNewsletterLabel?: Maybe<CompanyCampaignPageModelContactFormNewsletterLabelField>;
  contactFormSectionDescription?: Maybe<CompanyCampaignPageModelContactFormSectionDescriptionField>;
  contactFormSectionTitle?: Maybe<Scalars['String']>;
  contactFormSuccess?: Maybe<CompanyCampaignPageModelContactFormSuccessField>;
  contactFormTitle?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fleetValCompAverageProfitPerCar?: Maybe<Scalars['IntType']>;
  fleetValCompAverageValuationDescription?: Maybe<Scalars['String']>;
  fleetValCompDealerAverageValuation?: Maybe<Scalars['IntType']>;
  fleetValCompDealerAverageValuationDescription?: Maybe<Scalars['String']>;
  fleetValCompDealerValuationDescription?: Maybe<Scalars['String']>;
  fleetValCompDealerValuationTitle?: Maybe<Scalars['String']>;
  fleetValCompDisclaimer?: Maybe<CompanyCampaignPageModelFleetValCompDisclaimerField>;
  fleetValCompKvdAverageValuation?: Maybe<Scalars['IntType']>;
  fleetValCompKvdAverageValuationDescription?: Maybe<Scalars['String']>;
  fleetValCompKvdValuationDescription?: Maybe<Scalars['String']>;
  fleetValCompKvdValuationTitle?: Maybe<Scalars['String']>;
  fleetValCompResultDescription?: Maybe<Scalars['String']>;
  fleetValCompResultTitle?: Maybe<Scalars['String']>;
  fleetValCompTitle?: Maybe<Scalars['String']>;
  fleetValCompTotalVehiclesInfo?: Maybe<Scalars['String']>;
  fleetValCompUsp1?: Maybe<Scalars['String']>;
  fleetValCompUsp2?: Maybe<Scalars['String']>;
  fleetValCompUsp3?: Maybe<Scalars['String']>;
  fleetValReportAgeDescription?: Maybe<Scalars['String']>;
  fleetValReportAgeRecommendedLabel?: Maybe<Scalars['String']>;
  fleetValReportAgeTitle?: Maybe<Scalars['String']>;
  fleetValReportDealerDescription?: Maybe<Scalars['String']>;
  fleetValReportDealerTitle?: Maybe<Scalars['String']>;
  fleetValReportDisclaimer?: Maybe<CompanyCampaignPageModelFleetValReportDisclaimerField>;
  fleetValReportExpiredMessage?: Maybe<CompanyCampaignPageModelFleetValReportExpiredMessageField>;
  fleetValReportFormDescription?: Maybe<Scalars['String']>;
  fleetValReportFormTitle?: Maybe<Scalars['String']>;
  fleetValReportFuelDescription?: Maybe<Scalars['String']>;
  fleetValReportFuelTitle?: Maybe<Scalars['String']>;
  fleetValReportInsightsTitle?: Maybe<Scalars['String']>;
  fleetValReportKvdDescription?: Maybe<Scalars['String']>;
  fleetValReportKvdTitle?: Maybe<Scalars['String']>;
  fleetValReportMakeModelDescription?: Maybe<Scalars['String']>;
  fleetValReportMakeModelMoreInfo?: Maybe<Scalars['String']>;
  fleetValReportMakeModelTitle?: Maybe<Scalars['String']>;
  fleetValReportProcessingMessage?: Maybe<CompanyCampaignPageModelFleetValReportProcessingMessageField>;
  fleetValReportRecommendationText?: Maybe<CompanyCampaignPageModelFleetValReportRecommendationTextField>;
  fleetValReportRecommendationTitle?: Maybe<Scalars['String']>;
  fleetValReportResultDescription?: Maybe<Scalars['String']>;
  fleetValReportResultTitle?: Maybe<Scalars['String']>;
  fleetValReportTitle?: Maybe<Scalars['String']>;
  fleetValReportVehicleCountText?: Maybe<Scalars['String']>;
  hero?: Maybe<OptionalHeroRecord>;
  heroFormBtnText?: Maybe<Scalars['String']>;
  heroFormDescription?: Maybe<Scalars['String']>;
  heroFormSuccess?: Maybe<CompanyCampaignPageModelHeroFormSuccessField>;
  heroFormTitle?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  modularSections: Array<CompanyCampaignPageModelModularSectionsField>;
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllContactFormBtnTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllContactFormNewsletterLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllContactFormSectionDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllContactFormSectionTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllContactFormSuccessLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllContactFormTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompAverageValuationDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompDealerAverageValuationDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompDealerValuationDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompDealerValuationTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompDisclaimerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompKvdAverageValuationDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompKvdValuationDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompKvdValuationTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompResultDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompResultTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompTotalVehiclesInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompUsp1LocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompUsp2LocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValCompUsp3LocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportAgeDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportAgeRecommendedLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportAgeTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportDealerDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportDealerTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportDisclaimerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportExpiredMessageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportFormDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportFormTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportFuelDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportFuelTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportInsightsTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportKvdDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportKvdTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportMakeModelDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportMakeModelMoreInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportMakeModelTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportProcessingMessageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportRecommendationTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportRecommendationTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportResultDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportResultTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllFleetValReportVehicleCountTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllHeroFormBtnTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllHeroFormDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllHeroFormSuccessLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllHeroFormTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllHeroLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllModularSectionsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordContactFormBtnTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordContactFormNewsletterLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordContactFormSectionDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordContactFormSectionTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordContactFormSuccessArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordContactFormTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompAverageValuationDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompDealerAverageValuationDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompDealerValuationDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompDealerValuationTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompDisclaimerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompKvdAverageValuationDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompKvdValuationDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompKvdValuationTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompResultDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompResultTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompTotalVehiclesInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompUsp1Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompUsp2Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValCompUsp3Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportAgeDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportAgeRecommendedLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportAgeTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportDealerDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportDealerTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportDisclaimerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportExpiredMessageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportFormDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportFormTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportFuelDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportFuelTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportInsightsTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportKvdDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportKvdTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportMakeModelDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportMakeModelMoreInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportMakeModelTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportProcessingMessageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportRecommendationTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportRecommendationTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportResultDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportResultTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordFleetValReportVehicleCountTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordHeroArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordHeroFormBtnTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordHeroFormDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordHeroFormSuccessArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordHeroFormTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordModularSectionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Company campaign page (company_campaign_page) */
export type CompanyCampaignPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Company campaign: Reasons (company_campaign_reasons_block) */
export type CompanyCampaignReasonsBlockRecord = RecordInterface & {
  __typename?: 'CompanyCampaignReasonsBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  button?: Maybe<ButtonRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  reasons: Array<DescriptionRecord>;
  testimonials: Array<TestimonialQuoteRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Company campaign: Reasons (company_campaign_reasons_block) */
export type CompanyCampaignReasonsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Company campaign: Stats (company_campaign_stats_block) */
export type CompanyCampaignStatsBlockRecord = RecordInterface & {
  __typename?: 'CompanyCampaignStatsBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  statOne?: Maybe<Scalars['String']>;
  statThree?: Maybe<Scalars['String']>;
  statTwo?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Company campaign: Stats (company_campaign_stats_block) */
export type CompanyCampaignStatsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ConditionInfoModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ConditionInfoModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ConditionInfoModelFilter>>>;
  answer?: InputMaybe<TextFilter>;
  conditionStep?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
};

/** Specify nested blocks fields conditions */
export type ConditionInfoModelModelConditionInfoFieldBlocksConditions = {
  conditionInfo?: InputMaybe<ConditionInfoModelFilter>;
};

/** Specify nested blocks types presence */
export type ConditionInfoModelModelConditionInfoFieldBlocksPresence = {
  conditionInfo?: InputMaybe<Scalars['BooleanType']>;
};

/** Specify how to filter this specific Modular Content field instance */
export type ConditionInfoModelModelConditionInfoFieldFilter = {
  /** Filter records containing at least one block matching the specified conditions. All the conditions for a block model must match the same block */
  any?: InputMaybe<ConditionInfoModelModelConditionInfoFieldBlocksConditions>;
  /** Filter records containing at least one block of specified type or not */
  containsAny?: InputMaybe<ConditionInfoModelModelConditionInfoFieldBlocksPresence>;
  /** Filter records containing at least one block of any kind or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

export type ConditionInfoModelModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ConditionInfoModelModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ConditionInfoModelModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  conditionInfo?: InputMaybe<ConditionInfoModelModelConditionInfoFieldFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  key?: InputMaybe<StringFilter>;
  question?: InputMaybe<TextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type ConditionInfoModelModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'key_ASC'
  | 'key_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Test condition Info model (condition_info_model) */
export type ConditionInfoModelRecord = RecordInterface & {
  __typename?: 'ConditionInfoModelRecord';
  _allConditionInfoLocales?: Maybe<Array<ConditionInfoRecordListListNonNullMultiLocaleField>>;
  _allQuestionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  conditionInfo: Array<ConditionInfoRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  key?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Test condition Info model (condition_info_model) */
export type ConditionInfoModelRecord_AllConditionInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Test condition Info model (condition_info_model) */
export type ConditionInfoModelRecord_AllQuestionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Test condition Info model (condition_info_model) */
export type ConditionInfoModelRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Test condition Info model (condition_info_model) */
export type ConditionInfoModelRecordConditionInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Test condition Info model (condition_info_model) */
export type ConditionInfoModelRecordQuestionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};

/** Block of type Test condition info (condition_info) */
export type ConditionInfoRecord = RecordInterface & {
  __typename?: 'ConditionInfoRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  answer?: Maybe<Scalars['String']>;
  conditionStep?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Test condition info (condition_info) */
export type ConditionInfoRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Test condition info (condition_info) */
export type ConditionInfoRecordAnswerArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type ConditionInfoRecordListListNonNullMultiLocaleField = {
  __typename?: 'ConditionInfoRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<ConditionInfoRecord>;
};

/** Block of type Contact Button (contact_button) */
export type ContactButtonRecord = RecordInterface & {
  __typename?: 'ContactButtonRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  href?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Contact Button (contact_button) */
export type ContactButtonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ContactCardsBlockModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContactCardsBlockModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContactCardsBlockModelFilter>>>;
  fullWidth?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<ItemIdFilter>;
};

export type ContactCardsBlockModelItemsField = ContactDepartmentCardRecord | ContactPersonCardRecord;

/** Block of type Contact Cards (contact_cards_block) */
export type ContactCardsBlockRecord = RecordInterface & {
  __typename?: 'ContactCardsBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  fullWidth?: Maybe<Scalars['BooleanType']>;
  id: Scalars['ItemId'];
  items: Array<ContactCardsBlockModelItemsField>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Contact Cards (contact_cards_block) */
export type ContactCardsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Contact Department Card (contact_department_card) */
export type ContactDepartmentCardRecord = RecordInterface & {
  __typename?: 'ContactDepartmentCardRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  extraDescriptiveLine?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  showDetailedOpeningHours?: Maybe<Scalars['BooleanType']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Contact Department Card (contact_department_card) */
export type ContactDepartmentCardRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Contact Person Card (contact_person_card) */
export type ContactPersonCardRecord = RecordInterface & {
  __typename?: 'ContactPersonCardRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  extraDescriptiveLine?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePage?: Maybe<DynamicPageRecord>;
  role?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Contact Person Card (contact_person_card) */
export type ContactPersonCardRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Contact Section (contact_section) */
export type ContactSectionRecord = RecordInterface & {
  __typename?: 'ContactSectionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  buttons: Array<ContactButtonRecord>;
  createdAt: Scalars['DateTime'];
  days?: Maybe<Scalars['String']>;
  extraInfo?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Contact Section (contact_section) */
export type ContactSectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ContactSectionRecordListListNonNullMultiLocaleField = {
  __typename?: 'ContactSectionRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<ContactSectionRecord>;
};

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** Block of type Custom Meta (custom_meta_model) */
export type CustomMetaModelRecord = RecordInterface & {
  __typename?: 'CustomMetaModelRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  attrName?: Maybe<Scalars['String']>;
  attrValue?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Custom Meta (custom_meta_model) */
export type CustomMetaModelRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter DateTime fields */
export type DateTimeFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** Block of type Description (description) */
export type DescriptionRecord = RecordInterface & {
  __typename?: 'DescriptionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  descriptionBodyText?: Maybe<Scalars['String']>;
  descriptionTitle?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  imageIcon?: Maybe<ImageIconRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Description (description) */
export type DescriptionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Description (description) */
export type DescriptionRecordDescriptionBodyTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionRecordListListNonNullMultiLocaleField = {
  __typename?: 'DescriptionRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<DescriptionRecord>;
};

/** Block of type Dynamic Form Choice Field (dynamic_form_choice_field) */
export type DynamicFormChoiceFieldRecord = RecordInterface & {
  __typename?: 'DynamicFormChoiceFieldRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  followUpQuestionBackendKey?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  label?: Maybe<Scalars['String']>;
  selectedByDefault?: Maybe<Scalars['BooleanType']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Dynamic Form Choice Field (dynamic_form_choice_field) */
export type DynamicFormChoiceFieldRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type DynamicFormChoiceFieldRecordListListNonNullMultiLocaleField = {
  __typename?: 'DynamicFormChoiceFieldRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<DynamicFormChoiceFieldRecord>;
};

/** Block of type Dynamic Form Likert Scale Option (dynamic_form_likert_scale_option) */
export type DynamicFormLikertScaleOptionRecord = RecordInterface & {
  __typename?: 'DynamicFormLikertScaleOptionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  label?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Dynamic Form Likert Scale Option (dynamic_form_likert_scale_option) */
export type DynamicFormLikertScaleOptionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type DynamicFormLikertScaleOptionRecordListListNonNullMultiLocaleField = {
  __typename?: 'DynamicFormLikertScaleOptionRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<DynamicFormLikertScaleOptionRecord>;
};

/** Block of type Dynamic Form Likert Statement (dynamic_form_likert_statement) */
export type DynamicFormLikertStatementRecord = RecordInterface & {
  __typename?: 'DynamicFormLikertStatementRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  label?: Maybe<Scalars['String']>;
  statementKey?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Dynamic Form Likert Statement (dynamic_form_likert_statement) */
export type DynamicFormLikertStatementRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type DynamicFormLikertStatementRecordListListNonNullMultiLocaleField = {
  __typename?: 'DynamicFormLikertStatementRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<DynamicFormLikertStatementRecord>;
};

export type DynamicPageCustomElementModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DynamicPageCustomElementModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DynamicPageCustomElementModelFilter>>>;
  id?: InputMaybe<ItemIdFilter>;
  usageType?: InputMaybe<StringFilter>;
};

/** Block of type Dynamic page custom element (dynamic_page_custom_element) */
export type DynamicPageCustomElementRecord = RecordInterface & {
  __typename?: 'DynamicPageCustomElementRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
  usageType?: Maybe<Scalars['String']>;
};


/** Block of type Dynamic page custom element (dynamic_page_custom_element) */
export type DynamicPageCustomElementRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type DynamicPageFormModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DynamicPageFormModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DynamicPageFormModelFilter>>>;
  description?: InputMaybe<TextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  sendButton?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  usageType?: InputMaybe<StringFilter>;
};

/** Block of type Dynamic page form (dynamic_page_form) */
export type DynamicPageFormRecord = RecordInterface & {
  __typename?: 'DynamicPageFormRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  isActive?: Maybe<Scalars['BooleanType']>;
  sendButton?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usageType?: Maybe<Scalars['String']>;
};


/** Block of type Dynamic page form (dynamic_page_form) */
export type DynamicPageFormRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Dynamic page form (dynamic_page_form) */
export type DynamicPageFormRecordDescriptionArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type DynamicPageModelBodyBlocksField = AnchorNavigationRecord | ButtonRecord | CarInspirationListRecord | ContactCardsBlockRecord | DynamicPageCustomElementRecord | DynamicPageFormRecord | DynamicPageValuationFormRecord | FaqSectionBlockRecord | FeaturedBlocksBlockRecord | InlineimageRecord | LeasingPartnerNavigationRecord | LeasingPartnerPresentationRecord | SpacerRecord | TableRecord | TextGridRecord | TextSectionRecord | TextTabsBlockRecord | YoutubeClipRecord;

export type DynamicPageModelBodyField = {
  __typename?: 'DynamicPageModelBodyField';
  blocks: Array<DynamicPageModelBodyBlocksField>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<DynamicPageModelBodyLinksField>;
  value: Scalars['JsonField'];
};

/** Specify nested blocks fields conditions */
export type DynamicPageModelBodyFieldBlocksConditions = {
  anchorNavigation?: InputMaybe<AnchorNavigationModelFilter>;
  button?: InputMaybe<ButtonModelFilter>;
  carInspirationList?: InputMaybe<CarInspirationListModelFilter>;
  contactCardsBlock?: InputMaybe<ContactCardsBlockModelFilter>;
  dynamicPageCustomElement?: InputMaybe<DynamicPageCustomElementModelFilter>;
  dynamicPageForm?: InputMaybe<DynamicPageFormModelFilter>;
  dynamicPageValuationForm?: InputMaybe<DynamicPageValuationFormModelFilter>;
  faqSectionBlock?: InputMaybe<FaqSectionBlockModelFilter>;
  featuredBlocksBlock?: InputMaybe<FeaturedBlocksBlockModelFilter>;
  inlineimage?: InputMaybe<InlineimageModelFilter>;
  leasingPartnerNavigation?: InputMaybe<LeasingPartnerNavigationModelFilter>;
  leasingPartnerPresentation?: InputMaybe<LeasingPartnerPresentationModelFilter>;
  spacer?: InputMaybe<SpacerModelFilter>;
  table?: InputMaybe<TableModelFilter>;
  textGrid?: InputMaybe<TextGridModelFilter>;
  textSection?: InputMaybe<TextSectionModelFilter>;
  textTabsBlock?: InputMaybe<TextTabsBlockModelFilter>;
  youtubeClip?: InputMaybe<YoutubeClipModelFilter>;
};

/** Specify how to filter based on this field's blocks */
export type DynamicPageModelBodyFieldBlocksFilter = {
  /** Filter records containing at least one block matching the specified conditions. All the conditions for a block model must match the same block */
  any?: InputMaybe<DynamicPageModelBodyFieldBlocksConditions>;
  /** Filter records containing at least one block of specified type or not */
  containsAny?: InputMaybe<DynamicPageModelBodyFieldBlocksPresence>;
  /** Filter records containing at least one block of any kind or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

/** Specify nested blocks types presence */
export type DynamicPageModelBodyFieldBlocksPresence = {
  anchorNavigation?: InputMaybe<Scalars['BooleanType']>;
  button?: InputMaybe<Scalars['BooleanType']>;
  carInspirationList?: InputMaybe<Scalars['BooleanType']>;
  contactCardsBlock?: InputMaybe<Scalars['BooleanType']>;
  dynamicPageCustomElement?: InputMaybe<Scalars['BooleanType']>;
  dynamicPageForm?: InputMaybe<Scalars['BooleanType']>;
  dynamicPageValuationForm?: InputMaybe<Scalars['BooleanType']>;
  faqSectionBlock?: InputMaybe<Scalars['BooleanType']>;
  featuredBlocksBlock?: InputMaybe<Scalars['BooleanType']>;
  inlineimage?: InputMaybe<Scalars['BooleanType']>;
  leasingPartnerNavigation?: InputMaybe<Scalars['BooleanType']>;
  leasingPartnerPresentation?: InputMaybe<Scalars['BooleanType']>;
  spacer?: InputMaybe<Scalars['BooleanType']>;
  table?: InputMaybe<Scalars['BooleanType']>;
  textGrid?: InputMaybe<Scalars['BooleanType']>;
  textSection?: InputMaybe<Scalars['BooleanType']>;
  textTabsBlock?: InputMaybe<Scalars['BooleanType']>;
  youtubeClip?: InputMaybe<Scalars['BooleanType']>;
};

/** Specify how to filter this specific Structured Text field instance */
export type DynamicPageModelBodyFieldFilter = {
  /** Filter records based on this field blocks */
  blocks?: InputMaybe<DynamicPageModelBodyFieldBlocksFilter>;
  /** Filter records based on this field value */
  value?: InputMaybe<StructuredTextFilter>;
};

export type DynamicPageModelBodyFieldMultiLocaleField = {
  __typename?: 'DynamicPageModelBodyFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<DynamicPageModelBodyField>;
};

export type DynamicPageModelBodyLinksField = ButtonModelRecord | FormRecord;

/** Linking fields */
export type DynamicPageModelFieldsReferencingDynamicPageModel =
  | 'dynamicPage_body'
  | 'dynamicPage_body__contactCardsBlock_items__contactPersonCard_profilePage'
  | 'dynamicPage_body__textGrid_columns__textColumn_body__contactCardsBlock_items__contactPersonCard_profilePage'
  | 'dynamicPage_body__textSection_body__contactCardsBlock_items__contactPersonCard_profilePage'
  | 'dynamicPage_body__textSection_body__textGrid_columns__textColumn_body__contactCardsBlock_items__contactPersonCard_profilePage'
  | 'dynamicPage_body__textSection_body__textTabsBlock_tabs__textTab_body__textGrid_columns__textColumn_body__contactCardsBlock_items__contactPersonCard_profilePage'
  | 'dynamicPage_body__textTabsBlock_tabs__textTab_body__textGrid_columns__textColumn_body__contactCardsBlock_items__contactPersonCard_profilePage';

export type DynamicPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DynamicPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DynamicPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  body?: InputMaybe<DynamicPageModelBodyFieldFilter>;
  bodyBackgroundColor?: InputMaybe<StringFilter>;
  bodyContentBackgroundColor?: InputMaybe<StringFilter>;
  bodyContentBorderColor?: InputMaybe<StringFilter>;
  bodyContentMaxWidth?: InputMaybe<IntegerFilter>;
  bodyContentPadding?: InputMaybe<StringFilter>;
  bodyContentTextAlign?: InputMaybe<StringFilter>;
  bodyInnerContentMaxWidth?: InputMaybe<IntegerFilter>;
  bodyPaddingBottom?: InputMaybe<IntegerFilter>;
  bodyPaddingTop?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  hero?: InputMaybe<DynamicPageModelHeroFieldFilter>;
  id?: InputMaybe<ItemIdFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  shouldIndex?: InputMaybe<BooleanFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

/** Specify nested blocks fields conditions */
export type DynamicPageModelHeroFieldBlocksConditions = {
  optionalHero?: InputMaybe<OptionalHeroModelFilter>;
};

/** Specify nested blocks types presence */
export type DynamicPageModelHeroFieldBlocksPresence = {
  optionalHero?: InputMaybe<Scalars['BooleanType']>;
};

/** Specify how to filter this specific Modular Content field instance */
export type DynamicPageModelHeroFieldFilter = {
  /** Filter records containing at least one block matching the specified conditions */
  any?: InputMaybe<DynamicPageModelHeroFieldBlocksConditions>;
  /** Filter records containing at least one block of specified type or not */
  containsAny?: InputMaybe<DynamicPageModelHeroFieldBlocksPresence>;
  /** Filter records containing at least one block of any kind or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

export type DynamicPageModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'bodyBackgroundColor_ASC'
  | 'bodyBackgroundColor_DESC'
  | 'bodyContentBackgroundColor_ASC'
  | 'bodyContentBackgroundColor_DESC'
  | 'bodyContentBorderColor_ASC'
  | 'bodyContentBorderColor_DESC'
  | 'bodyContentMaxWidth_ASC'
  | 'bodyContentMaxWidth_DESC'
  | 'bodyContentPadding_ASC'
  | 'bodyContentPadding_DESC'
  | 'bodyContentTextAlign_ASC'
  | 'bodyContentTextAlign_DESC'
  | 'bodyInnerContentMaxWidth_ASC'
  | 'bodyInnerContentMaxWidth_DESC'
  | 'bodyPaddingBottom_ASC'
  | 'bodyPaddingBottom_DESC'
  | 'bodyPaddingTop_ASC'
  | 'bodyPaddingTop_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'isActive_ASC'
  | 'isActive_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldIndex_ASC'
  | 'shouldIndex_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecord = RecordInterface & {
  __typename?: 'DynamicPageRecord';
  _allBodyLocales?: Maybe<Array<DynamicPageModelBodyFieldMultiLocaleField>>;
  _allHeroLocales?: Maybe<Array<OptionalHeroRecordMultiLocaleField>>;
  _allReferencingDynamicPages: Array<DynamicPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingDynamicPagesMeta: CollectionMetadata;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSlugLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  body?: Maybe<DynamicPageModelBodyField>;
  bodyBackgroundColor?: Maybe<Scalars['String']>;
  bodyContentBackgroundColor?: Maybe<Scalars['String']>;
  bodyContentBorderColor?: Maybe<Scalars['String']>;
  bodyContentMaxWidth?: Maybe<Scalars['IntType']>;
  bodyContentPadding?: Maybe<Scalars['String']>;
  bodyContentTextAlign?: Maybe<Scalars['String']>;
  bodyInnerContentMaxWidth?: Maybe<Scalars['IntType']>;
  bodyPaddingBottom?: Maybe<Scalars['IntType']>;
  bodyPaddingTop?: Maybe<Scalars['IntType']>;
  createdAt: Scalars['DateTime'];
  hero?: Maybe<OptionalHeroRecord>;
  id: Scalars['ItemId'];
  isActive?: Maybe<Scalars['BooleanType']>;
  name?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoField>;
  shouldIndex?: Maybe<Scalars['BooleanType']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecord_AllBodyLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecord_AllHeroLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecord_AllReferencingDynamicPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<DynamicPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<DynamicPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenDynamicPageAndDynamicPage>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecord_AllReferencingDynamicPagesMetaArgs = {
  filter?: InputMaybe<DynamicPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenDynamicPageAndDynamicPage>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecord_AllSlugLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecordBodyArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecordHeroArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌀 Dynamic page (dynamic_page) */
export type DynamicPageRecordSlugArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type DynamicPageValuationFormModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DynamicPageValuationFormModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DynamicPageValuationFormModelFilter>>>;
  formHeading?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  imageAfter?: InputMaybe<FileFilter>;
  imageAnimation?: InputMaybe<FileFilter>;
  imageBefore?: InputMaybe<FileFilter>;
  subtitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

/** Block of type Dynamic page valuation form (dynamic_page_valuation_form) */
export type DynamicPageValuationFormRecord = RecordInterface & {
  __typename?: 'DynamicPageValuationFormRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  formHeading?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  imageAfter?: Maybe<FileField>;
  imageAnimation?: Maybe<FileField>;
  imageBefore?: Maybe<FileField>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Dynamic page valuation form (dynamic_page_valuation_form) */
export type DynamicPageValuationFormRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord = RecordInterface & {
  __typename?: 'EmailSubscriptionManagementRecord';
  _allProfileSettingsDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allProfileSettingsTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSubscriptionsLocales?: Maybe<Array<EmailSubscriptionRecordListListNonNullMultiLocaleField>>;
  _allUnsubscribeDoneConfirmationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allUnsubscribeDoneTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allUnsubscribeFooterLinkTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allUnsubscribeFooterTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allUnsubscribeInProgresTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allUnsubscribeShowMoreLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allUnsubscribeSubscriptionListDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  profileSettingsDescription?: Maybe<Scalars['String']>;
  profileSettingsTitle?: Maybe<Scalars['String']>;
  subscriptions: Array<EmailSubscriptionRecord>;
  unsubscribeDoneConfirmation?: Maybe<Scalars['String']>;
  unsubscribeDoneTitle?: Maybe<Scalars['String']>;
  unsubscribeFooterLinkText?: Maybe<Scalars['String']>;
  unsubscribeFooterText?: Maybe<Scalars['String']>;
  unsubscribeInProgresTitle?: Maybe<Scalars['String']>;
  unsubscribeShowMore?: Maybe<Scalars['String']>;
  unsubscribeSubscriptionListDescription?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllProfileSettingsDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllProfileSettingsTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllSubscriptionsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllUnsubscribeDoneConfirmationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllUnsubscribeDoneTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllUnsubscribeFooterLinkTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllUnsubscribeFooterTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllUnsubscribeInProgresTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllUnsubscribeShowMoreLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_AllUnsubscribeSubscriptionListDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordProfileSettingsDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordProfileSettingsTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordSubscriptionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordUnsubscribeDoneConfirmationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordUnsubscribeDoneTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordUnsubscribeFooterLinkTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordUnsubscribeFooterTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordUnsubscribeInProgresTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordUnsubscribeShowMoreArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Email subscription management (email_subscription_management) */
export type EmailSubscriptionManagementRecordUnsubscribeSubscriptionListDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Email Subscription (email_subscription) */
export type EmailSubscriptionRecord = RecordInterface & {
  __typename?: 'EmailSubscriptionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  checkboxDescription?: Maybe<Scalars['String']>;
  checkboxLabel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  isActive?: Maybe<Scalars['BooleanType']>;
  subscriptionType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Email Subscription (email_subscription) */
export type EmailSubscriptionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type EmailSubscriptionRecordListListNonNullMultiLocaleField = {
  __typename?: 'EmailSubscriptionRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<EmailSubscriptionRecord>;
};

export type FacilityModelDeliveryField = {
  __typename?: 'FacilityModelDeliveryField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FacilityModelDeliveryFieldMultiLocaleField = {
  __typename?: 'FacilityModelDeliveryFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FacilityModelDeliveryField>;
};

export type FacilityModelDirectionsField = {
  __typename?: 'FacilityModelDirectionsField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FacilityModelDirectionsFieldMultiLocaleField = {
  __typename?: 'FacilityModelDirectionsFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FacilityModelDirectionsField>;
};

export type FacilityModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FacilityModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FacilityModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  customMapLink?: InputMaybe<StringFilter>;
  dbId?: InputMaybe<StringFilter>;
  delivery?: InputMaybe<StructuredTextFilter>;
  directions?: InputMaybe<StructuredTextFilter>;
  fax?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  latitude?: InputMaybe<FloatFilter>;
  longitude?: InputMaybe<FloatFilter>;
  paymentOptions?: InputMaybe<StructuredTextFilter>;
  phone?: InputMaybe<StringFilter>;
  pickup?: InputMaybe<StructuredTextFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<StringFilter>;
  streetAddress?: InputMaybe<StringFilter>;
  testDrive?: InputMaybe<StructuredTextFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  zipCode?: InputMaybe<StringFilter>;
};

export type FacilityModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'city_ASC'
  | 'city_DESC'
  | 'country_ASC'
  | 'country_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'customMapLink_ASC'
  | 'customMapLink_DESC'
  | 'dbId_ASC'
  | 'dbId_DESC'
  | 'fax_ASC'
  | 'fax_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'latitude_ASC'
  | 'latitude_DESC'
  | 'longitude_ASC'
  | 'longitude_DESC'
  | 'phone_ASC'
  | 'phone_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'streetAddress_ASC'
  | 'streetAddress_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'zipCode_ASC'
  | 'zipCode_DESC';

export type FacilityModelPaymentOptionsField = {
  __typename?: 'FacilityModelPaymentOptionsField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FacilityModelPaymentOptionsFieldMultiLocaleField = {
  __typename?: 'FacilityModelPaymentOptionsFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FacilityModelPaymentOptionsField>;
};

export type FacilityModelPickupField = {
  __typename?: 'FacilityModelPickupField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FacilityModelPickupFieldMultiLocaleField = {
  __typename?: 'FacilityModelPickupFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FacilityModelPickupField>;
};

export type FacilityModelTestDriveField = {
  __typename?: 'FacilityModelTestDriveField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FacilityModelTestDriveFieldMultiLocaleField = {
  __typename?: 'FacilityModelTestDriveFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FacilityModelTestDriveField>;
};

/** Record of type 🏭 Facility (facility) */
export type FacilityRecord = RecordInterface & {
  __typename?: 'FacilityRecord';
  _allCountryLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allDeliveryLocales?: Maybe<Array<FacilityModelDeliveryFieldMultiLocaleField>>;
  _allDirectionsLocales?: Maybe<Array<FacilityModelDirectionsFieldMultiLocaleField>>;
  _allFaxLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPaymentOptionsLocales?: Maybe<Array<FacilityModelPaymentOptionsFieldMultiLocaleField>>;
  _allPhoneLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPickupLocales?: Maybe<Array<FacilityModelPickupFieldMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allTestDriveLocales?: Maybe<Array<FacilityModelTestDriveFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customMapLink?: Maybe<Scalars['String']>;
  dbId?: Maybe<Scalars['String']>;
  delivery?: Maybe<FacilityModelDeliveryField>;
  directions?: Maybe<FacilityModelDirectionsField>;
  fax?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  latitude?: Maybe<Scalars['FloatType']>;
  longitude?: Maybe<Scalars['FloatType']>;
  paymentOptions?: Maybe<FacilityModelPaymentOptionsField>;
  phone?: Maybe<Scalars['String']>;
  pickup?: Maybe<FacilityModelPickupField>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  testDrive?: Maybe<FacilityModelTestDriveField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zipCode?: Maybe<Scalars['String']>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_AllCountryLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_AllDeliveryLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_AllDirectionsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_AllFaxLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_AllPaymentOptionsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_AllPhoneLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_AllPickupLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_AllTestDriveLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecordCountryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecordDeliveryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecordDirectionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecordFaxArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecordPaymentOptionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecordPhoneArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecordPickupArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🏭 Facility (facility) */
export type FacilityRecordTestDriveArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type FAQ category block (faq_category_block) */
export type FaqCategoryBlockRecord = RecordInterface & {
  __typename?: 'FaqCategoryBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  icon?: Maybe<FileField>;
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  questions: Array<FaqQuestionNewRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type FAQ category block (faq_category_block) */
export type FaqCategoryBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FaqCategoryBlockRecordListListNonNullMultiLocaleField = {
  __typename?: 'FaqCategoryBlockRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<FaqCategoryBlockRecord>;
};

export type FaqModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  faqId?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  subtitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type FaqModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'faqId_ASC'
  | 'faqId_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type FaqQuestionNewModelAnswerBlocksField = TableRecord | YoutubeClipRecord;

export type FaqQuestionNewModelAnswerField = {
  __typename?: 'FaqQuestionNewModelAnswerField';
  blocks: Array<FaqQuestionNewModelAnswerBlocksField>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FaqQuestionNewModelAnswerFieldMultiLocaleField = {
  __typename?: 'FaqQuestionNewModelAnswerFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FaqQuestionNewModelAnswerField>;
};

export type FaqQuestionNewModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqQuestionNewModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqQuestionNewModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  answer?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  question?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type FaqQuestionNewModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'question_ASC'
  | 'question_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type ❔ FAQ question new (faq_question_new) */
export type FaqQuestionNewRecord = RecordInterface & {
  __typename?: 'FaqQuestionNewRecord';
  _allAnswerLocales?: Maybe<Array<FaqQuestionNewModelAnswerFieldMultiLocaleField>>;
  _allQuestionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSlugLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  answer?: Maybe<FaqQuestionNewModelAnswerField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  question?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type ❔ FAQ question new (faq_question_new) */
export type FaqQuestionNewRecord_AllAnswerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❔ FAQ question new (faq_question_new) */
export type FaqQuestionNewRecord_AllQuestionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❔ FAQ question new (faq_question_new) */
export type FaqQuestionNewRecord_AllSlugLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❔ FAQ question new (faq_question_new) */
export type FaqQuestionNewRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❔ FAQ question new (faq_question_new) */
export type FaqQuestionNewRecordAnswerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❔ FAQ question new (faq_question_new) */
export type FaqQuestionNewRecordQuestionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❔ FAQ question new (faq_question_new) */
export type FaqQuestionNewRecordSlugArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FaqQuestionNewRecordListListNonNullMultiLocaleField = {
  __typename?: 'FaqQuestionNewRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<FaqQuestionNewRecord>;
};

/** Record of type ❓ FAQ (faq) */
export type FaqRecord = RecordInterface & {
  __typename?: 'FaqRecord';
  _allCategoriesLocales?: Maybe<Array<FaqCategoryBlockRecordListListNonNullMultiLocaleField>>;
  _allSubtitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  categories: Array<FaqCategoryBlockRecord>;
  createdAt: Scalars['DateTime'];
  faqId?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type ❓ FAQ (faq) */
export type FaqRecord_AllCategoriesLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❓ FAQ (faq) */
export type FaqRecord_AllSubtitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❓ FAQ (faq) */
export type FaqRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❓ FAQ (faq) */
export type FaqRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❓ FAQ (faq) */
export type FaqRecordCategoriesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❓ FAQ (faq) */
export type FaqRecordSubtitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❓ FAQ (faq) */
export type FaqRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FaqSectionBlockModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqSectionBlockModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqSectionBlockModelFilter>>>;
  footerText?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  ingress?: InputMaybe<StringFilter>;
  questions?: InputMaybe<LinksFilter>;
  title?: InputMaybe<StringFilter>;
};

/** Block of type FAQ Section Block (faq_section_block) */
export type FaqSectionBlockRecord = RecordInterface & {
  __typename?: 'FaqSectionBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  footerLink?: Maybe<TextLinkRecord>;
  footerText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  ingress?: Maybe<Scalars['String']>;
  questions: Array<FaqQuestionNewRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type FAQ Section Block (faq_section_block) */
export type FaqSectionBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FaviconType =
  | 'appleTouchIcon'
  | 'icon'
  | 'msApplication';

export type FeaturedBlocksBlockModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeaturedBlocksBlockModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeaturedBlocksBlockModelFilter>>>;
  blockButtons?: InputMaybe<LinksFilter>;
  id?: InputMaybe<ItemIdFilter>;
};

/** Block of type Featured blocks (featured_blocks_block) */
export type FeaturedBlocksBlockRecord = RecordInterface & {
  __typename?: 'FeaturedBlocksBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  blockButtons: Array<BlockButtonRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Featured blocks (featured_blocks_block) */
export type FeaturedBlocksBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Featured Card Dep (featured_card_dep) */
export type FeaturedCardDepRecord = RecordInterface & {
  __typename?: 'FeaturedCardDepRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  buttons: Array<ButtonRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  titleWithText: Array<TitleWithTextRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Featured Card Dep (featured_card_dep) */
export type FeaturedCardDepRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FeaturedCardModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeaturedCardModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeaturedCardModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  buttons?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type FeaturedCardModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecord = RecordInterface & {
  __typename?: 'FeaturedCardRecord';
  _allButtonsLocales?: Maybe<Array<ButtonModelRecordListListNonNullMultiLocaleField>>;
  _allImageLocales?: Maybe<Array<FileFieldMultiLocaleField>>;
  _allNameLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTitleWithTextLocales?: Maybe<Array<TitleWithTextRecordListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  buttons: Array<ButtonModelRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  name?: Maybe<Scalars['String']>;
  titleWithText: Array<TitleWithTextRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecord_AllButtonsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecord_AllImageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecord_AllNameLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecord_AllTitleWithTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecordButtonsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecordImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecordNameArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Card (featured_card) */
export type FeaturedCardRecordTitleWithTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FeaturedCardRecordListListNonNullMultiLocaleField = {
  __typename?: 'FeaturedCardRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<FeaturedCardRecord>;
};

export type FeaturedCardRecordMultiLocaleField = {
  __typename?: 'FeaturedCardRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FeaturedCardRecord>;
};

export type FeaturedObjectModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeaturedObjectModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeaturedObjectModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  heading?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  linkText?: InputMaybe<StringFilter>;
  queryString?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type FeaturedObjectModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'queryString_ASC'
  | 'queryString_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Featured Object (featured_object) */
export type FeaturedObjectRecord = RecordInterface & {
  __typename?: 'FeaturedObjectRecord';
  _allHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLinkTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allQueryStringLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  linkText?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Featured Object (featured_object) */
export type FeaturedObjectRecord_AllHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Object (featured_object) */
export type FeaturedObjectRecord_AllLinkTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Object (featured_object) */
export type FeaturedObjectRecord_AllQueryStringLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Object (featured_object) */
export type FeaturedObjectRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Object (featured_object) */
export type FeaturedObjectRecordHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Object (featured_object) */
export type FeaturedObjectRecordLinkTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Featured Object (featured_object) */
export type FeaturedObjectRecordQueryStringArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FeaturedObjectRecordListListNonNullMultiLocaleField = {
  __typename?: 'FeaturedObjectRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<FeaturedObjectRecord>;
};

/** Block of type Featured warranty (featured_warranty) */
export type FeaturedWarrantyRecord = RecordInterface & {
  __typename?: 'FeaturedWarrantyRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  checkoutType?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  featuredPeriod?: Maybe<Scalars['IntType']>;
  featuredText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Featured warranty (featured_warranty) */
export type FeaturedWarrantyRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FileField = FileFieldInterface & {
  __typename?: 'FileField';
  _createdAt: Scalars['DateTime'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl?: Maybe<Scalars['String']>;
  _updatedAt: Scalars['DateTime'];
  alt?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  basename: Scalars['String'];
  blurUpThumb?: Maybe<Scalars['String']>;
  blurhash?: Maybe<Scalars['String']>;
  colors: Array<ColorField>;
  copyright?: Maybe<Scalars['String']>;
  customData: Scalars['CustomData'];
  exifInfo: Scalars['CustomData'];
  filename: Scalars['String'];
  focalPoint?: Maybe<FocalPoint>;
  format: Scalars['String'];
  height?: Maybe<Scalars['IntType']>;
  id: Scalars['UploadId'];
  md5: Scalars['String'];
  mimeType: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  responsiveImage?: Maybe<ResponsiveImage>;
  size: Scalars['IntType'];
  smartTags: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  thumbhash?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  video?: Maybe<UploadVideoField>;
  width?: Maybe<Scalars['IntType']>;
};


export type FileFieldAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float'];
  quality?: Scalars['Int'];
  size?: Scalars['Int'];
};


export type FileFieldCustomDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldFocalPointArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldResponsiveImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  imgixParams?: InputMaybe<ImgixParams>;
  locale?: InputMaybe<SiteLocale>;
  sizes?: InputMaybe<Scalars['String']>;
};


export type FileFieldTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldUrlArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
};

export type FileFieldInterface = {
  _createdAt: Scalars['DateTime'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl?: Maybe<Scalars['String']>;
  _updatedAt: Scalars['DateTime'];
  alt?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  basename: Scalars['String'];
  blurUpThumb?: Maybe<Scalars['String']>;
  blurhash?: Maybe<Scalars['String']>;
  colors: Array<ColorField>;
  copyright?: Maybe<Scalars['String']>;
  customData: Scalars['CustomData'];
  exifInfo: Scalars['CustomData'];
  filename: Scalars['String'];
  focalPoint?: Maybe<FocalPoint>;
  format: Scalars['String'];
  height?: Maybe<Scalars['IntType']>;
  id: Scalars['UploadId'];
  md5: Scalars['String'];
  mimeType: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  responsiveImage?: Maybe<ResponsiveImage>;
  size: Scalars['IntType'];
  smartTags: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  thumbhash?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  video?: Maybe<UploadVideoField>;
  width?: Maybe<Scalars['IntType']>;
};


export type FileFieldInterfaceAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float'];
  quality?: Scalars['Int'];
  size?: Scalars['Int'];
};


export type FileFieldInterfaceCustomDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceFocalPointArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceResponsiveImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  imgixParams?: InputMaybe<ImgixParams>;
  locale?: InputMaybe<SiteLocale>;
  sizes?: InputMaybe<Scalars['String']>;
};


export type FileFieldInterfaceTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceUrlArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
};

export type FileFieldMultiLocaleField = {
  __typename?: 'FileFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FileField>;
};

/** Specifies how to filter Single-file/image fields */
export type FileFilter = {
  /** Search for records with an exact match. The specified value must be an Upload ID */
  eq?: InputMaybe<Scalars['UploadId']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records that have one of the specified uploads */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
  /** Exclude records with an exact match. The specified value must be an Upload ID */
  neq?: InputMaybe<Scalars['UploadId']>;
  /** Filter records that do not have one of the specified uploads */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
};

export type FilterCardTooltipModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FilterCardTooltipModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FilterCardTooltipModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  condition?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  infoText?: InputMaybe<TextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type FilterCardTooltipModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'condition_ASC'
  | 'condition_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Filter card tooltip (filter_card_tooltip) */
export type FilterCardTooltipRecord = RecordInterface & {
  __typename?: 'FilterCardTooltipRecord';
  _allInfoTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  condition?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  infoText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Filter card tooltip (filter_card_tooltip) */
export type FilterCardTooltipRecord_AllInfoTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Filter card tooltip (filter_card_tooltip) */
export type FilterCardTooltipRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter card tooltip (filter_card_tooltip) */
export type FilterCardTooltipRecordInfoTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCardTooltipRecordListListNonNullMultiLocaleField = {
  __typename?: 'FilterCardTooltipRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<FilterCardTooltipRecord>;
};

export type FilterPageModelDescriptionField = {
  __typename?: 'FilterPageModelDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FilterPageModelDescriptionFieldMultiLocaleField = {
  __typename?: 'FilterPageModelDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FilterPageModelDescriptionField>;
};

export type FilterPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FilterPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FilterPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  cardTooltip?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  mainCategory?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  seoInformation?: InputMaybe<StructuredTextFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type FilterPageModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'mainCategory_ASC'
  | 'mainCategory_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type FilterPageModelSeoInformationBlocksField = SubtitleRecord | TitleRecord;

export type FilterPageModelSeoInformationField = {
  __typename?: 'FilterPageModelSeoInformationField';
  blocks: Array<FilterPageModelSeoInformationBlocksField>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FilterPageModelSeoInformationFieldMultiLocaleField = {
  __typename?: 'FilterPageModelSeoInformationFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FilterPageModelSeoInformationField>;
};

/** Record of type Filter page (filter_page) */
export type FilterPageRecord = RecordInterface & {
  __typename?: 'FilterPageRecord';
  _allCardTooltipLocales?: Maybe<Array<FilterCardTooltipRecordListListNonNullMultiLocaleField>>;
  _allCategoryBlurbsLocales?: Maybe<Array<CategoryBlurbRecordListListNonNullMultiLocaleField>>;
  _allDescriptionLocales?: Maybe<Array<FilterPageModelDescriptionFieldMultiLocaleField>>;
  _allReferencingCarBrandPages: Array<CarBrandPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCarBrandPagesMeta: CollectionMetadata;
  _allReferencingCarCategoryPages: Array<CarCategoryPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCarCategoryPagesMeta: CollectionMetadata;
  _allReferencingCarFamilyPages: Array<CarFamilyPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCarFamilyPagesMeta: CollectionMetadata;
  _allReferencingPromoSettings: Array<PromoSettingRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingPromoSettingsMeta: CollectionMetadata;
  _allSeoInformationLocales?: Maybe<Array<FilterPageModelSeoInformationFieldMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  cardTooltip: Array<FilterCardTooltipRecord>;
  categoryBlurbs: Array<CategoryBlurbRecord>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<FilterPageModelDescriptionField>;
  id: Scalars['ItemId'];
  mainCategory?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoField>;
  seoInformation?: Maybe<FilterPageModelSeoInformationField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllCardTooltipLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllCategoryBlurbsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllReferencingCarBrandPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarBrandPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarBrandPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarBrandPageAndFilterPage>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllReferencingCarBrandPagesMetaArgs = {
  filter?: InputMaybe<CarBrandPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarBrandPageAndFilterPage>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllReferencingCarCategoryPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarCategoryPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarCategoryPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarCategoryPageAndFilterPage>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllReferencingCarCategoryPagesMetaArgs = {
  filter?: InputMaybe<CarCategoryPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarCategoryPageAndFilterPage>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllReferencingCarFamilyPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarFamilyPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarFamilyPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarFamilyPageAndFilterPage>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllReferencingCarFamilyPagesMetaArgs = {
  filter?: InputMaybe<CarFamilyPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarFamilyPageAndFilterPage>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllReferencingPromoSettingsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoSettingModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PromoSettingModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenPromoSettingAndFilterPage>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllReferencingPromoSettingsMetaArgs = {
  filter?: InputMaybe<PromoSettingModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenPromoSettingAndFilterPage>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllSeoInformationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecordCardTooltipArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecordCategoryBlurbsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecordSeoInformationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Filter page (filter_page) */
export type FilterPageRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Fixed Price Tips Model (fixed_price_tips_model) */
export type FixedPriceTipsModelRecord = RecordInterface & {
  __typename?: 'FixedPriceTipsModelRecord';
  _allStructuredTextLocales?: Maybe<Array<StructuredTextBlockRecordMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  structuredText?: Maybe<StructuredTextBlockRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Fixed Price Tips Model (fixed_price_tips_model) */
export type FixedPriceTipsModelRecord_AllStructuredTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Fixed Price Tips Model (fixed_price_tips_model) */
export type FixedPriceTipsModelRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Fixed Price Tips Model (fixed_price_tips_model) */
export type FixedPriceTipsModelRecordStructuredTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Floating-point fields */
export type FloatFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['FloatType']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['FloatType']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['FloatType']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['FloatType']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['FloatType']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['FloatType']>;
};

/** Block of type FM:Button (fm_button) */
export type FmButtonRecord = RecordInterface & {
  __typename?: 'FmButtonRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  size?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};


/** Block of type FM:Button (fm_button) */
export type FmButtonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type FM: Get started (fm_get_started) */
export type FmGetStartedRecord = RecordInterface & {
  __typename?: 'FmGetStartedRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  button: Array<FmButtonRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  informationBody?: Maybe<Scalars['String']>;
  informationSectionImage: Array<FileField>;
  informationTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type FM: Get started (fm_get_started) */
export type FmGetStartedRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type FM: Get started (fm_get_started) */
export type FmGetStartedRecordInformationBodyArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type FmGetStartedRecordListListNonNullMultiLocaleField = {
  __typename?: 'FmGetStartedRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<FmGetStartedRecord>;
};

export type FmInformationSectionModelInformationTextField = {
  __typename?: 'FmInformationSectionModelInformationTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type FM: Information Section (fm_information_section) */
export type FmInformationSectionRecord = RecordInterface & {
  __typename?: 'FmInformationSectionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  informationText?: Maybe<FmInformationSectionModelInformationTextField>;
  light?: Maybe<FileField>;
  updatedAt: Scalars['DateTime'];
  ytVideo?: Maybe<VideoField>;
};


/** Block of type FM: Information Section (fm_information_section) */
export type FmInformationSectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FmInformationSectionRecordListListNonNullMultiLocaleField = {
  __typename?: 'FmInformationSectionRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<FmInformationSectionRecord>;
};

/** Record of type FM: Landing page (fm_page) */
export type FmPageRecord = RecordInterface & {
  __typename?: 'FmPageRecord';
  _allDescriptionLocales?: Maybe<Array<DescriptionRecordListListNonNullMultiLocaleField>>;
  _allGetStartedLocales?: Maybe<Array<FmGetStartedRecordListListNonNullMultiLocaleField>>;
  _allInformationSectionLocales?: Maybe<Array<FmInformationSectionRecordListListNonNullMultiLocaleField>>;
  _allNameLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOptionalHeroLocales?: Maybe<Array<OptionalHeroRecordMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allTestimonialQuoteLocales?: Maybe<Array<TestimonialQuoteRecordListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description: Array<DescriptionRecord>;
  getStarted: Array<FmGetStartedRecord>;
  id: Scalars['ItemId'];
  informationSection: Array<FmInformationSectionRecord>;
  name?: Maybe<Scalars['String']>;
  optionalHero?: Maybe<OptionalHeroRecord>;
  seo?: Maybe<SeoField>;
  testimonialQuote: Array<TestimonialQuoteRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecord_AllGetStartedLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecord_AllInformationSectionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecord_AllNameLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecord_AllOptionalHeroLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecord_AllTestimonialQuoteLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecordGetStartedArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecordInformationSectionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecordNameArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecordOptionalHeroArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Landing page (fm_page) */
export type FmPageRecordTestimonialQuoteArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FmTemporaryMessageModelMessageField = {
  __typename?: 'FmTemporaryMessageModelMessageField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FmTemporaryMessageModelMessageFieldMultiLocaleField = {
  __typename?: 'FmTemporaryMessageModelMessageFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FmTemporaryMessageModelMessageField>;
};

/** Record of type FM: Temporary Message (fm_temporary_message) */
export type FmTemporaryMessageRecord = RecordInterface & {
  __typename?: 'FmTemporaryMessageRecord';
  _allMessageLocales?: Maybe<Array<FmTemporaryMessageModelMessageFieldMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  message?: Maybe<FmTemporaryMessageModelMessageField>;
  placement?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type FM: Temporary Message (fm_temporary_message) */
export type FmTemporaryMessageRecord_AllMessageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Temporary Message (fm_temporary_message) */
export type FmTemporaryMessageRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Temporary Message (fm_temporary_message) */
export type FmTemporaryMessageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Temporary Message (fm_temporary_message) */
export type FmTemporaryMessageRecordMessageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type FM: Temporary Message (fm_temporary_message) */
export type FmTemporaryMessageRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer navigation (footer_navigation) */
export type FooterNavigationRecord = RecordInterface & {
  __typename?: 'FooterNavigationRecord';
  _allFooterButtonsLocales?: Maybe<Array<ButtonRecordListListNonNullMultiLocaleField>>;
  _allLinkGroupsLocales?: Maybe<Array<LinkGroupRecordListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  footerButtons: Array<ButtonRecord>;
  id: Scalars['ItemId'];
  linkGroups: Array<LinkGroupRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Footer navigation (footer_navigation) */
export type FooterNavigationRecord_AllFooterButtonsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Footer navigation (footer_navigation) */
export type FooterNavigationRecord_AllLinkGroupsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Footer navigation (footer_navigation) */
export type FooterNavigationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Footer navigation (footer_navigation) */
export type FooterNavigationRecordFooterButtonsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Footer navigation (footer_navigation) */
export type FooterNavigationRecordLinkGroupsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Form CSV recipient (form_csv_recipient) */
export type FormCsvRecipientRecord = RecordInterface & {
  __typename?: 'FormCsvRecipientRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Form CSV recipient (form_csv_recipient) */
export type FormCsvRecipientRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FormFieldModelCheckboxLabelField = {
  __typename?: 'FormFieldModelCheckboxLabelField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FormFieldModelCheckboxLabelFieldMultiLocaleField = {
  __typename?: 'FormFieldModelCheckboxLabelFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FormFieldModelCheckboxLabelField>;
};

export type FormFieldModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FormFieldModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FormFieldModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  allowOtherOption?: InputMaybe<BooleanFilter>;
  backendKey?: InputMaybe<StringFilter>;
  checkboxCheckedByDefault?: InputMaybe<BooleanFilter>;
  checkboxLabel?: InputMaybe<StructuredTextFilter>;
  checkboxNewsletterSubscriptionType?: InputMaybe<StringFilter>;
  choiceFieldType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  fieldType?: InputMaybe<StringFilter>;
  helperText?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  internalName?: InputMaybe<StringFilter>;
  likertLabel?: InputMaybe<StringFilter>;
  multipleChoiceLabel?: InputMaybe<StringFilter>;
  otherOptionLabel?: InputMaybe<StringFilter>;
  required?: InputMaybe<BooleanFilter>;
  textAreaLabel?: InputMaybe<StringFilter>;
  textAreaRows?: InputMaybe<IntegerFilter>;
  textFieldDefaultValue?: InputMaybe<StringFilter>;
  textFieldEmarsysContactType?: InputMaybe<StringFilter>;
  textFieldLabel?: InputMaybe<StringFilter>;
  textFieldPlaceholder?: InputMaybe<StringFilter>;
  textFieldType?: InputMaybe<StringFilter>;
  textFieldUniqueValueValidation?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type FormFieldModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'allowOtherOption_ASC'
  | 'allowOtherOption_DESC'
  | 'backendKey_ASC'
  | 'backendKey_DESC'
  | 'checkboxCheckedByDefault_ASC'
  | 'checkboxCheckedByDefault_DESC'
  | 'checkboxNewsletterSubscriptionType_ASC'
  | 'checkboxNewsletterSubscriptionType_DESC'
  | 'choiceFieldType_ASC'
  | 'choiceFieldType_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'fieldType_ASC'
  | 'fieldType_DESC'
  | 'helperText_ASC'
  | 'helperText_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'likertLabel_ASC'
  | 'likertLabel_DESC'
  | 'multipleChoiceLabel_ASC'
  | 'multipleChoiceLabel_DESC'
  | 'otherOptionLabel_ASC'
  | 'otherOptionLabel_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'textAreaLabel_ASC'
  | 'textAreaLabel_DESC'
  | 'textAreaRows_ASC'
  | 'textAreaRows_DESC'
  | 'textFieldDefaultValue_ASC'
  | 'textFieldDefaultValue_DESC'
  | 'textFieldEmarsysContactType_ASC'
  | 'textFieldEmarsysContactType_DESC'
  | 'textFieldLabel_ASC'
  | 'textFieldLabel_DESC'
  | 'textFieldPlaceholder_ASC'
  | 'textFieldPlaceholder_DESC'
  | 'textFieldType_ASC'
  | 'textFieldType_DESC'
  | 'textFieldUniqueValueValidation_ASC'
  | 'textFieldUniqueValueValidation_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord = RecordInterface & {
  __typename?: 'FormFieldRecord';
  _allCheckboxLabelLocales?: Maybe<Array<FormFieldModelCheckboxLabelFieldMultiLocaleField>>;
  _allChoicesLocales?: Maybe<Array<DynamicFormChoiceFieldRecordListListNonNullMultiLocaleField>>;
  _allHelperTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLikertLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLikertScaleOptionsLocales?: Maybe<Array<DynamicFormLikertScaleOptionRecordListListNonNullMultiLocaleField>>;
  _allLikertStatementsLocales?: Maybe<Array<DynamicFormLikertStatementRecordListListNonNullMultiLocaleField>>;
  _allMultipleChoiceLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOtherOptionLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTextAreaLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTextFieldDefaultValueLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTextFieldLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTextFieldPlaceholderLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  allowOtherOption?: Maybe<Scalars['BooleanType']>;
  backendKey?: Maybe<Scalars['String']>;
  checkboxCheckedByDefault?: Maybe<Scalars['BooleanType']>;
  checkboxLabel?: Maybe<FormFieldModelCheckboxLabelField>;
  checkboxNewsletterSubscriptionType?: Maybe<Scalars['String']>;
  choiceFieldType?: Maybe<Scalars['String']>;
  choices: Array<DynamicFormChoiceFieldRecord>;
  createdAt: Scalars['DateTime'];
  fieldType?: Maybe<Scalars['String']>;
  helperText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  internalName?: Maybe<Scalars['String']>;
  likertLabel?: Maybe<Scalars['String']>;
  likertScaleOptions: Array<DynamicFormLikertScaleOptionRecord>;
  likertStatements: Array<DynamicFormLikertStatementRecord>;
  multipleChoiceLabel?: Maybe<Scalars['String']>;
  otherOptionLabel?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['BooleanType']>;
  textAreaLabel?: Maybe<Scalars['String']>;
  textAreaRows?: Maybe<Scalars['IntType']>;
  textFieldDefaultValue?: Maybe<Scalars['String']>;
  textFieldEmarsysContactType?: Maybe<Scalars['String']>;
  textFieldLabel?: Maybe<Scalars['String']>;
  textFieldPlaceholder?: Maybe<Scalars['String']>;
  textFieldType?: Maybe<Scalars['String']>;
  textFieldUniqueValueValidation?: Maybe<Scalars['BooleanType']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllCheckboxLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllChoicesLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllHelperTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllLikertLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllLikertScaleOptionsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllLikertStatementsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllMultipleChoiceLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllOtherOptionLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllTextAreaLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllTextFieldDefaultValueLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllTextFieldLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_AllTextFieldPlaceholderLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordCheckboxLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordChoicesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordHelperTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordLikertLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordLikertScaleOptionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordLikertStatementsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordMultipleChoiceLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordOtherOptionLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordTextAreaLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordTextFieldDefaultValueArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordTextFieldLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 📩 Form Field (form_field) */
export type FormFieldRecordTextFieldPlaceholderArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FormModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FormModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FormModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  csvExportEnd?: InputMaybe<DateTimeFilter>;
  csvExportLink?: InputMaybe<SlugFilter>;
  csvExportLinkStaging?: InputMaybe<SlugFilter>;
  csvExportStart?: InputMaybe<DateTimeFilter>;
  csvLocale?: InputMaybe<StringFilter>;
  csvScheduleStart?: InputMaybe<DateTimeFilter>;
  csvSendingFrequencyDaily?: InputMaybe<BooleanFilter>;
  csvSendingFrequencyEndOfCampaign?: InputMaybe<BooleanFilter>;
  csvSendingFrequencyMonthly?: InputMaybe<BooleanFilter>;
  csvSendingFrequencyWeekly?: InputMaybe<BooleanFilter>;
  csvSendingTime?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  formAlreadyClosedDescription?: InputMaybe<StructuredTextFilter>;
  formFields?: InputMaybe<LinksFilter>;
  formName?: InputMaybe<StringFilter>;
  formNotOpenDescription?: InputMaybe<StructuredTextFilter>;
  formOpenDescription?: InputMaybe<StructuredTextFilter>;
  formSubmitButton?: InputMaybe<StringFilter>;
  formSuccessSubmissionDescription?: InputMaybe<StructuredTextFilter>;
  formTitle?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  internalName?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  submitFormDescription?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type FormModelFormAlreadyClosedDescriptionField = {
  __typename?: 'FormModelFormAlreadyClosedDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FormModelFormAlreadyClosedDescriptionFieldMultiLocaleField = {
  __typename?: 'FormModelFormAlreadyClosedDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FormModelFormAlreadyClosedDescriptionField>;
};

export type FormModelFormNotOpenDescriptionField = {
  __typename?: 'FormModelFormNotOpenDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FormModelFormNotOpenDescriptionFieldMultiLocaleField = {
  __typename?: 'FormModelFormNotOpenDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FormModelFormNotOpenDescriptionField>;
};

export type FormModelFormOpenDescriptionField = {
  __typename?: 'FormModelFormOpenDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FormModelFormOpenDescriptionFieldMultiLocaleField = {
  __typename?: 'FormModelFormOpenDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FormModelFormOpenDescriptionField>;
};

export type FormModelFormSuccessSubmissionDescriptionField = {
  __typename?: 'FormModelFormSuccessSubmissionDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type FormModelFormSuccessSubmissionDescriptionFieldMultiLocaleField = {
  __typename?: 'FormModelFormSuccessSubmissionDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<FormModelFormSuccessSubmissionDescriptionField>;
};

export type FormModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'csvExportEnd_ASC'
  | 'csvExportEnd_DESC'
  | 'csvExportStart_ASC'
  | 'csvExportStart_DESC'
  | 'csvLocale_ASC'
  | 'csvLocale_DESC'
  | 'csvScheduleStart_ASC'
  | 'csvScheduleStart_DESC'
  | 'csvSendingFrequencyDaily_ASC'
  | 'csvSendingFrequencyDaily_DESC'
  | 'csvSendingFrequencyEndOfCampaign_ASC'
  | 'csvSendingFrequencyEndOfCampaign_DESC'
  | 'csvSendingFrequencyMonthly_ASC'
  | 'csvSendingFrequencyMonthly_DESC'
  | 'csvSendingFrequencyWeekly_ASC'
  | 'csvSendingFrequencyWeekly_DESC'
  | 'csvSendingTime_ASC'
  | 'csvSendingTime_DESC'
  | 'endDate_ASC'
  | 'endDate_DESC'
  | 'formName_ASC'
  | 'formName_DESC'
  | 'formSubmitButton_ASC'
  | 'formSubmitButton_DESC'
  | 'formTitle_ASC'
  | 'formTitle_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isActive_ASC'
  | 'isActive_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC'
  | 'submitFormDescription_ASC'
  | 'submitFormDescription_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type ✉️ Form (form) */
export type FormRecord = RecordInterface & {
  __typename?: 'FormRecord';
  _allFormAlreadyClosedDescriptionLocales?: Maybe<Array<FormModelFormAlreadyClosedDescriptionFieldMultiLocaleField>>;
  _allFormNotOpenDescriptionLocales?: Maybe<Array<FormModelFormNotOpenDescriptionFieldMultiLocaleField>>;
  _allFormOpenDescriptionLocales?: Maybe<Array<FormModelFormOpenDescriptionFieldMultiLocaleField>>;
  _allFormSubmitButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFormSuccessSubmissionDescriptionLocales?: Maybe<Array<FormModelFormSuccessSubmissionDescriptionFieldMultiLocaleField>>;
  _allFormTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSubmitFormDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  csvExportEnd?: Maybe<Scalars['DateTime']>;
  csvExportLink?: Maybe<Scalars['String']>;
  csvExportLinkStaging?: Maybe<Scalars['String']>;
  csvExportStart?: Maybe<Scalars['DateTime']>;
  csvLocale?: Maybe<Scalars['String']>;
  csvRecipients: Array<FormCsvRecipientRecord>;
  csvScheduleStart?: Maybe<Scalars['DateTime']>;
  csvSendingFrequencyDaily?: Maybe<Scalars['BooleanType']>;
  csvSendingFrequencyEndOfCampaign?: Maybe<Scalars['BooleanType']>;
  csvSendingFrequencyMonthly?: Maybe<Scalars['BooleanType']>;
  csvSendingFrequencyWeekly?: Maybe<Scalars['BooleanType']>;
  csvSendingTime?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  formAlreadyClosedDescription?: Maybe<FormModelFormAlreadyClosedDescriptionField>;
  formFields: Array<FormFieldRecord>;
  formName?: Maybe<Scalars['String']>;
  formNotOpenDescription?: Maybe<FormModelFormNotOpenDescriptionField>;
  formOpenDescription?: Maybe<FormModelFormOpenDescriptionField>;
  formSubmitButton?: Maybe<Scalars['String']>;
  formSuccessSubmissionDescription?: Maybe<FormModelFormSuccessSubmissionDescriptionField>;
  formTitle?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  internalName?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['BooleanType']>;
  startDate?: Maybe<Scalars['DateTime']>;
  submitFormDescription?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type ✉️ Form (form) */
export type FormRecord_AllFormAlreadyClosedDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecord_AllFormNotOpenDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecord_AllFormOpenDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecord_AllFormSubmitButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecord_AllFormSuccessSubmissionDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecord_AllFormTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecord_AllSubmitFormDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecordFormAlreadyClosedDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecordFormNotOpenDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecordFormOpenDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecordFormSubmitButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecordFormSuccessSubmissionDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecordFormTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ✉️ Form (form) */
export type FormRecordSubmitFormDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🌐 Global configuration (global_configuration) */
export type GlobalConfigurationRecord = RecordInterface & {
  __typename?: 'GlobalConfigurationRecord';
  _allWarrantiesLocales?: Maybe<Array<WarrantyRecordListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  financingInterest?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  serviceAgreementCost: Array<ServiceAgreementCostRecord>;
  serviceAgreementLeasingCost?: Maybe<Scalars['JsonField']>;
  updatedAt: Scalars['DateTime'];
  warranties: Array<WarrantyRecord>;
};


/** Record of type 🌐 Global configuration (global_configuration) */
export type GlobalConfigurationRecord_AllWarrantiesLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌐 Global configuration (global_configuration) */
export type GlobalConfigurationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🌐 Global configuration (global_configuration) */
export type GlobalConfigurationRecordWarrantiesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type GlobalSeoField = {
  __typename?: 'GlobalSeoField';
  facebookPageUrl?: Maybe<Scalars['String']>;
  fallbackSeo?: Maybe<SeoField>;
  siteName?: Maybe<Scalars['String']>;
  titleSuffix?: Maybe<Scalars['String']>;
  twitterAccount?: Maybe<Scalars['String']>;
};

/** Block of type Headline (headline) */
export type HeadlineRecord = RecordInterface & {
  __typename?: 'HeadlineRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  tag?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Headline (headline) */
export type HeadlineRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type HeroModelModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroModelModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroModelModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  button?: InputMaybe<LinkFilter>;
  buttons?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  heading?: InputMaybe<StringFilter>;
  headingColor?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  subheading?: InputMaybe<StringFilter>;
  subheadingColor?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type HeroModelModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'headingColor_ASC'
  | 'headingColor_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'subheadingColor_ASC'
  | 'subheadingColor_DESC'
  | 'subheading_ASC'
  | 'subheading_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Hero Model (hero_model) */
export type HeroModelRecord = RecordInterface & {
  __typename?: 'HeroModelRecord';
  _allButtonLocales?: Maybe<Array<ButtonModelRecordMultiLocaleField>>;
  _allHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allImageLocales?: Maybe<Array<FileFieldMultiLocaleField>>;
  _allSubheadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  button?: Maybe<ButtonModelRecord>;
  buttons: Array<ButtonModelRecord>;
  createdAt: Scalars['DateTime'];
  heading?: Maybe<Scalars['String']>;
  headingColor?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  subheading?: Maybe<Scalars['String']>;
  subheadingColor?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Hero Model (hero_model) */
export type HeroModelRecord_AllButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Hero Model (hero_model) */
export type HeroModelRecord_AllHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Hero Model (hero_model) */
export type HeroModelRecord_AllImageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Hero Model (hero_model) */
export type HeroModelRecord_AllSubheadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Hero Model (hero_model) */
export type HeroModelRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Hero Model (hero_model) */
export type HeroModelRecordButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Hero Model (hero_model) */
export type HeroModelRecordHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Hero Model (hero_model) */
export type HeroModelRecordImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Hero Model (hero_model) */
export type HeroModelRecordSubheadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type HeroModelRecordMultiLocaleField = {
  __typename?: 'HeroModelRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<HeroModelRecord>;
};

/** Block of type HTML Input (html_input) */
export type HtmlInputRecord = RecordInterface & {
  __typename?: 'HtmlInputRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  htmlField?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type HTML Input (html_input) */
export type HtmlInputRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type HTML Input (html_input) */
export type HtmlInputRecordHtmlFieldArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

/** Block of type Icon List Item (icon_list_item) */
export type IconListItemRecord = RecordInterface & {
  __typename?: 'IconListItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  imageIcon?: Maybe<ImageIconRecord>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Icon List Item (icon_list_item) */
export type IconListItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Icon List (icon_list) */
export type IconListRecord = RecordInterface & {
  __typename?: 'IconListRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  items: Array<IconListItemRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Icon List (icon_list) */
export type IconListRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Image Icon (image_icon) */
export type ImageIconRecord = RecordInterface & {
  __typename?: 'ImageIconRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  icon?: Maybe<FileField>;
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Image Icon (image_icon) */
export type ImageIconRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/aspect-ratio)
   */
  ar?: InputMaybe<Scalars['String']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/automatic)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/background-color)
   */
  bg?: InputMaybe<Scalars['String']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-fallback)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Background Removal Foreground Type
   *
   * Specifies the image foreground type for background removal.
   *
   * Depends on: `bg-remove=true`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-foreground-type)
   */
  bgRemoveFgType?: InputMaybe<Array<ImgixParamsBgRemoveFgType>>;
  /**
   * Background Removal Semi Transparency
   *
   * Enables background removal while retaining semi-transparent areas.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-semi-transparency)
   */
  bgRemoveSemiTransparency?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement)
   */
  bgReplace?: InputMaybe<Scalars['String']>;
  /**
   * Background Replace Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replace-fallback)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement-negative-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-height)
   */
  blendH?: InputMaybe<Scalars['FloatType']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-padding)
   */
  blendPad?: InputMaybe<Scalars['IntType']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-width)
   */
  blendW?: InputMaybe<Scalars['FloatType']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-x-position)
   */
  blendX?: InputMaybe<Scalars['IntType']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-y-position)
   */
  blendY?: InputMaybe<Scalars['IntType']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/gaussian-blur)
   */
  blur?: InputMaybe<Scalars['IntType']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size)
   */
  border?: InputMaybe<Scalars['String']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/outer-border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/inner-border-radius)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/brightness)
   */
  bri?: InputMaybe<Scalars['IntType']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/client-hints)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/chroma-subsampling)
   */
  chromasub?: InputMaybe<Scalars['IntType']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-quantization)
   */
  colorquant?: InputMaybe<Scalars['IntType']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/palette-color-count)
   */
  colors?: InputMaybe<Scalars['IntType']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/contrast)
   */
  con?: InputMaybe<Scalars['IntType']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/crop-mode)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-space)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/download)
   */
  dl?: InputMaybe<Scalars['String']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/dots-per-inch)
   */
  dpi?: InputMaybe<Scalars['IntType']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/device-pixel-ratio)
   */
  dpr?: InputMaybe<Scalars['FloatType']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/exposure)
   */
  exp?: InputMaybe<Scalars['IntType']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/expiration)
   */
  expires?: InputMaybe<Scalars['IntType']>;
  /**
   * Face Blur
   *
   * Specifies the amount of blur to apply to detected faces. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-blur)
   */
  faceBlur?: InputMaybe<Scalars['IntType']>;
  /**
   * Face Pixelation
   *
   * Specifies the pixelation amount of the face.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-pixelation)
   */
  facePixel?: InputMaybe<Scalars['IntType']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-index)
   */
  faceindex?: InputMaybe<Scalars['IntType']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-padding)
   */
  facepad?: InputMaybe<Scalars['FloatType']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/json-face-data)
   */
  faces?: InputMaybe<Scalars['IntType']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-mode)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-negative-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-position)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-color-space)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<Array<ImgixParamsFillGradientLinearDirection>>;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/resize-fit-mode)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/flip-axis)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-format)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-x-position)
   */
  fpX?: InputMaybe<Scalars['FloatType']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-y-position)
   */
  fpY?: InputMaybe<Scalars['FloatType']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-zoom)
   */
  fpZ?: InputMaybe<Scalars['FloatType']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frames-per-second)
   */
  fps?: InputMaybe<Scalars['IntType']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-selection)
   */
  frame?: InputMaybe<Scalars['String']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/gamma)
   */
  gam?: InputMaybe<Scalars['IntType']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/animated-gif-quality)
   */
  gifQ?: InputMaybe<Scalars['IntType']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-colors)
   */
  gridColors?: InputMaybe<Scalars['String']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-size)
   */
  gridSize?: InputMaybe<Scalars['IntType']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-height)
   */
  h?: InputMaybe<Scalars['FloatType']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/highlight)
   */
  high?: InputMaybe<Scalars['IntType']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/halftone)
   */
  htn?: InputMaybe<Scalars['IntType']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/hue-shift)
   */
  hue?: InputMaybe<Scalars['IntType']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-interval)
   */
  interval?: InputMaybe<Scalars['IntType']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/iptc-passthrough)
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/jpg-progressive)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation)
   */
  loop?: InputMaybe<Scalars['IntType']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/lossless-compression)
   */
  lossless?: InputMaybe<Scalars['BooleanType']>;
  /**
   * License Plate Blur
   *
   * Specifies the amount of blur to apply to detected license plates. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/license-plate-detection/license-plate-blur)
   */
  lpBlur?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-image-url)
   */
  mark?: InputMaybe<Scalars['String']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alignment-mode)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-base-url)
   */
  markBase?: InputMaybe<Scalars['String']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-fit-mode)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-height)
   */
  markH?: InputMaybe<Scalars['FloatType']>;
  /**
   * Watermark If Minimum Height
   *
   * Displays the watermark if rendered base image pixel height is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-height)
   */
  markIfMinHeight?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark If Minimum Width
   *
   * Displays the watermark if rendered base image pixel width is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-width)
   */
  markIfMinWidth?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-padding)
   */
  markPad?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-rotation)
   */
  markRot?: InputMaybe<Scalars['FloatType']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-width)
   */
  markW?: InputMaybe<Scalars['FloatType']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-x-position)
   */
  markX?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-y-position)
   */
  markY?: InputMaybe<Scalars['IntType']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-type)
   */
  mask?: InputMaybe<Scalars['String']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-background-color)
   */
  maskBg?: InputMaybe<Scalars['String']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-height)
   */
  maxH?: InputMaybe<Scalars['IntType']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-width)
   */
  maxW?: InputMaybe<Scalars['IntType']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-height)
   */
  minH?: InputMaybe<Scalars['IntType']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-width)
   */
  minW?: InputMaybe<Scalars['IntType']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-bound)
   */
  nr?: InputMaybe<Scalars['IntType']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-sharpen)
   */
  nrs?: InputMaybe<Scalars['IntType']>;
  /**
   * Object Removal Negative Prompt
   *
   * Provides a negative text suggestion to object-removal-prompt. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-negative-prompt)
   */
  objectRemovalNegativePrompt?: InputMaybe<Scalars['String']>;
  /**
   * Object Removal Prompt
   *
   * Suggest auto generative fill for the object-removal-rect parameter
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-prompt)
   */
  objectRemovalPrompt?: InputMaybe<Scalars['String']>;
  /**
   * Object Removal
   *
   * Using a specified rectangle, an object is removed from the image
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal)
   */
  objectRemovalRect?: InputMaybe<Scalars['String']>;
  /**
   * Object Removal Seed
   *
   * Sets the generative seed value for object-removal. Used to generate new outputs from the same prompt
   *
   * Depends on: `object-removal-rect`, `object-removal-prompt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-seed)
   */
  objectRemovalSeed?: InputMaybe<Scalars['IntType']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/orientation)
   */
  orient?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding)
   */
  pad?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-right)
   */
  padRight?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-top)
   */
  padTop?: InputMaybe<Scalars['IntType']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-page-number)
   */
  page?: InputMaybe<Scalars['IntType']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/color-palette-extraction)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/css-prefix)
   */
  prefix?: InputMaybe<Scalars['String']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/pixellate)
   */
  px?: InputMaybe<Scalars['IntType']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=avif`, `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-quality)
   */
  q?: InputMaybe<Scalars['IntType']>;
  /**
   * Rasterize Bypass
   *
   * Bypasses all rendering parameters (including default parameters) and serves the original image. Works for svg+xml,x-eps,pdf, and vnd.adobe.illustrator.
   */
  rasterizeBypass?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/source-rectangle-region)
   */
  rect?: InputMaybe<Scalars['String']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/reverse)
   */
  reverse?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation)
   */
  rot?: InputMaybe<Scalars['FloatType']>;
  /**
   * Rotation Type
   *
   * Changes the rotation type.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation-type)
   */
  rotType?: InputMaybe<ImgixParamsRotType>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/saturation)
   */
  sat?: InputMaybe<Scalars['IntType']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/sepia-tone)
   */
  sepia?: InputMaybe<Scalars['IntType']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/shadow)
   */
  shad?: InputMaybe<Scalars['FloatType']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/sharpen)
   */
  sharp?: InputMaybe<Scalars['FloatType']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-skip)
   */
  skip?: InputMaybe<Scalars['IntType']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/sanitize-svg)
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-image)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Alpha
   *
   * Specifies a trim alpha on a trim operation.
   *
   * Depends on: `trim=alpha`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-alpha)
   */
  trimAlpha?: InputMaybe<Scalars['FloatType']>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-mean-difference)
   */
  trimMd?: InputMaybe<Scalars['FloatType']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-padding)
   */
  trimPad?: InputMaybe<Scalars['IntType']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-standard-deviation)
   */
  trimSd?: InputMaybe<Scalars['FloatType']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-tolerance)
   */
  trimTol?: InputMaybe<Scalars['FloatType']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-string)
   */
  txt?: InputMaybe<Scalars['String']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-clipping-mode)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-color)
   */
  txtColor?: InputMaybe<Scalars['String']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-fit-mode)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font)
   */
  txtFont?: InputMaybe<Scalars['String']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-leading)
   */
  txtLead?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline)
   */
  txtLine?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-padding)
   */
  txtPad?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-shadow)
   */
  txtShad?: InputMaybe<Scalars['FloatType']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-tracking)
   */
  txtTrack?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-x-position)
   */
  txtX?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-y-position)
   */
  txtY?: InputMaybe<Scalars['IntType']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscale?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask)
   */
  usm?: InputMaybe<Scalars['IntType']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask-radius)
   */
  usmrad?: InputMaybe<Scalars['FloatType']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/vibrance)
   */
  vib?: InputMaybe<Scalars['IntType']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-width)
   */
  w?: InputMaybe<Scalars['FloatType']>;
};

export type ImgixParamsAuto =
  | 'compress'
  | 'enhance'
  | 'format'
  | 'redeye';

export type ImgixParamsBgRemoveFgType =
  | 'auto'
  | 'car';

export type ImgixParamsBlendAlign =
  | 'bottom'
  | 'center'
  | 'left'
  | 'middle'
  | 'right'
  | 'top';

export type ImgixParamsBlendCrop =
  | 'bottom'
  | 'faces'
  | 'left'
  | 'right'
  | 'top';

export type ImgixParamsBlendFit =
  | 'clamp'
  | 'clip'
  | 'crop'
  | 'max'
  | 'scale';

export type ImgixParamsBlendMode =
  | 'burn'
  | 'color'
  | 'darken'
  | 'difference'
  | 'dodge'
  | 'exclusion'
  | 'hardlight'
  | 'hue'
  | 'lighten'
  | 'luminosity'
  | 'multiply'
  | 'normal'
  | 'overlay'
  | 'saturation'
  | 'screen'
  | 'softlight';

export type ImgixParamsBlendSize =
  | 'inherit';

export type ImgixParamsCh =
  | 'dpr'
  | 'saveData'
  | 'width';

export type ImgixParamsCrop =
  | 'bottom'
  | 'edges'
  | 'entropy'
  | 'faces'
  | 'focalpoint'
  | 'left'
  | 'right'
  | 'top';

export type ImgixParamsCs =
  | 'adobergb1998'
  | 'origin'
  | 'srgb'
  | 'strip'
  | 'tinysrgb';

export type ImgixParamsFill =
  | 'blur'
  | 'gen'
  | 'generative'
  | 'gradient'
  | 'solid';

export type ImgixParamsFillGenPos =
  | 'bottom'
  | 'center'
  | 'left'
  | 'middle'
  | 'right'
  | 'top';

export type ImgixParamsFillGradientCs =
  | 'hsl'
  | 'lch'
  | 'linear'
  | 'oklab'
  | 'srgb';

export type ImgixParamsFillGradientLinearDirection =
  | 'bottom'
  | 'left'
  | 'right'
  | 'top';

export type ImgixParamsFillGradientType =
  | 'linear'
  | 'radial';

export type ImgixParamsFit =
  | 'clamp'
  | 'clip'
  | 'crop'
  | 'facearea'
  | 'fill'
  | 'fillmax'
  | 'max'
  | 'min'
  | 'scale';

export type ImgixParamsFlip =
  | 'h'
  | 'hv'
  | 'v';

export type ImgixParamsFm =
  | 'avif'
  | 'blurhash'
  | 'gif'
  | 'jp2'
  | 'jpg'
  | 'json'
  | 'jxr'
  | 'mp4'
  | 'pjpg'
  | 'png'
  | 'png8'
  | 'png32'
  | 'webm'
  | 'webp';

export type ImgixParamsIptc =
  | 'allow'
  | 'block';

export type ImgixParamsMarkAlign =
  | 'bottom'
  | 'center'
  | 'left'
  | 'middle'
  | 'right'
  | 'top';

export type ImgixParamsMarkFit =
  | 'clip'
  | 'crop'
  | 'fill'
  | 'max'
  | 'scale';

export type ImgixParamsMarkTile =
  | 'grid';

export type ImgixParamsPalette =
  | 'css'
  | 'json';

export type ImgixParamsRotType =
  | 'pivot'
  | 'straighten';

export type ImgixParamsTransparency =
  | 'grid';

export type ImgixParamsTrim =
  | 'alpha'
  | 'auto'
  | 'color';

export type ImgixParamsTxtAlign =
  | 'bottom'
  | 'center'
  | 'left'
  | 'middle'
  | 'right'
  | 'top';

export type ImgixParamsTxtClip =
  | 'ellipsis'
  | 'end'
  | 'middle'
  | 'start';

export type ImgixParamsTxtFit =
  | 'max';

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']>;
};

export type InlineimageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<InlineimageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<InlineimageModelFilter>>>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  imageMaxWidth?: InputMaybe<StringFilter>;
  lefttext?: InputMaybe<TextFilter>;
  righttext?: InputMaybe<TextFilter>;
  textPlacement?: InputMaybe<StringFilter>;
};

export type InlineimageModelTextContentField = {
  __typename?: 'InlineimageModelTextContentField';
  blocks: Array<ButtonRecord>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<ButtonModelRecord>;
  value: Scalars['JsonField'];
};

/** Block of type InlineImage (inlineimage) */
export type InlineimageRecord = RecordInterface & {
  __typename?: 'InlineimageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  imageMaxWidth?: Maybe<Scalars['String']>;
  lefttext?: Maybe<Scalars['String']>;
  righttext?: Maybe<Scalars['String']>;
  textContent?: Maybe<InlineimageModelTextContentField>;
  textPlacement?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type InlineImage (inlineimage) */
export type InlineimageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type InlineImage (inlineimage) */
export type InlineimageRecordLefttextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Block of type InlineImage (inlineimage) */
export type InlineimageRecordRighttextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

/** Block of type Inspection Block (inspection_block) */
export type InspectionBlockRecord = RecordInterface & {
  __typename?: 'InspectionBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  conditions: Array<ConditionInfoModelRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  link?: Maybe<TextLinkRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Inspection Block (inspection_block) */
export type InspectionBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type InspectionBlockRecordMultiLocaleField = {
  __typename?: 'InspectionBlockRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<InspectionBlockRecord>;
};

/** Specifies how to filter Integer fields */
export type IntegerFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenArticleAndCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<ArticleModelFieldsReferencingCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<ArticleModelFieldsReferencingCategoryModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenArticleAndStructuredTextTemplate = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<ArticleModelFieldsReferencingStructuredTextTemplateModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<ArticleModelFieldsReferencingStructuredTextTemplateModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCarBrandPageAndFilterPage = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CarBrandPageModelFieldsReferencingFilterPageModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CarBrandPageModelFieldsReferencingFilterPageModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCarBrandPageAndSeoMetaTemplate = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CarBrandPageModelFieldsReferencingSeoMetaTemplateModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CarBrandPageModelFieldsReferencingSeoMetaTemplateModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCarBrandPageAndStringTemplate = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CarBrandPageModelFieldsReferencingStringTemplateModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CarBrandPageModelFieldsReferencingStringTemplateModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCarBrandPageAndStructuredTextTemplate = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CarBrandPageModelFieldsReferencingStructuredTextTemplateModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CarBrandPageModelFieldsReferencingStructuredTextTemplateModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCarCategoryPageAndFilterPage = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CarCategoryPageModelFieldsReferencingFilterPageModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CarCategoryPageModelFieldsReferencingFilterPageModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCarCategoryPageAndSeoMetaTemplate = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CarCategoryPageModelFieldsReferencingSeoMetaTemplateModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CarCategoryPageModelFieldsReferencingSeoMetaTemplateModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCarCategoryPageAndStructuredTextTemplate = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CarCategoryPageModelFieldsReferencingStructuredTextTemplateModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CarCategoryPageModelFieldsReferencingStructuredTextTemplateModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCarFamilyPageAndCarBrandPage = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CarFamilyPageModelFieldsReferencingCarBrandPageModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CarFamilyPageModelFieldsReferencingCarBrandPageModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCarFamilyPageAndFilterPage = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CarFamilyPageModelFieldsReferencingFilterPageModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CarFamilyPageModelFieldsReferencingFilterPageModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCategoryOrderAndCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CategoryOrderModelFieldsReferencingCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CategoryOrderModelFieldsReferencingCategoryModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCategoryOrderAndPage = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CategoryOrderModelFieldsReferencingPageModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CategoryOrderModelFieldsReferencingPageModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenDynamicPageAndDynamicPage = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<DynamicPageModelFieldsReferencingDynamicPageModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<DynamicPageModelFieldsReferencingDynamicPageModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenPromoSettingAndFilterPage = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<PromoSettingModelFieldsReferencingFilterPageModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<PromoSettingModelFieldsReferencingFilterPageModel>>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenArticleAndCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenArticleAndCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenArticleAndStructuredTextTemplate = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenArticleAndStructuredTextTemplate>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCarBrandPageAndFilterPage = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCarBrandPageAndFilterPage>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCarBrandPageAndSeoMetaTemplate = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCarBrandPageAndSeoMetaTemplate>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCarBrandPageAndStringTemplate = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCarBrandPageAndStringTemplate>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCarBrandPageAndStructuredTextTemplate = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCarBrandPageAndStructuredTextTemplate>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCarCategoryPageAndFilterPage = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCarCategoryPageAndFilterPage>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCarCategoryPageAndSeoMetaTemplate = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCarCategoryPageAndSeoMetaTemplate>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCarCategoryPageAndStructuredTextTemplate = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCarCategoryPageAndStructuredTextTemplate>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCarFamilyPageAndCarBrandPage = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCarFamilyPageAndCarBrandPage>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCarFamilyPageAndFilterPage = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCarFamilyPageAndFilterPage>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCategoryOrderAndCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCategoryOrderAndCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCategoryOrderAndPage = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCategoryOrderAndPage>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenDynamicPageAndDynamicPage = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenDynamicPageAndDynamicPage>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenPromoSettingAndFilterPage = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenPromoSettingAndFilterPage>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
};

export type ItemStatus =
  | 'draft'
  | 'published'
  | 'updated';

/** Specifies how to filter JSON fields */
export type JsonFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

/** Block of type Leasing Partner Navigation Item (leasing_partner_navigation_item) */
export type LeasingPartnerNavigationItemRecord = RecordInterface & {
  __typename?: 'LeasingPartnerNavigationItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  logo?: Maybe<FileField>;
  scrollTargetId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Leasing Partner Navigation Item (leasing_partner_navigation_item) */
export type LeasingPartnerNavigationItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type LeasingPartnerNavigationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LeasingPartnerNavigationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LeasingPartnerNavigationModelFilter>>>;
  helpText?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
};

/** Block of type Leasing Partner Navigation (leasing_partner_navigation) */
export type LeasingPartnerNavigationRecord = RecordInterface & {
  __typename?: 'LeasingPartnerNavigationRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  helpText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  partnerLogos: Array<LeasingPartnerNavigationItemRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Leasing Partner Navigation (leasing_partner_navigation) */
export type LeasingPartnerNavigationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type LeasingPartnerPresentationModelDescriptionField = {
  __typename?: 'LeasingPartnerPresentationModelDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type LeasingPartnerPresentationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LeasingPartnerPresentationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LeasingPartnerPresentationModelFilter>>>;
  anchorId?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  interestConfirmationDetailsHeading?: InputMaybe<StringFilter>;
  interestConfirmationSubjectHeading?: InputMaybe<StringFilter>;
  interestConfirmationText?: InputMaybe<TextFilter>;
  interestConfirmationTitle?: InputMaybe<StringFilter>;
  interestModalIntro?: InputMaybe<TextFilter>;
  interestModalTitle?: InputMaybe<StringFilter>;
  interestSubmitButtonText?: InputMaybe<StringFilter>;
  leasingProvider?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileFilter>;
  partnerName?: InputMaybe<StringFilter>;
  priceFootnote?: InputMaybe<StringFilter>;
  promotionHeading?: InputMaybe<StringFilter>;
  promotionVehicleCards?: InputMaybe<LinksFilter>;
  uspHeading?: InputMaybe<StringFilter>;
};

export type LeasingPartnerPresentationModelInterestConsentLabelField = {
  __typename?: 'LeasingPartnerPresentationModelInterestConsentLabelField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Leasing Partner Presentation (leasing_partner_presentation) */
export type LeasingPartnerPresentationRecord = RecordInterface & {
  __typename?: 'LeasingPartnerPresentationRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  anchorId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<LeasingPartnerPresentationModelDescriptionField>;
  id: Scalars['ItemId'];
  interestConfirmationDetailsHeading?: Maybe<Scalars['String']>;
  interestConfirmationSubjectHeading?: Maybe<Scalars['String']>;
  interestConfirmationText?: Maybe<Scalars['String']>;
  interestConfirmationTitle?: Maybe<Scalars['String']>;
  interestConsentLabel?: Maybe<LeasingPartnerPresentationModelInterestConsentLabelField>;
  interestModalIntro?: Maybe<Scalars['String']>;
  interestModalTitle?: Maybe<Scalars['String']>;
  interestSubmitButtonText?: Maybe<Scalars['String']>;
  leasingProvider?: Maybe<Scalars['String']>;
  linkButton?: Maybe<ButtonRecord>;
  logo?: Maybe<FileField>;
  partnerName?: Maybe<Scalars['String']>;
  priceFootnote?: Maybe<Scalars['String']>;
  promotionButton?: Maybe<ButtonRecord>;
  promotionCards: Array<LeasingPromotionCardRecord>;
  promotionHeading?: Maybe<Scalars['String']>;
  promotionVehicleCards: Array<LeasingPromotionVehicleCardRecord>;
  updatedAt: Scalars['DateTime'];
  uspHeading?: Maybe<Scalars['String']>;
  uspList: Array<TextRecord>;
};


/** Block of type Leasing Partner Presentation (leasing_partner_presentation) */
export type LeasingPartnerPresentationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Leasing Partner Presentation (leasing_partner_presentation) */
export type LeasingPartnerPresentationRecordInterestConfirmationTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Block of type Leasing Partner Presentation (leasing_partner_presentation) */
export type LeasingPartnerPresentationRecordInterestModalIntroArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

/** Block of type Leasing Promotion Card (leasing_promotion_card) */
export type LeasingPromotionCardRecord = RecordInterface & {
  __typename?: 'LeasingPromotionCardRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  brandAndModel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  leasingPeriodFrom?: Maybe<Scalars['IntType']>;
  linkUrl?: Maybe<Scalars['String']>;
  mileageFrom?: Maybe<Scalars['IntType']>;
  monthlyCostFrom?: Maybe<Scalars['IntType']>;
  productImage?: Maybe<FileField>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Leasing Promotion Card (leasing_promotion_card) */
export type LeasingPromotionCardRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type LeasingPromotionVehicleCardModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LeasingPromotionVehicleCardModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LeasingPromotionVehicleCardModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  brandAndModel?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  leasingPeriodFrom?: InputMaybe<IntegerFilter>;
  mileageFrom?: InputMaybe<IntegerFilter>;
  monthlyCostFrom?: InputMaybe<IntegerFilter>;
  productImage?: InputMaybe<FileFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type LeasingPromotionVehicleCardModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'brandAndModel_ASC'
  | 'brandAndModel_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'leasingPeriodFrom_ASC'
  | 'leasingPeriodFrom_DESC'
  | 'mileageFrom_ASC'
  | 'mileageFrom_DESC'
  | 'monthlyCostFrom_ASC'
  | 'monthlyCostFrom_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Leasing Promotion Vehicle Card (leasing_promotion_vehicle_card) */
export type LeasingPromotionVehicleCardRecord = RecordInterface & {
  __typename?: 'LeasingPromotionVehicleCardRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  brandAndModel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  leasingPeriodFrom?: Maybe<Scalars['IntType']>;
  mileageFrom?: Maybe<Scalars['IntType']>;
  monthlyCostFrom?: Maybe<Scalars['IntType']>;
  productImage?: Maybe<FileField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Leasing Promotion Vehicle Card (leasing_promotion_vehicle_card) */
export type LeasingPromotionVehicleCardRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Single-link fields */
export type LinkFilter = {
  /** Search for records with an exact match. The specified value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records linked to one of the specified records */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Exclude records with an exact match. The specified value must be a Record ID */
  neq?: InputMaybe<Scalars['ItemId']>;
  /** Filter records not linked to one of the specified records */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
};

export type LinkGroupModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LinkGroupModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LinkGroupModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type LinkGroupModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Link group (link_group) */
export type LinkGroupRecord = RecordInterface & {
  __typename?: 'LinkGroupRecord';
  _allLinksLocales?: Maybe<Array<TextLinkWithMetaModelRecordListListNonNullMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  links: Array<TextLinkWithMetaModelRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Link group (link_group) */
export type LinkGroupRecord_AllLinksLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Link group (link_group) */
export type LinkGroupRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Link group (link_group) */
export type LinkGroupRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Link group (link_group) */
export type LinkGroupRecordLinksArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Link group (link_group) */
export type LinkGroupRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type LinkGroupRecordListListNonNullMultiLocaleField = {
  __typename?: 'LinkGroupRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<LinkGroupRecord>;
};

/** Linking locales */
export type LinkingLocale =
  | '_nonLocalized'
  | 'da'
  | 'de'
  | 'en'
  | 'en_SE'
  | 'et'
  | 'fi'
  | 'pl'
  | 'sv';

/** Specifies how to filter by linking locales */
export type LinkingLocalesFilter = {
  /** Filter linking records that link to current record in at least one of the specified locales */
  anyIn?: InputMaybe<Array<LinkingLocale>>;
  /** Filter linking records that do not link to current record in any of the specified locales */
  notIn?: InputMaybe<Array<LinkingLocale>>;
};

/** Specifies how to filter Multiple-links fields */
export type LinksFilter = {
  /** Filter records linked to all of the specified records. The specified values must be Record IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Filter records linked to at least one of the specified records. The specified values must be Record IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Search for records with an exact match. The specified values must be Record IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records not linked to any of the specified records. The specified values must be Record IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
};

/** Specifies how to filter by locale */
export type LocalesFilter = {
  /** Filter records that are localized in all the specified locales */
  allIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are localized in at least one of the specified locales */
  anyIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are not localized in any of the specified locales */
  notIn?: InputMaybe<Array<SiteLocale>>;
};

export type MuxThumbnailFitMode =
  | 'crop'
  | 'pad'
  | 'preserve'
  | 'smartcrop'
  | 'stretch';

export type MuxThumbnailFormatType =
  | 'gif'
  | 'jpg'
  | 'png';

export type MuxThumbnailRotation =
  /** Rotate 90° clockwise */
  | 'ROTATE_90'
  /** Rotate 180° clockwise */
  | 'ROTATE_180'
  /** Rotate 270° clockwise */
  | 'ROTATE_270';

export type MyAuctionsWonPageModelCancellationConfirmationBodyField = {
  __typename?: 'MyAuctionsWonPageModelCancellationConfirmationBodyField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type MyAuctionsWonPageModelCancellationConfirmationBodyFieldMultiLocaleField = {
  __typename?: 'MyAuctionsWonPageModelCancellationConfirmationBodyFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<MyAuctionsWonPageModelCancellationConfirmationBodyField>;
};

export type MyAuctionsWonPageModelCancellationModalBodyField = {
  __typename?: 'MyAuctionsWonPageModelCancellationModalBodyField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type MyAuctionsWonPageModelCancellationModalBodyFieldMultiLocaleField = {
  __typename?: 'MyAuctionsWonPageModelCancellationModalBodyFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<MyAuctionsWonPageModelCancellationModalBodyField>;
};

export type MyAuctionsWonPageModelCancellationTermsField = {
  __typename?: 'MyAuctionsWonPageModelCancellationTermsField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type MyAuctionsWonPageModelCancellationTermsFieldMultiLocaleField = {
  __typename?: 'MyAuctionsWonPageModelCancellationTermsFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<MyAuctionsWonPageModelCancellationTermsField>;
};

export type MyAuctionsWonPageModelFooterContactTextField = {
  __typename?: 'MyAuctionsWonPageModelFooterContactTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type MyAuctionsWonPageModelFooterContactTextFieldMultiLocaleField = {
  __typename?: 'MyAuctionsWonPageModelFooterContactTextFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<MyAuctionsWonPageModelFooterContactTextField>;
};

export type MyAuctionsWonPageModelHelpTextField = {
  __typename?: 'MyAuctionsWonPageModelHelpTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord = RecordInterface & {
  __typename?: 'MyAuctionsWonPageRecord';
  _allCancellationAvailableTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationClosedTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationConfirmationBodyLocales?: Maybe<Array<MyAuctionsWonPageModelCancellationConfirmationBodyFieldMultiLocaleField>>;
  _allCancellationConfirmationCloseTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationConfirmationTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationModalBodyLocales?: Maybe<Array<MyAuctionsWonPageModelCancellationModalBodyFieldMultiLocaleField>>;
  _allCancellationModalCancelTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationModalConsentLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationModalSubmitTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationModalTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationRequestSentTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationRequestSentTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCancellationTermsLocales?: Maybe<Array<MyAuctionsWonPageModelCancellationTermsFieldMultiLocaleField>>;
  _allCheckoutActiveSubheadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCheckoutCallbackTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCheckoutClosedTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCheckoutCompletedTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCheckoutExpiryNoticeTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCheckoutPendingSubheadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allEmptyStateTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFooterContactTextLocales?: Maybe<Array<MyAuctionsWonPageModelFooterContactTextFieldMultiLocaleField>>;
  _allHeadlineLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  cancellationAvailableText?: Maybe<Scalars['String']>;
  cancellationButtonText?: Maybe<Scalars['String']>;
  cancellationClosedText?: Maybe<Scalars['String']>;
  cancellationConfirmationBody?: Maybe<MyAuctionsWonPageModelCancellationConfirmationBodyField>;
  cancellationConfirmationCloseText?: Maybe<Scalars['String']>;
  cancellationConfirmationTitle?: Maybe<Scalars['String']>;
  cancellationModalBody?: Maybe<MyAuctionsWonPageModelCancellationModalBodyField>;
  cancellationModalCancelText?: Maybe<Scalars['String']>;
  cancellationModalConsentLabel?: Maybe<Scalars['String']>;
  cancellationModalSubmitText?: Maybe<Scalars['String']>;
  cancellationModalTitle?: Maybe<Scalars['String']>;
  cancellationRequestSentText?: Maybe<Scalars['String']>;
  cancellationRequestSentTitle?: Maybe<Scalars['String']>;
  cancellationTerms?: Maybe<MyAuctionsWonPageModelCancellationTermsField>;
  checkoutActiveSubheading?: Maybe<Scalars['String']>;
  checkoutCallbackText?: Maybe<Scalars['String']>;
  checkoutClosedText?: Maybe<Scalars['String']>;
  checkoutCompletedText?: Maybe<Scalars['String']>;
  checkoutExpiryNoticeText?: Maybe<Scalars['String']>;
  checkoutPendingSubheading?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emptyStateText?: Maybe<Scalars['String']>;
  footerContactText?: Maybe<MyAuctionsWonPageModelFooterContactTextField>;
  headline?: Maybe<Scalars['String']>;
  helpText?: Maybe<MyAuctionsWonPageModelHelpTextField>;
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationAvailableTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationClosedTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationConfirmationBodyLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationConfirmationCloseTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationConfirmationTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationModalBodyLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationModalCancelTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationModalConsentLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationModalSubmitTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationModalTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationRequestSentTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationRequestSentTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCancellationTermsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCheckoutActiveSubheadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCheckoutCallbackTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCheckoutClosedTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCheckoutCompletedTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCheckoutExpiryNoticeTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllCheckoutPendingSubheadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllEmptyStateTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllFooterContactTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_AllHeadlineLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationAvailableTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationClosedTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationConfirmationBodyArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationConfirmationCloseTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationConfirmationTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationModalBodyArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationModalCancelTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationModalConsentLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationModalSubmitTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationModalTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationRequestSentTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationRequestSentTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCancellationTermsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCheckoutActiveSubheadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCheckoutCallbackTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCheckoutClosedTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCheckoutCompletedTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCheckoutExpiryNoticeTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordCheckoutPendingSubheadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordEmptyStateTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordFooterContactTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type My Auctions – Won (my_auctions_won_page) */
export type MyAuctionsWonPageRecordHeadlineArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type NavigationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  loggedInNavigationTitle?: InputMaybe<StringFilter>;
  navigationTitle?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  secondaryNavigationTitle?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type NavigationModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'loggedInNavigationTitle_ASC'
  | 'loggedInNavigationTitle_DESC'
  | 'navigationTitle_ASC'
  | 'navigationTitle_DESC'
  | 'position_ASC'
  | 'position_DESC'
  | 'secondaryNavigationTitle_ASC'
  | 'secondaryNavigationTitle_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Block of type Navigation primary link (navigation_primary_link) */
export type NavigationPrimaryLinkRecord = RecordInterface & {
  __typename?: 'NavigationPrimaryLinkRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  subNavigation?: Maybe<NavigationRecord>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Navigation primary link (navigation_primary_link) */
export type NavigationPrimaryLinkRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type NavigationPrimaryLinkRecordListListNonNullMultiLocaleField = {
  __typename?: 'NavigationPrimaryLinkRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<NavigationPrimaryLinkRecord>;
};

/** Record of type Navigation (navigation) */
export type NavigationRecord = RecordInterface & {
  __typename?: 'NavigationRecord';
  _allLoggedInNavigationLocales?: Maybe<Array<TextLinkRecordListListNonNullMultiLocaleField>>;
  _allLoggedInNavigationTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNavigationTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPrimaryNavigationLocales?: Maybe<Array<NavigationPrimaryLinkRecordListListNonNullMultiLocaleField>>;
  _allSecondaryNavigationLocales?: Maybe<Array<TextLinkRecordListListNonNullMultiLocaleField>>;
  _allSecondaryNavigationTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allUtilityBarNavigationLocales?: Maybe<Array<TextIconWithLinkRecordListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  loggedInNavigation: Array<TextLinkRecord>;
  loggedInNavigationTitle?: Maybe<Scalars['String']>;
  navigationTitle?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['IntType']>;
  primaryNavigation: Array<NavigationPrimaryLinkRecord>;
  secondaryNavigation: Array<TextLinkRecord>;
  secondaryNavigationTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  utilityBarNavigation: Array<TextIconWithLinkRecord>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecord_AllLoggedInNavigationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecord_AllLoggedInNavigationTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecord_AllNavigationTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecord_AllPrimaryNavigationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecord_AllSecondaryNavigationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecord_AllSecondaryNavigationTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecord_AllUtilityBarNavigationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecordLoggedInNavigationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecordLoggedInNavigationTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecordNavigationTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecordPrimaryNavigationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecordSecondaryNavigationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecordSecondaryNavigationTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Navigation (navigation) */
export type NavigationRecordUtilityBarNavigationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Newsletter SignUp (newsletter_signup) */
export type NewsletterSignupRecord = RecordInterface & {
  __typename?: 'NewsletterSignupRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  newsletterType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Newsletter SignUp (newsletter_signup) */
export type NewsletterSignupRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type NewsletterSignupRecordListListNonNullMultiLocaleField = {
  __typename?: 'NewsletterSignupRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<NewsletterSignupRecord>;
};

export type ObjectConditionModelTextField = {
  __typename?: 'ObjectConditionModelTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Object condition (object_condition) */
export type ObjectConditionRecord = RecordInterface & {
  __typename?: 'ObjectConditionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  condition?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  link?: Maybe<TextLinkRecord>;
  text?: Maybe<ObjectConditionModelTextField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Object condition (object_condition) */
export type ObjectConditionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ObjectConditionRecordListListNonNullMultiLocaleField = {
  __typename?: 'ObjectConditionRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<ObjectConditionRecord>;
};

export type ObjectPageModelBuyMethodsLoanWarningField = {
  __typename?: 'ObjectPageModelBuyMethodsLoanWarningField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type ObjectPageModelBuyMethodsLoanWarningFieldMultiLocaleField = {
  __typename?: 'ObjectPageModelBuyMethodsLoanWarningFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<ObjectPageModelBuyMethodsLoanWarningField>;
};

export type ObjectPageModelHeavyEquipmentFacilityExplanationField = {
  __typename?: 'ObjectPageModelHeavyEquipmentFacilityExplanationField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type ObjectPageModelHeavyEquipmentFacilityExplanationFieldMultiLocaleField = {
  __typename?: 'ObjectPageModelHeavyEquipmentFacilityExplanationFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<ObjectPageModelHeavyEquipmentFacilityExplanationField>;
};

export type ObjectPageModelHeavyEquipmentSalesTermsField = {
  __typename?: 'ObjectPageModelHeavyEquipmentSalesTermsField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type ObjectPageModelHeavyEquipmentSalesTermsFieldMultiLocaleField = {
  __typename?: 'ObjectPageModelHeavyEquipmentSalesTermsFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<ObjectPageModelHeavyEquipmentSalesTermsField>;
};

/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord = RecordInterface & {
  __typename?: 'ObjectPageRecord';
  _allBrakesLocales?: Maybe<Array<InspectionBlockRecordMultiLocaleField>>;
  _allBuyMethodsBiddingTutorialLinkLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allBuyMethodsFixedPriceTutorialLinkLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allBuyMethodsLoanCalculationExplanationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allBuyMethodsLoanWarningLocales?: Maybe<Array<ObjectPageModelBuyMethodsLoanWarningFieldMultiLocaleField>>;
  _allContactLocales?: Maybe<Array<ContactSectionRecordListListNonNullMultiLocaleField>>;
  _allDeliveryCalculatorDescriptorLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allDeliveryCalculatorDisclaimerLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allDeliveryCalculatorTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allDrivetrainLocales?: Maybe<Array<InspectionBlockRecordMultiLocaleField>>;
  _allEcoBulletPointsLocales?: Maybe<Array<TextRecordListListNonNullMultiLocaleField>>;
  _allEcoDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allEcoImageDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allEcoReadMoreTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allEcoReadMoreUrlLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allEcoSubtitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allEcoTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allExitButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allExteriorLocales?: Maybe<Array<InspectionBlockRecordMultiLocaleField>>;
  _allFinalButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFinalLinkLocales?: Maybe<Array<TextLinkRecordMultiLocaleField>>;
  _allGuideStepsLocales?: Maybe<Array<DescriptionRecordListListNonNullMultiLocaleField>>;
  _allHeavyEquipmentDescriptionWarningLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeavyEquipmentFacilityExplanationLocales?: Maybe<Array<ObjectPageModelHeavyEquipmentFacilityExplanationFieldMultiLocaleField>>;
  _allHeavyEquipmentSalesTermsLocales?: Maybe<Array<ObjectPageModelHeavyEquipmentSalesTermsFieldMultiLocaleField>>;
  _allHeavyEquipmentSalesTermsTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeavyEquipmentServicesLocales?: Maybe<Array<ObjectServiceRecordListListNonNullMultiLocaleField>>;
  _allHeavyEquipmentServicesTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeavyEquipmentVehicleFactsDisclaimerLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allInspectionOverviewLocales?: Maybe<Array<InspectionBlockRecordMultiLocaleField>>;
  _allInteriorLocales?: Maybe<Array<InspectionBlockRecordMultiLocaleField>>;
  _allNextButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allObjectConditionLocales?: Maybe<Array<ObjectConditionRecordListListNonNullMultiLocaleField>>;
  _allServicesLocales?: Maybe<Array<ObjectServiceRecordListListNonNullMultiLocaleField>>;
  _allServicesTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTechnologyAndEquipmentLocales?: Maybe<Array<InspectionBlockRecordMultiLocaleField>>;
  _allTiresLocales?: Maybe<Array<InspectionBlockRecordMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  brakes?: Maybe<InspectionBlockRecord>;
  buyMethodsBiddingTutorialLink?: Maybe<Scalars['String']>;
  buyMethodsFixedPriceTutorialLink?: Maybe<Scalars['String']>;
  buyMethodsLoanCalculationExplanation?: Maybe<Scalars['String']>;
  buyMethodsLoanWarning?: Maybe<ObjectPageModelBuyMethodsLoanWarningField>;
  contact: Array<ContactSectionRecord>;
  contactSectionControllerAuction?: Maybe<Scalars['BooleanType']>;
  contactSectionControllerFixedPrice?: Maybe<Scalars['BooleanType']>;
  createdAt: Scalars['DateTime'];
  deliveryCalculatorDescriptor?: Maybe<Scalars['String']>;
  deliveryCalculatorDisclaimer?: Maybe<Scalars['String']>;
  deliveryCalculatorTitle?: Maybe<Scalars['String']>;
  drivetrain?: Maybe<InspectionBlockRecord>;
  ecoBulletPoints: Array<TextRecord>;
  ecoDescription?: Maybe<Scalars['String']>;
  ecoImageDescription?: Maybe<Scalars['String']>;
  ecoReadMoreText?: Maybe<Scalars['String']>;
  ecoReadMoreUrl?: Maybe<Scalars['String']>;
  ecoSubtitle?: Maybe<Scalars['String']>;
  ecoTitle?: Maybe<Scalars['String']>;
  exitButtonText?: Maybe<Scalars['String']>;
  exterior?: Maybe<InspectionBlockRecord>;
  finalButtonText?: Maybe<Scalars['String']>;
  finalLink?: Maybe<TextLinkRecord>;
  guideSteps: Array<DescriptionRecord>;
  heavyEquipmentDescriptionWarning?: Maybe<Scalars['String']>;
  heavyEquipmentFacilityExplanation?: Maybe<ObjectPageModelHeavyEquipmentFacilityExplanationField>;
  heavyEquipmentSalesTerms?: Maybe<ObjectPageModelHeavyEquipmentSalesTermsField>;
  heavyEquipmentSalesTermsTitle?: Maybe<Scalars['String']>;
  heavyEquipmentServices: Array<ObjectServiceRecord>;
  heavyEquipmentServicesTitle?: Maybe<Scalars['String']>;
  heavyEquipmentVehicleFactsDisclaimer?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  inspectionOverview?: Maybe<InspectionBlockRecord>;
  interior?: Maybe<InspectionBlockRecord>;
  nextButtonText?: Maybe<Scalars['String']>;
  objectCondition: Array<ObjectConditionRecord>;
  services: Array<ObjectServiceRecord>;
  servicesTitle?: Maybe<Scalars['String']>;
  technologyAndEquipment?: Maybe<InspectionBlockRecord>;
  tires?: Maybe<InspectionBlockRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllBrakesLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllBuyMethodsBiddingTutorialLinkLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllBuyMethodsFixedPriceTutorialLinkLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllBuyMethodsLoanCalculationExplanationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllBuyMethodsLoanWarningLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllContactLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllDeliveryCalculatorDescriptorLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllDeliveryCalculatorDisclaimerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllDeliveryCalculatorTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllDrivetrainLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllEcoBulletPointsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllEcoDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllEcoImageDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllEcoReadMoreTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllEcoReadMoreUrlLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllEcoSubtitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllEcoTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllExitButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllExteriorLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllFinalButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllFinalLinkLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllGuideStepsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllHeavyEquipmentDescriptionWarningLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllHeavyEquipmentFacilityExplanationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllHeavyEquipmentSalesTermsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllHeavyEquipmentSalesTermsTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllHeavyEquipmentServicesLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllHeavyEquipmentServicesTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllHeavyEquipmentVehicleFactsDisclaimerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllInspectionOverviewLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllInteriorLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllNextButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllObjectConditionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllServicesLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllServicesTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllTechnologyAndEquipmentLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_AllTiresLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordBrakesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordBuyMethodsBiddingTutorialLinkArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordBuyMethodsFixedPriceTutorialLinkArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordBuyMethodsLoanCalculationExplanationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordBuyMethodsLoanWarningArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordContactArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordDeliveryCalculatorDescriptorArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordDeliveryCalculatorDisclaimerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordDeliveryCalculatorTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordDrivetrainArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordEcoBulletPointsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordEcoDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordEcoImageDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordEcoReadMoreTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordEcoReadMoreUrlArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordEcoSubtitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordEcoTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordExitButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordExteriorArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordFinalButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordFinalLinkArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordGuideStepsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordHeavyEquipmentDescriptionWarningArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordHeavyEquipmentFacilityExplanationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordHeavyEquipmentSalesTermsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordHeavyEquipmentSalesTermsTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordHeavyEquipmentServicesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordHeavyEquipmentServicesTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordHeavyEquipmentVehicleFactsDisclaimerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordInspectionOverviewArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordInteriorArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordNextButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordObjectConditionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordServicesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordServicesTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordTechnologyAndEquipmentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🚗 Object page (object_page) */
export type ObjectPageRecordTiresArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type ObjectServiceModelContentField = {
  __typename?: 'ObjectServiceModelContentField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Object service (object_service) */
export type ObjectServiceRecord = RecordInterface & {
  __typename?: 'ObjectServiceRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  active?: Maybe<Scalars['BooleanType']>;
  content?: Maybe<ObjectServiceModelContentField>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  excludeFromVehicleTypes: Array<VehicleTypeRecord>;
  footnote?: Maybe<Scalars['String']>;
  icon?: Maybe<FileField>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  jsonData?: Maybe<Scalars['JsonField']>;
  link: Array<TextLinkRecord>;
  serviceType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Object service (object_service) */
export type ObjectServiceRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ObjectServiceRecordListListNonNullMultiLocaleField = {
  __typename?: 'ObjectServiceRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<ObjectServiceRecord>;
};

export type OptionalHeroModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<OptionalHeroModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OptionalHeroModelFilter>>>;
  contentAlignment?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  showHero?: InputMaybe<BooleanFilter>;
  subtitle?: InputMaybe<StringFilter>;
  textColor?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

/** Block of type Optional Hero (optional_hero) */
export type OptionalHeroRecord = RecordInterface & {
  __typename?: 'OptionalHeroRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  button: Array<PromoButtonRecord>;
  contentAlignment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  showHero?: Maybe<Scalars['BooleanType']>;
  subtitle?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Optional Hero (optional_hero) */
export type OptionalHeroRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type OptionalHeroRecordListListNonNullMultiLocaleField = {
  __typename?: 'OptionalHeroRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<OptionalHeroRecord>;
};

export type OptionalHeroRecordMultiLocaleField = {
  __typename?: 'OptionalHeroRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<OptionalHeroRecord>;
};

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

export type PageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  loggedInContent?: InputMaybe<StructuredTextFilter>;
  loggedInTitle?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  publicContent?: InputMaybe<StructuredTextFilter>;
  publicTitle?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type PageModelLoggedInContentField = {
  __typename?: 'PageModelLoggedInContentField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PageModelLoggedInContentFieldMultiLocaleField = {
  __typename?: 'PageModelLoggedInContentFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PageModelLoggedInContentField>;
};

export type PageModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'loggedInTitle_ASC'
  | 'loggedInTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'publicTitle_ASC'
  | 'publicTitle_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type PageModelPublicContentField = {
  __typename?: 'PageModelPublicContentField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PageModelPublicContentFieldMultiLocaleField = {
  __typename?: 'PageModelPublicContentFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PageModelPublicContentField>;
};

/** Record of type Page (page) */
export type PageRecord = RecordInterface & {
  __typename?: 'PageRecord';
  _allLoggedInContentLocales?: Maybe<Array<PageModelLoggedInContentFieldMultiLocaleField>>;
  _allLoggedInTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOptionalHeroLocales?: Maybe<Array<OptionalHeroRecordMultiLocaleField>>;
  _allPublicContentLocales?: Maybe<Array<PageModelPublicContentFieldMultiLocaleField>>;
  _allPublicTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReferencingCategoryOrders: Array<CategoryOrderRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCategoryOrdersMeta: CollectionMetadata;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  loggedInContent?: Maybe<PageModelLoggedInContentField>;
  loggedInTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optionalHero?: Maybe<OptionalHeroRecord>;
  publicContent?: Maybe<PageModelPublicContentField>;
  publicTitle?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Page (page) */
export type PageRecord_AllLoggedInContentLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_AllLoggedInTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_AllOptionalHeroLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_AllPublicContentLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_AllPublicTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_AllReferencingCategoryOrdersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CategoryOrderModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CategoryOrderModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCategoryOrderAndPage>;
};


/** Record of type Page (page) */
export type PageRecord_AllReferencingCategoryOrdersMetaArgs = {
  filter?: InputMaybe<CategoryOrderModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCategoryOrderAndPage>;
};


/** Record of type Page (page) */
export type PageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordLoggedInContentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordLoggedInTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordOptionalHeroArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordPublicContentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordPublicTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by parent (tree-like collections only) */
export type ParentFilter = {
  /** Filter records children of the specified record. Value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']>;
  /** Filter records with a parent record or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

export type PartnershipItemModelDescriptionField = {
  __typename?: 'PartnershipItemModelDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PartnershipItemModelDescriptionFieldMultiLocaleField = {
  __typename?: 'PartnershipItemModelDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PartnershipItemModelDescriptionField>;
};

export type PartnershipItemModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PartnershipItemModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PartnershipItemModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  campaignCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  hasCampaignCode?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  parent?: InputMaybe<ParentFilter>;
  partnerLogo?: InputMaybe<FileFilter>;
  position?: InputMaybe<PositionFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type PartnershipItemModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'campaignCode_ASC'
  | 'campaignCode_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'hasCampaignCode_ASC'
  | 'hasCampaignCode_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'position_ASC'
  | 'position_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Partnership Item (partnership_item) */
export type PartnershipItemRecord = RecordInterface & {
  __typename?: 'PartnershipItemRecord';
  _allDescriptionLocales?: Maybe<Array<PartnershipItemModelDescriptionFieldMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  campaignCode?: Maybe<Scalars['String']>;
  children: Array<PartnershipItemRecord>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<PartnershipItemModelDescriptionField>;
  hasCampaignCode?: Maybe<Scalars['BooleanType']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  parent?: Maybe<PartnershipItemRecord>;
  partnerLogo?: Maybe<FileField>;
  position?: Maybe<Scalars['IntType']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Partnership Item (partnership_item) */
export type PartnershipItemRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Partnership Item (partnership_item) */
export type PartnershipItemRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Partnership Item (partnership_item) */
export type PartnershipItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Partnership Item (partnership_item) */
export type PartnershipItemRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Partnership Item (partnership_item) */
export type PartnershipItemRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Path item (path_item) */
export type PathItemRecord = RecordInterface & {
  __typename?: 'PathItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  buttonText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  informationText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Path item (path_item) */
export type PathItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Path item (path_item) */
export type PathItemRecordInformationTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type PathItemRecordMultiLocaleField = {
  __typename?: 'PathItemRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PathItemRecord>;
};

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']>;
};

export type PromoBannerTemplateModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PromoBannerTemplateModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PromoBannerTemplateModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<TextFilter>;
  ga4EventIdentifier?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  stampIsActive?: InputMaybe<BooleanFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type PromoBannerTemplateModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'ga4EventIdentifier_ASC'
  | 'ga4EventIdentifier_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'stampIsActive_ASC'
  | 'stampIsActive_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Promo Banner Template (promo_banner_template) */
export type PromoBannerTemplateRecord = RecordInterface & {
  __typename?: 'PromoBannerTemplateRecord';
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLinkButtonsLocales?: Maybe<Array<ButtonRecordListListNonNullMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  ga4EventIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  linkButtons: Array<ButtonRecord>;
  stamp: Array<StampRecord>;
  stampIsActive?: Maybe<Scalars['BooleanType']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Promo Banner Template (promo_banner_template) */
export type PromoBannerTemplateRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Promo Banner Template (promo_banner_template) */
export type PromoBannerTemplateRecord_AllLinkButtonsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Banner Template (promo_banner_template) */
export type PromoBannerTemplateRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Banner Template (promo_banner_template) */
export type PromoBannerTemplateRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Banner Template (promo_banner_template) */
export type PromoBannerTemplateRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Promo Banner Template (promo_banner_template) */
export type PromoBannerTemplateRecordLinkButtonsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Banner Template (promo_banner_template) */
export type PromoBannerTemplateRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Promo Button (promo_button) */
export type PromoButtonRecord = RecordInterface & {
  __typename?: 'PromoButtonRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundColorShade?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  link?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Promo Button (promo_button) */
export type PromoButtonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Promo Card (promo_card) */
export type PromoCardRecord = RecordInterface & {
  __typename?: 'PromoCardRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  applyForCategory: Array<FilterPageRecord>;
  cardPositionDesktop?: Maybe<Scalars['IntType']>;
  cardPositionPhone?: Maybe<Scalars['IntType']>;
  cardPositionTablet?: Maybe<Scalars['IntType']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  isActive?: Maybe<Scalars['BooleanType']>;
  promoCardTemplates: Array<PromoCardTemplateRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Promo Card (promo_card) */
export type PromoCardRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PromoCardRecordListListNonNullMultiLocaleField = {
  __typename?: 'PromoCardRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<PromoCardRecord>;
};

export type PromoCardTemplateModelContentBlocksField = IconListRecord | StampRecord | TitleRecord;

export type PromoCardTemplateModelContentField = {
  __typename?: 'PromoCardTemplateModelContentField';
  blocks: Array<PromoCardTemplateModelContentBlocksField>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PromoCardTemplateModelContentFieldMultiLocaleField = {
  __typename?: 'PromoCardTemplateModelContentFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PromoCardTemplateModelContentField>;
};

export type PromoCardTemplateModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PromoCardTemplateModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PromoCardTemplateModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  backgroundColorShade?: InputMaybe<StringFilter>;
  backgroundColorTheme?: InputMaybe<StringFilter>;
  cardType?: InputMaybe<StringFilter>;
  content?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  displayName?: InputMaybe<StringFilter>;
  ga4EventIdentifier?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  textColor?: InputMaybe<ColorFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type PromoCardTemplateModelLinkField = ButtonRecord | TextLinkRecord;

export type PromoCardTemplateModelLinkFieldListListNonNullMultiLocaleField = {
  __typename?: 'PromoCardTemplateModelLinkFieldListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<PromoCardTemplateModelLinkField>;
};

export type PromoCardTemplateModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'backgroundColorShade_ASC'
  | 'backgroundColorShade_DESC'
  | 'backgroundColorTheme_ASC'
  | 'backgroundColorTheme_DESC'
  | 'cardType_ASC'
  | 'cardType_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'displayName_ASC'
  | 'displayName_DESC'
  | 'ga4EventIdentifier_ASC'
  | 'ga4EventIdentifier_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecord = RecordInterface & {
  __typename?: 'PromoCardTemplateRecord';
  _allContentLocales?: Maybe<Array<PromoCardTemplateModelContentFieldMultiLocaleField>>;
  _allDisplayNameLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLinkLocales?: Maybe<Array<PromoCardTemplateModelLinkFieldListListNonNullMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  backgroundColorShade?: Maybe<Scalars['String']>;
  backgroundColorTheme?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  content?: Maybe<PromoCardTemplateModelContentField>;
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  ga4EventIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  link: Array<PromoCardTemplateModelLinkField>;
  textColor?: Maybe<ColorField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecord_AllContentLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecord_AllDisplayNameLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecord_AllLinkLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecordContentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecordDisplayNameArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecordLinkArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Card Template (promo_card_template) */
export type PromoCardTemplateRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export type PromoSettingModelFieldsReferencingFilterPageModel =
  | 'promoSetting_promoCards'
  | 'promoSetting_promoCards__promoCard_applyForCategory';

export type PromoSettingModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PromoSettingModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PromoSettingModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  usageType?: InputMaybe<StringFilter>;
};

export type PromoSettingModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'usageType_ASC'
  | 'usageType_DESC';

/** Record of type Promo Setting (promo_setting) */
export type PromoSettingRecord = RecordInterface & {
  __typename?: 'PromoSettingRecord';
  _allPromoCardsLocales?: Maybe<Array<PromoCardRecordListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  promoCards: Array<PromoCardRecord>;
  updatedAt: Scalars['DateTime'];
  usageType?: Maybe<Scalars['String']>;
};


/** Record of type Promo Setting (promo_setting) */
export type PromoSettingRecord_AllPromoCardsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Setting (promo_setting) */
export type PromoSettingRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Promo Setting (promo_setting) */
export type PromoSettingRecordPromoCardsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']>;
};

export type PurchaseAndPickUpTransferModelCommonSigningAbortedDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelCommonSigningAbortedDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelCommonSigningAbortedDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelCommonSigningAbortedDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelCommonSigningAbortedDescriptionField>;
};

export type PurchaseAndPickUpTransferModelCommonSigningFailedDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelCommonSigningFailedDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelCommonSigningFailedDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelCommonSigningFailedDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelCommonSigningFailedDescriptionField>;
};

export type PurchaseAndPickUpTransferModelCommonSigningNotFoundDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelCommonSigningNotFoundDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelCommonSigningNotFoundDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelCommonSigningNotFoundDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelCommonSigningNotFoundDescriptionField>;
};

export type PurchaseAndPickUpTransferModelPickUpCompleteStatusDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelPickUpCompleteStatusDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelPickUpCompleteStatusDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelPickUpCompleteStatusDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelPickUpCompleteStatusDescriptionField>;
};

export type PurchaseAndPickUpTransferModelPickUpDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelPickUpDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelPickUpDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelPickUpDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelPickUpDescriptionField>;
};

export type PurchaseAndPickUpTransferModelPickUpInitializedStatusDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelPickUpInitializedStatusDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelPickUpInitializedStatusDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelPickUpInitializedStatusDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelPickUpInitializedStatusDescriptionField>;
};

export type PurchaseAndPickUpTransferModelPurchaseCompleteStatusDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseCompleteStatusDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelPurchaseCompleteStatusDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseCompleteStatusDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelPurchaseCompleteStatusDescriptionField>;
};

export type PurchaseAndPickUpTransferModelPurchaseDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelPurchaseDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelPurchaseDescriptionField>;
};

export type PurchaseAndPickUpTransferModelPurchaseExplanationField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseExplanationField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelPurchaseExplanationFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseExplanationFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelPurchaseExplanationField>;
};

export type PurchaseAndPickUpTransferModelPurchaseFormDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseFormDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelPurchaseFormDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseFormDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelPurchaseFormDescriptionField>;
};

export type PurchaseAndPickUpTransferModelPurchaseInitializedStatusDescriptionField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseInitializedStatusDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PurchaseAndPickUpTransferModelPurchaseInitializedStatusDescriptionFieldMultiLocaleField = {
  __typename?: 'PurchaseAndPickUpTransferModelPurchaseInitializedStatusDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<PurchaseAndPickUpTransferModelPurchaseInitializedStatusDescriptionField>;
};

/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord = RecordInterface & {
  __typename?: 'PurchaseAndPickUpTransferRecord';
  _allCommonSigningAbortedDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelCommonSigningAbortedDescriptionFieldMultiLocaleField>>;
  _allCommonSigningAbortedTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCommonSigningFailedDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelCommonSigningFailedDescriptionFieldMultiLocaleField>>;
  _allCommonSigningFailedTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCommonSigningInitializedTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCommonSigningNotFoundDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelCommonSigningNotFoundDescriptionFieldMultiLocaleField>>;
  _allCommonSigningNotFoundTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPickUpCompleteStatusDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelPickUpCompleteStatusDescriptionFieldMultiLocaleField>>;
  _allPickUpCompleteStatusTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPickUpDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelPickUpDescriptionFieldMultiLocaleField>>;
  _allPickUpFormIdentificationQuestionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPickUpFormTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPickUpInitializedStatusDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelPickUpInitializedStatusDescriptionFieldMultiLocaleField>>;
  _allPickUpTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPickUpVehicleCardTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPurchaseCompleteStatusDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelPurchaseCompleteStatusDescriptionFieldMultiLocaleField>>;
  _allPurchaseCompleteStatusTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPurchaseDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelPurchaseDescriptionFieldMultiLocaleField>>;
  _allPurchaseExplanationLocales?: Maybe<Array<PurchaseAndPickUpTransferModelPurchaseExplanationFieldMultiLocaleField>>;
  _allPurchaseFormDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelPurchaseFormDescriptionFieldMultiLocaleField>>;
  _allPurchaseFormTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPurchaseInitializedStatusDescriptionLocales?: Maybe<Array<PurchaseAndPickUpTransferModelPurchaseInitializedStatusDescriptionFieldMultiLocaleField>>;
  _allPurchaseTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPurchaseVehicleCardTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  commonSigningAbortedDescription?: Maybe<PurchaseAndPickUpTransferModelCommonSigningAbortedDescriptionField>;
  commonSigningAbortedTitle?: Maybe<Scalars['String']>;
  commonSigningFailedDescription?: Maybe<PurchaseAndPickUpTransferModelCommonSigningFailedDescriptionField>;
  commonSigningFailedTitle?: Maybe<Scalars['String']>;
  commonSigningInitializedTitle?: Maybe<Scalars['String']>;
  commonSigningNotFoundDescription?: Maybe<PurchaseAndPickUpTransferModelCommonSigningNotFoundDescriptionField>;
  commonSigningNotFoundTitle?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  pickUpCompleteStatusDescription?: Maybe<PurchaseAndPickUpTransferModelPickUpCompleteStatusDescriptionField>;
  pickUpCompleteStatusTitle?: Maybe<Scalars['String']>;
  pickUpDescription?: Maybe<PurchaseAndPickUpTransferModelPickUpDescriptionField>;
  pickUpFormIdentificationQuestion?: Maybe<Scalars['String']>;
  pickUpFormTitle?: Maybe<Scalars['String']>;
  pickUpInitializedStatusDescription?: Maybe<PurchaseAndPickUpTransferModelPickUpInitializedStatusDescriptionField>;
  pickUpTitle?: Maybe<Scalars['String']>;
  pickUpVehicleCardTitle?: Maybe<Scalars['String']>;
  purchaseCompleteStatusDescription?: Maybe<PurchaseAndPickUpTransferModelPurchaseCompleteStatusDescriptionField>;
  purchaseCompleteStatusTitle?: Maybe<Scalars['String']>;
  purchaseDescription?: Maybe<PurchaseAndPickUpTransferModelPurchaseDescriptionField>;
  purchaseExplanation?: Maybe<PurchaseAndPickUpTransferModelPurchaseExplanationField>;
  purchaseFormDescription?: Maybe<PurchaseAndPickUpTransferModelPurchaseFormDescriptionField>;
  purchaseFormTitle?: Maybe<Scalars['String']>;
  purchaseInitializedStatusDescription?: Maybe<PurchaseAndPickUpTransferModelPurchaseInitializedStatusDescriptionField>;
  purchaseTitle?: Maybe<Scalars['String']>;
  purchaseVehicleCardTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllCommonSigningAbortedDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllCommonSigningAbortedTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllCommonSigningFailedDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllCommonSigningFailedTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllCommonSigningInitializedTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllCommonSigningNotFoundDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllCommonSigningNotFoundTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPickUpCompleteStatusDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPickUpCompleteStatusTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPickUpDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPickUpFormIdentificationQuestionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPickUpFormTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPickUpInitializedStatusDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPickUpTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPickUpVehicleCardTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPurchaseCompleteStatusDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPurchaseCompleteStatusTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPurchaseDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPurchaseExplanationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPurchaseFormDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPurchaseFormTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPurchaseInitializedStatusDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPurchaseTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_AllPurchaseVehicleCardTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordCommonSigningAbortedDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordCommonSigningAbortedTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordCommonSigningFailedDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordCommonSigningFailedTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordCommonSigningInitializedTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordCommonSigningNotFoundDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordCommonSigningNotFoundTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPickUpCompleteStatusDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPickUpCompleteStatusTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPickUpDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPickUpFormIdentificationQuestionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPickUpFormTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPickUpInitializedStatusDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPickUpTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPickUpVehicleCardTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPurchaseCompleteStatusDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPurchaseCompleteStatusTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPurchaseDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPurchaseExplanationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPurchaseFormDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPurchaseFormTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPurchaseInitializedStatusDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPurchaseTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 🧾 Purchase & Pick-Up Transfer (purchase_and_pick_up_transfer) */
export type PurchaseAndPickUpTransferRecordPurchaseVehicleCardTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type PurchaseOwnershipTransferModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PurchaseOwnershipTransferModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PurchaseOwnershipTransferModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  buttonInformationText?: InputMaybe<StringFilter>;
  contactInfo?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  identifier?: InputMaybe<StringFilter>;
  informationText?: InputMaybe<TextFilter>;
  nextStepS?: InputMaybe<LinksFilter>;
  pageTitle?: InputMaybe<StringFilter>;
  step?: InputMaybe<StringFilter>;
  subtitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  vehicleInfo?: InputMaybe<StringFilter>;
};

export type PurchaseOwnershipTransferModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'buttonInformationText_ASC'
  | 'buttonInformationText_DESC'
  | 'contactInfo_ASC'
  | 'contactInfo_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'identifier_ASC'
  | 'identifier_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'step_ASC'
  | 'step_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'vehicleInfo_ASC'
  | 'vehicleInfo_DESC';

/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord = RecordInterface & {
  __typename?: 'PurchaseOwnershipTransferRecord';
  _allButtonInformationTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allButtonLocales?: Maybe<Array<ButtonRecordMultiLocaleField>>;
  _allContactInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allInformationTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPageTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPrimaryPathLocales?: Maybe<Array<PathItemRecordMultiLocaleField>>;
  _allSecondaryPathLocales?: Maybe<Array<PathItemRecordMultiLocaleField>>;
  _allSubtitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allVehicleInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  button?: Maybe<ButtonRecord>;
  buttonInformationText?: Maybe<Scalars['String']>;
  contactInfo?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  identifier?: Maybe<Scalars['String']>;
  informationText?: Maybe<Scalars['String']>;
  nextStepS: Array<PurchaseOwnershipTransferRecord>;
  pageTitle?: Maybe<Scalars['String']>;
  primaryPath?: Maybe<PathItemRecord>;
  secondaryPath?: Maybe<PathItemRecord>;
  step?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vehicleInfo?: Maybe<Scalars['String']>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllButtonInformationTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllContactInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllInformationTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllPageTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllPrimaryPathLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllSecondaryPathLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllSubtitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_AllVehicleInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordButtonInformationTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordContactInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordInformationTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordPageTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordPrimaryPathArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordSecondaryPathArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordSubtitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Purchase ownership / transfer (purchase_ownership_transfer) */
export type PurchaseOwnershipTransferRecordVehicleInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query = {
  __typename?: 'Query';
  /** Returns meta information regarding a record collection */
  _allArticlesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBlockButtonsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allButtonModelsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCarBrandPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCarCategoryPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCarFamilyPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCategoriesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCheckoutsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allConditionInfoModelsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allDynamicPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFacilitiesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFaqQuestionNewsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFaqsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFeaturedCardsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFeaturedObjectsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFilterCardTooltipsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFilterPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFormFieldsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFormsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allHeroModelsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allLeasingPromotionVehicleCardsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allLinkGroupsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allNavigationsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPartnershipItemsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPromoBannerTemplatesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPromoCardTemplatesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPromoSettingsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPurchaseOwnershipTransfersMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allRedirectsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSchemaMigrationsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSeoInformationsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSeoMetaTemplatesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSiteMessagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allStringTemplatesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allStructuredTextTemplatesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allStructuredTextsMeta: CollectionMetadata;
  /** Returns meta information regarding an assets collection */
  _allUploadsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allVehicleMajorFeatureModalsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allVehicleTypesMeta: CollectionMetadata;
  /** Returns the single instance record */
  _site: Site;
  /** Returns a collection of records */
  allArticles: Array<ArticleRecord>;
  /** Returns a collection of records */
  allBlockButtons: Array<BlockButtonRecord>;
  /** Returns a collection of records */
  allButtonModels: Array<ButtonModelRecord>;
  /** Returns a collection of records */
  allCarBrandPages: Array<CarBrandPageRecord>;
  /** Returns a collection of records */
  allCarCategoryPages: Array<CarCategoryPageRecord>;
  /** Returns a collection of records */
  allCarFamilyPages: Array<CarFamilyPageRecord>;
  /** Returns a collection of records */
  allCategories: Array<CategoryRecord>;
  /** Returns a collection of records */
  allCheckouts: Array<CheckoutRecord>;
  /** Returns a collection of records */
  allConditionInfoModels: Array<ConditionInfoModelRecord>;
  /** Returns a collection of records */
  allDynamicPages: Array<DynamicPageRecord>;
  /** Returns a collection of records */
  allFacilities: Array<FacilityRecord>;
  /** Returns a collection of records */
  allFaqQuestionNews: Array<FaqQuestionNewRecord>;
  /** Returns a collection of records */
  allFaqs: Array<FaqRecord>;
  /** Returns a collection of records */
  allFeaturedCards: Array<FeaturedCardRecord>;
  /** Returns a collection of records */
  allFeaturedObjects: Array<FeaturedObjectRecord>;
  /** Returns a collection of records */
  allFilterCardTooltips: Array<FilterCardTooltipRecord>;
  /** Returns a collection of records */
  allFilterPages: Array<FilterPageRecord>;
  /** Returns a collection of records */
  allFormFields: Array<FormFieldRecord>;
  /** Returns a collection of records */
  allForms: Array<FormRecord>;
  /** Returns a collection of records */
  allHeroModels: Array<HeroModelRecord>;
  /** Returns a collection of records */
  allLeasingPromotionVehicleCards: Array<LeasingPromotionVehicleCardRecord>;
  /** Returns a collection of records */
  allLinkGroups: Array<LinkGroupRecord>;
  /** Returns a collection of records */
  allNavigations: Array<NavigationRecord>;
  /** Returns a collection of records */
  allPages: Array<PageRecord>;
  /** Returns a collection of records */
  allPartnershipItems: Array<PartnershipItemRecord>;
  /** Returns a collection of records */
  allPromoBannerTemplates: Array<PromoBannerTemplateRecord>;
  /** Returns a collection of records */
  allPromoCardTemplates: Array<PromoCardTemplateRecord>;
  /** Returns a collection of records */
  allPromoSettings: Array<PromoSettingRecord>;
  /** Returns a collection of records */
  allPurchaseOwnershipTransfers: Array<PurchaseOwnershipTransferRecord>;
  /** Returns a collection of records */
  allRedirects: Array<RedirectRecord>;
  /** Returns a collection of records */
  allSchemaMigrations: Array<SchemaMigrationRecord>;
  /** Returns a collection of records */
  allSeoInformations: Array<SeoInformationRecord>;
  /** Returns a collection of records */
  allSeoMetaTemplates: Array<SeoMetaTemplateRecord>;
  /** Returns a collection of records */
  allSiteMessages: Array<SiteMessageRecord>;
  /** Returns a collection of records */
  allStringTemplates: Array<StringTemplateRecord>;
  /** Returns a collection of records */
  allStructuredTextTemplates: Array<StructuredTextTemplateRecord>;
  /** Returns a collection of records */
  allStructuredTexts: Array<StructuredTextRecord>;
  /** Returns a collection of assets */
  allUploads: Array<FileField>;
  /** Returns a collection of records */
  allVehicleMajorFeatureModals: Array<VehicleMajorFeatureModalRecord>;
  /** Returns a collection of records */
  allVehicleTypes: Array<VehicleTypeRecord>;
  /** Returns a specific record */
  article?: Maybe<ArticleRecord>;
  /** Returns the single instance record */
  auctionTipsModel?: Maybe<AuctionTipsModelRecord>;
  /** Returns a specific record */
  blockButton?: Maybe<BlockButtonRecord>;
  /** Returns a specific record */
  buttonModel?: Maybe<ButtonModelRecord>;
  /** Returns a specific record */
  carBrandPage?: Maybe<CarBrandPageRecord>;
  /** Returns a specific record */
  carCategoryPage?: Maybe<CarCategoryPageRecord>;
  /** Returns a specific record */
  carFamilyPage?: Maybe<CarFamilyPageRecord>;
  /** Returns the single instance record */
  carGuide?: Maybe<CarGuideRecord>;
  /** Returns a specific record */
  category?: Maybe<CategoryRecord>;
  /** Returns the single instance record */
  categoryOrder?: Maybe<CategoryOrderRecord>;
  /** Returns a specific record */
  checkout?: Maybe<CheckoutRecord>;
  /** Returns the single instance record */
  companyCampaignExistingCustomerPage?: Maybe<CompanyCampaignExistingCustomerPageRecord>;
  /** Returns the single instance record */
  companyCampaignPage?: Maybe<CompanyCampaignPageRecord>;
  /** Returns a specific record */
  conditionInfoModel?: Maybe<ConditionInfoModelRecord>;
  /** Returns a specific record */
  dynamicPage?: Maybe<DynamicPageRecord>;
  /** Returns the single instance record */
  emailSubscriptionManagement?: Maybe<EmailSubscriptionManagementRecord>;
  /** Returns a specific record */
  facility?: Maybe<FacilityRecord>;
  /** Returns a specific record */
  faq?: Maybe<FaqRecord>;
  /** Returns a specific record */
  faqQuestionNew?: Maybe<FaqQuestionNewRecord>;
  /** Returns a specific record */
  featuredCard?: Maybe<FeaturedCardRecord>;
  /** Returns a specific record */
  featuredObject?: Maybe<FeaturedObjectRecord>;
  /** Returns a specific record */
  filterCardTooltip?: Maybe<FilterCardTooltipRecord>;
  /** Returns a specific record */
  filterPage?: Maybe<FilterPageRecord>;
  /** Returns the single instance record */
  fixedPriceTipsModel?: Maybe<FixedPriceTipsModelRecord>;
  /** Returns the single instance record */
  fmPage?: Maybe<FmPageRecord>;
  /** Returns the single instance record */
  fmTemporaryMessage?: Maybe<FmTemporaryMessageRecord>;
  /** Returns the single instance record */
  footerNavigation?: Maybe<FooterNavigationRecord>;
  /** Returns a specific record */
  form?: Maybe<FormRecord>;
  /** Returns a specific record */
  formField?: Maybe<FormFieldRecord>;
  /** Returns the single instance record */
  globalConfiguration?: Maybe<GlobalConfigurationRecord>;
  /** Returns a specific record */
  heroModel?: Maybe<HeroModelRecord>;
  /** Returns a specific record */
  leasingPromotionVehicleCard?: Maybe<LeasingPromotionVehicleCardRecord>;
  /** Returns a specific record */
  linkGroup?: Maybe<LinkGroupRecord>;
  /** Returns the single instance record */
  myAuctionsWonPage?: Maybe<MyAuctionsWonPageRecord>;
  /** Returns a specific record */
  navigation?: Maybe<NavigationRecord>;
  /** Returns the single instance record */
  objectPage?: Maybe<ObjectPageRecord>;
  /** Returns a specific record */
  page?: Maybe<PageRecord>;
  /** Returns a specific record */
  partnershipItem?: Maybe<PartnershipItemRecord>;
  /** Returns a specific record */
  promoBannerTemplate?: Maybe<PromoBannerTemplateRecord>;
  /** Returns a specific record */
  promoCardTemplate?: Maybe<PromoCardTemplateRecord>;
  /** Returns a specific record */
  promoSetting?: Maybe<PromoSettingRecord>;
  /** Returns the single instance record */
  purchaseAndPickUpTransfer?: Maybe<PurchaseAndPickUpTransferRecord>;
  /** Returns a specific record */
  purchaseOwnershipTransfer?: Maybe<PurchaseOwnershipTransferRecord>;
  /** Returns a specific record */
  redirect?: Maybe<RedirectRecord>;
  /** Returns a specific record */
  schemaMigration?: Maybe<SchemaMigrationRecord>;
  /** Returns the single instance record */
  sellFlowPage?: Maybe<SellFlowPageRecord>;
  /** Returns a specific record */
  seoInformation?: Maybe<SeoInformationRecord>;
  /** Returns a specific record */
  seoMetaTemplate?: Maybe<SeoMetaTemplateRecord>;
  /** Returns a specific record */
  siteMessage?: Maybe<SiteMessageRecord>;
  /** Returns the single instance record */
  startPage?: Maybe<StartPageRecord>;
  /** Returns a specific record */
  stringTemplate?: Maybe<StringTemplateRecord>;
  /** Returns a specific record */
  structuredText?: Maybe<StructuredTextRecord>;
  /** Returns a specific record */
  structuredTextTemplate?: Maybe<StructuredTextTemplateRecord>;
  /** Returns a specific asset */
  upload?: Maybe<FileField>;
  /** Returns the single instance record */
  valuationPage?: Maybe<ValuationPageRecord>;
  /** Returns a specific record */
  vehicleMajorFeatureModal?: Maybe<VehicleMajorFeatureModalRecord>;
  /** Returns a specific record */
  vehicleType?: Maybe<VehicleTypeRecord>;
};


/** The query root for this schema */
export type Query_AllArticlesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ArticleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllBlockButtonsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlockButtonModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllButtonModelsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ButtonModelModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCarBrandPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarBrandPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCarCategoryPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarCategoryPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCarFamilyPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarFamilyPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCategoriesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCheckoutsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CheckoutModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllConditionInfoModelsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ConditionInfoModelModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllDynamicPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<DynamicPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFacilitiesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FacilityModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFaqQuestionNewsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FaqQuestionNewModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFaqsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FaqModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFeaturedCardsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedCardModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFeaturedObjectsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedObjectModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFilterCardTooltipsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FilterCardTooltipModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFilterPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FilterPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFormFieldsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FormFieldModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFormsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FormModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllHeroModelsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HeroModelModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllLeasingPromotionVehicleCardsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LeasingPromotionVehicleCardModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllLinkGroupsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LinkGroupModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllNavigationsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<NavigationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPartnershipItemsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PartnershipItemModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPromoBannerTemplatesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoBannerTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPromoCardTemplatesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoCardTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPromoSettingsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoSettingModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPurchaseOwnershipTransfersMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PurchaseOwnershipTransferModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllRedirectsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<RedirectModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllSchemaMigrationsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SchemaMigrationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllSeoInformationsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SeoInformationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllSeoMetaTemplatesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SeoMetaTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllSiteMessagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SiteMessageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllStringTemplatesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<StringTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllStructuredTextTemplatesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<StructuredTextTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllStructuredTextsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<StructuredTextModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllUploadsMetaArgs = {
  filter?: InputMaybe<UploadFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllVehicleMajorFeatureModalsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<VehicleMajorFeatureModalModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllVehicleTypesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<VehicleTypeModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_SiteArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryAllArticlesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ArticleModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ArticleModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllBlockButtonsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlockButtonModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlockButtonModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllButtonModelsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ButtonModelModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ButtonModelModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllCarBrandPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarBrandPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarBrandPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllCarCategoryPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarCategoryPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarCategoryPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllCarFamilyPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarFamilyPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarFamilyPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllCategoriesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CategoryModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CategoryModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllCheckoutsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CheckoutModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CheckoutModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllConditionInfoModelsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ConditionInfoModelModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ConditionInfoModelModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllDynamicPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<DynamicPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<DynamicPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllFacilitiesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FacilityModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FacilityModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllFaqQuestionNewsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FaqQuestionNewModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FaqQuestionNewModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllFaqsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FaqModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FaqModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllFeaturedCardsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedCardModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeaturedCardModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllFeaturedObjectsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedObjectModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeaturedObjectModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllFilterCardTooltipsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FilterCardTooltipModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FilterCardTooltipModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllFilterPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FilterPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FilterPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllFormFieldsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FormFieldModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FormFieldModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllFormsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FormModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FormModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllHeroModelsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HeroModelModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HeroModelModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllLeasingPromotionVehicleCardsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LeasingPromotionVehicleCardModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LeasingPromotionVehicleCardModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllLinkGroupsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LinkGroupModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LinkGroupModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllNavigationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<NavigationModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<NavigationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllPartnershipItemsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PartnershipItemModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PartnershipItemModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllPromoBannerTemplatesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoBannerTemplateModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PromoBannerTemplateModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllPromoCardTemplatesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoCardTemplateModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PromoCardTemplateModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllPromoSettingsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoSettingModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PromoSettingModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllPurchaseOwnershipTransfersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PurchaseOwnershipTransferModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PurchaseOwnershipTransferModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllRedirectsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<RedirectModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<RedirectModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllSchemaMigrationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SchemaMigrationModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SchemaMigrationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllSeoInformationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SeoInformationModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SeoInformationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllSeoMetaTemplatesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SeoMetaTemplateModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SeoMetaTemplateModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllSiteMessagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SiteMessageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SiteMessageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllStringTemplatesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<StringTemplateModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<StringTemplateModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllStructuredTextTemplatesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<StructuredTextTemplateModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<StructuredTextTemplateModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllStructuredTextsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<StructuredTextModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<StructuredTextModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllUploadsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UploadFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllVehicleMajorFeatureModalsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<VehicleMajorFeatureModalModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<VehicleMajorFeatureModalModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryAllVehicleTypesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<VehicleTypeModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<VehicleTypeModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryArticleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ArticleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ArticleModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAuctionTipsModelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryBlockButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlockButtonModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlockButtonModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryButtonModelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ButtonModelModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ButtonModelModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCarBrandPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarBrandPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarBrandPageModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCarCategoryPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarCategoryPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarCategoryPageModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCarFamilyPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarFamilyPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarFamilyPageModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCarGuideArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryCategoryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CategoryModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCategoryOrderArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryCheckoutArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CheckoutModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CheckoutModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCompanyCampaignExistingCustomerPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryCompanyCampaignPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryConditionInfoModelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ConditionInfoModelModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ConditionInfoModelModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryDynamicPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<DynamicPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<DynamicPageModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryEmailSubscriptionManagementArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryFacilityArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FacilityModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FacilityModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFaqArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FaqModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FaqModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFaqQuestionNewArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FaqQuestionNewModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FaqQuestionNewModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFeaturedCardArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedCardModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeaturedCardModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFeaturedObjectArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedObjectModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeaturedObjectModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFilterCardTooltipArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FilterCardTooltipModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FilterCardTooltipModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFilterPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FilterPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FilterPageModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFixedPriceTipsModelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryFmPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryFmTemporaryMessageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryFooterNavigationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryFormArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FormModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FormModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFormFieldArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FormFieldModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FormFieldModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryGlobalConfigurationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryHeroModelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HeroModelModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HeroModelModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryLeasingPromotionVehicleCardArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LeasingPromotionVehicleCardModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LeasingPromotionVehicleCardModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryLinkGroupArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LinkGroupModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LinkGroupModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryMyAuctionsWonPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryNavigationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<NavigationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<NavigationModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryObjectPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PageModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPartnershipItemArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PartnershipItemModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PartnershipItemModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPromoBannerTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoBannerTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PromoBannerTemplateModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPromoCardTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoCardTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PromoCardTemplateModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPromoSettingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PromoSettingModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PromoSettingModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPurchaseAndPickUpTransferArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryPurchaseOwnershipTransferArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PurchaseOwnershipTransferModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PurchaseOwnershipTransferModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryRedirectArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<RedirectModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<RedirectModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerySchemaMigrationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SchemaMigrationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SchemaMigrationModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerySellFlowPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QuerySeoInformationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SeoInformationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SeoInformationModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerySeoMetaTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SeoMetaTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SeoMetaTemplateModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerySiteMessageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SiteMessageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SiteMessageModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryStartPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryStringTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<StringTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<StringTemplateModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryStructuredTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<StructuredTextModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<StructuredTextModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryStructuredTextTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<StructuredTextTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<StructuredTextTemplateModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryUploadArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UploadFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
};


/** The query root for this schema */
export type QueryValuationPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryVehicleMajorFeatureModalArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<VehicleMajorFeatureModalModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<VehicleMajorFeatureModalModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryVehicleTypeArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<VehicleTypeModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<VehicleTypeModelOrderBy>>>;
};

export type RecordInterface = {
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
};


export type RecordInterface_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type RedirectModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<RedirectModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<RedirectModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  active?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  fromUrl?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  toUrl?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  usageType?: InputMaybe<StringFilter>;
};

export type RedirectModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'active_ASC'
  | 'active_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'fromUrl_ASC'
  | 'fromUrl_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'toUrl_ASC'
  | 'toUrl_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'usageType_ASC'
  | 'usageType_DESC';

/** Record of type Redirect (redirect) */
export type RedirectRecord = RecordInterface & {
  __typename?: 'RedirectRecord';
  _allFromUrlLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allToUrlLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  active?: Maybe<Scalars['BooleanType']>;
  createdAt: Scalars['DateTime'];
  fromUrl?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  toUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usageType?: Maybe<Scalars['String']>;
};


/** Record of type Redirect (redirect) */
export type RedirectRecord_AllFromUrlLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Redirect (redirect) */
export type RedirectRecord_AllToUrlLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Redirect (redirect) */
export type RedirectRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Redirect (redirect) */
export type RedirectRecordFromUrlArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Redirect (redirect) */
export type RedirectRecordToUrlArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export type ResolutionType =
  | 'icon'
  | 'large'
  | 'medium'
  | 'small';

export type ResponsiveImage = {
  __typename?: 'ResponsiveImage';
  alt?: Maybe<Scalars['String']>;
  aspectRatio: Scalars['FloatType'];
  base64?: Maybe<Scalars['String']>;
  bgColor?: Maybe<Scalars['String']>;
  height: Scalars['IntType'];
  sizes: Scalars['String'];
  src: Scalars['String'];
  srcSet: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  webpSrcSet: Scalars['String'];
  width: Scalars['IntType'];
};

export type SchemaMigrationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SchemaMigrationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SchemaMigrationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type SchemaMigrationModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Schema migration (schema_migration) */
export type SchemaMigrationRecord = RecordInterface & {
  __typename?: 'SchemaMigrationRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Schema migration (schema_migration) */
export type SchemaMigrationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SellFlowDynamicItemModelBodyStructuredTextField = {
  __typename?: 'SellFlowDynamicItemModelBodyStructuredTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Sell flow dynamic item (sell_flow_dynamic_item) */
export type SellFlowDynamicItemRecord = RecordInterface & {
  __typename?: 'SellFlowDynamicItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bodyStructuredText?: Maybe<SellFlowDynamicItemModelBodyStructuredTextField>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Sell flow dynamic item (sell_flow_dynamic_item) */
export type SellFlowDynamicItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SellFlowDynamicItemRecordListListNonNullMultiLocaleField = {
  __typename?: 'SellFlowDynamicItemRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<SellFlowDynamicItemRecord>;
};

/** Block of type Sell flow form header (sell_flow_form_header) */
export type SellFlowFormHeaderRecord = RecordInterface & {
  __typename?: 'SellFlowFormHeaderRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Sell flow form header (sell_flow_form_header) */
export type SellFlowFormHeaderRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SellFlowFormHeaderRecordListListNonNullMultiLocaleField = {
  __typename?: 'SellFlowFormHeaderRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<SellFlowFormHeaderRecord>;
};

export type SellFlowPageModelHeavyEquipmentIntroductionField = {
  __typename?: 'SellFlowPageModelHeavyEquipmentIntroductionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type SellFlowPageModelHeavyEquipmentIntroductionFieldMultiLocaleField = {
  __typename?: 'SellFlowPageModelHeavyEquipmentIntroductionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SellFlowPageModelHeavyEquipmentIntroductionField>;
};

export type SellFlowPageModelHeavyEquipmentTermsStructuredTextField = {
  __typename?: 'SellFlowPageModelHeavyEquipmentTermsStructuredTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type SellFlowPageModelHeavyEquipmentTermsStructuredTextFieldMultiLocaleField = {
  __typename?: 'SellFlowPageModelHeavyEquipmentTermsStructuredTextFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SellFlowPageModelHeavyEquipmentTermsStructuredTextField>;
};

export type SellFlowPageModelHeavyEquipmentThankYouDescriptionField = {
  __typename?: 'SellFlowPageModelHeavyEquipmentThankYouDescriptionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type SellFlowPageModelHeavyEquipmentThankYouDescriptionFieldMultiLocaleField = {
  __typename?: 'SellFlowPageModelHeavyEquipmentThankYouDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SellFlowPageModelHeavyEquipmentThankYouDescriptionField>;
};

export type SellFlowPageModelNoticeOfInterestIntroductionField = {
  __typename?: 'SellFlowPageModelNoticeOfInterestIntroductionField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type SellFlowPageModelNoticeOfInterestIntroductionFieldMultiLocaleField = {
  __typename?: 'SellFlowPageModelNoticeOfInterestIntroductionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SellFlowPageModelNoticeOfInterestIntroductionField>;
};

/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord = RecordInterface & {
  __typename?: 'SellFlowPageRecord';
  _allCompanyCtaLinkDestinationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCompanyCtaTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCompanyDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCompanyTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allConfirmationExplanationsLocales?: Maybe<Array<SellFlowDynamicItemRecordListListNonNullMultiLocaleField>>;
  _allContactButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactButtonTextNotCompleteLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactConfirmationTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactExpressInformationTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactFormHeaderConsumerLocales?: Maybe<Array<SellFlowFormHeaderRecordListListNonNullMultiLocaleField>>;
  _allContactFormHeaderCorporateLocales?: Maybe<Array<SellFlowFormHeaderRecordListListNonNullMultiLocaleField>>;
  _allContactFormHeaderHeavyLocales?: Maybe<Array<SellFlowFormHeaderRecordListListNonNullMultiLocaleField>>;
  _allContactFormHeaderOtherLocales?: Maybe<Array<SellFlowFormHeaderRecordListListNonNullMultiLocaleField>>;
  _allContactFormHeaderRecreationalLocales?: Maybe<Array<SellFlowFormHeaderRecordListListNonNullMultiLocaleField>>;
  _allContactFormHeaderRequiresManualLocales?: Maybe<Array<SellFlowFormHeaderRecordListListNonNullMultiLocaleField>>;
  _allContactHeadingOneLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactHeadingTwoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allContactInformationTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeavyEquipmentHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeavyEquipmentIntroductionLocales?: Maybe<Array<SellFlowPageModelHeavyEquipmentIntroductionFieldMultiLocaleField>>;
  _allHeavyEquipmentTermsLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeavyEquipmentTermsStructuredTextLocales?: Maybe<Array<SellFlowPageModelHeavyEquipmentTermsStructuredTextFieldMultiLocaleField>>;
  _allHeavyEquipmentThankYouDescriptionLocales?: Maybe<Array<SellFlowPageModelHeavyEquipmentThankYouDescriptionFieldMultiLocaleField>>;
  _allHeavyEquipmentThankYouHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNoticeOfInterestEquipmentTextareaHelperTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNoticeOfInterestExtraTiresCheckboxLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNoticeOfInterestIntroductionLocales?: Maybe<Array<SellFlowPageModelNoticeOfInterestIntroductionFieldMultiLocaleField>>;
  _allNoticeOfInterestValuationServiceUnavailabilityWarningLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOdometerAdditionalInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOdometerHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOdometerIntroductionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOdometerMaxMileageErrorLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOdometerPlaceholderLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOdometerPrimaryButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOdometerSecondaryButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOdometerYearlyMaxErrorLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPrefilledButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPrefilledHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPrefilledIntroductionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationButtonTextOneLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationButtonTextTwoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationContinueButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationExplanationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationExplanationReservationAcceptedLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationHeadingReservationAcceptedLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationManualValuationHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationNotSureUpperExplanationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationReadyToContinueExplanationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationReadyToContinueHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationSetManualPriceButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationSetRecommendedPriceButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationThanksHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationUpperExplanationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReservationValuationHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesBiddingCheckItem1Locales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesBiddingCheckItem2Locales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesBiddingCheckItem3Locales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesBiddingHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesBiddingInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesBiddingManualValuationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesCtaButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesCtaHintLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesDiscountHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesDiscountInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressCheckItem1Locales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressCheckItem2Locales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressCheckItem3Locales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressInfoExtraLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressManualValuationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressUnavailableConditionsLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressUnavailableInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesExpressUnavailableLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSalesHeadingSingleOptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allStartActionBoxButtonLocales?: Maybe<Array<ButtonModelRecordMultiLocaleField>>;
  _allStartActionBoxTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allStartCarRequirementsHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allStartCarRequirementsListLocales?: Maybe<Array<TextRecordListListNonNullMultiLocaleField>>;
  _allStartHeroLocales?: Maybe<Array<HeroModelRecordMultiLocaleField>>;
  _allStartSellStepsLocales?: Maybe<Array<SellFlowStepRecordListListNonNullMultiLocaleField>>;
  _allStartSellStepsTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allStartSeoInformationLocales?: Maybe<Array<SeoInformationRecordListListNonNullMultiLocaleField>>;
  _allStartSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allStartTrustpilotTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allStartTrustpilotTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTermsDownloadButtonTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTermsDynamicItemsLocales?: Maybe<Array<SellFlowDynamicItemRecordListListNonNullMultiLocaleField>>;
  _allThankYouCompanyLocales?: Maybe<Array<SellFlowThankYouItemRecordListListNonNullMultiLocaleField>>;
  _allThankYouConsumerLocales?: Maybe<Array<SellFlowThankYouItemRecordListListNonNullMultiLocaleField>>;
  _allThankYouExpressLocales?: Maybe<Array<SellFlowThankYouItemRecordListListNonNullMultiLocaleField>>;
  _allThankYouManualValuationLocales?: Maybe<Array<SellFlowThankYouItemRecordListListNonNullMultiLocaleField>>;
  _allThankYouTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrimAddonsTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrimDontKnowPackageInfoTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrimGatekeeperHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrimGatekeeperTermsCheckboxLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrimHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrimIntroductionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrimPackageTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrimPrimaryButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrimPrimaryButtonManualValuationLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allVehicleHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allVehicleInputfieldPlaceholderLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allVehicleIntroductionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allVehiclePrimaryButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  companyCtaLinkDestination?: Maybe<Scalars['String']>;
  companyCtaText?: Maybe<Scalars['String']>;
  companyDescription?: Maybe<Scalars['String']>;
  companyTitle?: Maybe<Scalars['String']>;
  confirmationExplanations: Array<SellFlowDynamicItemRecord>;
  contactButtonText?: Maybe<Scalars['String']>;
  contactButtonTextNotComplete?: Maybe<Scalars['String']>;
  contactConfirmationText?: Maybe<Scalars['String']>;
  contactExpressInformationText?: Maybe<Scalars['String']>;
  contactFormHeaderConsumer: Array<SellFlowFormHeaderRecord>;
  contactFormHeaderCorporate: Array<SellFlowFormHeaderRecord>;
  contactFormHeaderHeavy: Array<SellFlowFormHeaderRecord>;
  contactFormHeaderOther: Array<SellFlowFormHeaderRecord>;
  contactFormHeaderRecreational: Array<SellFlowFormHeaderRecord>;
  contactFormHeaderRequiresManual: Array<SellFlowFormHeaderRecord>;
  contactHeadingOne?: Maybe<Scalars['String']>;
  contactHeadingTwo?: Maybe<Scalars['String']>;
  contactInformationText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  heavyEquipmentHeading?: Maybe<Scalars['String']>;
  heavyEquipmentIntroduction?: Maybe<SellFlowPageModelHeavyEquipmentIntroductionField>;
  heavyEquipmentTerms?: Maybe<Scalars['String']>;
  heavyEquipmentTermsStructuredText?: Maybe<SellFlowPageModelHeavyEquipmentTermsStructuredTextField>;
  heavyEquipmentThankYouDescription?: Maybe<SellFlowPageModelHeavyEquipmentThankYouDescriptionField>;
  heavyEquipmentThankYouHeading?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  noticeOfInterestEquipmentTextareaHelperText?: Maybe<Scalars['String']>;
  noticeOfInterestExtraTiresCheckboxLabel?: Maybe<Scalars['String']>;
  noticeOfInterestIntroduction?: Maybe<SellFlowPageModelNoticeOfInterestIntroductionField>;
  noticeOfInterestValuationServiceUnavailabilityWarning?: Maybe<Scalars['String']>;
  odometerAdditionalInfo?: Maybe<Scalars['String']>;
  odometerHeading?: Maybe<Scalars['String']>;
  odometerIntroduction?: Maybe<Scalars['String']>;
  odometerMaxMileageError?: Maybe<Scalars['String']>;
  odometerPlaceholder?: Maybe<Scalars['String']>;
  odometerPrimaryButton?: Maybe<Scalars['String']>;
  odometerSecondaryButton?: Maybe<Scalars['String']>;
  odometerYearlyMaxError?: Maybe<Scalars['String']>;
  prefilledButtonText?: Maybe<Scalars['String']>;
  prefilledHeading?: Maybe<Scalars['String']>;
  prefilledIntroduction?: Maybe<Scalars['String']>;
  reservationButtonTextOne?: Maybe<Scalars['String']>;
  reservationButtonTextTwo?: Maybe<Scalars['String']>;
  reservationContinueButton?: Maybe<Scalars['String']>;
  reservationExplanation?: Maybe<Scalars['String']>;
  reservationExplanationReservationAccepted?: Maybe<Scalars['String']>;
  reservationHeading?: Maybe<Scalars['String']>;
  reservationHeadingReservationAccepted?: Maybe<Scalars['String']>;
  reservationManualValuationHeading?: Maybe<Scalars['String']>;
  reservationNotSureUpperExplanation?: Maybe<Scalars['String']>;
  reservationReadyToContinueExplanation?: Maybe<Scalars['String']>;
  reservationReadyToContinueHeading?: Maybe<Scalars['String']>;
  reservationSetManualPriceButton?: Maybe<Scalars['String']>;
  reservationSetRecommendedPriceButton?: Maybe<Scalars['String']>;
  reservationThanksHeading?: Maybe<Scalars['String']>;
  reservationUpperExplanation?: Maybe<Scalars['String']>;
  reservationValuationHeading?: Maybe<Scalars['String']>;
  salesBiddingCheckItem1?: Maybe<Scalars['String']>;
  salesBiddingCheckItem2?: Maybe<Scalars['String']>;
  salesBiddingCheckItem3?: Maybe<Scalars['String']>;
  salesBiddingHeading?: Maybe<Scalars['String']>;
  salesBiddingInfo?: Maybe<Scalars['String']>;
  salesBiddingManualValuation?: Maybe<Scalars['String']>;
  salesCtaButtonText?: Maybe<Scalars['String']>;
  salesCtaHint?: Maybe<Scalars['String']>;
  salesDiscountHeading?: Maybe<Scalars['String']>;
  salesDiscountInfo?: Maybe<Scalars['String']>;
  salesExpressCheckItem1?: Maybe<Scalars['String']>;
  salesExpressCheckItem2?: Maybe<Scalars['String']>;
  salesExpressCheckItem3?: Maybe<Scalars['String']>;
  salesExpressHeading?: Maybe<Scalars['String']>;
  salesExpressInfo?: Maybe<Scalars['String']>;
  salesExpressInfoExtra?: Maybe<Scalars['String']>;
  salesExpressManualValuation?: Maybe<Scalars['String']>;
  salesExpressUnavailableConditions?: Maybe<Scalars['String']>;
  salesExpressUnavailableInfo?: Maybe<Scalars['String']>;
  salesExpressUnavailableLabel?: Maybe<Scalars['String']>;
  salesHeading?: Maybe<Scalars['String']>;
  salesHeadingSingleOption?: Maybe<Scalars['String']>;
  startActionBoxButton?: Maybe<ButtonModelRecord>;
  startActionBoxText?: Maybe<Scalars['String']>;
  startCarRequirementsHeading?: Maybe<Scalars['String']>;
  startCarRequirementsList: Array<TextRecord>;
  startFaqNew: Array<FaqQuestionNewRecord>;
  startHero?: Maybe<HeroModelRecord>;
  startSellSteps: Array<SellFlowStepRecord>;
  startSellStepsTitle?: Maybe<Scalars['String']>;
  startSeo?: Maybe<SeoField>;
  startSeoInformation: Array<SeoInformationRecord>;
  startTrustpilotText?: Maybe<Scalars['String']>;
  startTrustpilotTitle?: Maybe<Scalars['String']>;
  termsDownloadButtonText?: Maybe<Scalars['String']>;
  termsDynamicItems: Array<SellFlowDynamicItemRecord>;
  thankYouCompany: Array<SellFlowThankYouItemRecord>;
  thankYouConsumer: Array<SellFlowThankYouItemRecord>;
  thankYouExpress: Array<SellFlowThankYouItemRecord>;
  thankYouManualValuation: Array<SellFlowThankYouItemRecord>;
  thankYouTitle?: Maybe<Scalars['String']>;
  trimAddonsTitle?: Maybe<Scalars['String']>;
  trimDontKnowPackageInfoText?: Maybe<Scalars['String']>;
  trimGatekeeperHeading?: Maybe<Scalars['String']>;
  trimGatekeeperTermsCheckbox?: Maybe<Scalars['String']>;
  trimHeading?: Maybe<Scalars['String']>;
  trimIntroduction?: Maybe<Scalars['String']>;
  trimPackageTitle?: Maybe<Scalars['String']>;
  trimPrimaryButton?: Maybe<Scalars['String']>;
  trimPrimaryButtonManualValuation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vehicleHeading?: Maybe<Scalars['String']>;
  vehicleInputfieldPlaceholder?: Maybe<Scalars['String']>;
  vehicleIntroduction?: Maybe<Scalars['String']>;
  vehiclePrimaryButton?: Maybe<Scalars['String']>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllCompanyCtaLinkDestinationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllCompanyCtaTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllCompanyDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllCompanyTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllConfirmationExplanationsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactButtonTextNotCompleteLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactConfirmationTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactExpressInformationTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactFormHeaderConsumerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactFormHeaderCorporateLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactFormHeaderHeavyLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactFormHeaderOtherLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactFormHeaderRecreationalLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactFormHeaderRequiresManualLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactHeadingOneLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactHeadingTwoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllContactInformationTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllHeavyEquipmentHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllHeavyEquipmentIntroductionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllHeavyEquipmentTermsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllHeavyEquipmentTermsStructuredTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllHeavyEquipmentThankYouDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllHeavyEquipmentThankYouHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllNoticeOfInterestEquipmentTextareaHelperTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllNoticeOfInterestExtraTiresCheckboxLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllNoticeOfInterestIntroductionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllNoticeOfInterestValuationServiceUnavailabilityWarningLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllOdometerAdditionalInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllOdometerHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllOdometerIntroductionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllOdometerMaxMileageErrorLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllOdometerPlaceholderLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllOdometerPrimaryButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllOdometerSecondaryButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllOdometerYearlyMaxErrorLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllPrefilledButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllPrefilledHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllPrefilledIntroductionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationButtonTextOneLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationButtonTextTwoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationContinueButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationExplanationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationExplanationReservationAcceptedLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationHeadingReservationAcceptedLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationManualValuationHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationNotSureUpperExplanationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationReadyToContinueExplanationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationReadyToContinueHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationSetManualPriceButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationSetRecommendedPriceButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationThanksHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationUpperExplanationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllReservationValuationHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesBiddingCheckItem1LocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesBiddingCheckItem2LocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesBiddingCheckItem3LocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesBiddingHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesBiddingInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesBiddingManualValuationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesCtaButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesCtaHintLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesDiscountHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesDiscountInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressCheckItem1LocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressCheckItem2LocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressCheckItem3LocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressInfoExtraLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressManualValuationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressUnavailableConditionsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressUnavailableInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesExpressUnavailableLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllSalesHeadingSingleOptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartActionBoxButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartActionBoxTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartCarRequirementsHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartCarRequirementsListLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartHeroLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartSellStepsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartSellStepsTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartSeoInformationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartTrustpilotTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllStartTrustpilotTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTermsDownloadButtonTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTermsDynamicItemsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllThankYouCompanyLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllThankYouConsumerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllThankYouExpressLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllThankYouManualValuationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllThankYouTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTrimAddonsTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTrimDontKnowPackageInfoTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTrimGatekeeperHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTrimGatekeeperTermsCheckboxLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTrimHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTrimIntroductionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTrimPackageTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTrimPrimaryButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllTrimPrimaryButtonManualValuationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllVehicleHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllVehicleInputfieldPlaceholderLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllVehicleIntroductionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_AllVehiclePrimaryButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordCompanyCtaLinkDestinationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordCompanyCtaTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordCompanyDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordCompanyTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordConfirmationExplanationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactButtonTextNotCompleteArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactConfirmationTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactExpressInformationTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactFormHeaderConsumerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactFormHeaderCorporateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactFormHeaderHeavyArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactFormHeaderOtherArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactFormHeaderRecreationalArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactFormHeaderRequiresManualArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactHeadingOneArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactHeadingTwoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordContactInformationTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordHeavyEquipmentHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordHeavyEquipmentIntroductionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordHeavyEquipmentTermsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordHeavyEquipmentTermsStructuredTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordHeavyEquipmentThankYouDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordHeavyEquipmentThankYouHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordNoticeOfInterestEquipmentTextareaHelperTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordNoticeOfInterestExtraTiresCheckboxLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordNoticeOfInterestIntroductionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordNoticeOfInterestValuationServiceUnavailabilityWarningArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordOdometerAdditionalInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordOdometerHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordOdometerIntroductionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordOdometerMaxMileageErrorArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordOdometerPlaceholderArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordOdometerPrimaryButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordOdometerSecondaryButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordOdometerYearlyMaxErrorArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordPrefilledButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordPrefilledHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordPrefilledIntroductionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationButtonTextOneArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationButtonTextTwoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationContinueButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationExplanationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationExplanationReservationAcceptedArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationHeadingReservationAcceptedArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationManualValuationHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationNotSureUpperExplanationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationReadyToContinueExplanationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationReadyToContinueHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationSetManualPriceButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationSetRecommendedPriceButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationThanksHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationUpperExplanationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordReservationValuationHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesBiddingCheckItem1Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesBiddingCheckItem2Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesBiddingCheckItem3Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesBiddingHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesBiddingInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesBiddingManualValuationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesCtaButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesCtaHintArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesDiscountHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesDiscountInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressCheckItem1Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressCheckItem2Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressCheckItem3Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressInfoExtraArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressManualValuationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressUnavailableConditionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressUnavailableInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesExpressUnavailableLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordSalesHeadingSingleOptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartActionBoxButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartActionBoxTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartCarRequirementsHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartCarRequirementsListArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartHeroArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartSellStepsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartSellStepsTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartSeoInformationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartTrustpilotTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordStartTrustpilotTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTermsDownloadButtonTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTermsDynamicItemsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordThankYouCompanyArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordThankYouConsumerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordThankYouExpressArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordThankYouManualValuationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordThankYouTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTrimAddonsTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTrimDontKnowPackageInfoTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTrimGatekeeperHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTrimGatekeeperTermsCheckboxArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTrimHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTrimIntroductionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTrimPackageTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTrimPrimaryButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordTrimPrimaryButtonManualValuationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordVehicleHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordVehicleInputfieldPlaceholderArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordVehicleIntroductionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Sell flow page (sell_flow_page) */
export type SellFlowPageRecordVehiclePrimaryButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Sell flow step (sell_flow_step) */
export type SellFlowStepRecord = RecordInterface & {
  __typename?: 'SellFlowStepRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  step: Array<TextRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Sell flow step (sell_flow_step) */
export type SellFlowStepRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SellFlowStepRecordListListNonNullMultiLocaleField = {
  __typename?: 'SellFlowStepRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<SellFlowStepRecord>;
};

/** Block of type Sell flow thank you item (sell_flow_thank_you_item) */
export type SellFlowThankYouItemRecord = RecordInterface & {
  __typename?: 'SellFlowThankYouItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundImage?: Maybe<FileField>;
  button?: Maybe<ButtonModelRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  structuredText?: Maybe<StructuredTextBlockRecord>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Sell flow thank you item (sell_flow_thank_you_item) */
export type SellFlowThankYouItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Sell flow thank you item (sell_flow_thank_you_item) */
export type SellFlowThankYouItemRecordTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type SellFlowThankYouItemRecordListListNonNullMultiLocaleField = {
  __typename?: 'SellFlowThankYouItemRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<SellFlowThankYouItemRecord>;
};

export type SeoField = {
  __typename?: 'SeoField';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<FileField>;
  noIndex?: Maybe<Scalars['BooleanType']>;
  title?: Maybe<Scalars['String']>;
  twitterCard?: Maybe<Scalars['String']>;
};

export type SeoFieldMultiLocaleField = {
  __typename?: 'SeoFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SeoField>;
};

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

export type SeoInformationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SeoInformationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SeoInformationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type SeoInformationModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type SEO Information (seo_information) */
export type SeoInformationRecord = RecordInterface & {
  __typename?: 'SeoInformationRecord';
  _allContentLocales?: Maybe<Array<TitleWithTextRecordListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  content: Array<TitleWithTextRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type SEO Information (seo_information) */
export type SeoInformationRecord_AllContentLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type SEO Information (seo_information) */
export type SeoInformationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type SEO Information (seo_information) */
export type SeoInformationRecordContentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type SeoInformationRecordListListNonNullMultiLocaleField = {
  __typename?: 'SeoInformationRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<SeoInformationRecord>;
};

export type SeoInformationRecordMultiLocaleField = {
  __typename?: 'SeoInformationRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SeoInformationRecord>;
};

export type SeoMetaTemplateModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SeoMetaTemplateModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SeoMetaTemplateModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  template?: InputMaybe<SeoFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  usageType?: InputMaybe<StringFilter>;
};

export type SeoMetaTemplateModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'usageType_ASC'
  | 'usageType_DESC';

/** Record of type SEO meta template (seo_meta_template) */
export type SeoMetaTemplateRecord = RecordInterface & {
  __typename?: 'SeoMetaTemplateRecord';
  _allReferencingCarBrandPages: Array<CarBrandPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCarBrandPagesMeta: CollectionMetadata;
  _allReferencingCarCategoryPages: Array<CarCategoryPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCarCategoryPagesMeta: CollectionMetadata;
  _allTemplateLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  template?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime'];
  usageType?: Maybe<Scalars['String']>;
};


/** Record of type SEO meta template (seo_meta_template) */
export type SeoMetaTemplateRecord_AllReferencingCarBrandPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarBrandPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarBrandPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarBrandPageAndSeoMetaTemplate>;
};


/** Record of type SEO meta template (seo_meta_template) */
export type SeoMetaTemplateRecord_AllReferencingCarBrandPagesMetaArgs = {
  filter?: InputMaybe<CarBrandPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarBrandPageAndSeoMetaTemplate>;
};


/** Record of type SEO meta template (seo_meta_template) */
export type SeoMetaTemplateRecord_AllReferencingCarCategoryPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarCategoryPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarCategoryPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarCategoryPageAndSeoMetaTemplate>;
};


/** Record of type SEO meta template (seo_meta_template) */
export type SeoMetaTemplateRecord_AllReferencingCarCategoryPagesMetaArgs = {
  filter?: InputMaybe<CarCategoryPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarCategoryPageAndSeoMetaTemplate>;
};


/** Record of type SEO meta template (seo_meta_template) */
export type SeoMetaTemplateRecord_AllTemplateLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type SEO meta template (seo_meta_template) */
export type SeoMetaTemplateRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type SEO meta template (seo_meta_template) */
export type SeoMetaTemplateRecordTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Service agreement cost (service_agreement_cost) */
export type ServiceAgreementCostRecord = RecordInterface & {
  __typename?: 'ServiceAgreementCostRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  brand?: Maybe<Scalars['String']>;
  costInclVat?: Maybe<Scalars['FloatType']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  monthlyCost?: Maybe<Scalars['FloatType']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Service agreement cost (service_agreement_cost) */
export type ServiceAgreementCostRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Service content (service_content) */
export type ServiceContentRecord = RecordInterface & {
  __typename?: 'ServiceContentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<ImageIconRecord>;
  id: Scalars['ItemId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Service content (service_content) */
export type ServiceContentRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Service (service) */
export type ServiceRecord = RecordInterface & {
  __typename?: 'ServiceRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  serviceContent: Array<ServiceContentRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Service (service) */
export type ServiceRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type Site = {
  __typename?: 'Site';
  favicon?: Maybe<FileField>;
  faviconMetaTags: Array<Tag>;
  globalSeo?: Maybe<GlobalSeoField>;
  locales: Array<SiteLocale>;
  noIndex?: Maybe<Scalars['BooleanType']>;
};


export type SiteFaviconMetaTagsArgs = {
  variants?: InputMaybe<Array<InputMaybe<FaviconType>>>;
};


export type SiteGlobalSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type SiteLocale =
  | 'da'
  | 'de'
  | 'en'
  | 'en_SE'
  | 'et'
  | 'fi'
  | 'pl'
  | 'sv';

export type SiteMessageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SiteMessageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SiteMessageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  message?: InputMaybe<TextFilter>;
  placement?: InputMaybe<StringFilter>;
  siteMessageType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type SiteMessageModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'isActive_ASC'
  | 'isActive_DESC'
  | 'placement_ASC'
  | 'placement_DESC'
  | 'siteMessageType_ASC'
  | 'siteMessageType_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type ❗ Site message (site_message) */
export type SiteMessageRecord = RecordInterface & {
  __typename?: 'SiteMessageRecord';
  _allIsActiveLocales?: Maybe<Array<BooleanTypeMultiLocaleField>>;
  _allMessageLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allMessageStructuredTextLocales?: Maybe<Array<StructuredTextBlockRecordMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  isActive?: Maybe<Scalars['BooleanType']>;
  message?: Maybe<Scalars['String']>;
  messageStructuredText?: Maybe<StructuredTextBlockRecord>;
  placement?: Maybe<Scalars['String']>;
  siteMessageType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type ❗ Site message (site_message) */
export type SiteMessageRecord_AllIsActiveLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❗ Site message (site_message) */
export type SiteMessageRecord_AllMessageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type ❗ Site message (site_message) */
export type SiteMessageRecord_AllMessageStructuredTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❗ Site message (site_message) */
export type SiteMessageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❗ Site message (site_message) */
export type SiteMessageRecordIsActiveArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type ❗ Site message (site_message) */
export type SiteMessageRecordMessageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type ❗ Site message (site_message) */
export type SiteMessageRecordMessageStructuredTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SmallFeatureCardsBlockModelTextField = {
  __typename?: 'SmallFeatureCardsBlockModelTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Small Feature Cards (small_feature_cards_block) */
export type SmallFeatureCardsBlockRecord = RecordInterface & {
  __typename?: 'SmallFeatureCardsBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  articles: Array<ArticleRecord>;
  button?: Maybe<ButtonRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  text?: Maybe<SmallFeatureCardsBlockModelTextField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Small Feature Cards (small_feature_cards_block) */
export type SmallFeatureCardsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SmallFeatureCardsBlockRecordListListNonNullMultiLocaleField = {
  __typename?: 'SmallFeatureCardsBlockRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<SmallFeatureCardsBlockRecord>;
};

export type SmallFeatureCardsBlockRecordMultiLocaleField = {
  __typename?: 'SmallFeatureCardsBlockRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SmallFeatureCardsBlockRecord>;
};

/** Block of type Small Promo Banner (small_promo_banner) */
export type SmallPromoBannerRecord = RecordInterface & {
  __typename?: 'SmallPromoBannerRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundColorShade?: Maybe<Scalars['String']>;
  button: Array<PromoButtonRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  showSmallBanner?: Maybe<Scalars['BooleanType']>;
  text?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Small Promo Banner (small_promo_banner) */
export type SmallPromoBannerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SmallPromoBannerRecordListListNonNullMultiLocaleField = {
  __typename?: 'SmallPromoBannerRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<SmallPromoBannerRecord>;
};

export type SpacerModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SpacerModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SpacerModelFilter>>>;
  id?: InputMaybe<ItemIdFilter>;
  space?: InputMaybe<FloatFilter>;
};

/** Block of type Spacer (spacer) */
export type SpacerRecord = RecordInterface & {
  __typename?: 'SpacerRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  space?: Maybe<Scalars['FloatType']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Spacer (spacer) */
export type SpacerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Stamp (stamp) */
export type StampRecord = RecordInterface & {
  __typename?: 'StampRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  stampAppearance?: Maybe<Scalars['String']>;
  stampColor?: Maybe<Scalars['String']>;
  stampSize?: Maybe<Scalars['IntType']>;
  stampType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Stamp (stamp) */
export type StampRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Start Page (start_page) */
export type StartPageRecord = RecordInterface & {
  __typename?: 'StartPageRecord';
  _allAboutAreaLocales?: Maybe<Array<AboutAreaRecordListListNonNullMultiLocaleField>>;
  _allBlockButtonsLocales?: Maybe<Array<BlockButtonRecordListListNonNullMultiLocaleField>>;
  _allCategoryBlurbsHeadlineLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCategoryBlurbsLocales?: Maybe<Array<CategoryBlurbRecordListListNonNullMultiLocaleField>>;
  _allContactSectionLocales?: Maybe<Array<ContactSectionRecordListListNonNullMultiLocaleField>>;
  _allFeatureCardsIsActiveLocales?: Maybe<Array<BooleanTypeMultiLocaleField>>;
  _allFeaturedBlocksTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFeaturedObjectsLocales?: Maybe<Array<FeaturedObjectRecordListListNonNullMultiLocaleField>>;
  _allLargeFeaturedCardsLocales?: Maybe<Array<FeaturedCardRecordListListNonNullMultiLocaleField>>;
  _allLargePromoBannerLocales?: Maybe<Array<OptionalHeroRecordListListNonNullMultiLocaleField>>;
  _allMyVehiclesHeadlineLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSeoInformationLocales?: Maybe<Array<SeoInformationRecordListListNonNullMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSmallFeatureCardsLocales?: Maybe<Array<SmallFeatureCardsBlockRecordListListNonNullMultiLocaleField>>;
  _allSmallPromoBannerLocales?: Maybe<Array<SmallPromoBannerRecordListListNonNullMultiLocaleField>>;
  _allTrustpilotTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  aboutArea: Array<AboutAreaRecord>;
  blockButtons: Array<BlockButtonRecord>;
  categoryBlurbs: Array<CategoryBlurbRecord>;
  categoryBlurbsHeadline?: Maybe<Scalars['String']>;
  contactSection: Array<ContactSectionRecord>;
  createdAt: Scalars['DateTime'];
  featureCardsIsActive?: Maybe<Scalars['BooleanType']>;
  featuredBlocksTitle?: Maybe<Scalars['String']>;
  featuredObjects: Array<FeaturedObjectRecord>;
  id: Scalars['ItemId'];
  largeFeaturedCards: Array<FeaturedCardRecord>;
  largePromoBanner: Array<OptionalHeroRecord>;
  myVehiclesHeadline?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoField>;
  seoInformation: Array<SeoInformationRecord>;
  showSmallTrustpilot?: Maybe<Scalars['BooleanType']>;
  smallFeatureCards: Array<SmallFeatureCardsBlockRecord>;
  smallPromoBanner: Array<SmallPromoBannerRecord>;
  trustpilotTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllAboutAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllBlockButtonsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllCategoryBlurbsHeadlineLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllCategoryBlurbsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllContactSectionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllFeatureCardsIsActiveLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllFeaturedBlocksTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllFeaturedObjectsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllLargeFeaturedCardsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllLargePromoBannerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllMyVehiclesHeadlineLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllSeoInformationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllSmallFeatureCardsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllSmallPromoBannerLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_AllTrustpilotTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordAboutAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordBlockButtonsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordCategoryBlurbsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordCategoryBlurbsHeadlineArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordContactSectionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordFeatureCardsIsActiveArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordFeaturedBlocksTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordFeaturedObjectsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordLargeFeaturedCardsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordLargePromoBannerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordMyVehiclesHeadlineArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordSeoInformationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordSmallFeatureCardsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordSmallPromoBannerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Start Page (start_page) */
export type StartPageRecordTrustpilotTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']>;
  pattern: Scalars['String'];
  regexp?: InputMaybe<Scalars['BooleanType']>;
};

export type StringMultiLocaleField = {
  __typename?: 'StringMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<Scalars['String']>;
};

export type StringTemplateModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<StringTemplateModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StringTemplateModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  template?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  usageType?: InputMaybe<StringFilter>;
};

export type StringTemplateModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'template_ASC'
  | 'template_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'usageType_ASC'
  | 'usageType_DESC';

/** Record of type Single-line string template (string_template) */
export type StringTemplateRecord = RecordInterface & {
  __typename?: 'StringTemplateRecord';
  _allReferencingCarBrandPages: Array<CarBrandPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCarBrandPagesMeta: CollectionMetadata;
  _allTemplateLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  template?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usageType?: Maybe<Scalars['String']>;
};


/** Record of type Single-line string template (string_template) */
export type StringTemplateRecord_AllReferencingCarBrandPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarBrandPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarBrandPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarBrandPageAndStringTemplate>;
};


/** Record of type Single-line string template (string_template) */
export type StringTemplateRecord_AllReferencingCarBrandPagesMetaArgs = {
  filter?: InputMaybe<CarBrandPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarBrandPageAndStringTemplate>;
};


/** Record of type Single-line string template (string_template) */
export type StringTemplateRecord_AllTemplateLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Single-line string template (string_template) */
export type StringTemplateRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Single-line string template (string_template) */
export type StringTemplateRecordTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type StructuredTextBlockModelStructuredTextField = {
  __typename?: 'StructuredTextBlockModelStructuredTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Structured text block (structured_text_block) */
export type StructuredTextBlockRecord = RecordInterface & {
  __typename?: 'StructuredTextBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  structuredText?: Maybe<StructuredTextBlockModelStructuredTextField>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Structured text block (structured_text_block) */
export type StructuredTextBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type StructuredTextBlockRecordMultiLocaleField = {
  __typename?: 'StructuredTextBlockRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<StructuredTextBlockRecord>;
};

export type StructuredTextCardModelBodyField = {
  __typename?: 'StructuredTextCardModelBodyField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Structured Text Card (structured_text_card) */
export type StructuredTextCardRecord = RecordInterface & {
  __typename?: 'StructuredTextCardRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  body?: Maybe<StructuredTextCardModelBodyField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Structured Text Card (structured_text_card) */
export type StructuredTextCardRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Structured Text fields values */
export type StructuredTextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field set as blank (null or single empty paragraph) */
  isBlank?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StructuredTextModelContentBlocksField = HtmlInputRecord | TableRecord;

export type StructuredTextModelContentField = {
  __typename?: 'StructuredTextModelContentField';
  blocks: Array<StructuredTextModelContentBlocksField>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type StructuredTextModelContentFieldMultiLocaleField = {
  __typename?: 'StructuredTextModelContentFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<StructuredTextModelContentField>;
};

export type StructuredTextModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<StructuredTextModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StructuredTextModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  content?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type StructuredTextModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Structured text (structured_text) */
export type StructuredTextRecord = RecordInterface & {
  __typename?: 'StructuredTextRecord';
  _allContentLocales?: Maybe<Array<StructuredTextModelContentFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  content?: Maybe<StructuredTextModelContentField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Structured text (structured_text) */
export type StructuredTextRecord_AllContentLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Structured text (structured_text) */
export type StructuredTextRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Structured text (structured_text) */
export type StructuredTextRecordContentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type StructuredTextTemplateModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<StructuredTextTemplateModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StructuredTextTemplateModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  template?: InputMaybe<StructuredTextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  usageType?: InputMaybe<StringFilter>;
};

export type StructuredTextTemplateModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'usageType_ASC'
  | 'usageType_DESC';

export type StructuredTextTemplateModelTemplateField = {
  __typename?: 'StructuredTextTemplateModelTemplateField';
  blocks: Array<SubtitleRecord>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type StructuredTextTemplateModelTemplateFieldMultiLocaleField = {
  __typename?: 'StructuredTextTemplateModelTemplateFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<StructuredTextTemplateModelTemplateField>;
};

/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecord = RecordInterface & {
  __typename?: 'StructuredTextTemplateRecord';
  _allReferencingArticles: Array<ArticleRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingArticlesMeta: CollectionMetadata;
  _allReferencingCarBrandPages: Array<CarBrandPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCarBrandPagesMeta: CollectionMetadata;
  _allReferencingCarCategoryPages: Array<CarCategoryPageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCarCategoryPagesMeta: CollectionMetadata;
  _allTemplateLocales?: Maybe<Array<StructuredTextTemplateModelTemplateFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  template?: Maybe<StructuredTextTemplateModelTemplateField>;
  updatedAt: Scalars['DateTime'];
  usageType?: Maybe<Scalars['String']>;
};


/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecord_AllReferencingArticlesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ArticleModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ArticleModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenArticleAndStructuredTextTemplate>;
};


/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecord_AllReferencingArticlesMetaArgs = {
  filter?: InputMaybe<ArticleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenArticleAndStructuredTextTemplate>;
};


/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecord_AllReferencingCarBrandPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarBrandPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarBrandPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarBrandPageAndStructuredTextTemplate>;
};


/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecord_AllReferencingCarBrandPagesMetaArgs = {
  filter?: InputMaybe<CarBrandPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarBrandPageAndStructuredTextTemplate>;
};


/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecord_AllReferencingCarCategoryPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CarCategoryPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CarCategoryPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarCategoryPageAndStructuredTextTemplate>;
};


/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecord_AllReferencingCarCategoryPagesMetaArgs = {
  filter?: InputMaybe<CarCategoryPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCarCategoryPageAndStructuredTextTemplate>;
};


/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecord_AllTemplateLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Structured text template (structured_text_template) */
export type StructuredTextTemplateRecordTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Subtitle (subtitle) */
export type SubtitleRecord = RecordInterface & {
  __typename?: 'SubtitleRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  tag?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Subtitle (subtitle) */
export type SubtitleRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Support Chat Card (support_chat_card) */
export type SupportChatCardRecord = RecordInterface & {
  __typename?: 'SupportChatCardRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  ctaLabel?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Support Chat Card (support_chat_card) */
export type SupportChatCardRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TableModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TableModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TableModelFilter>>>;
  id?: InputMaybe<ItemIdFilter>;
  tablestructure?: InputMaybe<JsonFilter>;
};

/** Block of type Table (table) */
export type TableRecord = RecordInterface & {
  __typename?: 'TableRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  tablestructure?: Maybe<Scalars['JsonField']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Table (table) */
export type TableRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type Tag = {
  __typename?: 'Tag';
  attributes?: Maybe<Scalars['MetaTagAttributes']>;
  content?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};

/** Block of type Testimonial Quote (testimonial_quote) */
export type TestimonialQuoteRecord = RecordInterface & {
  __typename?: 'TestimonialQuoteRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  quote?: Maybe<Scalars['String']>;
  testimonialStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Testimonial Quote (testimonial_quote) */
export type TestimonialQuoteRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Testimonial Quote (testimonial_quote) */
export type TestimonialQuoteRecordQuoteArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type TestimonialQuoteRecordListListNonNullMultiLocaleField = {
  __typename?: 'TestimonialQuoteRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<TestimonialQuoteRecord>;
};

export type TextColumnModelBodyBlocksField = CarInspirationListRecord | ContactCardsBlockRecord | DynamicPageCustomElementRecord | InlineimageRecord | SpacerRecord | StructuredTextCardRecord | SupportChatCardRecord | YoutubeClipRecord;

export type TextColumnModelBodyField = {
  __typename?: 'TextColumnModelBodyField';
  blocks: Array<TextColumnModelBodyBlocksField>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<TextColumnModelBodyLinksField>;
  value: Scalars['JsonField'];
};

export type TextColumnModelBodyLinksField = ButtonModelRecord | FormRecord;

/** Block of type Text column (text_column) */
export type TextColumnRecord = RecordInterface & {
  __typename?: 'TextColumnRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  body?: Maybe<TextColumnModelBodyField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Text column (text_column) */
export type TextColumnRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter text fields */
export type TextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type TextGridModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextGridModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextGridModelFilter>>>;
  columnGap?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<ItemIdFilter>;
  rowGap?: InputMaybe<IntegerFilter>;
};

/** Block of type Text grid (text_grid) */
export type TextGridRecord = RecordInterface & {
  __typename?: 'TextGridRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  columnGap?: Maybe<Scalars['IntType']>;
  columns: Array<TextColumnRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  rowGap?: Maybe<Scalars['IntType']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Text grid (text_grid) */
export type TextGridRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Text Icon (text_icon) */
export type TextIconRecord = RecordInterface & {
  __typename?: 'TextIconRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  imageIcon?: Maybe<ImageIconRecord>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Text Icon (text_icon) */
export type TextIconRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Text Icon With Link (text_icon_with_link) */
export type TextIconWithLinkRecord = RecordInterface & {
  __typename?: 'TextIconWithLinkRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  textIcon: Array<TextIconRecord>;
  textLink: Array<TextLinkRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Text Icon With Link (text_icon_with_link) */
export type TextIconWithLinkRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TextIconWithLinkRecordListListNonNullMultiLocaleField = {
  __typename?: 'TextIconWithLinkRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<TextIconWithLinkRecord>;
};

/** Block of type Text Link (text_link) */
export type TextLinkRecord = RecordInterface & {
  __typename?: 'TextLinkRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  caption?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Text Link (text_link) */
export type TextLinkRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TextLinkRecordListListNonNullMultiLocaleField = {
  __typename?: 'TextLinkRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<TextLinkRecord>;
};

export type TextLinkRecordMultiLocaleField = {
  __typename?: 'TextLinkRecordMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<TextLinkRecord>;
};

/** Block of type Text Link With Meta (text_link_with_meta_model) */
export type TextLinkWithMetaModelRecord = RecordInterface & {
  __typename?: 'TextLinkWithMetaModelRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  alternativeActionKey?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customLinkMeta: Array<CustomMetaModelRecord>;
  id: Scalars['ItemId'];
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Text Link With Meta (text_link_with_meta_model) */
export type TextLinkWithMetaModelRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TextLinkWithMetaModelRecordListListNonNullMultiLocaleField = {
  __typename?: 'TextLinkWithMetaModelRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<TextLinkWithMetaModelRecord>;
};

/** Block of type Text (text) */
export type TextRecord = RecordInterface & {
  __typename?: 'TextRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Text (text) */
export type TextRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TextRecordListListNonNullMultiLocaleField = {
  __typename?: 'TextRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<TextRecord>;
};

export type TextSectionModelBodyBlocksField = AnchorNavigationRecord | ButtonRecord | CarInspirationListRecord | ContactCardsBlockRecord | DynamicPageCustomElementRecord | DynamicPageFormRecord | DynamicPageValuationFormRecord | FaqSectionBlockRecord | FeaturedBlocksBlockRecord | InlineimageRecord | LeasingPartnerNavigationRecord | SpacerRecord | TableRecord | TextGridRecord | TextTabsBlockRecord | YoutubeClipRecord;

export type TextSectionModelBodyField = {
  __typename?: 'TextSectionModelBodyField';
  blocks: Array<TextSectionModelBodyBlocksField>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<TextSectionModelBodyLinksField>;
  value: Scalars['JsonField'];
};

export type TextSectionModelBodyLinksField = ButtonModelRecord | FormRecord;

export type TextSectionModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextSectionModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextSectionModelFilter>>>;
  backgroundColor?: InputMaybe<StringFilter>;
  contentBackgroundColor?: InputMaybe<StringFilter>;
  contentBorderColor?: InputMaybe<StringFilter>;
  contentMaxWidth?: InputMaybe<IntegerFilter>;
  contentPadding?: InputMaybe<StringFilter>;
  contentTextAlign?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  innerContentMaxWidth?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  paddingBottom?: InputMaybe<IntegerFilter>;
  paddingTop?: InputMaybe<IntegerFilter>;
};

/** Block of type Text section (text_section) */
export type TextSectionRecord = RecordInterface & {
  __typename?: 'TextSectionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<Scalars['String']>;
  body?: Maybe<TextSectionModelBodyField>;
  contentBackgroundColor?: Maybe<Scalars['String']>;
  contentBorderColor?: Maybe<Scalars['String']>;
  contentMaxWidth?: Maybe<Scalars['IntType']>;
  contentPadding?: Maybe<Scalars['String']>;
  contentTextAlign?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  innerContentMaxWidth?: Maybe<Scalars['IntType']>;
  name?: Maybe<Scalars['String']>;
  paddingBottom?: Maybe<Scalars['IntType']>;
  paddingTop?: Maybe<Scalars['IntType']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Text section (text_section) */
export type TextSectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TextTabModelBodyField = {
  __typename?: 'TextTabModelBodyField';
  blocks: Array<TextGridRecord>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Text tab (text_tab) */
export type TextTabRecord = RecordInterface & {
  __typename?: 'TextTabRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  body?: Maybe<TextTabModelBodyField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  tabName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Text tab (text_tab) */
export type TextTabRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TextTabsBlockModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextTabsBlockModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextTabsBlockModelFilter>>>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
};

/** Block of type Text tabs (text_tabs_block) */
export type TextTabsBlockRecord = RecordInterface & {
  __typename?: 'TextTabsBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  tabs: Array<TextTabRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Text tabs (text_tabs_block) */
export type TextTabsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Title (title) */
export type TitleRecord = RecordInterface & {
  __typename?: 'TitleRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  tag?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Title (title) */
export type TitleRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TitleWithTextModelTextField = {
  __typename?: 'TitleWithTextModelTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Title With Text (title_with_text) */
export type TitleWithTextRecord = RecordInterface & {
  __typename?: 'TitleWithTextRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  text?: Maybe<TitleWithTextModelTextField>;
  title: Array<TitleRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Title With Text (title_with_text) */
export type TitleWithTextRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TitleWithTextRecordListListNonNullMultiLocaleField = {
  __typename?: 'TitleWithTextRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<TitleWithTextRecord>;
};

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  path?: InputMaybe<UploadPathFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'basename_ASC'
  | 'basename_DESC'
  | 'filename_ASC'
  | 'filename_DESC'
  | 'format_ASC'
  | 'format_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'mimeType_ASC'
  | 'mimeType_DESC'
  | 'resolution_ASC'
  | 'resolution_DESC'
  | 'size_ASC'
  | 'size_DESC';

export type UploadOrientation =
  | 'landscape'
  | 'portrait'
  | 'square';

/** Specifies how to filter by path */
export type UploadPathFilter = {
  /** Search the asset with the specified path */
  eq?: InputMaybe<Scalars['String']>;
  /** Search assets with the specified paths */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude the asset with the specified path */
  neq?: InputMaybe<Scalars['String']>;
  /** Search assets that do not have the specified paths */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadType =
  | 'archive'
  | 'audio'
  | 'image'
  | 'pdfdocument'
  | 'presentation'
  | 'richtext'
  | 'spreadsheet'
  | 'video';

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']>;
};

export type UploadVideoField = {
  __typename?: 'UploadVideoField';
  alt?: Maybe<Scalars['String']>;
  blurUpThumb?: Maybe<Scalars['String']>;
  blurhash?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  framerate?: Maybe<Scalars['Int']>;
  height: Scalars['IntType'];
  mp4Url?: Maybe<Scalars['String']>;
  muxAssetId: Scalars['String'];
  muxPlaybackId: Scalars['String'];
  /** Default poster frame, in seconds into the video. Resolves to the record-level field override when present, otherwise the upload-level default. `null` means Mux's default (middle of the video). */
  posterTime?: Maybe<Scalars['Float']>;
  streamingUrl: Scalars['String'];
  thumbhash?: Maybe<Scalars['String']>;
  thumbnailUrl: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  width: Scalars['IntType'];
};


export type UploadVideoFieldAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type UploadVideoFieldBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float'];
  quality?: Scalars['Int'];
  size?: Scalars['Int'];
};


export type UploadVideoFieldMp4UrlArgs = {
  exactRes?: InputMaybe<VideoMp4Res>;
  res?: InputMaybe<VideoMp4Res>;
};


export type UploadVideoFieldThumbnailUrlArgs = {
  fitMode?: InputMaybe<MuxThumbnailFitMode>;
  flipH?: InputMaybe<Scalars['Boolean']>;
  flipV?: InputMaybe<Scalars['Boolean']>;
  format?: InputMaybe<MuxThumbnailFormatType>;
  height?: InputMaybe<Scalars['Int']>;
  rotate?: InputMaybe<MuxThumbnailRotation>;
  time?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type UploadVideoFieldTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']>;
};

/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord = RecordInterface & {
  __typename?: 'ValuationPageRecord';
  _allActionBoxTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allButtonLocales?: Maybe<Array<ButtonRecordMultiLocaleField>>;
  _allFaqLocales?: Maybe<Array<FaqQuestionNewRecordListListNonNullMultiLocaleField>>;
  _allHeadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allImageLocales?: Maybe<Array<FileFieldMultiLocaleField>>;
  _allLargeFeatureCardLocales?: Maybe<Array<FeaturedCardRecordMultiLocaleField>>;
  _allLargeFeatureCardsLocales?: Maybe<Array<FeaturedCardRecordListListNonNullMultiLocaleField>>;
  _allSeoInformationLocales?: Maybe<Array<SeoInformationRecordMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSmallFeatureCardsLocales?: Maybe<Array<SmallFeatureCardsBlockRecordMultiLocaleField>>;
  _allSubheadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTrustpilotTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  actionBoxTitle?: Maybe<Scalars['String']>;
  button?: Maybe<ButtonRecord>;
  createdAt: Scalars['DateTime'];
  faq: Array<FaqQuestionNewRecord>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  largeFeatureCard?: Maybe<FeaturedCardRecord>;
  largeFeatureCards: Array<FeaturedCardRecord>;
  seo?: Maybe<SeoField>;
  seoInformation?: Maybe<SeoInformationRecord>;
  smallFeatureCards?: Maybe<SmallFeatureCardsBlockRecord>;
  subheading?: Maybe<Scalars['String']>;
  trustpilotTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllActionBoxTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllFaqLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllHeadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllImageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllLargeFeatureCardLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllLargeFeatureCardsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllSeoInformationLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllSmallFeatureCardsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllSubheadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_AllTrustpilotTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordActionBoxTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordFaqArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordHeadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordLargeFeatureCardArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordLargeFeatureCardsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordSeoInformationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordSmallFeatureCardsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordSubheadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type 💲 Valuation Page (valuation_page) */
export type ValuationPageRecordTrustpilotTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type VehicleMajorFeatureModalModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<VehicleMajorFeatureModalModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VehicleMajorFeatureModalModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  conditions?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  key?: InputMaybe<StringFilter>;
  text?: InputMaybe<StructuredTextFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type VehicleMajorFeatureModalModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'key_ASC'
  | 'key_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type VehicleMajorFeatureModalModelTextField = {
  __typename?: 'VehicleMajorFeatureModalModelTextField';
  blocks: Array<Scalars['String']>;
  inlineBlocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type VehicleMajorFeatureModalModelTextFieldMultiLocaleField = {
  __typename?: 'VehicleMajorFeatureModalModelTextFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<VehicleMajorFeatureModalModelTextField>;
};

/** Record of type Vehicle Major Feature Modal (vehicle_major_feature_modal) */
export type VehicleMajorFeatureModalRecord = RecordInterface & {
  __typename?: 'VehicleMajorFeatureModalRecord';
  _allLinkLocales?: Maybe<Array<TextLinkRecordMultiLocaleField>>;
  _allTextLocales?: Maybe<Array<VehicleMajorFeatureModalModelTextFieldMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  conditions: Array<ConditionInfoModelRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  key?: Maybe<Scalars['String']>;
  link?: Maybe<TextLinkRecord>;
  text?: Maybe<VehicleMajorFeatureModalModelTextField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Vehicle Major Feature Modal (vehicle_major_feature_modal) */
export type VehicleMajorFeatureModalRecord_AllLinkLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Vehicle Major Feature Modal (vehicle_major_feature_modal) */
export type VehicleMajorFeatureModalRecord_AllTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Vehicle Major Feature Modal (vehicle_major_feature_modal) */
export type VehicleMajorFeatureModalRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Vehicle Major Feature Modal (vehicle_major_feature_modal) */
export type VehicleMajorFeatureModalRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Vehicle Major Feature Modal (vehicle_major_feature_modal) */
export type VehicleMajorFeatureModalRecordLinkArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Vehicle Major Feature Modal (vehicle_major_feature_modal) */
export type VehicleMajorFeatureModalRecordTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Vehicle Major Feature Modal (vehicle_major_feature_modal) */
export type VehicleMajorFeatureModalRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type VehicleTypeModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<VehicleTypeModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VehicleTypeModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type VehicleTypeModelOrderBy =
  | '_createdAt_ASC'
  | '_createdAt_DESC'
  | '_firstPublishedAt_ASC'
  | '_firstPublishedAt_DESC'
  | '_isValid_ASC'
  | '_isValid_DESC'
  | '_publicationScheduledAt_ASC'
  | '_publicationScheduledAt_DESC'
  | '_publishedAt_ASC'
  | '_publishedAt_DESC'
  | '_status_ASC'
  | '_status_DESC'
  | '_unpublishingScheduledAt_ASC'
  | '_unpublishingScheduledAt_DESC'
  | '_updatedAt_ASC'
  | '_updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Record of type Vehicle Type (vehicle_type) */
export type VehicleTypeRecord = RecordInterface & {
  __typename?: 'VehicleTypeRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Vehicle Type (vehicle_type) */
export type VehicleTypeRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type VideoField = {
  __typename?: 'VideoField';
  height: Scalars['IntType'];
  provider: Scalars['String'];
  providerUid: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['IntType'];
};

export type VideoMp4Res =
  | 'high'
  | 'low'
  | 'medium';

/** Block of type Warranty (warranty) */
export type WarrantyRecord = RecordInterface & {
  __typename?: 'WarrantyRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  auctionType?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  leasingPrice?: Maybe<Scalars['IntType']>;
  loanPrice?: Maybe<Scalars['IntType']>;
  maxAge?: Maybe<Scalars['IntType']>;
  maxMileage?: Maybe<Scalars['IntType']>;
  period?: Maybe<Scalars['IntType']>;
  price?: Maybe<Scalars['IntType']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Warranty (warranty) */
export type WarrantyRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type WarrantyRecordListListNonNullMultiLocaleField = {
  __typename?: 'WarrantyRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<WarrantyRecord>;
};

export type YoutubeClipModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<YoutubeClipModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<YoutubeClipModelFilter>>>;
  aspectRatio?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  linkParameters?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  videoId?: InputMaybe<StringFilter>;
  width?: InputMaybe<IntegerFilter>;
};

/** Block of type YouTube clip (youtube_clip) */
export type YoutubeClipRecord = RecordInterface & {
  __typename?: 'YoutubeClipRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  aspectRatio?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  linkParameters?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  videoId?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['IntType']>;
};


/** Block of type YouTube clip (youtube_clip) */
export type YoutubeClipRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FocalPoint = {
  __typename?: 'focalPoint';
  x: Scalars['FloatType'];
  y: Scalars['FloatType'];
};

export type BiddingQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type BiddingQuery = { __typename?: 'Query', auctionTipsModel?: { __typename?: 'AuctionTipsModelRecord', structuredText?: { __typename?: 'StructuredTextBlockRecord', structuredText?: { __typename?: 'StructuredTextBlockModelStructuredTextField', value: any } | null } | null } | null };

export type CategoryBySlugQueryVariables = Exact<{
  locale: SiteLocale;
  slug: Scalars['String'];
}>;


export type CategoryBySlugQuery = { __typename?: 'Query', category?: { __typename?: 'CategoryRecord', id: any, name?: string | null, slug?: string | null, _editingUrl?: string | null, optionalHero?: { __typename?: 'OptionalHeroRecord', textColor?: string | null, title?: string | null, subtitle?: string | null, contentAlignment?: string | null, showHero?: any | null, button: Array<{ __typename?: 'PromoButtonRecord', backgroundColor?: string | null, backgroundColorShade?: string | null, link?: string | null, text?: string | null, textColor?: string | null }>, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null } | null, structuredDescription?: { __typename?: 'CategoryModelStructuredDescriptionField', value: any, blocks: Array<string>, links: Array<string> } | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null } | null };

export type ArticlesByCategoryAndSlugWithRichTextQueryVariables = Exact<{
  locale: SiteLocale;
  slug: Scalars['String'];
  categoryId: Scalars['ItemId'];
}>;


export type ArticlesByCategoryAndSlugWithRichTextQuery = { __typename?: 'Query', article?: { __typename?: 'ArticleRecord', title?: string | null, subtitle?: string | null, _firstPublishedAt?: any | null, _publishedAt?: any | null, premable?: string | null, _editingUrl?: string | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null, additionalCategories: Array<{ __typename?: 'CategoryRecord', slug?: string | null, name?: string | null, id: any }>, articleimage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, newsletterSignupSection: Array<{ __typename?: 'NewsletterSignupRecord', title?: string | null, description?: string | null, newsletterType?: string | null }>, body?: { __typename?: 'ArticleModelBodyField', value: any, blocks: Array<{ __typename: 'AnchorNavigationRecord', id: any, items: Array<{ __typename?: 'AnchorNavigationItemRecord', id: any, sectionHeading?: string | null }> } | { __typename: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | { __typename: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename: 'HeadlineRecord', id: any, text?: string | null, tag?: string | null } | { __typename: 'HtmlInputRecord', id: any, htmlField?: string | null } | { __typename: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename: 'NewsletterSignupRecord', id: any, title?: string | null, description?: string | null } | { __typename: 'SpacerRecord', id: any, space?: any | null } | { __typename: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null } | { __typename: 'TableRecord', id: any, tablestructure?: any | null } | { __typename: 'TitleRecord', id: any, text?: string | null, tag?: string | null } | { __typename: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null, seoInfo?: { __typename?: 'ArticleModelSeoInfoField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, seoInfoTemplate?: { __typename?: 'StructuredTextTemplateRecord', template?: { __typename?: 'StructuredTextTemplateModelTemplateField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null } | null };

export type ArticlesForCategoryQueryVariables = Exact<{
  locale: SiteLocale;
  categoryId: Scalars['ItemId'];
  ignoreArticleSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ArticlesForCategoryQuery = { __typename?: 'Query', allArticles: Array<{ __typename?: 'ArticleRecord', slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> };

export type ArticlesForCategoryWithAdditionalQueryVariables = Exact<{
  locale: SiteLocale;
  categoryId: Scalars['ItemId'];
  ignoreArticleSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ArticlesForCategoryWithAdditionalQuery = { __typename?: 'Query', allArticles: Array<{ __typename?: 'ArticleRecord', slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> };

export type ArticlesByCategoriesQueryVariables = Exact<{
  locale: SiteLocale;
  categoryIds: Array<Scalars['ItemId']> | Scalars['ItemId'];
  ignoreArticleSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ArticlesByCategoriesQuery = { __typename?: 'Query', allArticles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, id: any, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> };

export type PageByNameQueryVariables = Exact<{
  locale: SiteLocale;
  name: Scalars['String'];
}>;


export type PageByNameQuery = { __typename?: 'Query', page?: { __typename?: 'PageRecord', name?: string | null, _editingUrl?: string | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null, optionalHero?: { __typename?: 'OptionalHeroRecord', textColor?: string | null, title?: string | null, subtitle?: string | null, contentAlignment?: string | null, showHero?: any | null, button: Array<{ __typename?: 'PromoButtonRecord', backgroundColor?: string | null, backgroundColorShade?: string | null, link?: string | null, text?: string | null, textColor?: string | null }>, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null } | null, _allReferencingCategoryOrders: Array<{ __typename?: 'CategoryOrderRecord', categories: Array<{ __typename?: 'CategoryRecord', id: any }> }> } | null };

export type IndexArticleFieldsFragment = { __typename?: 'ArticleRecord', slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null };

export type AllArticlesForMainPageQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type AllArticlesForMainPageQuery = { __typename?: 'Query', allArticles: Array<{ __typename?: 'ArticleRecord', slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> };

export type SearchAllArticlesQueryVariables = Exact<{
  locale: SiteLocale;
  query: Scalars['String'];
}>;


export type SearchAllArticlesQuery = { __typename?: 'Query', allArticles: Array<{ __typename?: 'ArticleRecord', slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> };

export type ArticlesBySlugsQueryVariables = Exact<{
  locale: SiteLocale;
  requestedLocale: SiteLocale;
  slugs: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type ArticlesBySlugsQuery = { __typename?: 'Query', allArticles: Array<{ __typename?: 'ArticleRecord', slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> };

export type AllCategoriesQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type AllCategoriesQuery = { __typename?: 'Query', allCategories: Array<{ __typename?: 'CategoryRecord', slug?: string | null, name?: string | null, id: any }> };

export type PreviousCategoryQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type PreviousCategoryQuery = { __typename?: 'Query', allCategories: Array<{ __typename?: 'CategoryRecord', slug?: string | null, _allReferencingArticles: Array<{ __typename?: 'ArticleRecord', slug?: string | null, previousCategory?: { __typename?: 'CategoryRecord', slug?: string | null } | null, mainCategory?: { __typename?: 'CategoryRecord', slug?: string | null } | null }> }> };

export type BaseCarBrandPageFragment = { __typename?: 'CarBrandPageRecord', name?: string | null, slug?: string | null, heading?: string | null, headingTag?: string | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, headingTemplate?: { __typename?: 'StringTemplateRecord', template?: string | null } | null, seoInfo?: { __typename?: 'CarBrandPageModelSeoInfoField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, seoInfoTemplate?: { __typename?: 'StructuredTextTemplateRecord', template?: { __typename?: 'StructuredTextTemplateModelTemplateField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null } | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null, seoTemplate?: { __typename?: 'SeoMetaTemplateRecord', template?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string } | null } | null } | null } | null, _allReferencingCarFamilyPages: Array<{ __typename?: 'CarFamilyPageRecord', name?: string | null, slug?: string | null }> };

export type CarTreeFamilyBySlugQueryVariables = Exact<{
  locale: SiteLocale;
  slug: Scalars['String'];
  filterPage: Scalars['ItemId'];
}>;


export type CarTreeFamilyBySlugQuery = { __typename?: 'Query', carFamilyPage?: { __typename?: 'CarFamilyPageRecord', id: any, name?: string | null, slug?: string | null, queryParams?: string | null, displaySeoText?: any | null, preamble?: { __typename?: 'CarFamilyPageModelPreambleField', value: any, links: Array<string> } | null, text?: { __typename?: 'CarFamilyPageModelTextField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, brand?: { __typename?: 'CarBrandPageRecord', name?: string | null, slug?: string | null, heading?: string | null, headingTag?: string | null, familyPreambleTemplate?: { __typename?: 'StructuredTextTemplateRecord', template?: { __typename?: 'StructuredTextTemplateModelTemplateField', value: any, links: Array<string> } | null } | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, headingTemplate?: { __typename?: 'StringTemplateRecord', template?: string | null } | null, seoInfo?: { __typename?: 'CarBrandPageModelSeoInfoField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, seoInfoTemplate?: { __typename?: 'StructuredTextTemplateRecord', template?: { __typename?: 'StructuredTextTemplateModelTemplateField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null } | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null, seoTemplate?: { __typename?: 'SeoMetaTemplateRecord', template?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string } | null } | null } | null } | null, _allReferencingCarFamilyPages: Array<{ __typename?: 'CarFamilyPageRecord', name?: string | null, slug?: string | null }> } | null } | null };

export type CarTreeAllBrandsQueryVariables = Exact<{
  filterPage: Scalars['ItemId'];
}>;


export type CarTreeAllBrandsQuery = { __typename?: 'Query', allCarBrandPages: Array<{ __typename?: 'CarBrandPageRecord', name?: string | null, slug?: string | null }> };

export type AllBrandAndFamilySlugsQueryVariables = Exact<{
  locale: SiteLocale;
  limit: Scalars['IntType'];
  skip: Scalars['IntType'];
}>;


export type AllBrandAndFamilySlugsQuery = { __typename?: 'Query', allCarBrandPages: Array<{ __typename?: 'CarBrandPageRecord', slug?: string | null, _allReferencingCarFamilyPages: Array<{ __typename?: 'CarFamilyPageRecord', slug?: string | null }> }> };

export type CarBrandAndCategoryBySlugQueryVariables = Exact<{
  locale: SiteLocale;
  slug: Scalars['String'];
  filterPage: Scalars['ItemId'];
}>;


export type CarBrandAndCategoryBySlugQuery = { __typename?: 'Query', carBrandPage?: { __typename?: 'CarBrandPageRecord', id: any, queryParams?: string | null, name?: string | null, slug?: string | null, heading?: string | null, headingTag?: string | null, preamble?: { __typename?: 'CarBrandPageModelPreambleField', value: any, links: Array<string> } | null, preambleTemplate?: { __typename?: 'StructuredTextTemplateRecord', template?: { __typename?: 'StructuredTextTemplateModelTemplateField', value: any, links: Array<string> } | null } | null, text?: { __typename?: 'CarBrandPageModelTextField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, headingTemplate?: { __typename?: 'StringTemplateRecord', template?: string | null } | null, seoInfo?: { __typename?: 'CarBrandPageModelSeoInfoField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, seoInfoTemplate?: { __typename?: 'StructuredTextTemplateRecord', template?: { __typename?: 'StructuredTextTemplateModelTemplateField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null } | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null, seoTemplate?: { __typename?: 'SeoMetaTemplateRecord', template?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string } | null } | null } | null } | null, _allReferencingCarFamilyPages: Array<{ __typename?: 'CarFamilyPageRecord', name?: string | null, slug?: string | null }> } | null, carCategoryPage?: { __typename?: 'CarCategoryPageRecord', id: any, name?: string | null, slug?: string | null, heading?: string | null, headingTag?: string | null, queryParams?: string | null, preamble?: { __typename?: 'CarCategoryPageModelPreambleField', value: any, links: Array<string> } | null, text?: { __typename?: 'CarCategoryPageModelTextField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'CarInspirationListRecord' } | { __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, seoInfo?: { __typename?: 'CarCategoryPageModelSeoInfoField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, seoInfoTemplate?: { __typename?: 'StructuredTextTemplateRecord', template?: { __typename?: 'StructuredTextTemplateModelTemplateField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null }> } | null } | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null, seoTemplate?: { __typename?: 'SeoMetaTemplateRecord', template?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string } | null } | null } | null } | null } | null };

export type CarguideQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type CarguideQuery = { __typename?: 'Query', carGuide?: { __typename?: 'CarGuideRecord', title?: string | null, description?: string | null, startButtonText?: string | null, _editingUrl?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, questions: Array<{ __typename?: 'CarGuideQuestionRecord', title?: string | null, subtitle?: string | null, question?: string | null, tag?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }>, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null } | null };

export type CheckoutStepFragment = { __typename?: 'CheckoutStepRecord', title?: string | null, subtitle?: string | null, description?: string | null, nextButtonText?: string | null };

export type CheckoutQueryVariables = Exact<{
  locale: SiteLocale;
  flowType: Scalars['String'];
}>;


export type CheckoutQuery = { __typename?: 'Query', checkout?: { __typename?: 'CheckoutRecord', title?: string | null, description?: string | null, auctionTitle?: string | null, auctionDescription?: string | null, closedDescription?: string | null, finalInformationText?: string | null, finalSubmitButtonText?: string | null, finalAuctionSubmitButtonText?: string | null, acceptPolicyText?: string | null, acceptPolicyLinkText?: string | null, acceptSitePolicyLinkText?: string | null, acceptDeliveryPolicyText?: string | null, acceptPickupPolicyText?: string | null, acceptBuyerTransferPolicyText?: string | null, _editingUrl?: string | null, policyPrivate?: { __typename?: 'StructuredTextRecord', content?: { __typename?: 'StructuredTextModelContentField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'HtmlInputRecord' } | { __typename?: 'TableRecord', id: any, tablestructure?: any | null }> } | null } | null, policyCompany?: { __typename?: 'StructuredTextRecord', content?: { __typename?: 'StructuredTextModelContentField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'HtmlInputRecord' } | { __typename?: 'TableRecord', id: any, tablestructure?: any | null }> } | null } | null, policySite?: { __typename?: 'StructuredTextRecord', content?: { __typename?: 'StructuredTextModelContentField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'HtmlInputRecord' } | { __typename?: 'TableRecord', id: any, tablestructure?: any | null }> } | null } | null, stepsFinancing?: { __typename?: 'CheckoutStepRecord', title?: string | null, subtitle?: string | null, description?: string | null, nextButtonText?: string | null, details?: { __typename?: 'CheckoutStepDeliveryCommonRecord' } | { __typename?: 'CheckoutStepFinancingCommonRecord', labelCash?: string | null, labelLoan?: string | null, loanSellingPoint?: string | null, servicesTitle?: string | null, insuranceTitle?: string | null, insuranceDescription?: string | null, warrantyTitle?: string | null, warrantyDescription?: string | null, warrantyDescriptionAuction?: string | null, warrantyDescriptionFixedPrice?: string | null, serviceAgreementTitle?: string | null, serviceAgreementDescription?: string | null, serviceAgreementCheckboxLabel?: string | null, requestedFinancingLabel?: string | null, tireTitle?: string | null, tireDescription?: string | null, carToSellTitle?: string | null, carToSellDescription?: string | null, carToSellCheckboxLabel?: string | null, loanWarning?: { __typename?: 'CheckoutStepFinancingCommonModelLoanWarningField', blocks: Array<string>, links: Array<string>, value: any } | null, warrantyExtendedInfo?: { __typename?: 'CheckoutStepFinancingCommonModelWarrantyExtendedInfoField', blocks: Array<string>, links: Array<string>, value: any } | null, serviceAgreementFullDescription?: { __typename?: 'CheckoutStepFinancingCommonModelServiceAgreementFullDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, featuredWarranty: Array<{ __typename?: 'FeaturedWarrantyRecord', checkoutType?: string | null, featuredText?: string | null, featuredPeriod?: any | null }> } | { __typename?: 'CheckoutStepOwnerDetailsCarDealerRecord' } | { __typename?: 'CheckoutStepSummaryCommonRecord' } | null } | null, stepsOwnerDetails?: { __typename?: 'CheckoutStepRecord', title?: string | null, subtitle?: string | null, description?: string | null, nextButtonText?: string | null, details?: { __typename?: 'CheckoutStepDeliveryCommonRecord' } | { __typename?: 'CheckoutStepFinancingCommonRecord' } | { __typename?: 'CheckoutStepOwnerDetailsCarDealerRecord', buyerTransferInformationText?: string | null, informationTitle?: string | null, informationText?: { __typename?: 'CheckoutStepOwnerDetailsCarDealerModelInformationTextField', blocks: Array<string>, links: Array<string>, value: any } | null } | { __typename?: 'CheckoutStepSummaryCommonRecord' } | null } | null, stepsDelivery?: { __typename?: 'CheckoutStepRecord', title?: string | null, subtitle?: string | null, description?: string | null, nextButtonText?: string | null, details?: { __typename?: 'CheckoutStepDeliveryCommonRecord', vehicleLocation?: string | null, deliveryMethodTitle?: string | null, pickUpMethodTitle?: string | null, pickupMethodInformation?: string | null, pickupTimeTitle?: string | null, timePickerTitle?: string | null, timePickerText?: string | null, personIdentificationTitle?: string | null } | { __typename?: 'CheckoutStepFinancingCommonRecord' } | { __typename?: 'CheckoutStepOwnerDetailsCarDealerRecord' } | { __typename?: 'CheckoutStepSummaryCommonRecord' } | null } | null, stepsSummary?: { __typename?: 'CheckoutStepRecord', title?: string | null, subtitle?: string | null, description?: string | null, nextButtonText?: string | null, details?: { __typename?: 'CheckoutStepDeliveryCommonRecord' } | { __typename?: 'CheckoutStepFinancingCommonRecord' } | { __typename?: 'CheckoutStepOwnerDetailsCarDealerRecord' } | { __typename?: 'CheckoutStepSummaryCommonRecord', totalPriceTitle?: string | null, vatText?: string | null, transportTitle?: string | null } | null } | null, confirmationData: Array<{ __typename?: 'CheckoutConfirmationRecord', checkoutType?: string | null, title?: string | null, reservation?: string | null, whatHappensNow?: string | null, yourOrder?: string | null, summary?: string | null, totalPriceTitle?: string | null, transportTitle?: string | null, reservationNotFirstInLine?: string | null, paymentTitle?: string | null, paymentExplanation?: string | null, paymentInformation?: string | null, paymentButtonText?: string | null, carDealerPaymentInformationTitle?: string | null, carDealerPaymentInformationText?: { __typename?: 'CheckoutConfirmationModelCarDealerPaymentInformationTextField', blocks: Array<string>, links: Array<string>, value: any } | null, confirmationSteps: Array<{ __typename?: 'CheckoutConfirmationStepRecord', title?: string | null, description?: string | null }> }> } | null };

export type AllSlugsQueryVariables = Exact<{
  currentLocale: SiteLocale;
  requestedLocale: SiteLocale;
  carBrandOrCategorySlug: Scalars['String'];
  carFamilySlug: Scalars['String'];
  categorySlug: Scalars['String'];
  articleSlug: Scalars['String'];
  faqQuestionSlug: Scalars['String'];
  dynamicPageSlug: Scalars['String'];
}>;


export type AllSlugsQuery = { __typename?: 'Query', carCategoryPage?: { __typename?: 'CarCategoryPageRecord', slug?: string | null } | null, carBrandPage?: { __typename?: 'CarBrandPageRecord', slug?: string | null, _allReferencingCarFamilyPages: Array<{ __typename?: 'CarFamilyPageRecord', slug?: string | null }> } | null, category?: { __typename?: 'CategoryRecord', slug?: string | null, _allReferencingArticles: Array<{ __typename?: 'ArticleRecord', slug?: string | null }> } | null, faqQuestionNew?: { __typename?: 'FaqQuestionNewRecord', slug?: string | null } | null, dynamicPage?: { __typename?: 'DynamicPageRecord', slug?: string | null } | null };

export type AllLocalizedSlugsQueryVariables = Exact<{
  limit: Scalars['IntType'];
  skip: Scalars['IntType'];
}>;


export type AllLocalizedSlugsQuery = { __typename?: 'Query', allCarCategoryPages: Array<{ __typename?: 'CarCategoryPageRecord', updatedAt: any, _allSlugLocales?: Array<{ __typename?: 'StringMultiLocaleField', locale?: SiteLocale | null, value?: string | null }> | null, filterPage?: { __typename?: 'FilterPageRecord', mainCategory?: string | null } | null }>, allCarBrandPages: Array<{ __typename?: 'CarBrandPageRecord', slug?: string | null, updatedAt: any, filterPage?: { __typename?: 'FilterPageRecord', mainCategory?: string | null } | null, _allReferencingCarFamilyPages: Array<{ __typename?: 'CarFamilyPageRecord', updatedAt: any, _allSlugLocales?: Array<{ __typename?: 'StringMultiLocaleField', locale?: SiteLocale | null, value?: string | null }> | null }> }>, allCategories: Array<{ __typename?: 'CategoryRecord', updatedAt: any, _allSlugLocales?: Array<{ __typename?: 'StringMultiLocaleField', locale?: SiteLocale | null, value?: string | null }> | null, _allReferencingArticles: Array<{ __typename?: 'ArticleRecord', updatedAt: any, _allSlugLocales?: Array<{ __typename?: 'StringMultiLocaleField', locale?: SiteLocale | null, value?: string | null }> | null }> }>, allFaqQuestionNews: Array<{ __typename?: 'FaqQuestionNewRecord', updatedAt: any, _allSlugLocales?: Array<{ __typename?: 'StringMultiLocaleField', locale?: SiteLocale | null, value?: string | null }> | null }>, allDynamicPages: Array<{ __typename?: 'DynamicPageRecord', updatedAt: any, _allSlugLocales?: Array<{ __typename?: 'StringMultiLocaleField', locale?: SiteLocale | null, value?: string | null }> | null }> };

export type CompanyCampaignPageQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type CompanyCampaignPageQuery = { __typename?: 'Query', companyCampaignPage?: { __typename?: 'CompanyCampaignPageRecord', heroFormTitle?: string | null, heroFormBtnText?: string | null, heroFormDescription?: string | null, contactFormSectionTitle?: string | null, contactFormTitle?: string | null, contactFormBtnText?: string | null, fleetValCompTitle?: string | null, fleetValCompAverageProfitPerCar?: any | null, fleetValCompAverageValuationDescription?: string | null, fleetValCompKvdAverageValuation?: any | null, fleetValCompKvdAverageValuationDescription?: string | null, fleetValCompDealerAverageValuation?: any | null, fleetValCompDealerAverageValuationDescription?: string | null, fleetValCompTotalVehiclesInfo?: string | null, fleetValCompKvdValuationTitle?: string | null, fleetValCompKvdValuationDescription?: string | null, fleetValCompDealerValuationTitle?: string | null, fleetValCompDealerValuationDescription?: string | null, fleetValCompResultTitle?: string | null, fleetValCompResultDescription?: string | null, fleetValCompUsp1?: string | null, fleetValCompUsp2?: string | null, fleetValCompUsp3?: string | null, fleetValReportTitle?: string | null, fleetValReportVehicleCountText?: string | null, fleetValReportDealerTitle?: string | null, fleetValReportDealerDescription?: string | null, fleetValReportKvdTitle?: string | null, fleetValReportKvdDescription?: string | null, fleetValReportResultTitle?: string | null, fleetValReportResultDescription?: string | null, fleetValReportInsightsTitle?: string | null, fleetValReportMakeModelTitle?: string | null, fleetValReportMakeModelDescription?: string | null, fleetValReportMakeModelMoreInfo?: string | null, fleetValReportAgeTitle?: string | null, fleetValReportAgeDescription?: string | null, fleetValReportAgeRecommendedLabel?: string | null, fleetValReportFuelTitle?: string | null, fleetValReportFuelDescription?: string | null, fleetValReportFormTitle?: string | null, fleetValReportFormDescription?: string | null, fleetValReportRecommendationTitle?: string | null, _editingUrl?: string | null, hero?: { __typename?: 'OptionalHeroRecord', textColor?: string | null, title?: string | null, subtitle?: string | null, contentAlignment?: string | null, showHero?: any | null, button: Array<{ __typename?: 'PromoButtonRecord', backgroundColor?: string | null, backgroundColorShade?: string | null, link?: string | null, text?: string | null, textColor?: string | null }>, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null } | null, heroFormSuccess?: { __typename?: 'CompanyCampaignPageModelHeroFormSuccessField', blocks: Array<string>, links: Array<string>, value: any } | null, contactFormSectionDescription?: { __typename?: 'CompanyCampaignPageModelContactFormSectionDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, contactFormNewsletterLabel?: { __typename?: 'CompanyCampaignPageModelContactFormNewsletterLabelField', blocks: Array<string>, links: Array<string>, value: any } | null, contactFormSuccess?: { __typename?: 'CompanyCampaignPageModelContactFormSuccessField', blocks: Array<string>, links: Array<string>, value: any } | null, fleetValCompDisclaimer?: { __typename?: 'CompanyCampaignPageModelFleetValCompDisclaimerField', blocks: Array<string>, links: Array<string>, value: any } | null, fleetValReportDisclaimer?: { __typename?: 'CompanyCampaignPageModelFleetValReportDisclaimerField', blocks: Array<string>, links: Array<string>, value: any } | null, fleetValReportProcessingMessage?: { __typename?: 'CompanyCampaignPageModelFleetValReportProcessingMessageField', blocks: Array<string>, links: Array<string>, value: any } | null, fleetValReportExpiredMessage?: { __typename?: 'CompanyCampaignPageModelFleetValReportExpiredMessageField', blocks: Array<string>, links: Array<string>, value: any } | null, fleetValReportRecommendationText?: { __typename?: 'CompanyCampaignPageModelFleetValReportRecommendationTextField', blocks: Array<string>, links: Array<string>, value: any } | null, modularSections: Array<{ __typename?: 'CompanyCampaignCarguideRecord', id: any, preTitle?: string | null, title?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, button?: { __typename?: 'ButtonRecord', color?: string | null, text?: string | null } | null, text?: { __typename?: 'CompanyCampaignCarguideModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null } | { __typename?: 'CompanyCampaignFleetManagerRecord', id: any, title?: string | null, description?: string | null, subtitle?: string | null, youtubeVideo?: { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null } | null, button?: { __typename?: 'ButtonRecord', text?: string | null, color?: string | null, url?: string | null, openLinkInNewWindow?: any | null } | null, bulletPoints?: { __typename?: 'CompanyCampaignFleetManagerModelBulletPointsField', blocks: Array<string>, links: Array<string>, value: any } | null } | { __typename?: 'CompanyCampaignNewsletterRecord', id: any, newsletter?: { __typename?: 'NewsletterSignupRecord', title?: string | null, newsletterType?: string | null, description?: string | null } | null, socialMedia?: { __typename?: 'TextIconRecord', text?: string | null, imageIcon?: { __typename?: 'ImageIconRecord', icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null } | null } | null } | { __typename?: 'CompanyCampaignReasonsBlockRecord', id: any, title?: string | null, reasons: Array<{ __typename?: 'DescriptionRecord', descriptionTitle?: string | null, descriptionBodyText?: string | null, imageIcon?: { __typename?: 'ImageIconRecord', icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null } | null }>, testimonials: Array<{ __typename?: 'TestimonialQuoteRecord', quote?: string | null, testimonialStatus?: string | null }> } | { __typename?: 'CompanyCampaignStatsBlockRecord', id: any, statOne?: string | null, statThree?: string | null, statTwo?: string | null } | { __typename?: 'SmallFeatureCardsBlockRecord', id: any, title?: string | null, button?: { __typename?: 'ButtonRecord', color?: string | null, size?: string | null, text?: string | null, url?: string | null } | null, text?: { __typename?: 'SmallFeatureCardsBlockModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, id: any, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> }>, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null } | null };

export type DynamicPageQueryVariables = Exact<{
  locale: SiteLocale;
  slug: Scalars['String'];
}>;


export type DynamicPageQuery = { __typename?: 'Query', dynamicPage?: { __typename?: 'DynamicPageRecord', bodyBackgroundColor?: string | null, bodyPaddingTop?: any | null, bodyPaddingBottom?: any | null, bodyContentMaxWidth?: any | null, bodyContentBackgroundColor?: string | null, bodyContentPadding?: string | null, bodyContentTextAlign?: string | null, bodyContentBorderColor?: string | null, bodyInnerContentMaxWidth?: any | null, _editingUrl?: string | null, hero?: { __typename?: 'OptionalHeroRecord', textColor?: string | null, title?: string | null, subtitle?: string | null, contentAlignment?: string | null, showHero?: any | null, button: Array<{ __typename?: 'PromoButtonRecord', backgroundColor?: string | null, backgroundColorShade?: string | null, link?: string | null, text?: string | null, textColor?: string | null }>, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null } | null, body?: { __typename?: 'DynamicPageModelBodyField', value: any, blocks: Array<{ __typename?: 'AnchorNavigationRecord', id: any, items: Array<{ __typename?: 'AnchorNavigationItemRecord', id: any, sectionHeading?: string | null }> } | { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> } | { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null } | { __typename?: 'DynamicPageFormRecord', id: any, isActive?: any | null, usageType?: string | null, title?: string | null, description?: string | null, sendButton?: string | null } | { __typename?: 'DynamicPageValuationFormRecord', id: any, subtitle?: string | null, title?: string | null, formHeading?: string | null, imageBefore?: { __typename?: 'FileField', alt?: string | null, url: string } | null, imageAnimation?: { __typename?: 'FileField', alt?: string | null, url: string } | null, imageAfter?: { __typename?: 'FileField', alt?: string | null, url: string } | null } | { __typename?: 'FaqSectionBlockRecord', id: any, title?: string | null, ingress?: string | null, footerText?: string | null, footerLink?: { __typename?: 'TextLinkRecord', id: any, text?: string | null, url?: string | null } | null, questions: Array<{ __typename?: 'FaqQuestionNewRecord', id: any, question?: string | null, answer?: { __typename?: 'FaqQuestionNewModelAnswerField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> } | { __typename?: 'FeaturedBlocksBlockRecord', id: any, blockButtons: Array<{ __typename?: 'BlockButtonRecord', id: any, linkUrl?: string | null, preamble?: string | null, title?: string | null, backgroundImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }> } | { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename?: 'LeasingPartnerNavigationRecord', id: any, title?: string | null, helpText?: string | null, partnerLogos: Array<{ __typename?: 'LeasingPartnerNavigationItemRecord', id: any, scrollTargetId?: string | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }> } | { __typename?: 'LeasingPartnerPresentationRecord', id: any, anchorId?: string | null, partnerName?: string | null, leasingProvider?: string | null, uspHeading?: string | null, promotionHeading?: string | null, interestModalTitle?: string | null, interestModalIntro?: string | null, priceFootnote?: string | null, interestSubmitButtonText?: string | null, interestConfirmationTitle?: string | null, interestConfirmationText?: string | null, interestConfirmationSubjectHeading?: string | null, interestConfirmationDetailsHeading?: string | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, description?: { __typename?: 'LeasingPartnerPresentationModelDescriptionField', value: any, links: Array<string>, blocks: Array<string> } | null, uspList: Array<{ __typename?: 'TextRecord', id: any, text?: string | null }>, linkButton?: { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | null, promotionVehicleCards: Array<{ __typename?: 'LeasingPromotionVehicleCardRecord', id: any, brandAndModel?: string | null, monthlyCostFrom?: any | null, leasingPeriodFrom?: any | null, mileageFrom?: any | null, productImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }>, promotionButton?: { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | null, interestConsentLabel?: { __typename?: 'LeasingPartnerPresentationModelInterestConsentLabelField', value: any, links: Array<string>, blocks: Array<string> } | null } | { __typename?: 'SpacerRecord', id: any, space?: any | null } | { __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'TextGridRecord', id: any, columnGap?: any | null, rowGap?: any | null, columns: Array<{ __typename?: 'TextColumnRecord', body?: { __typename?: 'TextColumnModelBodyField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> }>, blocks: Array<{ __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> } | { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null } | { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename?: 'SpacerRecord', id: any, space?: any | null } | { __typename?: 'StructuredTextCardRecord', id: any, body?: { __typename?: 'StructuredTextCardModelBodyField', value: any, links: Array<string>, blocks: Array<string> } | null } | { __typename?: 'SupportChatCardRecord', id: any, text?: string | null, ctaLabel?: string | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> } | { __typename?: 'TextSectionRecord', id: any, backgroundColor?: string | null, paddingTop?: any | null, paddingBottom?: any | null, contentMaxWidth?: any | null, contentBackgroundColor?: string | null, contentPadding?: string | null, contentTextAlign?: string | null, contentBorderColor?: string | null, innerContentMaxWidth?: any | null, body?: { __typename?: 'TextSectionModelBodyField', value: any, blocks: Array<{ __typename?: 'AnchorNavigationRecord', id: any, items: Array<{ __typename?: 'AnchorNavigationItemRecord', id: any, sectionHeading?: string | null }> } | { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> } | { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null } | { __typename?: 'DynamicPageFormRecord', id: any, isActive?: any | null, usageType?: string | null, title?: string | null, description?: string | null, sendButton?: string | null } | { __typename?: 'DynamicPageValuationFormRecord', id: any, subtitle?: string | null, title?: string | null, formHeading?: string | null, imageBefore?: { __typename?: 'FileField', alt?: string | null, url: string } | null, imageAnimation?: { __typename?: 'FileField', alt?: string | null, url: string } | null, imageAfter?: { __typename?: 'FileField', alt?: string | null, url: string } | null } | { __typename?: 'FaqSectionBlockRecord', id: any, title?: string | null, ingress?: string | null, footerText?: string | null, footerLink?: { __typename?: 'TextLinkRecord', id: any, text?: string | null, url?: string | null } | null, questions: Array<{ __typename?: 'FaqQuestionNewRecord', id: any, question?: string | null, answer?: { __typename?: 'FaqQuestionNewModelAnswerField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> } | { __typename?: 'FeaturedBlocksBlockRecord', id: any, blockButtons: Array<{ __typename?: 'BlockButtonRecord', id: any, linkUrl?: string | null, preamble?: string | null, title?: string | null, backgroundImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }> } | { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename?: 'LeasingPartnerNavigationRecord', id: any, title?: string | null, helpText?: string | null, partnerLogos: Array<{ __typename?: 'LeasingPartnerNavigationItemRecord', id: any, scrollTargetId?: string | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }> } | { __typename?: 'SpacerRecord', id: any, space?: any | null } | { __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'TextGridRecord', id: any, columnGap?: any | null, rowGap?: any | null, columns: Array<{ __typename?: 'TextColumnRecord', body?: { __typename?: 'TextColumnModelBodyField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> }>, blocks: Array<{ __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> } | { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null } | { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename?: 'SpacerRecord', id: any, space?: any | null } | { __typename?: 'StructuredTextCardRecord', id: any, body?: { __typename?: 'StructuredTextCardModelBodyField', value: any, links: Array<string>, blocks: Array<string> } | null } | { __typename?: 'SupportChatCardRecord', id: any, text?: string | null, ctaLabel?: string | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> } | { __typename?: 'TextTabsBlockRecord', id: any, title?: string | null, tabs: Array<{ __typename?: 'TextTabRecord', id: any, tabName?: string | null, body?: { __typename?: 'TextTabModelBodyField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TextGridRecord', id: any, columnGap?: any | null, rowGap?: any | null, columns: Array<{ __typename?: 'TextColumnRecord', body?: { __typename?: 'TextColumnModelBodyField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> }>, blocks: Array<{ __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> } | { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null } | { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename?: 'SpacerRecord', id: any, space?: any | null } | { __typename?: 'StructuredTextCardRecord', id: any, body?: { __typename?: 'StructuredTextCardModelBodyField', value: any, links: Array<string>, blocks: Array<string> } | null } | { __typename?: 'SupportChatCardRecord', id: any, text?: string | null, ctaLabel?: string | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> }> } | null }> } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }>, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> }> } | null } | { __typename?: 'TextTabsBlockRecord', id: any, title?: string | null, tabs: Array<{ __typename?: 'TextTabRecord', id: any, tabName?: string | null, body?: { __typename?: 'TextTabModelBodyField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TextGridRecord', id: any, columnGap?: any | null, rowGap?: any | null, columns: Array<{ __typename?: 'TextColumnRecord', body?: { __typename?: 'TextColumnModelBodyField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> }>, blocks: Array<{ __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> } | { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null } | { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename?: 'SpacerRecord', id: any, space?: any | null } | { __typename?: 'StructuredTextCardRecord', id: any, body?: { __typename?: 'StructuredTextCardModelBodyField', value: any, links: Array<string>, blocks: Array<string> } | null } | { __typename?: 'SupportChatCardRecord', id: any, text?: string | null, ctaLabel?: string | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> }> } | null }> } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }>, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> }> } | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null } | null };

export type FacilityQueryVariables = Exact<{
  locale: SiteLocale;
  slug: Scalars['String'];
}>;


export type FacilityQuery = { __typename?: 'Query', facility?: { __typename?: 'FacilityRecord', dbId?: string | null, title?: string | null, slug?: string | null, phone?: string | null, fax?: string | null, streetAddress?: string | null, zipCode?: string | null, city?: string | null, customMapLink?: string | null, longitude?: any | null, latitude?: any | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, testDrive?: { __typename?: 'FacilityModelTestDriveField', blocks: Array<string>, links: Array<string>, value: any } | null, delivery?: { __typename?: 'FacilityModelDeliveryField', blocks: Array<string>, links: Array<string>, value: any } | null, directions?: { __typename?: 'FacilityModelDirectionsField', blocks: Array<string>, links: Array<string>, value: any } | null, paymentOptions?: { __typename?: 'FacilityModelPaymentOptionsField', blocks: Array<string>, links: Array<string>, value: any } | null, pickup?: { __typename?: 'FacilityModelPickupField', blocks: Array<string>, links: Array<string>, value: any } | null } | null };

export type FaqPageQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type FaqPageQuery = { __typename?: 'Query', faq?: { __typename?: 'FaqRecord', title?: string | null, subtitle?: string | null, categories: Array<{ __typename?: 'FaqCategoryBlockRecord', name?: string | null, icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null, questions: Array<{ __typename?: 'FaqQuestionNewRecord', question?: string | null, slug?: string | null, answer?: { __typename?: 'FaqQuestionNewModelAnswerField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> }> } | null };

export type FilterPageQueryVariables = Exact<{
  locale: SiteLocale;
  mainCategory: Scalars['String'];
}>;


export type FilterPageQuery = { __typename?: 'Query', filterPage?: { __typename?: 'FilterPageRecord', id: any, title?: string | null, _editingUrl?: string | null, description?: { __typename?: 'FilterPageModelDescriptionField', value: any } | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null, seoInformation?: { __typename?: 'FilterPageModelSeoInformationField', value: any, links: Array<string>, blocks: Array<{ __typename?: 'SubtitleRecord', id: any, text?: string | null, tag?: string | null } | { __typename?: 'TitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, categoryBlurbs: Array<{ __typename?: 'CategoryBlurbRecord', link?: string | null, text?: string | null, backgroundColor?: string | null, imageIcon: Array<{ __typename?: 'ImageIconRecord', icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null }> }>, cardTooltip: Array<{ __typename?: 'FilterCardTooltipRecord', infoText?: string | null, condition?: string | null }> } | null };

export type GlobalConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalConfigurationQuery = { __typename?: 'Query', globalConfiguration?: { __typename?: 'GlobalConfigurationRecord', financingInterest?: string | null } | null };

export type MajorFeatureByKeyQueryVariables = Exact<{
  locale: SiteLocale;
  key: Scalars['String'];
}>;


export type MajorFeatureByKeyQuery = { __typename?: 'Query', vehicleMajorFeatureModal?: { __typename?: 'VehicleMajorFeatureModalRecord', key?: string | null, title?: string | null, _editingUrl?: string | null, text?: { __typename?: 'VehicleMajorFeatureModalModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, conditions: Array<{ __typename?: 'ConditionInfoModelRecord', question?: string | null, key?: string | null, conditionInfo: Array<{ __typename?: 'ConditionInfoRecord', answer?: string | null, conditionStep?: string | null }> }> } | null };

export type MyAuctionsWonPageQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type MyAuctionsWonPageQuery = { __typename?: 'Query', myAuctionsWonPage?: { __typename?: 'MyAuctionsWonPageRecord', _editingUrl?: string | null, emptyStateText?: string | null, headline?: string | null, checkoutActiveSubheading?: string | null, checkoutPendingSubheading?: string | null, checkoutCompletedText?: string | null, checkoutCallbackText?: string | null, checkoutClosedText?: string | null, checkoutExpiryNoticeText?: string | null, cancellationButtonText?: string | null, cancellationAvailableText?: string | null, cancellationRequestSentTitle?: string | null, cancellationRequestSentText?: string | null, cancellationClosedText?: string | null, cancellationModalTitle?: string | null, cancellationModalConsentLabel?: string | null, cancellationModalSubmitText?: string | null, cancellationModalCancelText?: string | null, cancellationConfirmationTitle?: string | null, cancellationConfirmationCloseText?: string | null, helpText?: { __typename?: 'MyAuctionsWonPageModelHelpTextField', blocks: Array<string>, links: Array<string>, value: any } | null, footerContactText?: { __typename?: 'MyAuctionsWonPageModelFooterContactTextField', blocks: Array<string>, links: Array<string>, value: any } | null, cancellationTerms?: { __typename?: 'MyAuctionsWonPageModelCancellationTermsField', blocks: Array<string>, links: Array<string>, value: any } | null, cancellationModalBody?: { __typename?: 'MyAuctionsWonPageModelCancellationModalBodyField', blocks: Array<string>, links: Array<string>, value: any } | null, cancellationConfirmationBody?: { __typename?: 'MyAuctionsWonPageModelCancellationConfirmationBodyField', blocks: Array<string>, links: Array<string>, value: any } | null } | null };

export type LinkFragment = { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null };

export type NavigationQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type NavigationQuery = { __typename?: 'Query', navigation?: { __typename?: 'NavigationRecord', navigationTitle?: string | null, secondaryNavigationTitle?: string | null, loggedInNavigationTitle?: string | null, primaryNavigation: Array<{ __typename?: 'NavigationPrimaryLinkRecord', text?: string | null, url?: string | null, description?: string | null, subNavigation?: { __typename?: 'NavigationRecord', navigationTitle?: string | null, secondaryNavigationTitle?: string | null, primaryNavigation: Array<{ __typename?: 'NavigationPrimaryLinkRecord', text?: string | null, url?: string | null, description?: string | null, subNavigation?: { __typename?: 'NavigationRecord', navigationTitle?: string | null, secondaryNavigationTitle?: string | null, primaryNavigation: Array<{ __typename?: 'NavigationPrimaryLinkRecord', text?: string | null, url?: string | null, description?: string | null, subNavigation?: { __typename?: 'NavigationRecord', navigationTitle?: string | null, secondaryNavigationTitle?: string | null, primaryNavigation: Array<{ __typename?: 'NavigationPrimaryLinkRecord', text?: string | null, url?: string | null, description?: string | null }>, secondaryNavigation: Array<{ __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }> } | null }>, secondaryNavigation: Array<{ __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }> } | null }>, secondaryNavigation: Array<{ __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }> } | null }>, secondaryNavigation: Array<{ __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }>, utilityBarNavigation: Array<{ __typename?: 'TextIconWithLinkRecord', textIcon: Array<{ __typename?: 'TextIconRecord', text?: string | null, imageIcon?: { __typename?: 'ImageIconRecord', icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null } | null }>, textLink: Array<{ __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }> }>, loggedInNavigation: Array<{ __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }> } | null };

export type FooterNavigationQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type FooterNavigationQuery = { __typename?: 'Query', footerNavigation?: { __typename?: 'FooterNavigationRecord', _editingUrl?: string | null, linkGroups: Array<{ __typename?: 'LinkGroupRecord', title?: string | null, links: Array<{ __typename?: 'TextLinkWithMetaModelRecord', text?: string | null, url?: string | null, alternativeActionKey?: string | null, customLinkMeta: Array<{ __typename?: 'CustomMetaModelRecord', attrName?: string | null, attrValue?: string | null }> }> }>, footerButtons: Array<{ __typename?: 'ButtonRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null };

export type ServicesFragment = { __typename?: 'ObjectServiceRecord', id: any, serviceType?: string | null, title?: string | null, description?: string | null, footnote?: string | null, jsonData?: any | null, active?: any | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null, content?: { __typename?: 'ObjectServiceModelContentField', value: any, blocks: Array<string>, links: Array<string> } | null, link: Array<{ __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }>, excludeFromVehicleTypes: Array<{ __typename?: 'VehicleTypeRecord', id: any, name?: string | null }> };

export type BulletPointsFragment = { __typename?: 'TextRecord', text?: string | null };

export type ObjectPageQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type ObjectPageQuery = { __typename?: 'Query', objectPage?: { __typename?: 'ObjectPageRecord', contactSectionControllerAuction?: any | null, contactSectionControllerFixedPrice?: any | null, buyMethodsBiddingTutorialLink?: string | null, buyMethodsFixedPriceTutorialLink?: string | null, buyMethodsLoanCalculationExplanation?: string | null, heavyEquipmentDescriptionWarning?: string | null, heavyEquipmentSalesTermsTitle?: string | null, heavyEquipmentVehicleFactsDisclaimer?: string | null, heavyEquipmentServicesTitle?: string | null, nextButtonText?: string | null, exitButtonText?: string | null, finalButtonText?: string | null, ecoTitle?: string | null, ecoSubtitle?: string | null, ecoDescription?: string | null, ecoImageDescription?: string | null, ecoReadMoreUrl?: string | null, ecoReadMoreText?: string | null, _editingUrl?: string | null, deliveryCalculatorTitle?: string | null, deliveryCalculatorDisclaimer?: string | null, buyMethodsLoanWarning?: { __typename?: 'ObjectPageModelBuyMethodsLoanWarningField', value: any, blocks: Array<string>, links: Array<string> } | null, contact: Array<{ __typename?: 'ContactSectionRecord', title?: string | null, subtitle?: string | null, days?: string | null, extraInfo?: string | null, buttons: Array<{ __typename?: 'ContactButtonRecord', text?: string | null, href?: string | null, icon?: string | null }> }>, heavyEquipmentFacilityExplanation?: { __typename?: 'ObjectPageModelHeavyEquipmentFacilityExplanationField', value: any, blocks: Array<string>, links: Array<string> } | null, heavyEquipmentSalesTerms?: { __typename?: 'ObjectPageModelHeavyEquipmentSalesTermsField', value: any, blocks: Array<string>, links: Array<string> } | null, heavyEquipmentServices: Array<{ __typename?: 'ObjectServiceRecord', id: any, serviceType?: string | null, title?: string | null, description?: string | null, footnote?: string | null, jsonData?: any | null, active?: any | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null, content?: { __typename?: 'ObjectServiceModelContentField', value: any, blocks: Array<string>, links: Array<string> } | null, link: Array<{ __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }>, excludeFromVehicleTypes: Array<{ __typename?: 'VehicleTypeRecord', id: any, name?: string | null }> }>, finalLink?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, guideSteps: Array<{ __typename?: 'DescriptionRecord', descriptionTitle?: string | null, descriptionBodyText?: string | null, imageIcon?: { __typename?: 'ImageIconRecord', icon?: { __typename?: 'FileField', url: string } | null } | null }>, ecoBulletPoints: Array<{ __typename?: 'TextRecord', text?: string | null }>, inspectionOverview?: { __typename?: 'InspectionBlockRecord', title?: string | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null } | null, drivetrain?: { __typename?: 'InspectionBlockRecord', title?: string | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, conditions: Array<{ __typename?: 'ConditionInfoModelRecord', key?: string | null, question?: string | null, conditionInfo: Array<{ __typename?: 'ConditionInfoRecord', conditionStep?: string | null, answer?: string | null }> }> } | null, brakes?: { __typename?: 'InspectionBlockRecord', title?: string | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, conditions: Array<{ __typename?: 'ConditionInfoModelRecord', key?: string | null, question?: string | null, conditionInfo: Array<{ __typename?: 'ConditionInfoRecord', conditionStep?: string | null, answer?: string | null }> }> } | null, technologyAndEquipment?: { __typename?: 'InspectionBlockRecord', title?: string | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, conditions: Array<{ __typename?: 'ConditionInfoModelRecord', key?: string | null, question?: string | null, conditionInfo: Array<{ __typename?: 'ConditionInfoRecord', conditionStep?: string | null, answer?: string | null }> }> } | null, interior?: { __typename?: 'InspectionBlockRecord', title?: string | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, conditions: Array<{ __typename?: 'ConditionInfoModelRecord', key?: string | null, question?: string | null, conditionInfo: Array<{ __typename?: 'ConditionInfoRecord', conditionStep?: string | null, answer?: string | null }> }> } | null, exterior?: { __typename?: 'InspectionBlockRecord', title?: string | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, conditions: Array<{ __typename?: 'ConditionInfoModelRecord', key?: string | null, question?: string | null, conditionInfo: Array<{ __typename?: 'ConditionInfoRecord', conditionStep?: string | null, answer?: string | null }> }> } | null, tires?: { __typename?: 'InspectionBlockRecord', title?: string | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, conditions: Array<{ __typename?: 'ConditionInfoModelRecord', key?: string | null, question?: string | null, conditionInfo: Array<{ __typename?: 'ConditionInfoRecord', conditionStep?: string | null, answer?: string | null }> }> } | null, objectCondition: Array<{ __typename?: 'ObjectConditionRecord', condition?: string | null, title?: string | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, text?: { __typename?: 'ObjectConditionModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null }> } | null };

export type ObjectServicesQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type ObjectServicesQuery = { __typename?: 'Query', objectPage?: { __typename?: 'ObjectPageRecord', servicesTitle?: string | null, deliveryCalculatorTitle?: string | null, deliveryCalculatorDescriptor?: string | null, deliveryCalculatorDisclaimer?: string | null, services: Array<{ __typename?: 'ObjectServiceRecord', id: any, serviceType?: string | null, title?: string | null, description?: string | null, footnote?: string | null, jsonData?: any | null, active?: any | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null, content?: { __typename?: 'ObjectServiceModelContentField', value: any, blocks: Array<string>, links: Array<string> } | null, link: Array<{ __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }>, excludeFromVehicleTypes: Array<{ __typename?: 'VehicleTypeRecord', id: any, name?: string | null }> }> } | null };

export type FixedPriceReservationTipsQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type FixedPriceReservationTipsQuery = { __typename?: 'Query', fixedPriceTipsModel?: { __typename?: 'FixedPriceTipsModelRecord', structuredText?: { __typename?: 'StructuredTextBlockRecord', structuredText?: { __typename?: 'StructuredTextBlockModelStructuredTextField', value: any } | null } | null } | null };

export type InspectionFragment = { __typename?: 'InspectionBlockRecord', title?: string | null, link?: { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null } | null, conditions: Array<{ __typename?: 'ConditionInfoModelRecord', key?: string | null, question?: string | null, conditionInfo: Array<{ __typename?: 'ConditionInfoRecord', conditionStep?: string | null, answer?: string | null }> }> };

export type PartnershipPageQueryVariables = Exact<{
  locale: SiteLocale;
  isAuthenticated: Scalars['Boolean'];
}>;


export type PartnershipPageQuery = { __typename?: 'Query', page?: { __typename?: 'PageRecord', name?: string | null, loggedInTitle?: string | null, publicTitle?: string | null, _editingUrl?: string | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null, optionalHero?: { __typename?: 'OptionalHeroRecord', textColor?: string | null, title?: string | null, subtitle?: string | null, contentAlignment?: string | null, showHero?: any | null, button: Array<{ __typename?: 'PromoButtonRecord', backgroundColor?: string | null, backgroundColorShade?: string | null, link?: string | null, text?: string | null, textColor?: string | null }>, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null } | null, loggedInContent?: { __typename?: 'PageModelLoggedInContentField', value: any } | null, publicContent?: { __typename?: 'PageModelPublicContentField', value: any } | null } | null, allPartnershipItems: Array<{ __typename?: 'PartnershipItemRecord', id: any, title?: string | null, campaignCode?: string | null, hasCampaignCode?: any | null, _editingUrl?: string | null, description?: { __typename?: 'PartnershipItemModelDescriptionField', value: any } | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, partnerLogo?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> };

export type StampFragment = { __typename?: 'StampRecord', stampType?: string | null, stampColor?: string | null, stampAppearance?: string | null, stampSize?: any | null };

export type PromoCardFragment = { __typename?: 'PromoCardRecord', id: any, isActive?: any | null, cardPositionPhone?: any | null, cardPositionTablet?: any | null, cardPositionDesktop?: any | null, applyForCategory: Array<{ __typename?: 'FilterPageRecord', mainCategory?: string | null }>, promoCardTemplates: Array<{ __typename?: 'PromoCardTemplateRecord', id: any, cardType?: string | null, title?: string | null, ga4EventIdentifier?: string | null, backgroundColorTheme?: string | null, backgroundColorShade?: string | null, content?: { __typename?: 'PromoCardTemplateModelContentField', value: any, blocks: Array<{ __typename: 'IconListRecord', id: any, items: Array<{ __typename?: 'IconListItemRecord', text?: string | null, imageIcon?: { __typename?: 'ImageIconRecord', icon?: { __typename?: 'FileField', title?: string | null } | null } | null }> } | { __typename: 'StampRecord', id: any, stampType?: string | null, stampColor?: string | null, stampAppearance?: string | null, stampSize?: any | null } | { __typename: 'TitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, link: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }>, textColor?: { __typename?: 'ColorField', hex: string } | null, backgroundColor?: { __typename?: 'ColorField', hex: string } | null }> };

export type PromoSettingByUsageTypeQueryVariables = Exact<{
  locale: SiteLocale;
  usageType: Scalars['String'];
}>;


export type PromoSettingByUsageTypeQuery = { __typename?: 'Query', promoSetting?: { __typename?: 'PromoSettingRecord', id: any, usageType?: string | null, promoCards: Array<{ __typename?: 'PromoCardRecord', id: any, isActive?: any | null, cardPositionPhone?: any | null, cardPositionTablet?: any | null, cardPositionDesktop?: any | null, applyForCategory: Array<{ __typename?: 'FilterPageRecord', mainCategory?: string | null }>, promoCardTemplates: Array<{ __typename?: 'PromoCardTemplateRecord', id: any, cardType?: string | null, title?: string | null, ga4EventIdentifier?: string | null, backgroundColorTheme?: string | null, backgroundColorShade?: string | null, content?: { __typename?: 'PromoCardTemplateModelContentField', value: any, blocks: Array<{ __typename: 'IconListRecord', id: any, items: Array<{ __typename?: 'IconListItemRecord', text?: string | null, imageIcon?: { __typename?: 'ImageIconRecord', icon?: { __typename?: 'FileField', title?: string | null } | null } | null }> } | { __typename: 'StampRecord', id: any, stampType?: string | null, stampColor?: string | null, stampAppearance?: string | null, stampSize?: any | null } | { __typename: 'TitleRecord', id: any, text?: string | null, tag?: string | null }> } | null, link: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'TextLinkRecord', text?: string | null, url?: string | null }>, textColor?: { __typename?: 'ColorField', hex: string } | null, backgroundColor?: { __typename?: 'ColorField', hex: string } | null }> }> } | null };

export type AllRedirectsQueryVariables = Exact<{
  locale: SiteLocale;
  limit: Scalars['IntType'];
  skip: Scalars['IntType'];
}>;


export type AllRedirectsQuery = { __typename?: 'Query', allRedirects: Array<{ __typename?: 'RedirectRecord', fromUrl?: string | null, toUrl?: string | null }> };

export type ButtonAttributesFragment = { __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null };

export type ThankYouItemAttributesFragment = { __typename?: 'SellFlowThankYouItemRecord', title?: string | null, backgroundImage?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string> } | null, structuredText?: { __typename?: 'StructuredTextBlockRecord', structuredText?: { __typename?: 'StructuredTextBlockModelStructuredTextField', value: any } | null } | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, button?: { __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null } | null };

export type FormHeaderAttributesFragment = { __typename?: 'SellFlowFormHeaderRecord', title?: string | null, description?: string | null };

export type DynamicItemAttributesFragment = { __typename?: 'SellFlowDynamicItemRecord', key?: string | null, title?: string | null, description?: string | null, bodyStructuredText?: { __typename?: 'SellFlowDynamicItemModelBodyStructuredTextField', blocks: Array<string>, links: Array<string>, value: any } | null };

export type SellFlowStartContentQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type SellFlowStartContentQuery = { __typename?: 'Query', sellFlowPage?: { __typename?: 'SellFlowPageRecord', startActionBoxText?: string | null, startSellStepsTitle?: string | null, startTrustpilotTitle?: string | null, startCarRequirementsHeading?: string | null, startHero?: { __typename?: 'HeroModelRecord', heading?: string | null, headingColor?: string | null, subheading?: string | null, subheadingColor?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null } | null, startActionBoxButton?: { __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null } | null, startSellSteps: Array<{ __typename?: 'SellFlowStepRecord', title?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, step: Array<{ __typename?: 'TextRecord', text?: string | null }> }>, startSeoInformation: Array<{ __typename?: 'SeoInformationRecord', content: Array<{ __typename?: 'TitleWithTextRecord', title: Array<{ __typename?: 'TitleRecord', text?: string | null, tag?: string | null }>, text?: { __typename?: 'TitleWithTextModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null }> }>, startSeo?: { __typename?: 'SeoField', description?: string | null, title?: string | null, image?: { __typename?: 'FileField', url: string } | null } | null, startFaqNew: Array<{ __typename?: 'FaqQuestionNewRecord', question?: string | null, answer?: { __typename?: 'FaqQuestionNewModelAnswerField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }>, startCarRequirementsList: Array<{ __typename?: 'TextRecord', text?: string | null }> } | null };

export type SellFlowInterestFormContentQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type SellFlowInterestFormContentQuery = { __typename?: 'Query', sellFlowPage?: { __typename?: 'SellFlowPageRecord', vehicleHeading?: string | null, vehicleInputfieldPlaceholder?: string | null, vehicleIntroduction?: string | null, vehiclePrimaryButton?: string | null, odometerHeading?: string | null, odometerIntroduction?: string | null, odometerPlaceholder?: string | null, odometerPrimaryButton?: string | null, odometerSecondaryButton?: string | null, odometerAdditionalInfo?: string | null, odometerYearlyMaxError?: string | null, odometerMaxMileageError?: string | null, trimHeading?: string | null, trimIntroduction?: string | null, trimPrimaryButton?: string | null, trimDontKnowPackageInfoText?: string | null, trimPackageTitle?: string | null, trimAddonsTitle?: string | null, trimPrimaryButtonManualValuation?: string | null, trimGatekeeperHeading?: string | null, trimGatekeeperTermsCheckbox?: string | null, salesHeading?: string | null, salesHeadingSingleOption?: string | null, salesDiscountHeading?: string | null, salesDiscountInfo?: string | null, salesBiddingHeading?: string | null, salesBiddingManualValuation?: string | null, salesBiddingInfo?: string | null, salesBiddingCheckItem1?: string | null, salesBiddingCheckItem2?: string | null, salesBiddingCheckItem3?: string | null, salesExpressHeading?: string | null, salesExpressManualValuation?: string | null, salesExpressInfo?: string | null, salesExpressInfoExtra?: string | null, salesExpressCheckItem1?: string | null, salesExpressCheckItem2?: string | null, salesExpressCheckItem3?: string | null, salesCtaButtonText?: string | null, contactHeadingOne?: string | null, contactConfirmationText?: string | null, contactHeadingTwo?: string | null, contactInformationText?: string | null, contactExpressInformationText?: string | null, contactButtonText?: string | null, contactButtonTextNotComplete?: string | null, noticeOfInterestEquipmentTextareaHelperText?: string | null, noticeOfInterestExtraTiresCheckboxLabel?: string | null, noticeOfInterestValuationServiceUnavailabilityWarning?: string | null, thankYouTitle?: string | null, companyTitle?: string | null, companyDescription?: string | null, companyCtaText?: string | null, companyCtaLinkDestination?: string | null, prefilledHeading?: string | null, prefilledIntroduction?: string | null, prefilledButtonText?: string | null, contactFormHeaderRequiresManual: Array<{ __typename?: 'SellFlowFormHeaderRecord', title?: string | null, description?: string | null }>, contactFormHeaderRecreational: Array<{ __typename?: 'SellFlowFormHeaderRecord', title?: string | null, description?: string | null }>, contactFormHeaderConsumer: Array<{ __typename?: 'SellFlowFormHeaderRecord', title?: string | null, description?: string | null }>, contactFormHeaderCorporate: Array<{ __typename?: 'SellFlowFormHeaderRecord', title?: string | null, description?: string | null }>, contactFormHeaderHeavy: Array<{ __typename?: 'SellFlowFormHeaderRecord', title?: string | null, description?: string | null }>, contactFormHeaderOther: Array<{ __typename?: 'SellFlowFormHeaderRecord', title?: string | null, description?: string | null }>, noticeOfInterestIntroduction?: { __typename?: 'SellFlowPageModelNoticeOfInterestIntroductionField', blocks: Array<string>, links: Array<string>, value: any } | null, thankYouConsumer: Array<{ __typename?: 'SellFlowThankYouItemRecord', title?: string | null, backgroundImage?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string> } | null, structuredText?: { __typename?: 'StructuredTextBlockRecord', structuredText?: { __typename?: 'StructuredTextBlockModelStructuredTextField', value: any } | null } | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, button?: { __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null } | null }>, thankYouManualValuation: Array<{ __typename?: 'SellFlowThankYouItemRecord', title?: string | null, backgroundImage?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string> } | null, structuredText?: { __typename?: 'StructuredTextBlockRecord', structuredText?: { __typename?: 'StructuredTextBlockModelStructuredTextField', value: any } | null } | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, button?: { __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null } | null }>, thankYouCompany: Array<{ __typename?: 'SellFlowThankYouItemRecord', title?: string | null, backgroundImage?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string> } | null, structuredText?: { __typename?: 'StructuredTextBlockRecord', structuredText?: { __typename?: 'StructuredTextBlockModelStructuredTextField', value: any } | null } | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, button?: { __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null } | null }>, thankYouExpress: Array<{ __typename?: 'SellFlowThankYouItemRecord', title?: string | null, backgroundImage?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string> } | null, structuredText?: { __typename?: 'StructuredTextBlockRecord', structuredText?: { __typename?: 'StructuredTextBlockModelStructuredTextField', value: any } | null } | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, button?: { __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null } | null }> } | null };

export type SellFlowHeavyEquipmentInterestFormContentQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type SellFlowHeavyEquipmentInterestFormContentQuery = { __typename?: 'Query', sellFlowPage?: { __typename?: 'SellFlowPageRecord', heavyEquipmentHeading?: string | null, heavyEquipmentThankYouHeading?: string | null, heavyEquipmentIntroduction?: { __typename?: 'SellFlowPageModelHeavyEquipmentIntroductionField', blocks: Array<string>, links: Array<string>, value: any } | null, heavyEquipmentTermsStructuredText?: { __typename?: 'SellFlowPageModelHeavyEquipmentTermsStructuredTextField', blocks: Array<string>, links: Array<string>, value: any } | null, heavyEquipmentThankYouDescription?: { __typename?: 'SellFlowPageModelHeavyEquipmentThankYouDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null } | null };

export type SellFlowConfirmationViewContentQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type SellFlowConfirmationViewContentQuery = { __typename?: 'Query', sellFlowPage?: { __typename?: 'SellFlowPageRecord', confirmationExplanations: Array<{ __typename?: 'SellFlowDynamicItemRecord', key?: string | null, title?: string | null, description?: string | null, bodyStructuredText?: { __typename?: 'SellFlowDynamicItemModelBodyStructuredTextField', blocks: Array<string>, links: Array<string>, value: any } | null }> } | null };

export type SellFlowReservationViewContentQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type SellFlowReservationViewContentQuery = { __typename?: 'Query', sellFlowPage?: { __typename?: 'SellFlowPageRecord', reservationThanksHeading?: string | null, reservationUpperExplanation?: string | null, reservationNotSureUpperExplanation?: string | null, reservationHeading?: string | null, reservationExplanation?: string | null, reservationValuationHeading?: string | null, reservationManualValuationHeading?: string | null, reservationSetManualPriceButton?: string | null, reservationSetRecommendedPriceButton?: string | null, reservationReadyToContinueHeading?: string | null, reservationHeadingReservationAccepted?: string | null, reservationReadyToContinueExplanation?: string | null, reservationExplanationReservationAccepted?: string | null } | null };

export type SellFlowTermsAndConditionsViewContentQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type SellFlowTermsAndConditionsViewContentQuery = { __typename?: 'Query', sellFlowPage?: { __typename?: 'SellFlowPageRecord', termsDownloadButtonText?: string | null, termsDynamicItems: Array<{ __typename?: 'SellFlowDynamicItemRecord', key?: string | null, title?: string | null, description?: string | null, bodyStructuredText?: { __typename?: 'SellFlowDynamicItemModelBodyStructuredTextField', blocks: Array<string>, links: Array<string>, value: any } | null }> } | null };

export type ResponsiveW2000ImageFragment = { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null };

export type ResponsiveW400ImageFragment = { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null };

export type ResponsiveW400H400ImageFragment = { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null };

type DynamicPageCustomElement_AnchorNavigationRecord_Fragment = { __typename?: 'AnchorNavigationRecord' };

type DynamicPageCustomElement_ButtonRecord_Fragment = { __typename?: 'ButtonRecord' };

type DynamicPageCustomElement_CarInspirationListRecord_Fragment = { __typename?: 'CarInspirationListRecord' };

type DynamicPageCustomElement_ContactCardsBlockRecord_Fragment = { __typename?: 'ContactCardsBlockRecord' };

type DynamicPageCustomElement_DynamicPageCustomElementRecord_Fragment = { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null };

type DynamicPageCustomElement_DynamicPageFormRecord_Fragment = { __typename?: 'DynamicPageFormRecord' };

type DynamicPageCustomElement_DynamicPageValuationFormRecord_Fragment = { __typename?: 'DynamicPageValuationFormRecord' };

type DynamicPageCustomElement_FaqSectionBlockRecord_Fragment = { __typename?: 'FaqSectionBlockRecord' };

type DynamicPageCustomElement_FeaturedBlocksBlockRecord_Fragment = { __typename?: 'FeaturedBlocksBlockRecord' };

type DynamicPageCustomElement_InlineimageRecord_Fragment = { __typename?: 'InlineimageRecord' };

type DynamicPageCustomElement_LeasingPartnerNavigationRecord_Fragment = { __typename?: 'LeasingPartnerNavigationRecord' };

type DynamicPageCustomElement_SpacerRecord_Fragment = { __typename?: 'SpacerRecord' };

type DynamicPageCustomElement_TableRecord_Fragment = { __typename?: 'TableRecord' };

type DynamicPageCustomElement_TextGridRecord_Fragment = { __typename?: 'TextGridRecord' };

type DynamicPageCustomElement_TextTabsBlockRecord_Fragment = { __typename?: 'TextTabsBlockRecord' };

type DynamicPageCustomElement_YoutubeClipRecord_Fragment = { __typename?: 'YoutubeClipRecord' };

export type DynamicPageCustomElementFragment = DynamicPageCustomElement_AnchorNavigationRecord_Fragment | DynamicPageCustomElement_ButtonRecord_Fragment | DynamicPageCustomElement_CarInspirationListRecord_Fragment | DynamicPageCustomElement_ContactCardsBlockRecord_Fragment | DynamicPageCustomElement_DynamicPageCustomElementRecord_Fragment | DynamicPageCustomElement_DynamicPageFormRecord_Fragment | DynamicPageCustomElement_DynamicPageValuationFormRecord_Fragment | DynamicPageCustomElement_FaqSectionBlockRecord_Fragment | DynamicPageCustomElement_FeaturedBlocksBlockRecord_Fragment | DynamicPageCustomElement_InlineimageRecord_Fragment | DynamicPageCustomElement_LeasingPartnerNavigationRecord_Fragment | DynamicPageCustomElement_SpacerRecord_Fragment | DynamicPageCustomElement_TableRecord_Fragment | DynamicPageCustomElement_TextGridRecord_Fragment | DynamicPageCustomElement_TextTabsBlockRecord_Fragment | DynamicPageCustomElement_YoutubeClipRecord_Fragment;

export type ButtonModelFragment = { __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null };

export type ButtonBlockFragment = { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null };

export type CarInspirationListFragment = { __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null };

export type BlockButtonFragment = { __typename?: 'BlockButtonRecord', id: any, linkUrl?: string | null, preamble?: string | null, title?: string | null, backgroundImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null };

export type InlineImageFragment = { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null };

export type YoutubeClipFragment = { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null };

type TextGrid_AnchorNavigationRecord_Fragment = { __typename?: 'AnchorNavigationRecord' };

type TextGrid_ButtonRecord_Fragment = { __typename?: 'ButtonRecord' };

type TextGrid_CarInspirationListRecord_Fragment = { __typename?: 'CarInspirationListRecord' };

type TextGrid_ContactCardsBlockRecord_Fragment = { __typename?: 'ContactCardsBlockRecord' };

type TextGrid_DynamicPageCustomElementRecord_Fragment = { __typename?: 'DynamicPageCustomElementRecord' };

type TextGrid_DynamicPageFormRecord_Fragment = { __typename?: 'DynamicPageFormRecord' };

type TextGrid_DynamicPageValuationFormRecord_Fragment = { __typename?: 'DynamicPageValuationFormRecord' };

type TextGrid_FaqSectionBlockRecord_Fragment = { __typename?: 'FaqSectionBlockRecord' };

type TextGrid_FeaturedBlocksBlockRecord_Fragment = { __typename?: 'FeaturedBlocksBlockRecord' };

type TextGrid_InlineimageRecord_Fragment = { __typename?: 'InlineimageRecord' };

type TextGrid_LeasingPartnerNavigationRecord_Fragment = { __typename?: 'LeasingPartnerNavigationRecord' };

type TextGrid_SpacerRecord_Fragment = { __typename?: 'SpacerRecord' };

type TextGrid_TableRecord_Fragment = { __typename?: 'TableRecord' };

type TextGrid_TextGridRecord_Fragment = { __typename?: 'TextGridRecord', id: any, columnGap?: any | null, rowGap?: any | null, columns: Array<{ __typename?: 'TextColumnRecord', body?: { __typename?: 'TextColumnModelBodyField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> }>, blocks: Array<{ __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> } | { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null } | { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename?: 'SpacerRecord', id: any, space?: any | null } | { __typename?: 'StructuredTextCardRecord', id: any, body?: { __typename?: 'StructuredTextCardModelBodyField', value: any, links: Array<string>, blocks: Array<string> } | null } | { __typename?: 'SupportChatCardRecord', id: any, text?: string | null, ctaLabel?: string | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> };

type TextGrid_TextTabsBlockRecord_Fragment = { __typename?: 'TextTabsBlockRecord' };

type TextGrid_YoutubeClipRecord_Fragment = { __typename?: 'YoutubeClipRecord' };

export type TextGridFragment = TextGrid_AnchorNavigationRecord_Fragment | TextGrid_ButtonRecord_Fragment | TextGrid_CarInspirationListRecord_Fragment | TextGrid_ContactCardsBlockRecord_Fragment | TextGrid_DynamicPageCustomElementRecord_Fragment | TextGrid_DynamicPageFormRecord_Fragment | TextGrid_DynamicPageValuationFormRecord_Fragment | TextGrid_FaqSectionBlockRecord_Fragment | TextGrid_FeaturedBlocksBlockRecord_Fragment | TextGrid_InlineimageRecord_Fragment | TextGrid_LeasingPartnerNavigationRecord_Fragment | TextGrid_SpacerRecord_Fragment | TextGrid_TableRecord_Fragment | TextGrid_TextGridRecord_Fragment | TextGrid_TextTabsBlockRecord_Fragment | TextGrid_YoutubeClipRecord_Fragment;

type DynamicPageBodyOnlyBlocks_AnchorNavigationRecord_Fragment = { __typename?: 'AnchorNavigationRecord' };

type DynamicPageBodyOnlyBlocks_ButtonRecord_Fragment = { __typename?: 'ButtonRecord' };

type DynamicPageBodyOnlyBlocks_CarInspirationListRecord_Fragment = { __typename?: 'CarInspirationListRecord' };

type DynamicPageBodyOnlyBlocks_ContactCardsBlockRecord_Fragment = { __typename?: 'ContactCardsBlockRecord' };

type DynamicPageBodyOnlyBlocks_DynamicPageCustomElementRecord_Fragment = { __typename?: 'DynamicPageCustomElementRecord' };

type DynamicPageBodyOnlyBlocks_DynamicPageFormRecord_Fragment = { __typename?: 'DynamicPageFormRecord' };

type DynamicPageBodyOnlyBlocks_DynamicPageValuationFormRecord_Fragment = { __typename?: 'DynamicPageValuationFormRecord' };

type DynamicPageBodyOnlyBlocks_FaqSectionBlockRecord_Fragment = { __typename?: 'FaqSectionBlockRecord' };

type DynamicPageBodyOnlyBlocks_FeaturedBlocksBlockRecord_Fragment = { __typename?: 'FeaturedBlocksBlockRecord' };

type DynamicPageBodyOnlyBlocks_InlineimageRecord_Fragment = { __typename?: 'InlineimageRecord' };

type DynamicPageBodyOnlyBlocks_LeasingPartnerNavigationRecord_Fragment = { __typename?: 'LeasingPartnerNavigationRecord' };

type DynamicPageBodyOnlyBlocks_LeasingPartnerPresentationRecord_Fragment = { __typename?: 'LeasingPartnerPresentationRecord', id: any, anchorId?: string | null, partnerName?: string | null, leasingProvider?: string | null, uspHeading?: string | null, promotionHeading?: string | null, interestModalTitle?: string | null, interestModalIntro?: string | null, priceFootnote?: string | null, interestSubmitButtonText?: string | null, interestConfirmationTitle?: string | null, interestConfirmationText?: string | null, interestConfirmationSubjectHeading?: string | null, interestConfirmationDetailsHeading?: string | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, description?: { __typename?: 'LeasingPartnerPresentationModelDescriptionField', value: any, links: Array<string>, blocks: Array<string> } | null, uspList: Array<{ __typename?: 'TextRecord', id: any, text?: string | null }>, linkButton?: { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | null, promotionVehicleCards: Array<{ __typename?: 'LeasingPromotionVehicleCardRecord', id: any, brandAndModel?: string | null, monthlyCostFrom?: any | null, leasingPeriodFrom?: any | null, mileageFrom?: any | null, productImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }>, promotionButton?: { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | null, interestConsentLabel?: { __typename?: 'LeasingPartnerPresentationModelInterestConsentLabelField', value: any, links: Array<string>, blocks: Array<string> } | null };

type DynamicPageBodyOnlyBlocks_SpacerRecord_Fragment = { __typename?: 'SpacerRecord' };

type DynamicPageBodyOnlyBlocks_TableRecord_Fragment = { __typename?: 'TableRecord' };

type DynamicPageBodyOnlyBlocks_TextGridRecord_Fragment = { __typename?: 'TextGridRecord' };

type DynamicPageBodyOnlyBlocks_TextSectionRecord_Fragment = { __typename?: 'TextSectionRecord' };

type DynamicPageBodyOnlyBlocks_TextTabsBlockRecord_Fragment = { __typename?: 'TextTabsBlockRecord' };

type DynamicPageBodyOnlyBlocks_YoutubeClipRecord_Fragment = { __typename?: 'YoutubeClipRecord' };

export type DynamicPageBodyOnlyBlocksFragment = DynamicPageBodyOnlyBlocks_AnchorNavigationRecord_Fragment | DynamicPageBodyOnlyBlocks_ButtonRecord_Fragment | DynamicPageBodyOnlyBlocks_CarInspirationListRecord_Fragment | DynamicPageBodyOnlyBlocks_ContactCardsBlockRecord_Fragment | DynamicPageBodyOnlyBlocks_DynamicPageCustomElementRecord_Fragment | DynamicPageBodyOnlyBlocks_DynamicPageFormRecord_Fragment | DynamicPageBodyOnlyBlocks_DynamicPageValuationFormRecord_Fragment | DynamicPageBodyOnlyBlocks_FaqSectionBlockRecord_Fragment | DynamicPageBodyOnlyBlocks_FeaturedBlocksBlockRecord_Fragment | DynamicPageBodyOnlyBlocks_InlineimageRecord_Fragment | DynamicPageBodyOnlyBlocks_LeasingPartnerNavigationRecord_Fragment | DynamicPageBodyOnlyBlocks_LeasingPartnerPresentationRecord_Fragment | DynamicPageBodyOnlyBlocks_SpacerRecord_Fragment | DynamicPageBodyOnlyBlocks_TableRecord_Fragment | DynamicPageBodyOnlyBlocks_TextGridRecord_Fragment | DynamicPageBodyOnlyBlocks_TextSectionRecord_Fragment | DynamicPageBodyOnlyBlocks_TextTabsBlockRecord_Fragment | DynamicPageBodyOnlyBlocks_YoutubeClipRecord_Fragment;

type DynamicPageBodyBlocks_AnchorNavigationRecord_Fragment = { __typename?: 'AnchorNavigationRecord', id: any, items: Array<{ __typename?: 'AnchorNavigationItemRecord', id: any, sectionHeading?: string | null }> };

type DynamicPageBodyBlocks_ButtonRecord_Fragment = { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null };

type DynamicPageBodyBlocks_CarInspirationListRecord_Fragment = { __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null };

type DynamicPageBodyBlocks_ContactCardsBlockRecord_Fragment = { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> };

type DynamicPageBodyBlocks_DynamicPageCustomElementRecord_Fragment = { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null };

type DynamicPageBodyBlocks_DynamicPageFormRecord_Fragment = { __typename?: 'DynamicPageFormRecord', id: any, isActive?: any | null, usageType?: string | null, title?: string | null, description?: string | null, sendButton?: string | null };

type DynamicPageBodyBlocks_DynamicPageValuationFormRecord_Fragment = { __typename?: 'DynamicPageValuationFormRecord', id: any, subtitle?: string | null, title?: string | null, formHeading?: string | null, imageBefore?: { __typename?: 'FileField', alt?: string | null, url: string } | null, imageAnimation?: { __typename?: 'FileField', alt?: string | null, url: string } | null, imageAfter?: { __typename?: 'FileField', alt?: string | null, url: string } | null };

type DynamicPageBodyBlocks_FaqSectionBlockRecord_Fragment = { __typename?: 'FaqSectionBlockRecord', id: any, title?: string | null, ingress?: string | null, footerText?: string | null, footerLink?: { __typename?: 'TextLinkRecord', id: any, text?: string | null, url?: string | null } | null, questions: Array<{ __typename?: 'FaqQuestionNewRecord', id: any, question?: string | null, answer?: { __typename?: 'FaqQuestionNewModelAnswerField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> };

type DynamicPageBodyBlocks_FeaturedBlocksBlockRecord_Fragment = { __typename?: 'FeaturedBlocksBlockRecord', id: any, blockButtons: Array<{ __typename?: 'BlockButtonRecord', id: any, linkUrl?: string | null, preamble?: string | null, title?: string | null, backgroundImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }> };

type DynamicPageBodyBlocks_InlineimageRecord_Fragment = { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null };

type DynamicPageBodyBlocks_LeasingPartnerNavigationRecord_Fragment = { __typename?: 'LeasingPartnerNavigationRecord', id: any, title?: string | null, helpText?: string | null, partnerLogos: Array<{ __typename?: 'LeasingPartnerNavigationItemRecord', id: any, scrollTargetId?: string | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }> };

type DynamicPageBodyBlocks_SpacerRecord_Fragment = { __typename?: 'SpacerRecord', id: any, space?: any | null };

type DynamicPageBodyBlocks_TableRecord_Fragment = { __typename?: 'TableRecord', id: any, tablestructure?: any | null };

type DynamicPageBodyBlocks_TextGridRecord_Fragment = { __typename?: 'TextGridRecord', id: any, columnGap?: any | null, rowGap?: any | null, columns: Array<{ __typename?: 'TextColumnRecord', body?: { __typename?: 'TextColumnModelBodyField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> }>, blocks: Array<{ __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> } | { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null } | { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename?: 'SpacerRecord', id: any, space?: any | null } | { __typename?: 'StructuredTextCardRecord', id: any, body?: { __typename?: 'StructuredTextCardModelBodyField', value: any, links: Array<string>, blocks: Array<string> } | null } | { __typename?: 'SupportChatCardRecord', id: any, text?: string | null, ctaLabel?: string | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> };

type DynamicPageBodyBlocks_TextTabsBlockRecord_Fragment = { __typename?: 'TextTabsBlockRecord', id: any, title?: string | null, tabs: Array<{ __typename?: 'TextTabRecord', id: any, tabName?: string | null, body?: { __typename?: 'TextTabModelBodyField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TextGridRecord', id: any, columnGap?: any | null, rowGap?: any | null, columns: Array<{ __typename?: 'TextColumnRecord', body?: { __typename?: 'TextColumnModelBodyField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null } | { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> }>, blocks: Array<{ __typename?: 'CarInspirationListRecord', id: any, heading?: string | null, linkText?: string | null, queryString?: string | null } | { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> } | { __typename?: 'DynamicPageCustomElementRecord', id: any, usageType?: string | null } | { __typename?: 'InlineimageRecord', id: any, righttext?: string | null, lefttext?: string | null, imageMaxWidth?: string | null, textPlacement?: string | null, image?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, lightboxImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, textContent?: { __typename?: 'InlineimageModelTextContentField', value: any, links: Array<{ __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null }>, blocks: Array<{ __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null }> } | null } | { __typename?: 'SpacerRecord', id: any, space?: any | null } | { __typename?: 'StructuredTextCardRecord', id: any, body?: { __typename?: 'StructuredTextCardModelBodyField', value: any, links: Array<string>, blocks: Array<string> } | null } | { __typename?: 'SupportChatCardRecord', id: any, text?: string | null, ctaLabel?: string | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> }> } | null }> };

type DynamicPageBodyBlocks_YoutubeClipRecord_Fragment = { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null };

export type DynamicPageBodyBlocksFragment = DynamicPageBodyBlocks_AnchorNavigationRecord_Fragment | DynamicPageBodyBlocks_ButtonRecord_Fragment | DynamicPageBodyBlocks_CarInspirationListRecord_Fragment | DynamicPageBodyBlocks_ContactCardsBlockRecord_Fragment | DynamicPageBodyBlocks_DynamicPageCustomElementRecord_Fragment | DynamicPageBodyBlocks_DynamicPageFormRecord_Fragment | DynamicPageBodyBlocks_DynamicPageValuationFormRecord_Fragment | DynamicPageBodyBlocks_FaqSectionBlockRecord_Fragment | DynamicPageBodyBlocks_FeaturedBlocksBlockRecord_Fragment | DynamicPageBodyBlocks_InlineimageRecord_Fragment | DynamicPageBodyBlocks_LeasingPartnerNavigationRecord_Fragment | DynamicPageBodyBlocks_SpacerRecord_Fragment | DynamicPageBodyBlocks_TableRecord_Fragment | DynamicPageBodyBlocks_TextGridRecord_Fragment | DynamicPageBodyBlocks_TextTabsBlockRecord_Fragment | DynamicPageBodyBlocks_YoutubeClipRecord_Fragment;

export type OptionalHeroFragment = { __typename?: 'OptionalHeroRecord', textColor?: string | null, title?: string | null, subtitle?: string | null, contentAlignment?: string | null, showHero?: any | null, button: Array<{ __typename?: 'PromoButtonRecord', backgroundColor?: string | null, backgroundColorShade?: string | null, link?: string | null, text?: string | null, textColor?: string | null }>, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null };

export type DynamicFormFieldModelFragment = { __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> };

export type DynamicFormModelFragment = { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> };

type DynamicPageBodyLinks_ButtonModelRecord_Fragment = { __typename?: 'ButtonModelRecord', id: any, text?: string | null, url?: string | null, color?: string | null, size?: string | null, openLinkInNewWindow?: any | null };

type DynamicPageBodyLinks_FormRecord_Fragment = { __typename?: 'FormRecord', id: any, isActive?: any | null, startDate?: any | null, endDate?: any | null, formTitle?: string | null, submitFormDescription?: string | null, formSubmitButton?: string | null, internalName?: string | null, formOpenDescription?: { __typename?: 'FormModelFormOpenDescriptionField', value: any } | null, formNotOpenDescription?: { __typename?: 'FormModelFormNotOpenDescriptionField', value: any } | null, formAlreadyClosedDescription?: { __typename?: 'FormModelFormAlreadyClosedDescriptionField', value: any } | null, formSuccessSubmissionDescription?: { __typename?: 'FormModelFormSuccessSubmissionDescriptionField', value: any } | null, formFields: Array<{ __typename?: 'FormFieldRecord', fieldType?: string | null, backendKey?: string | null, required?: any | null, helperText?: string | null, textFieldType?: string | null, textFieldLabel?: string | null, textFieldPlaceholder?: string | null, textFieldDefaultValue?: string | null, textAreaLabel?: string | null, textAreaRows?: any | null, checkboxCheckedByDefault?: any | null, multipleChoiceLabel?: string | null, choiceFieldType?: string | null, allowOtherOption?: any | null, otherOptionLabel?: string | null, likertLabel?: string | null, checkboxLabel?: { __typename?: 'FormFieldModelCheckboxLabelField', value: any } | null, choices: Array<{ __typename?: 'DynamicFormChoiceFieldRecord', label?: string | null, selectedByDefault?: any | null, followUpQuestionBackendKey?: string | null }>, likertScaleOptions: Array<{ __typename?: 'DynamicFormLikertScaleOptionRecord', label?: string | null }>, likertStatements: Array<{ __typename?: 'DynamicFormLikertStatementRecord', label?: string | null, statementKey?: string | null }> }> };

export type DynamicPageBodyLinksFragment = DynamicPageBodyLinks_ButtonModelRecord_Fragment | DynamicPageBodyLinks_FormRecord_Fragment;

export type ArticleMiniatureImageFragment = { __typename?: 'ArticleRecord', miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null };

export type LargeFeaturedCardFragment = { __typename?: 'FeaturedCardRecord', image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, titleWithText: Array<{ __typename?: 'TitleWithTextRecord', title: Array<{ __typename?: 'TitleRecord', text?: string | null, tag?: string | null }>, text?: { __typename?: 'TitleWithTextModelTextField', value: any, links: Array<string>, blocks: Array<string> } | null }>, buttons: Array<{ __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null }> };

export type FaqQuestionAnsweFieldFragment = { __typename?: 'FaqQuestionNewModelAnswerField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> };

export type SeoFieldFragment = { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null };

export type ResponsiveImagePropsFragment = { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null };

export type ContactCardsFragment = { __typename?: 'ContactCardsBlockRecord', id: any, fullWidth?: any | null, items: Array<{ __typename?: 'ContactDepartmentCardRecord', id: any, email?: string | null, extraDescriptiveLine?: string | null, name?: string | null, openingHours?: string | null, phone?: string | null, showDetailedOpeningHours?: any | null } | { __typename?: 'ContactPersonCardRecord', id: any, email?: string | null, role?: string | null, extraDescriptiveLine?: string | null, name?: string | null, phone?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, profilePage?: { __typename?: 'DynamicPageRecord', id: any, slug?: string | null } | null }> };

export type SupportChatCardFragment = { __typename?: 'SupportChatCardRecord', id: any, text?: string | null, ctaLabel?: string | null };

export type StructuredTextCardFragment = { __typename?: 'StructuredTextCardRecord', id: any, body?: { __typename?: 'StructuredTextCardModelBodyField', value: any, links: Array<string>, blocks: Array<string> } | null };

export type SpacerFragment = { __typename?: 'SpacerRecord', id: any, space?: any | null };

export type AnchorNavigationFragment = { __typename?: 'AnchorNavigationRecord', id: any, items: Array<{ __typename?: 'AnchorNavigationItemRecord', id: any, sectionHeading?: string | null }> };

export type LeasingPartnerNavigationFragment = { __typename?: 'LeasingPartnerNavigationRecord', id: any, title?: string | null, helpText?: string | null, partnerLogos: Array<{ __typename?: 'LeasingPartnerNavigationItemRecord', id: any, scrollTargetId?: string | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }> };

export type FaqSectionBlockFragment = { __typename?: 'FaqSectionBlockRecord', id: any, title?: string | null, ingress?: string | null, footerText?: string | null, footerLink?: { __typename?: 'TextLinkRecord', id: any, text?: string | null, url?: string | null } | null, questions: Array<{ __typename?: 'FaqQuestionNewRecord', id: any, question?: string | null, answer?: { __typename?: 'FaqQuestionNewModelAnswerField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }> };

export type LeasingPromotionCardFragment = { __typename?: 'LeasingPromotionVehicleCardRecord', id: any, brandAndModel?: string | null, monthlyCostFrom?: any | null, leasingPeriodFrom?: any | null, mileageFrom?: any | null, productImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null };

export type LeasingPartnerPresentationFragment = { __typename?: 'LeasingPartnerPresentationRecord', id: any, anchorId?: string | null, partnerName?: string | null, leasingProvider?: string | null, uspHeading?: string | null, promotionHeading?: string | null, interestModalTitle?: string | null, interestModalIntro?: string | null, priceFootnote?: string | null, interestSubmitButtonText?: string | null, interestConfirmationTitle?: string | null, interestConfirmationText?: string | null, interestConfirmationSubjectHeading?: string | null, interestConfirmationDetailsHeading?: string | null, logo?: { __typename?: 'FileField', url: string, alt?: string | null, tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, description?: { __typename?: 'LeasingPartnerPresentationModelDescriptionField', value: any, links: Array<string>, blocks: Array<string> } | null, uspList: Array<{ __typename?: 'TextRecord', id: any, text?: string | null }>, linkButton?: { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | null, promotionVehicleCards: Array<{ __typename?: 'LeasingPromotionVehicleCardRecord', id: any, brandAndModel?: string | null, monthlyCostFrom?: any | null, leasingPeriodFrom?: any | null, mileageFrom?: any | null, productImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }>, promotionButton?: { __typename?: 'ButtonRecord', id: any, text?: string | null, size?: string | null, url?: string | null, color?: string | null, variant?: string | null, openLinkInNewWindow?: any | null } | null, interestConsentLabel?: { __typename?: 'LeasingPartnerPresentationModelInterestConsentLabelField', value: any, links: Array<string>, blocks: Array<string> } | null };

export type SiteMessagesQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type SiteMessagesQuery = { __typename?: 'Query', allSiteMessages: Array<{ __typename?: 'SiteMessageRecord', id: any, isActive?: any | null, placement?: string | null, siteMessageType?: string | null, messageStructuredText?: { __typename?: 'StructuredTextBlockRecord', structuredText?: { __typename?: 'StructuredTextBlockModelStructuredTextField', value: any } | null } | null }> };

export type StartPageQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type StartPageQuery = { __typename?: 'Query', startPage?: { __typename?: 'StartPageRecord', showSmallTrustpilot?: any | null, featuredBlocksTitle?: string | null, myVehiclesHeadline?: string | null, trustpilotTitle?: string | null, featureCardsIsActive?: any | null, categoryBlurbsHeadline?: string | null, _editingUrl?: string | null, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null, blockButtons: Array<{ __typename?: 'BlockButtonRecord', id: any, linkUrl?: string | null, preamble?: string | null, title?: string | null, backgroundImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }>, aboutArea: Array<{ __typename?: 'AboutAreaRecord', title: Array<{ __typename?: 'TitleRecord', text?: string | null, tag?: string | null }>, paragraph?: { __typename?: 'AboutAreaModelParagraphField', value: any, blocks: Array<string>, links: Array<string> } | null, linkList: Array<{ __typename?: 'TextLinkRecord', text?: string | null, caption?: string | null, url?: string | null }>, iconsWithText: Array<{ __typename?: 'TextIconRecord', text?: string | null, imageIcon?: { __typename?: 'ImageIconRecord', icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null } | null }> }>, largeFeaturedCards: Array<{ __typename?: 'FeaturedCardRecord', image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, titleWithText: Array<{ __typename?: 'TitleWithTextRecord', title: Array<{ __typename?: 'TitleRecord', text?: string | null, tag?: string | null }>, text?: { __typename?: 'TitleWithTextModelTextField', value: any, links: Array<string>, blocks: Array<string> } | null }>, buttons: Array<{ __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null }> }>, seoInformation: Array<{ __typename?: 'SeoInformationRecord', content: Array<{ __typename?: 'TitleWithTextRecord', title: Array<{ __typename?: 'TitleRecord', text?: string | null, tag?: string | null }>, text?: { __typename?: 'TitleWithTextModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null }> }>, smallPromoBanner: Array<{ __typename?: 'SmallPromoBannerRecord', showSmallBanner?: any | null, backgroundColor?: string | null, backgroundColorShade?: string | null, text?: string | null, textColor?: string | null, button: Array<{ __typename?: 'PromoButtonRecord', link?: string | null, text?: string | null, textColor?: string | null, backgroundColor?: string | null, backgroundColorShade?: string | null }> }>, largePromoBanner: Array<{ __typename?: 'OptionalHeroRecord', textColor?: string | null, title?: string | null, subtitle?: string | null, contentAlignment?: string | null, showHero?: any | null, button: Array<{ __typename?: 'PromoButtonRecord', backgroundColor?: string | null, backgroundColorShade?: string | null, link?: string | null, text?: string | null, textColor?: string | null }>, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null }>, featuredObjects: Array<{ __typename?: 'FeaturedObjectRecord', heading?: string | null, linkText?: string | null, queryString?: string | null }>, contactSection: Array<{ __typename?: 'ContactSectionRecord', title?: string | null, subtitle?: string | null, days?: string | null, extraInfo?: string | null, buttons: Array<{ __typename?: 'ContactButtonRecord', icon?: string | null, text?: string | null, href?: string | null }> }>, smallFeatureCards: Array<{ __typename?: 'SmallFeatureCardsBlockRecord', title?: string | null, button?: { __typename?: 'ButtonRecord', color?: string | null, size?: string | null, text?: string | null, url?: string | null } | null, text?: { __typename?: 'SmallFeatureCardsBlockModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, id: any, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> }>, categoryBlurbs: Array<{ __typename?: 'CategoryBlurbRecord', text?: string | null, link?: string | null, backgroundColor?: string | null, imageIcon: Array<{ __typename?: 'ImageIconRecord', icon?: { __typename?: 'FileField', url: string, alt?: string | null } | null }> }> } | null };

export type EmailSubscriptionManagementQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type EmailSubscriptionManagementQuery = { __typename?: 'Query', emailSubscriptionManagement?: { __typename?: 'EmailSubscriptionManagementRecord', profileSettingsTitle?: string | null, profileSettingsDescription?: string | null, unsubscribeInProgresTitle?: string | null, unsubscribeDoneTitle?: string | null, unsubscribeDoneConfirmation?: string | null, unsubscribeShowMore?: string | null, unsubscribeSubscriptionListDescription?: string | null, unsubscribeFooterText?: string | null, unsubscribeFooterLinkText?: string | null, subscriptions: Array<{ __typename?: 'EmailSubscriptionRecord', isActive?: any | null, subscriptionType?: string | null, checkboxLabel?: string | null, checkboxDescription?: string | null }> } | null };

export type TransferInfoPageQueryVariables = Exact<{
  locale: SiteLocale;
  identifier: Scalars['String'];
}>;


export type TransferInfoPageQuery = { __typename?: 'Query', purchaseOwnershipTransfer?: { __typename?: 'PurchaseOwnershipTransferRecord', identifier?: string | null, pageTitle?: string | null, title?: string | null, subtitle?: string | null, informationText?: string | null, contactInfo?: string | null, vehicleInfo?: string | null, buttonInformationText?: string | null, button?: { __typename?: 'ButtonRecord', text?: string | null, url?: string | null } | null, primaryPath?: { __typename?: 'PathItemRecord', title?: string | null, informationText?: string | null, buttonText?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null } | null, secondaryPath?: { __typename?: 'PathItemRecord', title?: string | null, informationText?: string | null, buttonText?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null } | null } | null };

export type PathItemFragment = { __typename?: 'PathItemRecord', title?: string | null, informationText?: string | null, buttonText?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null };

export type PurchaseAndPickUpTransferQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type PurchaseAndPickUpTransferQuery = { __typename?: 'Query', purchaseAndPickUpTransfer?: { __typename?: 'PurchaseAndPickUpTransferRecord', commonSigningInitializedTitle?: string | null, commonSigningFailedTitle?: string | null, commonSigningAbortedTitle?: string | null, commonSigningNotFoundTitle?: string | null, purchaseTitle?: string | null, purchaseVehicleCardTitle?: string | null, purchaseFormTitle?: string | null, purchaseCompleteStatusTitle?: string | null, pickUpTitle?: string | null, pickUpVehicleCardTitle?: string | null, pickUpFormTitle?: string | null, pickUpFormIdentificationQuestion?: string | null, pickUpCompleteStatusTitle?: string | null, commonSigningFailedDescription?: { __typename?: 'PurchaseAndPickUpTransferModelCommonSigningFailedDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, commonSigningAbortedDescription?: { __typename?: 'PurchaseAndPickUpTransferModelCommonSigningAbortedDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, commonSigningNotFoundDescription?: { __typename?: 'PurchaseAndPickUpTransferModelCommonSigningNotFoundDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, purchaseDescription?: { __typename?: 'PurchaseAndPickUpTransferModelPurchaseDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, purchaseFormDescription?: { __typename?: 'PurchaseAndPickUpTransferModelPurchaseFormDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, purchaseExplanation?: { __typename?: 'PurchaseAndPickUpTransferModelPurchaseExplanationField', blocks: Array<string>, links: Array<string>, value: any } | null, purchaseInitializedStatusDescription?: { __typename?: 'PurchaseAndPickUpTransferModelPurchaseInitializedStatusDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, purchaseCompleteStatusDescription?: { __typename?: 'PurchaseAndPickUpTransferModelPurchaseCompleteStatusDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, pickUpDescription?: { __typename?: 'PurchaseAndPickUpTransferModelPickUpDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, pickUpInitializedStatusDescription?: { __typename?: 'PurchaseAndPickUpTransferModelPickUpInitializedStatusDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null, pickUpCompleteStatusDescription?: { __typename?: 'PurchaseAndPickUpTransferModelPickUpCompleteStatusDescriptionField', blocks: Array<string>, links: Array<string>, value: any } | null } | null };

export type ValuationPageQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type ValuationPageQuery = { __typename?: 'Query', valuationPage?: { __typename?: 'ValuationPageRecord', heading?: string | null, subheading?: string | null, actionBoxTitle?: string | null, _editingUrl?: string | null, trustpilotTitle?: string | null, image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null, focalPoint?: { __typename?: 'focalPoint', x: any, y: any } | null } | null, button?: { __typename?: 'ButtonRecord', url?: string | null, variant?: string | null, size?: string | null, color?: string | null, text?: string | null } | null, faq: Array<{ __typename?: 'FaqQuestionNewRecord', question?: string | null, answer?: { __typename?: 'FaqQuestionNewModelAnswerField', links: Array<string>, value: any, blocks: Array<{ __typename?: 'TableRecord', id: any, tablestructure?: any | null } | { __typename?: 'YoutubeClipRecord', id: any, videoId?: string | null, linkParameters?: string | null, width?: any | null, aspectRatio?: string | null }> } | null }>, largeFeatureCard?: { __typename?: 'FeaturedCardRecord', image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, titleWithText: Array<{ __typename?: 'TitleWithTextRecord', title: Array<{ __typename?: 'TitleRecord', text?: string | null, tag?: string | null }>, text?: { __typename?: 'TitleWithTextModelTextField', value: any, links: Array<string>, blocks: Array<string> } | null }>, buttons: Array<{ __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null }> } | null, smallFeatureCards?: { __typename?: 'SmallFeatureCardsBlockRecord', title?: string | null, text?: { __typename?: 'SmallFeatureCardsBlockModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null, title?: string | null, _firstPublishedAt?: any | null, mainCategory?: { __typename?: 'CategoryRecord', name?: string | null, id: any, slug?: string | null } | null, miniatureImage?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null }> } | null, seoInformation?: { __typename?: 'SeoInformationRecord', content: Array<{ __typename?: 'TitleWithTextRecord', title: Array<{ __typename?: 'TitleRecord', text?: string | null, tag?: string | null }>, text?: { __typename?: 'TitleWithTextModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null }> } | null, largeFeatureCards: Array<{ __typename?: 'FeaturedCardRecord', image?: { __typename?: 'FileField', tags: Array<string>, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, base64?: string | null } | null } | null, titleWithText: Array<{ __typename?: 'TitleWithTextRecord', title: Array<{ __typename?: 'TitleRecord', text?: string | null, tag?: string | null }>, text?: { __typename?: 'TitleWithTextModelTextField', value: any, links: Array<string>, blocks: Array<string> } | null }>, buttons: Array<{ __typename?: 'ButtonModelRecord', text?: string | null, url?: string | null, color?: string | null, size?: string | null }> }>, seo?: { __typename?: 'SeoField', title?: string | null, description?: string | null, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', src: string, alt?: string | null } | null } | null } | null } | null };

export const ResponsiveImagePropsFragmentDoc = gql`
    fragment ResponsiveImageProps on ResponsiveImage {
  srcSet
  webpSrcSet
  sizes
  src
  width
  height
  aspectRatio
  alt
  title
  base64
}
    `;
export const ArticleMiniatureImageFragmentDoc = gql`
    fragment ArticleMiniatureImage on ArticleRecord {
  miniatureImage {
    responsiveImage(
      imgixParams: {fit: crop, w: 400, h: 400, auto: format, q: 65}
      sizes: "(max-width: 768px) 50vw, (max-width: 1200px) 25vw, 276px"
    ) {
      ...ResponsiveImageProps
    }
    tags
  }
}
    ${ResponsiveImagePropsFragmentDoc}`;
export const IndexArticleFieldsFragmentDoc = gql`
    fragment IndexArticleFields on ArticleRecord {
  mainCategory {
    name
    slug
  }
  slug
  title
  _firstPublishedAt
  ...ArticleMiniatureImage
}
    ${ArticleMiniatureImageFragmentDoc}`;
export const SeoFieldFragmentDoc = gql`
    fragment SeoField on SeoField {
  title
  description
  image {
    responsiveImage {
      src
      alt
    }
  }
}
    `;
export const BaseCarBrandPageFragmentDoc = gql`
    fragment BaseCarBrandPage on CarBrandPageRecord {
  name
  slug
  logo {
    url
    alt
    responsiveImage(imgixParams: {fit: crop, auto: format}) {
      ...ResponsiveImageProps
    }
    tags
  }
  heading
  headingTag
  headingTemplate {
    template
  }
  seoInfo {
    value
    links
    blocks {
      ... on SubtitleRecord {
        id
        text
        tag
      }
    }
  }
  seoInfoTemplate {
    template {
      value
      links
      blocks {
        ... on SubtitleRecord {
          id
          text
          tag
        }
      }
    }
  }
  seo {
    ...SeoField
  }
  seoTemplate {
    template {
      title
      description
      image {
        responsiveImage {
          src
        }
      }
    }
  }
  _allReferencingCarFamilyPages(orderBy: name_ASC) {
    name
    slug
  }
}
    ${ResponsiveImagePropsFragmentDoc}
${SeoFieldFragmentDoc}`;
export const CheckoutStepFragmentDoc = gql`
    fragment CheckoutStep on CheckoutStepRecord {
  title
  subtitle
  description
  nextButtonText
}
    `;
export const LinkFragmentDoc = gql`
    fragment Link on TextLinkRecord {
  text
  url
}
    `;
export const ServicesFragmentDoc = gql`
    fragment Services on ObjectServiceRecord {
  id
  serviceType
  title
  image {
    responsiveImage(imgixParams: {fit: crop, w: 80, h: 80, auto: format}) {
      ...ResponsiveImageProps
    }
    focalPoint {
      x
      y
    }
    tags
  }
  icon {
    url
    alt
  }
  description
  footnote
  content {
    value
    blocks
    links
  }
  link {
    text
    url
  }
  jsonData
  active
  excludeFromVehicleTypes {
    id
    name
  }
}
    ${ResponsiveImagePropsFragmentDoc}`;
export const BulletPointsFragmentDoc = gql`
    fragment BulletPoints on TextRecord {
  text
}
    `;
export const InspectionFragmentDoc = gql`
    fragment Inspection on InspectionBlockRecord {
  title
  link {
    text
    url
  }
  conditions {
    key
    question
    conditionInfo {
      conditionStep
      answer
    }
  }
}
    `;
export const StampFragmentDoc = gql`
    fragment Stamp on StampRecord {
  stampType
  stampColor
  stampAppearance
  stampSize
}
    `;
export const ButtonBlockFragmentDoc = gql`
    fragment ButtonBlock on ButtonRecord {
  id
  text
  size
  url
  color
  variant
  openLinkInNewWindow
}
    `;
export const PromoCardFragmentDoc = gql`
    fragment PromoCard on PromoCardRecord {
  id
  isActive
  applyForCategory {
    mainCategory
  }
  cardPositionPhone
  cardPositionTablet
  cardPositionDesktop
  promoCardTemplates {
    ... on PromoCardTemplateRecord {
      id
      cardType
      title
      content {
        value
        blocks {
          __typename
          ... on TitleRecord {
            id
            text
            tag
          }
          ... on StampRecord {
            id
            ...Stamp
          }
          ... on IconListRecord {
            id
            items {
              ... on IconListItemRecord {
                text
                imageIcon {
                  icon {
                    title
                  }
                }
              }
            }
          }
        }
      }
      link {
        ...ButtonBlock
        ... on TextLinkRecord {
          text
          url
        }
      }
      textColor {
        hex
      }
      backgroundColor {
        hex
      }
      ga4EventIdentifier
      backgroundColorTheme
      backgroundColorShade
    }
  }
}
    ${StampFragmentDoc}
${ButtonBlockFragmentDoc}`;
export const ButtonAttributesFragmentDoc = gql`
    fragment ButtonAttributes on ButtonModelRecord {
  text
  url
  color
  size
}
    `;
export const ThankYouItemAttributesFragmentDoc = gql`
    fragment ThankYouItemAttributes on SellFlowThankYouItemRecord {
  title
  backgroundImage {
    url
    alt
    tags
  }
  structuredText {
    structuredText {
      value
    }
  }
  image {
    responsiveImage(
      imgixParams: {fit: crop, w: 200, h: 200, auto: format, q: 65}
      sizes: "200px"
    ) {
      ...ResponsiveImageProps
    }
    tags
  }
  button {
    ...ButtonAttributes
  }
}
    ${ResponsiveImagePropsFragmentDoc}
${ButtonAttributesFragmentDoc}`;
export const FormHeaderAttributesFragmentDoc = gql`
    fragment FormHeaderAttributes on SellFlowFormHeaderRecord {
  title
  description
}
    `;
export const DynamicItemAttributesFragmentDoc = gql`
    fragment DynamicItemAttributes on SellFlowDynamicItemRecord {
  key
  title
  description
  bodyStructuredText {
    blocks
    links
    value
  }
}
    `;
export const ResponsiveW400ImageFragmentDoc = gql`
    fragment ResponsiveW400Image on FileField {
  responsiveImage(imgixParams: {auto: format, q: 65, w: 400}) {
    ...ResponsiveImageProps
  }
  focalPoint {
    x
    y
  }
  tags
}
    ${ResponsiveImagePropsFragmentDoc}`;
export const LeasingPromotionCardFragmentDoc = gql`
    fragment LeasingPromotionCard on LeasingPromotionVehicleCardRecord {
  id
  brandAndModel
  monthlyCostFrom
  leasingPeriodFrom
  mileageFrom
  productImage {
    ...ResponsiveW400Image
  }
}
    ${ResponsiveW400ImageFragmentDoc}`;
export const LeasingPartnerPresentationFragmentDoc = gql`
    fragment LeasingPartnerPresentation on LeasingPartnerPresentationRecord {
  id
  anchorId
  partnerName
  leasingProvider
  uspHeading
  logo {
    url
    alt
    ...ResponsiveW400Image
  }
  description {
    value
    links
    blocks
  }
  uspList {
    id
    text
  }
  linkButton {
    ...ButtonBlock
  }
  promotionHeading
  promotionVehicleCards {
    ...LeasingPromotionCard
  }
  promotionButton {
    ...ButtonBlock
  }
  interestModalTitle
  interestModalIntro
  priceFootnote
  interestConsentLabel {
    value
    links
    blocks
  }
  interestSubmitButtonText
  interestConfirmationTitle
  interestConfirmationText
  interestConfirmationSubjectHeading
  interestConfirmationDetailsHeading
}
    ${ResponsiveW400ImageFragmentDoc}
${ButtonBlockFragmentDoc}
${LeasingPromotionCardFragmentDoc}`;
export const DynamicPageBodyOnlyBlocksFragmentDoc = gql`
    fragment DynamicPageBodyOnlyBlocks on DynamicPageModelBodyBlocksField {
  ...LeasingPartnerPresentation
}
    ${LeasingPartnerPresentationFragmentDoc}`;
export const ButtonModelFragmentDoc = gql`
    fragment ButtonModel on ButtonModelRecord {
  id
  text
  url
  color
  size
  openLinkInNewWindow
}
    `;
export const DynamicFormFieldModelFragmentDoc = gql`
    fragment DynamicFormFieldModel on FormFieldRecord {
  fieldType
  backendKey
  required
  helperText
  textFieldType
  textFieldLabel
  textFieldPlaceholder
  textFieldDefaultValue
  textAreaLabel
  textAreaRows
  checkboxLabel {
    value
  }
  checkboxCheckedByDefault
  multipleChoiceLabel
  choiceFieldType
  choices {
    label
    selectedByDefault
    followUpQuestionBackendKey
  }
  allowOtherOption
  otherOptionLabel
  likertLabel
  likertScaleOptions {
    label
  }
  likertStatements {
    label
    statementKey
  }
}
    `;
export const DynamicFormModelFragmentDoc = gql`
    fragment DynamicFormModel on FormRecord {
  id
  isActive
  startDate
  endDate
  formTitle
  formOpenDescription {
    value
  }
  formNotOpenDescription {
    value
  }
  formAlreadyClosedDescription {
    value
  }
  formSuccessSubmissionDescription {
    value
  }
  formFields {
    ...DynamicFormFieldModel
  }
  submitFormDescription
  formSubmitButton
  internalName
}
    ${DynamicFormFieldModelFragmentDoc}`;
export const DynamicPageBodyLinksFragmentDoc = gql`
    fragment DynamicPageBodyLinks on DynamicPageModelBodyLinksField {
  ...ButtonModel
  ...DynamicFormModel
}
    ${ButtonModelFragmentDoc}
${DynamicFormModelFragmentDoc}`;
export const DynamicPageCustomElementFragmentDoc = gql`
    fragment DynamicPageCustomElement on TextSectionModelBodyBlocksField {
  ... on DynamicPageCustomElementRecord {
    id
    usageType
  }
}
    `;
export const InlineImageFragmentDoc = gql`
    fragment InlineImage on InlineimageRecord {
  id
  image {
    responsiveImage(imgixParams: {fit: crop, w: 568, auto: format}) {
      ...ResponsiveImageProps
    }
    lightboxImage: responsiveImage(imgixParams: {auto: format, q: 75, w: 2400}) {
      ...ResponsiveImageProps
    }
    url
    alt
    tags
  }
  righttext
  lefttext
  imageMaxWidth
  textPlacement
  textContent {
    value
    links {
      ...ButtonModel
    }
    blocks {
      ...ButtonBlock
    }
  }
}
    ${ResponsiveImagePropsFragmentDoc}
${ButtonModelFragmentDoc}
${ButtonBlockFragmentDoc}`;
export const CarInspirationListFragmentDoc = gql`
    fragment CarInspirationList on CarInspirationListRecord {
  id
  heading
  linkText
  queryString
}
    `;
export const YoutubeClipFragmentDoc = gql`
    fragment YoutubeClip on YoutubeClipRecord {
  id
  videoId
  linkParameters
  width
  aspectRatio
}
    `;
export const ResponsiveW400H400ImageFragmentDoc = gql`
    fragment ResponsiveW400H400Image on FileField {
  responsiveImage(imgixParams: {fit: crop, w: 400, h: 400, auto: format, q: 65}) {
    ...ResponsiveImageProps
  }
  focalPoint {
    x
    y
  }
  tags
}
    ${ResponsiveImagePropsFragmentDoc}`;
export const ContactCardsFragmentDoc = gql`
    fragment ContactCards on ContactCardsBlockRecord {
  id
  fullWidth
  items {
    ... on ContactDepartmentCardRecord {
      id
      email
      extraDescriptiveLine
      name
      openingHours
      phone
      showDetailedOpeningHours
    }
    ... on ContactPersonCardRecord {
      id
      email
      role
      extraDescriptiveLine
      name
      phone
      image {
        ...ResponsiveW400H400Image
      }
      profilePage {
        ... on DynamicPageRecord {
          id
          slug
        }
      }
    }
  }
}
    ${ResponsiveW400H400ImageFragmentDoc}`;
export const SupportChatCardFragmentDoc = gql`
    fragment SupportChatCard on SupportChatCardRecord {
  id
  text
  ctaLabel
}
    `;
export const StructuredTextCardFragmentDoc = gql`
    fragment StructuredTextCard on StructuredTextCardRecord {
  id
  body {
    value
    links
    blocks
  }
}
    `;
export const SpacerFragmentDoc = gql`
    fragment Spacer on SpacerRecord {
  id
  space
}
    `;
export const TextGridFragmentDoc = gql`
    fragment TextGrid on TextSectionModelBodyBlocksField {
  ... on TextGridRecord {
    id
    columnGap
    rowGap
    columns {
      body {
        value
        links {
          ...DynamicPageBodyLinks
        }
        blocks {
          ...DynamicPageCustomElement
          ...InlineImage
          ...CarInspirationList
          ...YoutubeClip
          ...ContactCards
          ...SupportChatCard
          ...StructuredTextCard
          ...Spacer
        }
      }
    }
  }
}
    ${DynamicPageBodyLinksFragmentDoc}
${DynamicPageCustomElementFragmentDoc}
${InlineImageFragmentDoc}
${CarInspirationListFragmentDoc}
${YoutubeClipFragmentDoc}
${ContactCardsFragmentDoc}
${SupportChatCardFragmentDoc}
${StructuredTextCardFragmentDoc}
${SpacerFragmentDoc}`;
export const BlockButtonFragmentDoc = gql`
    fragment BlockButton on BlockButtonRecord {
  id
  backgroundImage {
    ...ResponsiveW400Image
  }
  linkUrl
  preamble
  title
}
    ${ResponsiveW400ImageFragmentDoc}`;
export const AnchorNavigationFragmentDoc = gql`
    fragment AnchorNavigation on AnchorNavigationRecord {
  id
  items {
    id
    sectionHeading
  }
}
    `;
export const LeasingPartnerNavigationFragmentDoc = gql`
    fragment LeasingPartnerNavigation on LeasingPartnerNavigationRecord {
  id
  title
  helpText
  partnerLogos {
    id
    scrollTargetId
    logo {
      url
      alt
      ...ResponsiveW400Image
    }
  }
}
    ${ResponsiveW400ImageFragmentDoc}`;
export const FaqQuestionAnsweFieldFragmentDoc = gql`
    fragment FaqQuestionAnsweField on FaqQuestionNewModelAnswerField {
  blocks {
    ... on TableRecord {
      id
      tablestructure
    }
    ...YoutubeClip
  }
  links
  value
}
    ${YoutubeClipFragmentDoc}`;
export const FaqSectionBlockFragmentDoc = gql`
    fragment FaqSectionBlock on FaqSectionBlockRecord {
  id
  title
  ingress
  footerText
  footerLink {
    id
    text
    url
  }
  questions {
    id
    question
    answer {
      ...FaqQuestionAnsweField
    }
  }
}
    ${FaqQuestionAnsweFieldFragmentDoc}`;
export const DynamicPageBodyBlocksFragmentDoc = gql`
    fragment DynamicPageBodyBlocks on TextSectionModelBodyBlocksField {
  ...TextGrid
  ...DynamicPageCustomElement
  ...InlineImage
  ...CarInspirationList
  ...ButtonBlock
  ... on TableRecord {
    id
    tablestructure
  }
  ... on DynamicPageFormRecord {
    id
    isActive
    usageType
    title
    description
    sendButton
  }
  ... on TextTabsBlockRecord {
    id
    title
    tabs {
      ... on TextTabRecord {
        id
        tabName
        body {
          blocks {
            ...TextGrid
          }
          links
          value
        }
      }
    }
  }
  ... on DynamicPageValuationFormRecord {
    id
    subtitle
    title
    formHeading
    imageBefore {
      alt
      url
    }
    imageAnimation {
      alt
      url
    }
    imageAfter {
      alt
      url
    }
  }
  ... on FeaturedBlocksBlockRecord {
    id
    blockButtons {
      ...BlockButton
    }
  }
  ...YoutubeClip
  ...ContactCards
  ...AnchorNavigation
  ...LeasingPartnerNavigation
  ...FaqSectionBlock
  ...Spacer
}
    ${TextGridFragmentDoc}
${DynamicPageCustomElementFragmentDoc}
${InlineImageFragmentDoc}
${CarInspirationListFragmentDoc}
${ButtonBlockFragmentDoc}
${BlockButtonFragmentDoc}
${YoutubeClipFragmentDoc}
${ContactCardsFragmentDoc}
${AnchorNavigationFragmentDoc}
${LeasingPartnerNavigationFragmentDoc}
${FaqSectionBlockFragmentDoc}
${SpacerFragmentDoc}`;
export const ResponsiveW2000ImageFragmentDoc = gql`
    fragment ResponsiveW2000Image on FileField {
  responsiveImage(imgixParams: {auto: format, q: 65, w: 2000}) {
    ...ResponsiveImageProps
  }
  focalPoint {
    x
    y
  }
  tags
}
    ${ResponsiveImagePropsFragmentDoc}`;
export const OptionalHeroFragmentDoc = gql`
    fragment OptionalHero on OptionalHeroRecord {
  button {
    backgroundColor
    backgroundColorShade
    link
    text
    textColor
  }
  textColor
  title
  subtitle
  image {
    ...ResponsiveW2000Image
  }
  contentAlignment
  showHero
}
    ${ResponsiveW2000ImageFragmentDoc}`;
export const LargeFeaturedCardFragmentDoc = gql`
    fragment largeFeaturedCard on FeaturedCardRecord {
  image {
    responsiveImage(
      imgixParams: {auto: format, q: 65}
      sizes: "(max-width: 768px) 90vw, (max-width: 1350px) 50vw, 656px"
    ) {
      ...ResponsiveImageProps
    }
    tags
  }
  titleWithText {
    title {
      text
      tag
    }
    text {
      value
      links
      blocks
    }
  }
  buttons {
    text
    url
    color
    size
  }
}
    ${ResponsiveImagePropsFragmentDoc}`;
export const PathItemFragmentDoc = gql`
    fragment PathItem on PathItemRecord {
  image {
    ...ResponsiveW400H400Image
  }
  title
  informationText
  buttonText
}
    ${ResponsiveW400H400ImageFragmentDoc}`;
export const BiddingDocument = gql`
    query Bidding($locale: SiteLocale!) {
  auctionTipsModel(locale: $locale) {
    structuredText {
      structuredText {
        value
      }
    }
  }
}
    `;

export function useBiddingQuery(options: Omit<Urql.UseQueryArgs<BiddingQueryVariables>, 'query'>) {
  return Urql.useQuery<BiddingQuery, BiddingQueryVariables>({ query: BiddingDocument, ...options });
};
export const CategoryBySlugDocument = gql`
    query CategoryBySlug($locale: SiteLocale!, $slug: String!) {
  category(locale: $locale, filter: {slug: {eq: $slug}}) {
    id
    name
    slug
    optionalHero {
      ...OptionalHero
    }
    structuredDescription {
      value
      blocks
      links
    }
    seo {
      ...SeoField
    }
    _editingUrl
  }
}
    ${OptionalHeroFragmentDoc}
${SeoFieldFragmentDoc}`;

export function useCategoryBySlugQuery(options: Omit<Urql.UseQueryArgs<CategoryBySlugQueryVariables>, 'query'>) {
  return Urql.useQuery<CategoryBySlugQuery, CategoryBySlugQueryVariables>({ query: CategoryBySlugDocument, ...options });
};
export const ArticlesByCategoryAndSlugWithRichTextDocument = gql`
    query ArticlesByCategoryAndSlugWithRichText($locale: SiteLocale!, $slug: String!, $categoryId: ItemId!) {
  article(
    locale: $locale
    filter: {mainCategory: {eq: $categoryId}, slug: {eq: $slug}}
  ) {
    title
    subtitle
    seo {
      ...SeoField
    }
    _firstPublishedAt
    _publishedAt
    additionalCategories {
      slug
      name
      id
    }
    premable
    articleimage {
      responsiveImage(imgixParams: {fit: crop, auto: format, q: 65, w: 720, h: 320}) {
        ...ResponsiveImageProps
      }
      tags
    }
    ...ArticleMiniatureImage
    newsletterSignupSection {
      title
      description
      newsletterType
    }
    body {
      value
      blocks {
        __typename
        ...ButtonBlock
        ...InlineImage
        ... on TableRecord {
          id
          tablestructure
        }
        ... on SubtitleRecord {
          id
          text
          tag
        }
        ... on HeadlineRecord {
          id
          text
          tag
        }
        ... on TitleRecord {
          id
          text
          tag
        }
        ... on NewsletterSignupRecord {
          id
          title
          description
        }
        ...CarInspirationList
        ... on HtmlInputRecord {
          id
          htmlField(markdown: false)
        }
        ...Spacer
        ...AnchorNavigation
        ...YoutubeClip
      }
    }
    _editingUrl
    seoInfo {
      value
      links
      blocks {
        ... on SubtitleRecord {
          id
          text
          tag
        }
      }
    }
    seoInfoTemplate {
      template {
        value
        links
        blocks {
          ... on SubtitleRecord {
            id
            text
            tag
          }
        }
      }
    }
  }
}
    ${SeoFieldFragmentDoc}
${ResponsiveImagePropsFragmentDoc}
${ArticleMiniatureImageFragmentDoc}
${ButtonBlockFragmentDoc}
${InlineImageFragmentDoc}
${CarInspirationListFragmentDoc}
${SpacerFragmentDoc}
${AnchorNavigationFragmentDoc}
${YoutubeClipFragmentDoc}`;

export function useArticlesByCategoryAndSlugWithRichTextQuery(options: Omit<Urql.UseQueryArgs<ArticlesByCategoryAndSlugWithRichTextQueryVariables>, 'query'>) {
  return Urql.useQuery<ArticlesByCategoryAndSlugWithRichTextQuery, ArticlesByCategoryAndSlugWithRichTextQueryVariables>({ query: ArticlesByCategoryAndSlugWithRichTextDocument, ...options });
};
export const ArticlesForCategoryDocument = gql`
    query ArticlesForCategory($locale: SiteLocale!, $categoryId: ItemId!, $ignoreArticleSlugs: [String!]) {
  allArticles(
    locale: $locale
    filter: {mainCategory: {eq: $categoryId}, slug: {notIn: $ignoreArticleSlugs, neq: null}}
    orderBy: _firstPublishedAt_DESC
    first: 100
  ) {
    ...IndexArticleFields
  }
}
    ${IndexArticleFieldsFragmentDoc}`;

export function useArticlesForCategoryQuery(options: Omit<Urql.UseQueryArgs<ArticlesForCategoryQueryVariables>, 'query'>) {
  return Urql.useQuery<ArticlesForCategoryQuery, ArticlesForCategoryQueryVariables>({ query: ArticlesForCategoryDocument, ...options });
};
export const ArticlesForCategoryWithAdditionalDocument = gql`
    query ArticlesForCategoryWithAdditional($locale: SiteLocale!, $categoryId: ItemId!, $ignoreArticleSlugs: [String!]) {
  allArticles(
    locale: $locale
    filter: {OR: [{mainCategory: {eq: $categoryId}}, {additionalCategories: {anyIn: [$categoryId]}}], slug: {notIn: $ignoreArticleSlugs, neq: null}}
    orderBy: _firstPublishedAt_DESC
    first: 100
  ) {
    ...IndexArticleFields
  }
}
    ${IndexArticleFieldsFragmentDoc}`;

export function useArticlesForCategoryWithAdditionalQuery(options: Omit<Urql.UseQueryArgs<ArticlesForCategoryWithAdditionalQueryVariables>, 'query'>) {
  return Urql.useQuery<ArticlesForCategoryWithAdditionalQuery, ArticlesForCategoryWithAdditionalQueryVariables>({ query: ArticlesForCategoryWithAdditionalDocument, ...options });
};
export const ArticlesByCategoriesDocument = gql`
    query ArticlesByCategories($locale: SiteLocale!, $categoryIds: [ItemId!]!, $ignoreArticleSlugs: [String!]) {
  allArticles(
    locale: $locale
    filter: {mainCategory: {in: $categoryIds}, slug: {notIn: $ignoreArticleSlugs, neq: null}}
    orderBy: _firstPublishedAt_DESC
  ) {
    id
    slug
    title
    _firstPublishedAt
    mainCategory {
      name
      id
      slug
    }
    ...ArticleMiniatureImage
  }
}
    ${ArticleMiniatureImageFragmentDoc}`;

export function useArticlesByCategoriesQuery(options: Omit<Urql.UseQueryArgs<ArticlesByCategoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<ArticlesByCategoriesQuery, ArticlesByCategoriesQueryVariables>({ query: ArticlesByCategoriesDocument, ...options });
};
export const PageByNameDocument = gql`
    query PageByName($locale: SiteLocale!, $name: String!) {
  page(locale: $locale, filter: {name: {eq: $name}}) {
    name
    seo {
      ...SeoField
    }
    optionalHero {
      ...OptionalHero
    }
    _allReferencingCategoryOrders {
      categories {
        id
      }
    }
    _editingUrl
  }
}
    ${SeoFieldFragmentDoc}
${OptionalHeroFragmentDoc}`;

export function usePageByNameQuery(options: Omit<Urql.UseQueryArgs<PageByNameQueryVariables>, 'query'>) {
  return Urql.useQuery<PageByNameQuery, PageByNameQueryVariables>({ query: PageByNameDocument, ...options });
};
export const AllArticlesForMainPageDocument = gql`
    query AllArticlesForMainPage($locale: SiteLocale!) {
  allArticles(locale: $locale, orderBy: _firstPublishedAt_DESC) {
    ...IndexArticleFields
  }
}
    ${IndexArticleFieldsFragmentDoc}`;

export function useAllArticlesForMainPageQuery(options: Omit<Urql.UseQueryArgs<AllArticlesForMainPageQueryVariables>, 'query'>) {
  return Urql.useQuery<AllArticlesForMainPageQuery, AllArticlesForMainPageQueryVariables>({ query: AllArticlesForMainPageDocument, ...options });
};
export const SearchAllArticlesDocument = gql`
    query SearchAllArticles($locale: SiteLocale!, $query: String!) {
  allArticles(
    locale: $locale
    filter: {OR: [{title: {matches: {pattern: $query}}}, {body: {matches: {pattern: $query}}}, {premable: {matches: {pattern: $query}}}]}
  ) {
    ...IndexArticleFields
  }
}
    ${IndexArticleFieldsFragmentDoc}`;

export function useSearchAllArticlesQuery(options: Omit<Urql.UseQueryArgs<SearchAllArticlesQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchAllArticlesQuery, SearchAllArticlesQueryVariables>({ query: SearchAllArticlesDocument, ...options });
};
export const ArticlesBySlugsDocument = gql`
    query ArticlesBySlugs($locale: SiteLocale!, $requestedLocale: SiteLocale!, $slugs: [String]!) {
  allArticles(locale: $locale, filter: {slug: {in: $slugs, neq: null}}) {
    mainCategory {
      name(locale: $requestedLocale)
      slug(locale: $requestedLocale)
    }
    slug(locale: $requestedLocale)
    title(locale: $requestedLocale)
    _firstPublishedAt
    ...ArticleMiniatureImage
  }
}
    ${ArticleMiniatureImageFragmentDoc}`;

export function useArticlesBySlugsQuery(options: Omit<Urql.UseQueryArgs<ArticlesBySlugsQueryVariables>, 'query'>) {
  return Urql.useQuery<ArticlesBySlugsQuery, ArticlesBySlugsQueryVariables>({ query: ArticlesBySlugsDocument, ...options });
};
export const AllCategoriesDocument = gql`
    query AllCategories($locale: SiteLocale!) {
  allCategories(
    locale: $locale
    orderBy: _firstPublishedAt_DESC
    first: 100
    filter: {slug: {neq: null}}
  ) {
    slug
    name
    id
  }
}
    `;

export function useAllCategoriesQuery(options: Omit<Urql.UseQueryArgs<AllCategoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllCategoriesQuery, AllCategoriesQueryVariables>({ query: AllCategoriesDocument, ...options });
};
export const PreviousCategoryDocument = gql`
    query PreviousCategory($locale: SiteLocale!) {
  allCategories(locale: $locale, filter: {slug: {neq: null}}) {
    slug
    _allReferencingArticles(through: {fields: {anyIn: article_previousCategory}}) {
      slug
      previousCategory {
        slug
      }
      mainCategory {
        slug
      }
    }
  }
}
    `;

export function usePreviousCategoryQuery(options: Omit<Urql.UseQueryArgs<PreviousCategoryQueryVariables>, 'query'>) {
  return Urql.useQuery<PreviousCategoryQuery, PreviousCategoryQueryVariables>({ query: PreviousCategoryDocument, ...options });
};
export const CarTreeFamilyBySlugDocument = gql`
    query CarTreeFamilyBySlug($locale: SiteLocale!, $slug: String!, $filterPage: ItemId!) {
  carFamilyPage(
    locale: $locale
    filter: {slug: {eq: $slug}, filterPage: {eq: $filterPage}}
  ) {
    id
    name
    slug
    preamble {
      value
      links
    }
    queryParams
    text {
      value
      links
      blocks {
        ... on SubtitleRecord {
          id
          text
          tag
        }
      }
    }
    displaySeoText
    brand {
      ...BaseCarBrandPage
      familyPreambleTemplate {
        template {
          value
          links
        }
      }
    }
  }
}
    ${BaseCarBrandPageFragmentDoc}`;

export function useCarTreeFamilyBySlugQuery(options: Omit<Urql.UseQueryArgs<CarTreeFamilyBySlugQueryVariables>, 'query'>) {
  return Urql.useQuery<CarTreeFamilyBySlugQuery, CarTreeFamilyBySlugQueryVariables>({ query: CarTreeFamilyBySlugDocument, ...options });
};
export const CarTreeAllBrandsDocument = gql`
    query CarTreeAllBrands($filterPage: ItemId!) {
  allCarBrandPages(
    orderBy: name_ASC
    first: 100
    filter: {filterPage: {eq: $filterPage}}
  ) {
    name
    slug
  }
}
    `;

export function useCarTreeAllBrandsQuery(options: Omit<Urql.UseQueryArgs<CarTreeAllBrandsQueryVariables>, 'query'>) {
  return Urql.useQuery<CarTreeAllBrandsQuery, CarTreeAllBrandsQueryVariables>({ query: CarTreeAllBrandsDocument, ...options });
};
export const AllBrandAndFamilySlugsDocument = gql`
    query AllBrandAndFamilySlugs($locale: SiteLocale!, $limit: IntType!, $skip: IntType!) {
  allCarBrandPages(locale: $locale, first: $limit, skip: $skip) {
    slug
    _allReferencingCarFamilyPages {
      slug
    }
  }
}
    `;

export function useAllBrandAndFamilySlugsQuery(options: Omit<Urql.UseQueryArgs<AllBrandAndFamilySlugsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllBrandAndFamilySlugsQuery, AllBrandAndFamilySlugsQueryVariables>({ query: AllBrandAndFamilySlugsDocument, ...options });
};
export const CarBrandAndCategoryBySlugDocument = gql`
    query CarBrandAndCategoryBySlug($locale: SiteLocale!, $slug: String!, $filterPage: ItemId!) {
  carBrandPage(
    locale: $locale
    filter: {slug: {eq: $slug}, filterPage: {eq: $filterPage}}
  ) {
    id
    ...BaseCarBrandPage
    preamble {
      value
      links
    }
    preambleTemplate {
      template {
        value
        links
      }
    }
    queryParams
    text {
      value
      links
      blocks {
        ... on SubtitleRecord {
          id
          text
          tag
        }
      }
    }
  }
  carCategoryPage(
    locale: $locale
    filter: {slug: {eq: $slug}, filterPage: {eq: $filterPage}}
  ) {
    id
    name
    slug
    heading
    headingTag
    preamble {
      value
      links
    }
    queryParams
    text {
      value
      links
      blocks {
        ... on SubtitleRecord {
          id
          text
          tag
        }
      }
    }
    seoInfo {
      value
      links
      blocks {
        ... on SubtitleRecord {
          id
          text
          tag
        }
      }
    }
    seoInfoTemplate {
      template {
        value
        links
        blocks {
          ... on SubtitleRecord {
            id
            text
            tag
          }
        }
      }
    }
    seo {
      ...SeoField
    }
    seoTemplate {
      template {
        title
        description
        image {
          responsiveImage {
            src
          }
        }
      }
    }
  }
}
    ${BaseCarBrandPageFragmentDoc}
${SeoFieldFragmentDoc}`;

export function useCarBrandAndCategoryBySlugQuery(options: Omit<Urql.UseQueryArgs<CarBrandAndCategoryBySlugQueryVariables>, 'query'>) {
  return Urql.useQuery<CarBrandAndCategoryBySlugQuery, CarBrandAndCategoryBySlugQueryVariables>({ query: CarBrandAndCategoryBySlugDocument, ...options });
};
export const CarguideDocument = gql`
    query Carguide($locale: SiteLocale!) {
  carGuide(locale: $locale) {
    title
    description
    startButtonText
    image {
      ...ResponsiveW400H400Image
    }
    questions {
      title
      subtitle
      question
      tag
      image {
        ...ResponsiveW400H400Image
      }
    }
    seo {
      ...SeoField
    }
    _editingUrl
  }
}
    ${ResponsiveW400H400ImageFragmentDoc}
${SeoFieldFragmentDoc}`;

export function useCarguideQuery(options: Omit<Urql.UseQueryArgs<CarguideQueryVariables>, 'query'>) {
  return Urql.useQuery<CarguideQuery, CarguideQueryVariables>({ query: CarguideDocument, ...options });
};
export const CheckoutDocument = gql`
    query Checkout($locale: SiteLocale!, $flowType: String!) {
  checkout(locale: $locale, filter: {checkoutFlow: {eq: $flowType}}) {
    title
    description
    auctionTitle
    auctionDescription
    closedDescription
    finalInformationText
    finalSubmitButtonText
    finalAuctionSubmitButtonText
    acceptPolicyText
    acceptPolicyLinkText
    acceptSitePolicyLinkText
    acceptDeliveryPolicyText
    acceptPickupPolicyText
    acceptBuyerTransferPolicyText
    policyPrivate {
      content {
        blocks {
          ... on TableRecord {
            id
            tablestructure
          }
        }
        links
        value
      }
    }
    policyCompany {
      content {
        blocks {
          ... on TableRecord {
            id
            tablestructure
          }
        }
        links
        value
      }
    }
    policySite {
      content {
        blocks {
          ... on TableRecord {
            id
            tablestructure
          }
        }
        links
        value
      }
    }
    stepsFinancing {
      ...CheckoutStep
      details {
        ... on CheckoutStepFinancingCommonRecord {
          labelCash
          labelLoan
          loanSellingPoint
          loanWarning {
            blocks
            links
            value
          }
          servicesTitle
          insuranceTitle
          insuranceDescription
          warrantyTitle
          warrantyDescription
          warrantyDescriptionAuction
          warrantyDescriptionFixedPrice
          warrantyExtendedInfo {
            blocks
            links
            value
          }
          serviceAgreementTitle
          serviceAgreementDescription
          serviceAgreementFullDescription {
            blocks
            links
            value
          }
          serviceAgreementCheckboxLabel
          requestedFinancingLabel
          featuredWarranty {
            checkoutType
            featuredText
            featuredPeriod
          }
          tireTitle
          tireDescription
          carToSellTitle
          carToSellDescription
          carToSellCheckboxLabel
        }
      }
    }
    stepsOwnerDetails {
      ...CheckoutStep
      details {
        ... on CheckoutStepOwnerDetailsCarDealerRecord {
          buyerTransferInformationText
          informationTitle
          informationText {
            blocks
            links
            value
          }
        }
      }
    }
    stepsDelivery {
      ...CheckoutStep
      details {
        ... on CheckoutStepDeliveryCommonRecord {
          vehicleLocation
          deliveryMethodTitle
          pickUpMethodTitle
          pickupMethodInformation
          pickupTimeTitle
          timePickerTitle
          timePickerText
          personIdentificationTitle
        }
      }
    }
    stepsSummary {
      ...CheckoutStep
      details {
        ... on CheckoutStepSummaryCommonRecord {
          totalPriceTitle
          vatText
          transportTitle
        }
      }
    }
    confirmationData {
      checkoutType
      title
      reservation
      whatHappensNow
      yourOrder
      summary
      totalPriceTitle
      transportTitle
      reservationNotFirstInLine
      paymentTitle
      paymentExplanation
      paymentInformation
      paymentButtonText
      carDealerPaymentInformationTitle
      carDealerPaymentInformationText {
        blocks
        links
        value
      }
      confirmationSteps {
        title
        description
      }
    }
    _editingUrl
  }
}
    ${CheckoutStepFragmentDoc}`;

export function useCheckoutQuery(options: Omit<Urql.UseQueryArgs<CheckoutQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckoutQuery, CheckoutQueryVariables>({ query: CheckoutDocument, ...options });
};
export const AllSlugsDocument = gql`
    query AllSlugs($currentLocale: SiteLocale!, $requestedLocale: SiteLocale!, $carBrandOrCategorySlug: String!, $carFamilySlug: String!, $categorySlug: String!, $articleSlug: String!, $faqQuestionSlug: String!, $dynamicPageSlug: String!) {
  carCategoryPage(
    locale: $currentLocale
    filter: {slug: {eq: $carBrandOrCategorySlug}}
  ) {
    slug(locale: $requestedLocale)
  }
  carBrandPage(
    locale: $currentLocale
    filter: {slug: {eq: $carBrandOrCategorySlug}}
  ) {
    slug
    _allReferencingCarFamilyPages(filter: {slug: {eq: $carFamilySlug}}) {
      slug(locale: $requestedLocale)
    }
  }
  category(locale: $currentLocale, filter: {slug: {eq: $categorySlug}}) {
    slug(locale: $requestedLocale)
    _allReferencingArticles(filter: {slug: {eq: $articleSlug}}) {
      slug(locale: $requestedLocale)
    }
  }
  faqQuestionNew(locale: $currentLocale, filter: {slug: {eq: $faqQuestionSlug}}) {
    slug(locale: $requestedLocale)
  }
  dynamicPage(locale: $currentLocale, filter: {slug: {eq: $dynamicPageSlug}}) {
    slug(locale: $requestedLocale)
  }
}
    `;

export function useAllSlugsQuery(options: Omit<Urql.UseQueryArgs<AllSlugsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllSlugsQuery, AllSlugsQueryVariables>({ query: AllSlugsDocument, ...options });
};
export const AllLocalizedSlugsDocument = gql`
    query AllLocalizedSlugs($limit: IntType!, $skip: IntType!) {
  allCarCategoryPages(first: $limit, skip: $skip) {
    _allSlugLocales {
      locale
      value
    }
    filterPage {
      mainCategory
    }
    updatedAt
  }
  allCarBrandPages(first: $limit, skip: $skip) {
    slug
    filterPage {
      mainCategory
    }
    updatedAt
    _allReferencingCarFamilyPages(first: 100) {
      updatedAt
      _allSlugLocales {
        locale
        value
      }
    }
  }
  allCategories(first: $limit, skip: $skip) {
    updatedAt
    _allSlugLocales {
      locale
      value
    }
    _allReferencingArticles(first: 100) {
      updatedAt
      _allSlugLocales {
        locale
        value
      }
    }
  }
  allFaqQuestionNews(first: $limit, skip: $skip) {
    updatedAt
    _allSlugLocales {
      locale
      value
    }
  }
  allDynamicPages(
    first: $limit
    skip: $skip
    filter: {isActive: {eq: true}, shouldIndex: {eq: true}}
  ) {
    updatedAt
    _allSlugLocales {
      locale
      value
    }
  }
}
    `;

export function useAllLocalizedSlugsQuery(options: Omit<Urql.UseQueryArgs<AllLocalizedSlugsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllLocalizedSlugsQuery, AllLocalizedSlugsQueryVariables>({ query: AllLocalizedSlugsDocument, ...options });
};
export const CompanyCampaignPageDocument = gql`
    query CompanyCampaignPage($locale: SiteLocale!) {
  companyCampaignPage(locale: $locale) {
    hero {
      ...OptionalHero
    }
    heroFormTitle
    heroFormBtnText
    heroFormDescription
    heroFormSuccess {
      blocks
      links
      value
    }
    contactFormSectionTitle
    contactFormSectionDescription {
      blocks
      links
      value
    }
    contactFormTitle
    contactFormNewsletterLabel {
      blocks
      links
      value
    }
    contactFormBtnText
    contactFormSuccess {
      blocks
      links
      value
    }
    fleetValCompTitle
    fleetValCompAverageProfitPerCar
    fleetValCompAverageValuationDescription
    fleetValCompKvdAverageValuation
    fleetValCompKvdAverageValuationDescription
    fleetValCompDealerAverageValuation
    fleetValCompDealerAverageValuationDescription
    fleetValCompDisclaimer {
      blocks
      links
      value
    }
    fleetValCompTotalVehiclesInfo
    fleetValCompKvdValuationTitle
    fleetValCompKvdValuationDescription
    fleetValCompDealerValuationTitle
    fleetValCompDealerValuationDescription
    fleetValCompResultTitle
    fleetValCompResultDescription
    fleetValCompUsp1
    fleetValCompUsp2
    fleetValCompUsp3
    fleetValReportTitle
    fleetValReportVehicleCountText
    fleetValReportDealerTitle
    fleetValReportDealerDescription
    fleetValReportKvdTitle
    fleetValReportKvdDescription
    fleetValReportResultTitle
    fleetValReportResultDescription
    fleetValReportDisclaimer {
      blocks
      links
      value
    }
    fleetValReportProcessingMessage {
      blocks
      links
      value
    }
    fleetValReportExpiredMessage {
      blocks
      links
      value
    }
    fleetValReportInsightsTitle
    fleetValReportMakeModelTitle
    fleetValReportMakeModelDescription
    fleetValReportMakeModelMoreInfo
    fleetValReportAgeTitle
    fleetValReportAgeDescription
    fleetValReportAgeRecommendedLabel
    fleetValReportFuelTitle
    fleetValReportFuelDescription
    fleetValReportFormTitle
    fleetValReportFormDescription
    fleetValReportRecommendationTitle
    fleetValReportRecommendationText {
      blocks
      links
      value
    }
    modularSections {
      ... on CompanyCampaignStatsBlockRecord {
        id
        statOne
        statThree
        statTwo
      }
      ... on CompanyCampaignReasonsBlockRecord {
        id
        title
        reasons {
          imageIcon {
            icon {
              url
              alt
            }
          }
          descriptionTitle
          descriptionBodyText
        }
        testimonials {
          quote
          testimonialStatus
        }
      }
      ... on CompanyCampaignFleetManagerRecord {
        id
        youtubeVideo {
          ...YoutubeClip
        }
        title
        description
        subtitle
        button {
          text
          color
          url
          openLinkInNewWindow
        }
        bulletPoints {
          blocks
          links
          value
        }
      }
      ... on CompanyCampaignNewsletterRecord {
        id
        newsletter {
          title
          newsletterType
          description
        }
        socialMedia {
          text
          imageIcon {
            icon {
              url
              alt
            }
          }
        }
      }
      ... on SmallFeatureCardsBlockRecord {
        id
        button {
          color
          size
          text
          url
        }
        title
        text {
          blocks
          links
          value
        }
        articles {
          id
          slug
          title
          _firstPublishedAt
          mainCategory {
            name
            id
            slug
          }
          ...ArticleMiniatureImage
        }
      }
      ... on CompanyCampaignCarguideRecord {
        image {
          responsiveImage(
            imgixParams: {auto: format, q: 65}
            sizes: "(max-width: 1023px) 100vw, (max-width: 1400px) 50vw, 632px"
          ) {
            ...ResponsiveImageProps
          }
          tags
        }
        id
        preTitle
        title
        button {
          color
          text
        }
        text {
          blocks
          links
          value
        }
      }
    }
    _editingUrl
    seo {
      ...SeoField
    }
  }
}
    ${OptionalHeroFragmentDoc}
${YoutubeClipFragmentDoc}
${ArticleMiniatureImageFragmentDoc}
${ResponsiveImagePropsFragmentDoc}
${SeoFieldFragmentDoc}`;

export function useCompanyCampaignPageQuery(options: Omit<Urql.UseQueryArgs<CompanyCampaignPageQueryVariables>, 'query'>) {
  return Urql.useQuery<CompanyCampaignPageQuery, CompanyCampaignPageQueryVariables>({ query: CompanyCampaignPageDocument, ...options });
};
export const DynamicPageDocument = gql`
    query DynamicPage($locale: SiteLocale!, $slug: String!) {
  dynamicPage(filter: {slug: {eq: $slug}, isActive: {eq: true}}, locale: $locale) {
    hero {
      ...OptionalHero
    }
    body {
      value
      blocks {
        ...DynamicPageBodyBlocks
        ...DynamicPageBodyOnlyBlocks
        ... on TextSectionRecord {
          id
          backgroundColor
          paddingTop
          paddingBottom
          contentMaxWidth
          contentBackgroundColor
          contentPadding
          contentTextAlign
          contentBorderColor
          innerContentMaxWidth
          body {
            blocks {
              ...DynamicPageBodyBlocks
            }
            links {
              ...DynamicPageBodyLinks
            }
            value
          }
        }
      }
      links {
        ...DynamicPageBodyLinks
      }
    }
    bodyBackgroundColor
    bodyPaddingTop
    bodyPaddingBottom
    bodyContentMaxWidth
    bodyContentBackgroundColor
    bodyContentPadding
    bodyContentTextAlign
    bodyContentBorderColor
    bodyInnerContentMaxWidth
    seo {
      ...SeoField
    }
    _editingUrl
  }
}
    ${OptionalHeroFragmentDoc}
${DynamicPageBodyBlocksFragmentDoc}
${DynamicPageBodyOnlyBlocksFragmentDoc}
${DynamicPageBodyLinksFragmentDoc}
${SeoFieldFragmentDoc}`;

export function useDynamicPageQuery(options: Omit<Urql.UseQueryArgs<DynamicPageQueryVariables>, 'query'>) {
  return Urql.useQuery<DynamicPageQuery, DynamicPageQueryVariables>({ query: DynamicPageDocument, ...options });
};
export const FacilityDocument = gql`
    query Facility($locale: SiteLocale!, $slug: String!) {
  facility(locale: $locale, filter: {dbId: {eq: $slug}}) {
    dbId
    title
    image {
      responsiveImage(
        imgixParams: {auto: format, q: 65, w: 800}
        sizes: "(max-width: 768px) 100vw, 640px"
      ) {
        ...ResponsiveImageProps
      }
      tags
    }
    slug
    phone
    fax
    streetAddress
    zipCode
    city
    customMapLink
    longitude
    latitude
    testDrive {
      blocks
      links
      value
    }
    delivery {
      blocks
      links
      value
    }
    directions {
      blocks
      links
      value
    }
    paymentOptions {
      blocks
      links
      value
    }
    pickup {
      blocks
      links
      value
    }
  }
}
    ${ResponsiveImagePropsFragmentDoc}`;

export function useFacilityQuery(options: Omit<Urql.UseQueryArgs<FacilityQueryVariables>, 'query'>) {
  return Urql.useQuery<FacilityQuery, FacilityQueryVariables>({ query: FacilityDocument, ...options });
};
export const FaqPageDocument = gql`
    query faqPage($locale: SiteLocale!) {
  faq(locale: $locale, filter: {faqId: {eq: "FAQ_PAGE"}}) {
    title
    subtitle
    categories {
      name
      icon {
        url
        alt
      }
      questions {
        question
        answer {
          ...FaqQuestionAnsweField
        }
        slug
      }
    }
  }
}
    ${FaqQuestionAnsweFieldFragmentDoc}`;

export function useFaqPageQuery(options: Omit<Urql.UseQueryArgs<FaqPageQueryVariables>, 'query'>) {
  return Urql.useQuery<FaqPageQuery, FaqPageQueryVariables>({ query: FaqPageDocument, ...options });
};
export const FilterPageDocument = gql`
    query filterPage($locale: SiteLocale!, $mainCategory: String!) {
  filterPage(locale: $locale, filter: {mainCategory: {eq: $mainCategory}}) {
    id
    title
    description {
      value
    }
    seo {
      ...SeoField
    }
    seoInformation {
      value
      links
      blocks {
        ... on TitleRecord {
          id
          text
          tag
        }
        ... on SubtitleRecord {
          id
          text
          tag
        }
      }
    }
    categoryBlurbs {
      link
      text
      backgroundColor
      imageIcon {
        icon {
          url
          alt
        }
      }
    }
    cardTooltip {
      infoText
      condition
    }
    _editingUrl
  }
}
    ${SeoFieldFragmentDoc}`;

export function useFilterPageQuery(options: Omit<Urql.UseQueryArgs<FilterPageQueryVariables>, 'query'>) {
  return Urql.useQuery<FilterPageQuery, FilterPageQueryVariables>({ query: FilterPageDocument, ...options });
};
export const GlobalConfigurationDocument = gql`
    query GlobalConfiguration {
  globalConfiguration {
    financingInterest
  }
}
    `;

export function useGlobalConfigurationQuery(options?: Omit<Urql.UseQueryArgs<GlobalConfigurationQueryVariables>, 'query'>) {
  return Urql.useQuery<GlobalConfigurationQuery, GlobalConfigurationQueryVariables>({ query: GlobalConfigurationDocument, ...options });
};
export const MajorFeatureByKeyDocument = gql`
    query MajorFeatureByKey($locale: SiteLocale!, $key: String!) {
  vehicleMajorFeatureModal(locale: $locale, filter: {key: {eq: $key}}) {
    key
    title
    text {
      blocks
      links
      value
    }
    _editingUrl
    link {
      text
      url
    }
    conditions {
      question
      conditionInfo {
        answer
        conditionStep
      }
      key
    }
  }
}
    `;

export function useMajorFeatureByKeyQuery(options: Omit<Urql.UseQueryArgs<MajorFeatureByKeyQueryVariables>, 'query'>) {
  return Urql.useQuery<MajorFeatureByKeyQuery, MajorFeatureByKeyQueryVariables>({ query: MajorFeatureByKeyDocument, ...options });
};
export const MyAuctionsWonPageDocument = gql`
    query MyAuctionsWonPage($locale: SiteLocale!) {
  myAuctionsWonPage(locale: $locale) {
    _editingUrl
    emptyStateText
    headline
    checkoutActiveSubheading
    checkoutPendingSubheading
    checkoutCompletedText
    checkoutCallbackText
    checkoutClosedText
    checkoutExpiryNoticeText
    helpText {
      blocks
      links
      value
    }
    footerContactText {
      blocks
      links
      value
    }
    cancellationTerms {
      blocks
      links
      value
    }
    cancellationButtonText
    cancellationAvailableText
    cancellationRequestSentTitle
    cancellationRequestSentText
    cancellationClosedText
    cancellationModalTitle
    cancellationModalBody {
      blocks
      links
      value
    }
    cancellationModalConsentLabel
    cancellationModalSubmitText
    cancellationModalCancelText
    cancellationConfirmationTitle
    cancellationConfirmationBody {
      blocks
      links
      value
    }
    cancellationConfirmationCloseText
  }
}
    `;

export function useMyAuctionsWonPageQuery(options: Omit<Urql.UseQueryArgs<MyAuctionsWonPageQueryVariables>, 'query'>) {
  return Urql.useQuery<MyAuctionsWonPageQuery, MyAuctionsWonPageQueryVariables>({ query: MyAuctionsWonPageDocument, ...options });
};
export const NavigationDocument = gql`
    query Navigation($locale: SiteLocale!) {
  navigation(locale: $locale) {
    navigationTitle
    primaryNavigation {
      text
      url
      description
      subNavigation {
        navigationTitle
        primaryNavigation {
          text
          url
          description
          subNavigation {
            navigationTitle
            primaryNavigation {
              text
              url
              description
              subNavigation {
                navigationTitle
                primaryNavigation {
                  text
                  url
                  description
                }
                secondaryNavigationTitle
                secondaryNavigation {
                  ...Link
                }
              }
            }
            secondaryNavigationTitle
            secondaryNavigation {
              ...Link
            }
          }
        }
        secondaryNavigationTitle
        secondaryNavigation {
          ...Link
        }
      }
    }
    secondaryNavigationTitle
    secondaryNavigation {
      ...Link
    }
    utilityBarNavigation {
      textIcon {
        text
        imageIcon {
          icon {
            url
            alt
          }
        }
      }
      textLink {
        text
        url
      }
    }
    loggedInNavigationTitle
    loggedInNavigation {
      ...Link
    }
  }
}
    ${LinkFragmentDoc}`;

export function useNavigationQuery(options: Omit<Urql.UseQueryArgs<NavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<NavigationQuery, NavigationQueryVariables>({ query: NavigationDocument, ...options });
};
export const FooterNavigationDocument = gql`
    query FooterNavigation($locale: SiteLocale!) {
  footerNavigation(locale: $locale) {
    linkGroups {
      title
      links {
        text
        url
        customLinkMeta {
          attrName
          attrValue
        }
        alternativeActionKey
      }
    }
    footerButtons {
      text
      url
      color
      size
      variant
      openLinkInNewWindow
    }
    _editingUrl
  }
}
    `;

export function useFooterNavigationQuery(options: Omit<Urql.UseQueryArgs<FooterNavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<FooterNavigationQuery, FooterNavigationQueryVariables>({ query: FooterNavigationDocument, ...options });
};
export const ObjectPageDocument = gql`
    query objectPage($locale: SiteLocale!) {
  objectPage(locale: $locale) {
    contactSectionControllerAuction
    contactSectionControllerFixedPrice
    buyMethodsBiddingTutorialLink
    buyMethodsFixedPriceTutorialLink
    buyMethodsLoanCalculationExplanation
    buyMethodsLoanWarning {
      value
      blocks
      links
    }
    contact {
      title
      subtitle
      buttons {
        text
        href
        icon
      }
      days
      extraInfo
    }
    heavyEquipmentDescriptionWarning
    heavyEquipmentFacilityExplanation {
      value
      blocks
      links
    }
    heavyEquipmentSalesTermsTitle
    heavyEquipmentSalesTerms {
      value
      blocks
      links
    }
    heavyEquipmentVehicleFactsDisclaimer
    heavyEquipmentServicesTitle
    heavyEquipmentServices {
      ...Services
    }
    nextButtonText
    exitButtonText
    finalButtonText
    finalLink {
      text
      url
    }
    guideSteps {
      descriptionTitle
      descriptionBodyText
      imageIcon {
        icon {
          url
        }
      }
    }
    ecoTitle
    ecoSubtitle
    ecoDescription
    ecoBulletPoints {
      ...BulletPoints
    }
    ecoImageDescription
    ecoReadMoreUrl
    ecoReadMoreText
    _editingUrl
    inspectionOverview {
      title
      link {
        text
        url
      }
    }
    drivetrain {
      ...Inspection
    }
    brakes {
      ...Inspection
    }
    technologyAndEquipment {
      ...Inspection
    }
    interior {
      ...Inspection
    }
    exterior {
      ...Inspection
    }
    tires {
      ...Inspection
    }
    objectCondition {
      condition
      title
      link {
        text
        url
      }
      text {
        blocks
        links
        value
      }
    }
    deliveryCalculatorTitle
    deliveryCalculatorDisclaimer
  }
}
    ${ServicesFragmentDoc}
${BulletPointsFragmentDoc}
${InspectionFragmentDoc}`;

export function useObjectPageQuery(options: Omit<Urql.UseQueryArgs<ObjectPageQueryVariables>, 'query'>) {
  return Urql.useQuery<ObjectPageQuery, ObjectPageQueryVariables>({ query: ObjectPageDocument, ...options });
};
export const ObjectServicesDocument = gql`
    query objectServices($locale: SiteLocale!) {
  objectPage(locale: $locale) {
    servicesTitle
    services {
      ...Services
    }
    deliveryCalculatorTitle
    deliveryCalculatorDescriptor
    deliveryCalculatorDisclaimer
  }
}
    ${ServicesFragmentDoc}`;

export function useObjectServicesQuery(options: Omit<Urql.UseQueryArgs<ObjectServicesQueryVariables>, 'query'>) {
  return Urql.useQuery<ObjectServicesQuery, ObjectServicesQueryVariables>({ query: ObjectServicesDocument, ...options });
};
export const FixedPriceReservationTipsDocument = gql`
    query FixedPriceReservationTips($locale: SiteLocale!) {
  fixedPriceTipsModel(locale: $locale) {
    structuredText {
      structuredText {
        value
      }
    }
  }
}
    `;

export function useFixedPriceReservationTipsQuery(options: Omit<Urql.UseQueryArgs<FixedPriceReservationTipsQueryVariables>, 'query'>) {
  return Urql.useQuery<FixedPriceReservationTipsQuery, FixedPriceReservationTipsQueryVariables>({ query: FixedPriceReservationTipsDocument, ...options });
};
export const PartnershipPageDocument = gql`
    query PartnershipPage($locale: SiteLocale!, $isAuthenticated: Boolean!) {
  page(locale: $locale, filter: {name: {eq: "Partnership page"}}) {
    name
    seo {
      ...SeoField
    }
    optionalHero {
      ...OptionalHero
    }
    loggedInTitle
    loggedInContent {
      value
    }
    publicTitle
    publicContent {
      value
    }
    _editingUrl
  }
  allPartnershipItems(locale: $locale) {
    id
    title
    description {
      value
    }
    image {
      responsiveImage(
        imgixParams: {fit: crop, auto: format, q: 65, w: 740}
        sizes: "(max-width: 768px) 90vw, (max-width: 1200px) 45vw, 550px"
      ) {
        ...ResponsiveImageProps
      }
      focalPoint {
        x
        y
      }
      tags
    }
    partnerLogo {
      responsiveImage(
        imgixParams: {auto: format, w: 400}
        sizes: "(max-width: 768px) 50vw, (max-width: 1200px) 25vw, 240px"
      ) {
        ...ResponsiveImageProps
      }
      tags
    }
    campaignCode @include(if: $isAuthenticated)
    hasCampaignCode
    _editingUrl
  }
}
    ${SeoFieldFragmentDoc}
${OptionalHeroFragmentDoc}
${ResponsiveImagePropsFragmentDoc}`;

export function usePartnershipPageQuery(options: Omit<Urql.UseQueryArgs<PartnershipPageQueryVariables>, 'query'>) {
  return Urql.useQuery<PartnershipPageQuery, PartnershipPageQueryVariables>({ query: PartnershipPageDocument, ...options });
};
export const PromoSettingByUsageTypeDocument = gql`
    query promoSettingByUsageType($locale: SiteLocale!, $usageType: String!) {
  promoSetting(locale: $locale, filter: {usageType: {eq: $usageType}}) {
    id
    usageType
    promoCards {
      ...PromoCard
    }
  }
}
    ${PromoCardFragmentDoc}`;

export function usePromoSettingByUsageTypeQuery(options: Omit<Urql.UseQueryArgs<PromoSettingByUsageTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<PromoSettingByUsageTypeQuery, PromoSettingByUsageTypeQueryVariables>({ query: PromoSettingByUsageTypeDocument, ...options });
};
export const AllRedirectsDocument = gql`
    query AllRedirects($locale: SiteLocale!, $limit: IntType!, $skip: IntType!) {
  allRedirects(
    filter: {active: {eq: true}, fromUrl: {isBlank: false}, toUrl: {isBlank: false}}
    locale: $locale
    first: $limit
    skip: $skip
  ) {
    fromUrl
    toUrl
  }
}
    `;

export function useAllRedirectsQuery(options: Omit<Urql.UseQueryArgs<AllRedirectsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllRedirectsQuery, AllRedirectsQueryVariables>({ query: AllRedirectsDocument, ...options });
};
export const SellFlowStartContentDocument = gql`
    query SellFlowStartContent($locale: SiteLocale) {
  sellFlowPage(locale: $locale) {
    startHero {
      image {
        ...ResponsiveW2000Image
      }
      heading
      headingColor
      subheading
      subheadingColor
    }
    startActionBoxText
    startActionBoxButton {
      ...ButtonAttributes
    }
    startSellStepsTitle
    startSellSteps {
      title
      image {
        responsiveImage(
          imgixParams: {fit: crop, auto: format, q: 65, w: 800}
          sizes: "(max-width: 768px) 95vw, (max-width: 1024px) 45vw, 242px"
        ) {
          ...ResponsiveImageProps
        }
        tags
      }
      step {
        text
      }
    }
    startTrustpilotTitle
    startSeoInformation {
      content {
        title {
          text
          tag
        }
        text {
          blocks
          links
          value
        }
      }
    }
    startSeo {
      description
      title
      image {
        url
      }
    }
    startFaqNew {
      question
      answer {
        ...FaqQuestionAnsweField
      }
    }
    startCarRequirementsHeading
    startCarRequirementsList {
      text
    }
  }
}
    ${ResponsiveW2000ImageFragmentDoc}
${ButtonAttributesFragmentDoc}
${ResponsiveImagePropsFragmentDoc}
${FaqQuestionAnsweFieldFragmentDoc}`;

export function useSellFlowStartContentQuery(options?: Omit<Urql.UseQueryArgs<SellFlowStartContentQueryVariables>, 'query'>) {
  return Urql.useQuery<SellFlowStartContentQuery, SellFlowStartContentQueryVariables>({ query: SellFlowStartContentDocument, ...options });
};
export const SellFlowInterestFormContentDocument = gql`
    query SellFlowInterestFormContent($locale: SiteLocale) {
  sellFlowPage(locale: $locale) {
    vehicleHeading
    vehicleInputfieldPlaceholder
    vehicleIntroduction
    vehiclePrimaryButton
    odometerHeading
    odometerIntroduction
    odometerPlaceholder
    odometerPrimaryButton
    odometerSecondaryButton
    odometerAdditionalInfo
    odometerYearlyMaxError
    odometerMaxMileageError
    trimHeading
    trimIntroduction
    trimPrimaryButton
    trimDontKnowPackageInfoText
    trimPackageTitle
    trimAddonsTitle
    trimPrimaryButtonManualValuation
    trimGatekeeperHeading
    trimGatekeeperTermsCheckbox
    salesHeading
    salesHeadingSingleOption
    salesDiscountHeading
    salesDiscountInfo
    salesBiddingHeading
    salesBiddingManualValuation
    salesBiddingInfo
    salesBiddingCheckItem1
    salesBiddingCheckItem2
    salesBiddingCheckItem3
    salesExpressHeading
    salesExpressManualValuation
    salesExpressInfo
    salesExpressInfoExtra
    salesExpressCheckItem1
    salesExpressCheckItem2
    salesExpressCheckItem3
    salesCtaButtonText
    contactHeadingOne
    contactConfirmationText
    contactHeadingTwo
    contactInformationText
    contactExpressInformationText
    contactButtonText
    contactButtonTextNotComplete
    contactFormHeaderRequiresManual {
      ...FormHeaderAttributes
    }
    contactFormHeaderRecreational {
      ...FormHeaderAttributes
    }
    contactFormHeaderConsumer {
      ...FormHeaderAttributes
    }
    contactFormHeaderCorporate {
      ...FormHeaderAttributes
    }
    contactFormHeaderHeavy {
      ...FormHeaderAttributes
    }
    contactFormHeaderOther {
      ...FormHeaderAttributes
    }
    noticeOfInterestIntroduction {
      blocks
      links
      value
    }
    noticeOfInterestEquipmentTextareaHelperText
    noticeOfInterestExtraTiresCheckboxLabel
    noticeOfInterestValuationServiceUnavailabilityWarning
    thankYouTitle
    thankYouConsumer {
      ...ThankYouItemAttributes
    }
    thankYouManualValuation {
      ...ThankYouItemAttributes
    }
    thankYouCompany {
      ...ThankYouItemAttributes
    }
    thankYouExpress {
      ...ThankYouItemAttributes
    }
    companyTitle
    companyDescription
    companyCtaText
    companyCtaLinkDestination
    prefilledHeading
    prefilledIntroduction
    prefilledButtonText
  }
}
    ${FormHeaderAttributesFragmentDoc}
${ThankYouItemAttributesFragmentDoc}`;

export function useSellFlowInterestFormContentQuery(options?: Omit<Urql.UseQueryArgs<SellFlowInterestFormContentQueryVariables>, 'query'>) {
  return Urql.useQuery<SellFlowInterestFormContentQuery, SellFlowInterestFormContentQueryVariables>({ query: SellFlowInterestFormContentDocument, ...options });
};
export const SellFlowHeavyEquipmentInterestFormContentDocument = gql`
    query SellFlowHeavyEquipmentInterestFormContent($locale: SiteLocale) {
  sellFlowPage(locale: $locale) {
    heavyEquipmentHeading
    heavyEquipmentIntroduction {
      blocks
      links
      value
    }
    heavyEquipmentTermsStructuredText {
      blocks
      links
      value
    }
    heavyEquipmentThankYouHeading
    heavyEquipmentThankYouDescription {
      blocks
      links
      value
    }
  }
}
    `;

export function useSellFlowHeavyEquipmentInterestFormContentQuery(options?: Omit<Urql.UseQueryArgs<SellFlowHeavyEquipmentInterestFormContentQueryVariables>, 'query'>) {
  return Urql.useQuery<SellFlowHeavyEquipmentInterestFormContentQuery, SellFlowHeavyEquipmentInterestFormContentQueryVariables>({ query: SellFlowHeavyEquipmentInterestFormContentDocument, ...options });
};
export const SellFlowConfirmationViewContentDocument = gql`
    query SellFlowConfirmationViewContent($locale: SiteLocale) {
  sellFlowPage(locale: $locale) {
    confirmationExplanations {
      ...DynamicItemAttributes
    }
  }
}
    ${DynamicItemAttributesFragmentDoc}`;

export function useSellFlowConfirmationViewContentQuery(options?: Omit<Urql.UseQueryArgs<SellFlowConfirmationViewContentQueryVariables>, 'query'>) {
  return Urql.useQuery<SellFlowConfirmationViewContentQuery, SellFlowConfirmationViewContentQueryVariables>({ query: SellFlowConfirmationViewContentDocument, ...options });
};
export const SellFlowReservationViewContentDocument = gql`
    query SellFlowReservationViewContent($locale: SiteLocale) {
  sellFlowPage(locale: $locale) {
    reservationThanksHeading
    reservationUpperExplanation
    reservationNotSureUpperExplanation
    reservationHeading
    reservationExplanation
    reservationValuationHeading
    reservationManualValuationHeading
    reservationSetManualPriceButton
    reservationSetRecommendedPriceButton
    reservationReadyToContinueHeading
    reservationHeadingReservationAccepted
    reservationReadyToContinueExplanation
    reservationExplanationReservationAccepted
  }
}
    `;

export function useSellFlowReservationViewContentQuery(options?: Omit<Urql.UseQueryArgs<SellFlowReservationViewContentQueryVariables>, 'query'>) {
  return Urql.useQuery<SellFlowReservationViewContentQuery, SellFlowReservationViewContentQueryVariables>({ query: SellFlowReservationViewContentDocument, ...options });
};
export const SellFlowTermsAndConditionsViewContentDocument = gql`
    query SellFlowTermsAndConditionsViewContent($locale: SiteLocale) {
  sellFlowPage(locale: $locale) {
    termsDynamicItems {
      ...DynamicItemAttributes
    }
    termsDownloadButtonText
  }
}
    ${DynamicItemAttributesFragmentDoc}`;

export function useSellFlowTermsAndConditionsViewContentQuery(options?: Omit<Urql.UseQueryArgs<SellFlowTermsAndConditionsViewContentQueryVariables>, 'query'>) {
  return Urql.useQuery<SellFlowTermsAndConditionsViewContentQuery, SellFlowTermsAndConditionsViewContentQueryVariables>({ query: SellFlowTermsAndConditionsViewContentDocument, ...options });
};
export const SiteMessagesDocument = gql`
    query SiteMessages($locale: SiteLocale!) {
  allSiteMessages(locale: $locale, filter: {isActive: {eq: true}}) {
    id
    isActive
    messageStructuredText {
      structuredText {
        value
      }
    }
    placement
    siteMessageType
  }
}
    `;

export function useSiteMessagesQuery(options: Omit<Urql.UseQueryArgs<SiteMessagesQueryVariables>, 'query'>) {
  return Urql.useQuery<SiteMessagesQuery, SiteMessagesQueryVariables>({ query: SiteMessagesDocument, ...options });
};
export const StartPageDocument = gql`
    query StartPage($locale: SiteLocale!) {
  startPage(locale: $locale) {
    seo {
      ...SeoField
    }
    blockButtons {
      ...BlockButton
    }
    aboutArea {
      title {
        text
        tag
      }
      paragraph {
        value
        blocks
        links
      }
      linkList {
        text
        caption
        url
      }
      iconsWithText {
        text
        imageIcon {
          icon {
            url
            alt
          }
        }
      }
    }
    largeFeaturedCards {
      ...largeFeaturedCard
    }
    seoInformation {
      content {
        title {
          text
          tag
        }
        text {
          blocks
          links
          value
        }
      }
    }
    smallPromoBanner {
      showSmallBanner
      backgroundColor
      backgroundColorShade
      text
      textColor
      button {
        link
        text
        textColor
        backgroundColor
        backgroundColorShade
      }
    }
    largePromoBanner {
      ...OptionalHero
    }
    showSmallTrustpilot
    featuredBlocksTitle
    myVehiclesHeadline
    featuredObjects {
      heading
      linkText
      queryString
    }
    contactSection {
      title
      subtitle
      days
      extraInfo
      buttons {
        icon
        text
        href
      }
    }
    trustpilotTitle
    smallFeatureCards {
      button {
        color
        size
        text
        url
      }
      title
      text {
        blocks
        links
        value
      }
      articles {
        id
        slug
        title
        _firstPublishedAt
        mainCategory {
          name
          id
          slug
        }
        ...ArticleMiniatureImage
      }
    }
    featureCardsIsActive
    categoryBlurbsHeadline
    categoryBlurbs {
      text
      link
      backgroundColor
      imageIcon {
        icon {
          url
          alt
        }
      }
    }
    _editingUrl
  }
}
    ${SeoFieldFragmentDoc}
${BlockButtonFragmentDoc}
${LargeFeaturedCardFragmentDoc}
${OptionalHeroFragmentDoc}
${ArticleMiniatureImageFragmentDoc}`;

export function useStartPageQuery(options: Omit<Urql.UseQueryArgs<StartPageQueryVariables>, 'query'>) {
  return Urql.useQuery<StartPageQuery, StartPageQueryVariables>({ query: StartPageDocument, ...options });
};
export const EmailSubscriptionManagementDocument = gql`
    query EmailSubscriptionManagement($locale: SiteLocale!) {
  emailSubscriptionManagement(locale: $locale) {
    subscriptions {
      isActive
      subscriptionType
      checkboxLabel
      checkboxDescription
    }
    profileSettingsTitle
    profileSettingsDescription
    unsubscribeInProgresTitle
    unsubscribeDoneTitle
    unsubscribeDoneConfirmation
    unsubscribeShowMore
    unsubscribeSubscriptionListDescription
    unsubscribeFooterText
    unsubscribeFooterLinkText
  }
}
    `;

export function useEmailSubscriptionManagementQuery(options: Omit<Urql.UseQueryArgs<EmailSubscriptionManagementQueryVariables>, 'query'>) {
  return Urql.useQuery<EmailSubscriptionManagementQuery, EmailSubscriptionManagementQueryVariables>({ query: EmailSubscriptionManagementDocument, ...options });
};
export const TransferInfoPageDocument = gql`
    query transferInfoPage($locale: SiteLocale!, $identifier: String!) {
  purchaseOwnershipTransfer(
    locale: $locale
    filter: {identifier: {eq: $identifier}}
  ) {
    identifier
    pageTitle
    title
    subtitle
    informationText
    contactInfo
    vehicleInfo
    button {
      text
      url
    }
    buttonInformationText
    primaryPath {
      ...PathItem
    }
    secondaryPath {
      ...PathItem
    }
  }
}
    ${PathItemFragmentDoc}`;

export function useTransferInfoPageQuery(options: Omit<Urql.UseQueryArgs<TransferInfoPageQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferInfoPageQuery, TransferInfoPageQueryVariables>({ query: TransferInfoPageDocument, ...options });
};
export const PurchaseAndPickUpTransferDocument = gql`
    query purchaseAndPickUpTransfer($locale: SiteLocale!) {
  purchaseAndPickUpTransfer(locale: $locale) {
    commonSigningInitializedTitle
    commonSigningFailedTitle
    commonSigningFailedDescription {
      blocks
      links
      value
    }
    commonSigningAbortedTitle
    commonSigningAbortedDescription {
      blocks
      links
      value
    }
    commonSigningNotFoundTitle
    commonSigningNotFoundDescription {
      blocks
      links
      value
    }
    purchaseTitle
    purchaseDescription {
      blocks
      links
      value
    }
    purchaseVehicleCardTitle
    purchaseFormTitle
    purchaseFormDescription {
      blocks
      links
      value
    }
    purchaseExplanation {
      blocks
      links
      value
    }
    purchaseInitializedStatusDescription {
      blocks
      links
      value
    }
    purchaseCompleteStatusTitle
    purchaseCompleteStatusDescription {
      blocks
      links
      value
    }
    pickUpTitle
    pickUpDescription {
      blocks
      links
      value
    }
    pickUpVehicleCardTitle
    pickUpFormTitle
    pickUpFormIdentificationQuestion
    pickUpInitializedStatusDescription {
      blocks
      links
      value
    }
    pickUpCompleteStatusTitle
    pickUpCompleteStatusDescription {
      blocks
      links
      value
    }
  }
}
    `;

export function usePurchaseAndPickUpTransferQuery(options: Omit<Urql.UseQueryArgs<PurchaseAndPickUpTransferQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseAndPickUpTransferQuery, PurchaseAndPickUpTransferQueryVariables>({ query: PurchaseAndPickUpTransferDocument, ...options });
};
export const ValuationPageDocument = gql`
    query ValuationPage($locale: SiteLocale!) {
  valuationPage(locale: $locale) {
    image {
      ...ResponsiveW2000Image
    }
    heading
    subheading
    actionBoxTitle
    button {
      url
      variant
      size
      color
      text
    }
    _editingUrl
    faq {
      question
      answer {
        ...FaqQuestionAnsweField
      }
    }
    largeFeatureCard {
      ...largeFeaturedCard
    }
    smallFeatureCards {
      title
      text {
        blocks
        links
        value
      }
      articles {
        id
        slug
        title
        _firstPublishedAt
        mainCategory {
          name
          id
          slug
        }
        ...ArticleMiniatureImage
      }
    }
    trustpilotTitle
    seoInformation {
      content {
        title {
          text
          tag
        }
        text {
          blocks
          links
          value
        }
      }
    }
    largeFeatureCards {
      ...largeFeaturedCard
    }
    seo {
      ...SeoField
    }
  }
}
    ${ResponsiveW2000ImageFragmentDoc}
${FaqQuestionAnsweFieldFragmentDoc}
${LargeFeaturedCardFragmentDoc}
${ArticleMiniatureImageFragmentDoc}
${SeoFieldFragmentDoc}`;

export function useValuationPageQuery(options: Omit<Urql.UseQueryArgs<ValuationPageQueryVariables>, 'query'>) {
  return Urql.useQuery<ValuationPageQuery, ValuationPageQueryVariables>({ query: ValuationPageDocument, ...options });
};